//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.8.0 (NJsonSchema v11.0.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class AuthorizedApiBase {
  private get token() {
    let tokenJSON = sessionStorage.getItem(
      `oidc.user:${process.env.REACT_APP_AUTH_URL}/:${process.env.CLIENT_ID}`
    )

    let token = tokenJSON ? JSON.parse(tokenJSON) : null

    return token ? `Bearer ${token.access_token}` : ""
  }

  protected transformOptions = (options: RequestInit): Promise<RequestInit> => {
    options.headers = {
      ...options.headers,
      Authorization: this.token,
    }
    return Promise.resolve(options)
  }
}

export interface IAdminIntegrationsClient {

    createCredential(clientGroupId: number, body: CreateCredentialBody): Promise<CreateCredentialResult>;

    getCredentials(clientGroupId: number): Promise<CredentialBriefDto[]>;

    rotateCredential(id: number): Promise<RotateCredentialSecretResult>;

    revokeCredential(id: number): Promise<FileResponse>;

    createSubscription(clientGroupId: number, body: CreateSubscriptionBody): Promise<CreateSubscriptionResult>;

    getSubscriptions(clientGroupId: number): Promise<SubscriptionBriefDto[]>;

    updateSubscription(id: number, body: UpdateSubscriptionBody): Promise<FileResponse>;

    activateSubscription(id: number): Promise<FileResponse>;

    deactivateSubscription(id: number): Promise<FileResponse>;

    rotateSubscriptionSecret(id: number): Promise<RotateSubscriptionSecretResult>;

    getDeliveries(clientGroupId: number, status: string | null | undefined, eventType: string | null | undefined, eventId: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Promise<PaginatedListOfDeliveryBriefDto>;

    retryDelivery(id: number): Promise<FileResponse>;

    upsertExternalIdentity(clientGroupId: number, body: UpsertExternalIdentityBody): Promise<ExternalIdentityBriefDto>;
}

export class AdminIntegrationsClient extends AuthorizedApiBase implements IAdminIntegrationsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    createCredential(clientGroupId: number, body: CreateCredentialBody): Promise<CreateCredentialResult> {
        let url_ = this.baseUrl + "/api/admin/integrations/client-groups/{clientGroupId}/credentials";
        if (clientGroupId === undefined || clientGroupId === null)
            throw new Error("The parameter 'clientGroupId' must be defined.");
        url_ = url_.replace("{clientGroupId}", encodeURIComponent("" + clientGroupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCredential(_response);
        });
    }

    protected processCreateCredential(response: Response): Promise<CreateCredentialResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateCredentialResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateCredentialResult>(null as any);
    }

    getCredentials(clientGroupId: number): Promise<CredentialBriefDto[]> {
        let url_ = this.baseUrl + "/api/admin/integrations/client-groups/{clientGroupId}/credentials";
        if (clientGroupId === undefined || clientGroupId === null)
            throw new Error("The parameter 'clientGroupId' must be defined.");
        url_ = url_.replace("{clientGroupId}", encodeURIComponent("" + clientGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCredentials(_response);
        });
    }

    protected processGetCredentials(response: Response): Promise<CredentialBriefDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CredentialBriefDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CredentialBriefDto[]>(null as any);
    }

    rotateCredential(id: number): Promise<RotateCredentialSecretResult> {
        let url_ = this.baseUrl + "/api/admin/integrations/credentials/{id}/rotate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRotateCredential(_response);
        });
    }

    protected processRotateCredential(response: Response): Promise<RotateCredentialSecretResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RotateCredentialSecretResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RotateCredentialSecretResult>(null as any);
    }

    revokeCredential(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/admin/integrations/credentials/{id}/revoke";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRevokeCredential(_response);
        });
    }

    protected processRevokeCredential(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    createSubscription(clientGroupId: number, body: CreateSubscriptionBody): Promise<CreateSubscriptionResult> {
        let url_ = this.baseUrl + "/api/admin/integrations/client-groups/{clientGroupId}/subscriptions";
        if (clientGroupId === undefined || clientGroupId === null)
            throw new Error("The parameter 'clientGroupId' must be defined.");
        url_ = url_.replace("{clientGroupId}", encodeURIComponent("" + clientGroupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateSubscription(_response);
        });
    }

    protected processCreateSubscription(response: Response): Promise<CreateSubscriptionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateSubscriptionResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateSubscriptionResult>(null as any);
    }

    getSubscriptions(clientGroupId: number): Promise<SubscriptionBriefDto[]> {
        let url_ = this.baseUrl + "/api/admin/integrations/client-groups/{clientGroupId}/subscriptions";
        if (clientGroupId === undefined || clientGroupId === null)
            throw new Error("The parameter 'clientGroupId' must be defined.");
        url_ = url_.replace("{clientGroupId}", encodeURIComponent("" + clientGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSubscriptions(_response);
        });
    }

    protected processGetSubscriptions(response: Response): Promise<SubscriptionBriefDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubscriptionBriefDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriptionBriefDto[]>(null as any);
    }

    updateSubscription(id: number, body: UpdateSubscriptionBody): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/admin/integrations/subscriptions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateSubscription(_response);
        });
    }

    protected processUpdateSubscription(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    activateSubscription(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/admin/integrations/subscriptions/{id}/activate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processActivateSubscription(_response);
        });
    }

    protected processActivateSubscription(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deactivateSubscription(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/admin/integrations/subscriptions/{id}/deactivate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeactivateSubscription(_response);
        });
    }

    protected processDeactivateSubscription(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    rotateSubscriptionSecret(id: number): Promise<RotateSubscriptionSecretResult> {
        let url_ = this.baseUrl + "/api/admin/integrations/subscriptions/{id}/rotate-secret";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRotateSubscriptionSecret(_response);
        });
    }

    protected processRotateSubscriptionSecret(response: Response): Promise<RotateSubscriptionSecretResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RotateSubscriptionSecretResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RotateSubscriptionSecretResult>(null as any);
    }

    getDeliveries(clientGroupId: number, status: string | null | undefined, eventType: string | null | undefined, eventId: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Promise<PaginatedListOfDeliveryBriefDto> {
        let url_ = this.baseUrl + "/api/admin/integrations/client-groups/{clientGroupId}/deliveries?";
        if (clientGroupId === undefined || clientGroupId === null)
            throw new Error("The parameter 'clientGroupId' must be defined.");
        url_ = url_.replace("{clientGroupId}", encodeURIComponent("" + clientGroupId));
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (eventType !== undefined && eventType !== null)
            url_ += "eventType=" + encodeURIComponent("" + eventType) + "&";
        if (eventId !== undefined && eventId !== null)
            url_ += "eventId=" + encodeURIComponent("" + eventId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDeliveries(_response);
        });
    }

    protected processGetDeliveries(response: Response): Promise<PaginatedListOfDeliveryBriefDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfDeliveryBriefDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfDeliveryBriefDto>(null as any);
    }

    retryDelivery(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/admin/integrations/deliveries/{id}/retry";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRetryDelivery(_response);
        });
    }

    protected processRetryDelivery(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    upsertExternalIdentity(clientGroupId: number, body: UpsertExternalIdentityBody): Promise<ExternalIdentityBriefDto> {
        let url_ = this.baseUrl + "/api/admin/integrations/client-groups/{clientGroupId}/external-identities";
        if (clientGroupId === undefined || clientGroupId === null)
            throw new Error("The parameter 'clientGroupId' must be defined.");
        url_ = url_.replace("{clientGroupId}", encodeURIComponent("" + clientGroupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertExternalIdentity(_response);
        });
    }

    protected processUpsertExternalIdentity(response: Response): Promise<ExternalIdentityBriefDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalIdentityBriefDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExternalIdentityBriefDto>(null as any);
    }
}

export interface IAdministratorsClient {

    getAdministratorWithPagination(keyword: string | null | undefined, type: AdministratorType | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfAdministratorBriefDto>;

    create(command: CreateAdministratorCommand): Promise<FileResponse>;

    detele(command: DeleteAdministratorCommand): Promise<FileResponse>;

    update(command: UpdateAdministratorCommand): Promise<FileResponse>;

    changePassword(command: UpdateAdministratorPasswordCommand): Promise<Result>;

    forceChangePassword(command: ForceUpdateAdministratorPasswordCommand): Promise<Result>;

    sendNotification(id: string): Promise<FileResponse>;
}

export class AdministratorsClient extends AuthorizedApiBase implements IAdministratorsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAdministratorWithPagination(keyword: string | null | undefined, type: AdministratorType | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfAdministratorBriefDto> {
        let url_ = this.baseUrl + "/api/Administrators?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAdministratorWithPagination(_response);
        });
    }

    protected processGetAdministratorWithPagination(response: Response): Promise<PaginatedListOfAdministratorBriefDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfAdministratorBriefDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfAdministratorBriefDto>(null as any);
    }

    create(command: CreateAdministratorCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Administrators";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    detele(command: DeleteAdministratorCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Administrators";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDetele(_response);
        });
    }

    protected processDetele(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    update(command: UpdateAdministratorCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Administrators/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    changePassword(command: UpdateAdministratorPasswordCommand): Promise<Result> {
        let url_ = this.baseUrl + "/api/Administrators/Password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    forceChangePassword(command: ForceUpdateAdministratorPasswordCommand): Promise<Result> {
        let url_ = this.baseUrl + "/api/Administrators/ForceChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processForceChangePassword(_response);
        });
    }

    protected processForceChangePassword(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    sendNotification(id: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Administrators/{id}/Notification";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendNotification(_response);
        });
    }

    protected processSendNotification(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IAliVodVideosClient {

    getAliVodVideo(aliVodVideoId: number | undefined): Promise<AliVodVideoBriefDto>;

    createAliVodVideoAuth(command: CreateAliVodVideoAuthCommand): Promise<VideoUploadCredentialResponse>;

    createAliVodVideo(command: CreateAliVodVideoCommand): Promise<AliVodVideoDto>;

    createVideoPlayAuth(command: CreateVideoPlayAuthCommand): Promise<PlayAuthResponse>;

    downloadAliVodVideo(mediaLibraryId: number | undefined): Promise<FileResponse>;
}

export class AliVodVideosClient extends AuthorizedApiBase implements IAliVodVideosClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAliVodVideo(aliVodVideoId: number | undefined): Promise<AliVodVideoBriefDto> {
        let url_ = this.baseUrl + "/api/AliVodVideos/Get?";
        if (aliVodVideoId === null)
            throw new Error("The parameter 'aliVodVideoId' cannot be null.");
        else if (aliVodVideoId !== undefined)
            url_ += "aliVodVideoId=" + encodeURIComponent("" + aliVodVideoId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAliVodVideo(_response);
        });
    }

    protected processGetAliVodVideo(response: Response): Promise<AliVodVideoBriefDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AliVodVideoBriefDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AliVodVideoBriefDto>(null as any);
    }

    createAliVodVideoAuth(command: CreateAliVodVideoAuthCommand): Promise<VideoUploadCredentialResponse> {
        let url_ = this.baseUrl + "/api/AliVodVideos/CreateAliVodVideoAuth";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateAliVodVideoAuth(_response);
        });
    }

    protected processCreateAliVodVideoAuth(response: Response): Promise<VideoUploadCredentialResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VideoUploadCredentialResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VideoUploadCredentialResponse>(null as any);
    }

    createAliVodVideo(command: CreateAliVodVideoCommand): Promise<AliVodVideoDto> {
        let url_ = this.baseUrl + "/api/AliVodVideos/CreateAliVodVideo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateAliVodVideo(_response);
        });
    }

    protected processCreateAliVodVideo(response: Response): Promise<AliVodVideoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AliVodVideoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AliVodVideoDto>(null as any);
    }

    createVideoPlayAuth(command: CreateVideoPlayAuthCommand): Promise<PlayAuthResponse> {
        let url_ = this.baseUrl + "/api/AliVodVideos/CreateVideoPlayAuth";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateVideoPlayAuth(_response);
        });
    }

    protected processCreateVideoPlayAuth(response: Response): Promise<PlayAuthResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlayAuthResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlayAuthResponse>(null as any);
    }

    downloadAliVodVideo(mediaLibraryId: number | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/AliVodVideos/DownloadAliVodVideo?";
        if (mediaLibraryId === null)
            throw new Error("The parameter 'mediaLibraryId' cannot be null.");
        else if (mediaLibraryId !== undefined)
            url_ += "mediaLibraryId=" + encodeURIComponent("" + mediaLibraryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadAliVodVideo(_response);
        });
    }

    protected processDownloadAliVodVideo(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IAllCourseClient {

    searchAllCourses(searchTerm: string | null | undefined, statuses: CourseStatus[] | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfAllCourseBriefDto>;
}

export class AllCourseClient extends AuthorizedApiBase implements IAllCourseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    searchAllCourses(searchTerm: string | null | undefined, statuses: CourseStatus[] | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfAllCourseBriefDto> {
        let url_ = this.baseUrl + "/api/AllCourse/search?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (statuses !== undefined && statuses !== null)
            statuses && statuses.forEach(item => { url_ += "Statuses[]=" + encodeURIComponent("" + item) + "&"; });
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchAllCourses(_response);
        });
    }

    protected processSearchAllCourses(response: Response): Promise<PaginatedListOfAllCourseBriefDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfAllCourseBriefDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfAllCourseBriefDto>(null as any);
    }
}

export interface IAssessmentReportsClient {

    getAssessmentReportsWithPagination(keyword: string | null | undefined, clientGroupId: number | null | undefined, assessmentId: number | null | undefined, isSentBefore: boolean | null | undefined, isComplete: boolean | null | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfAssessmentReportDto>;

    exportPOST(command: CreateAssessmentReportCommand): Promise<number>;

    archiveAssessmentReport(id: number | undefined): Promise<FileResponse>;

    sendAssessmentReport(id: number, command: SendAssessmentReportCommand): Promise<FileResponse>;

    sendAssessmentReport2(command: SendAssessmentReportBulkCommand): Promise<FileResponse>;

    get(id: number): Promise<AssessmentReportDto>;

    getTemplate(id: number): Promise<FileResponse>;

    getFileBulk(ids: number[] | undefined): Promise<FileResponse>;

    exportGET(assessmentId: number | null | undefined, clientGroupId: number | null | undefined): Promise<FileResponse>;

    exportGET2(assessmentId: number | null | undefined, clientGroupId: number | null | undefined): Promise<FileResponse>;

    getScore(id: number): Promise<ScoreDto>;
}

export class AssessmentReportsClient extends AuthorizedApiBase implements IAssessmentReportsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAssessmentReportsWithPagination(keyword: string | null | undefined, clientGroupId: number | null | undefined, assessmentId: number | null | undefined, isSentBefore: boolean | null | undefined, isComplete: boolean | null | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfAssessmentReportDto> {
        let url_ = this.baseUrl + "/api/AssessmentReports?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (clientGroupId !== undefined && clientGroupId !== null)
            url_ += "ClientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        if (assessmentId !== undefined && assessmentId !== null)
            url_ += "AssessmentId=" + encodeURIComponent("" + assessmentId) + "&";
        if (isSentBefore !== undefined && isSentBefore !== null)
            url_ += "IsSentBefore=" + encodeURIComponent("" + isSentBefore) + "&";
        if (isComplete !== undefined && isComplete !== null)
            url_ += "IsComplete=" + encodeURIComponent("" + isComplete) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAssessmentReportsWithPagination(_response);
        });
    }

    protected processGetAssessmentReportsWithPagination(response: Response): Promise<PaginatedListOfAssessmentReportDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfAssessmentReportDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfAssessmentReportDto>(null as any);
    }

    exportPOST(command: CreateAssessmentReportCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/AssessmentReports";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportPOST(_response);
        });
    }

    protected processExportPOST(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    archiveAssessmentReport(id: number | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/AssessmentReports?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processArchiveAssessmentReport(_response);
        });
    }

    protected processArchiveAssessmentReport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    sendAssessmentReport(id: number, command: SendAssessmentReportCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/AssessmentReports/{id}/Send";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendAssessmentReport(_response);
        });
    }

    protected processSendAssessmentReport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    sendAssessmentReport2(command: SendAssessmentReportBulkCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/AssessmentReports/SendBulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendAssessmentReport2(_response);
        });
    }

    protected processSendAssessmentReport2(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    get(id: number): Promise<AssessmentReportDto> {
        let url_ = this.baseUrl + "/api/AssessmentReports/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<AssessmentReportDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssessmentReportDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssessmentReportDto>(null as any);
    }

    getTemplate(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/AssessmentReports/{id}/File";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTemplate(_response);
        });
    }

    protected processGetTemplate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getFileBulk(ids: number[] | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/AssessmentReports/FileBulk?";
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFileBulk(_response);
        });
    }

    protected processGetFileBulk(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    exportGET(assessmentId: number | null | undefined, clientGroupId: number | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/AssessmentReports/User/Export?";
        if (assessmentId !== undefined && assessmentId !== null)
            url_ += "AssessmentId=" + encodeURIComponent("" + assessmentId) + "&";
        if (clientGroupId !== undefined && clientGroupId !== null)
            url_ += "ClientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportGET(_response);
        });
    }

    protected processExportGET(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    exportGET2(assessmentId: number | null | undefined, clientGroupId: number | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/AssessmentReports/User/Send?";
        if (assessmentId !== undefined && assessmentId !== null)
            url_ += "AssessmentId=" + encodeURIComponent("" + assessmentId) + "&";
        if (clientGroupId !== undefined && clientGroupId !== null)
            url_ += "ClientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportGET2(_response);
        });
    }

    protected processExportGET2(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getScore(id: number): Promise<ScoreDto> {
        let url_ = this.baseUrl + "/api/AssessmentReports/{id}/Score";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetScore(_response);
        });
    }

    protected processGetScore(response: Response): Promise<ScoreDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScoreDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScoreDto>(null as any);
    }
}

export interface IAssessmentsClient {

    export(assessmentId: number | null | undefined, questionCategoryId: number | null | undefined, assessmentTemplateId: number | null | undefined, clientUserId: string | null | undefined, clientGroupId: number | null | undefined, isIncludeDecedents: boolean | undefined, isCompleted: boolean | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<FileResponse>;

    exportReport(formId: number | undefined, clientGroupId: number | undefined, regenerateQuestionSlot: boolean | undefined): Promise<FileResponse>;

    sendAssessmentReminderBulk(command: SendAssessmentReminderBulkCommand): Promise<FileResponse>;

    send(assessmentId: number | null | undefined, questionCategoryId: number | null | undefined, assessmentTemplateId: number | null | undefined, clientUserId: string | null | undefined, clientGroupId: number | null | undefined, isIncludeDecedents: boolean | undefined, isCompleted: boolean | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<FileResponse>;
}

export class AssessmentsClient extends AuthorizedApiBase implements IAssessmentsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    export(assessmentId: number | null | undefined, questionCategoryId: number | null | undefined, assessmentTemplateId: number | null | undefined, clientUserId: string | null | undefined, clientGroupId: number | null | undefined, isIncludeDecedents: boolean | undefined, isCompleted: boolean | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Assessments/Export?";
        if (assessmentId !== undefined && assessmentId !== null)
            url_ += "AssessmentId=" + encodeURIComponent("" + assessmentId) + "&";
        if (questionCategoryId !== undefined && questionCategoryId !== null)
            url_ += "QuestionCategoryId=" + encodeURIComponent("" + questionCategoryId) + "&";
        if (assessmentTemplateId !== undefined && assessmentTemplateId !== null)
            url_ += "AssessmentTemplateId=" + encodeURIComponent("" + assessmentTemplateId) + "&";
        if (clientUserId !== undefined && clientUserId !== null)
            url_ += "ClientUserId=" + encodeURIComponent("" + clientUserId) + "&";
        if (clientGroupId !== undefined && clientGroupId !== null)
            url_ += "ClientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        if (isIncludeDecedents === null)
            throw new Error("The parameter 'isIncludeDecedents' cannot be null.");
        else if (isIncludeDecedents !== undefined)
            url_ += "IsIncludeDecedents=" + encodeURIComponent("" + isIncludeDecedents) + "&";
        if (isCompleted !== undefined && isCompleted !== null)
            url_ += "IsCompleted=" + encodeURIComponent("" + isCompleted) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    exportReport(formId: number | undefined, clientGroupId: number | undefined, regenerateQuestionSlot: boolean | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Assessments/Report/Export?";
        if (formId === null)
            throw new Error("The parameter 'formId' cannot be null.");
        else if (formId !== undefined)
            url_ += "FormId=" + encodeURIComponent("" + formId) + "&";
        if (clientGroupId === null)
            throw new Error("The parameter 'clientGroupId' cannot be null.");
        else if (clientGroupId !== undefined)
            url_ += "ClientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        if (regenerateQuestionSlot === null)
            throw new Error("The parameter 'regenerateQuestionSlot' cannot be null.");
        else if (regenerateQuestionSlot !== undefined)
            url_ += "RegenerateQuestionSlot=" + encodeURIComponent("" + regenerateQuestionSlot) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportReport(_response);
        });
    }

    protected processExportReport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    sendAssessmentReminderBulk(command: SendAssessmentReminderBulkCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Assessments/ReminderSendBulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendAssessmentReminderBulk(_response);
        });
    }

    protected processSendAssessmentReminderBulk(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    send(assessmentId: number | null | undefined, questionCategoryId: number | null | undefined, assessmentTemplateId: number | null | undefined, clientUserId: string | null | undefined, clientGroupId: number | null | undefined, isIncludeDecedents: boolean | undefined, isCompleted: boolean | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Assessments/Send";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (assessmentId !== null && assessmentId !== undefined)
            content_.append("AssessmentId", assessmentId.toString());
        if (questionCategoryId !== null && questionCategoryId !== undefined)
            content_.append("QuestionCategoryId", questionCategoryId.toString());
        if (assessmentTemplateId !== null && assessmentTemplateId !== undefined)
            content_.append("AssessmentTemplateId", assessmentTemplateId.toString());
        if (clientUserId !== null && clientUserId !== undefined)
            content_.append("ClientUserId", clientUserId.toString());
        if (clientGroupId !== null && clientGroupId !== undefined)
            content_.append("ClientGroupId", clientGroupId.toString());
        if (isIncludeDecedents === null || isIncludeDecedents === undefined)
            throw new Error("The parameter 'isIncludeDecedents' cannot be null.");
        else
            content_.append("IsIncludeDecedents", isIncludeDecedents.toString());
        if (isCompleted !== null && isCompleted !== undefined)
            content_.append("IsCompleted", isCompleted.toString());
        if (pageNumber === null || pageNumber === undefined)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else
            content_.append("PageNumber", pageNumber.toString());
        if (pageSize === null || pageSize === undefined)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else
            content_.append("PageSize", pageSize.toString());
        if (orderBy !== null && orderBy !== undefined)
            content_.append("OrderBy", orderBy.toString());
        if (isOrderByAsc === null || isOrderByAsc === undefined)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else
            content_.append("IsOrderByAsc", isOrderByAsc.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSend(_response);
        });
    }

    protected processSend(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IAssessmentTemplatesClient {

    get(id: number): Promise<AssessmentTemplateDto>;

    update(id: number, command: UpdateAssessmentTemplateCommand): Promise<FileResponse>;

    delete(id: number): Promise<FileResponse>;

    getAssessmentTemplatesWithPagination(keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfAssessmentTemplateBriefDto>;

    create(command: CreateAssessmentTemplateCommand): Promise<number>;

    getAssessmentTemplateFormsWithPagination(keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfAssessmentTemplateFormBriefDto>;

    upload(file: FileParameter | null | undefined): Promise<number>;

    export(): Promise<FileResponse>;

    exportDescriptions(): Promise<FileResponse>;

    uploadDescriptions(file: FileParameter | null | undefined): Promise<number>;

    exportForms(): Promise<FileResponse>;

    uploadForms(file: FileParameter | null | undefined): Promise<number>;

    getAssessmentTemplateList(): Promise<AssessmentTemplateBriefListDto[]>;
}

export class AssessmentTemplatesClient extends AuthorizedApiBase implements IAssessmentTemplatesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    get(id: number): Promise<AssessmentTemplateDto> {
        let url_ = this.baseUrl + "/api/AssessmentTemplates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<AssessmentTemplateDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssessmentTemplateDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssessmentTemplateDto>(null as any);
    }

    update(id: number, command: UpdateAssessmentTemplateCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/AssessmentTemplates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    delete(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/AssessmentTemplates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getAssessmentTemplatesWithPagination(keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfAssessmentTemplateBriefDto> {
        let url_ = this.baseUrl + "/api/AssessmentTemplates?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAssessmentTemplatesWithPagination(_response);
        });
    }

    protected processGetAssessmentTemplatesWithPagination(response: Response): Promise<PaginatedListOfAssessmentTemplateBriefDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfAssessmentTemplateBriefDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfAssessmentTemplateBriefDto>(null as any);
    }

    create(command: CreateAssessmentTemplateCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/AssessmentTemplates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getAssessmentTemplateFormsWithPagination(keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfAssessmentTemplateFormBriefDto> {
        let url_ = this.baseUrl + "/api/AssessmentTemplates/Form?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAssessmentTemplateFormsWithPagination(_response);
        });
    }

    protected processGetAssessmentTemplateFormsWithPagination(response: Response): Promise<PaginatedListOfAssessmentTemplateFormBriefDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfAssessmentTemplateFormBriefDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfAssessmentTemplateFormBriefDto>(null as any);
    }

    upload(file: FileParameter | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/AssessmentTemplates/Upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    export(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/AssessmentTemplates/Export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    exportDescriptions(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/AssessmentTemplates/Description/Export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportDescriptions(_response);
        });
    }

    protected processExportDescriptions(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    uploadDescriptions(file: FileParameter | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/AssessmentTemplates/Description/Upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadDescriptions(_response);
        });
    }

    protected processUploadDescriptions(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    exportForms(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/AssessmentTemplates/Form/Export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportForms(_response);
        });
    }

    protected processExportForms(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    uploadForms(file: FileParameter | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/AssessmentTemplates/Form/Upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadForms(_response);
        });
    }

    protected processUploadForms(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getAssessmentTemplateList(): Promise<AssessmentTemplateBriefListDto[]> {
        let url_ = this.baseUrl + "/api/AssessmentTemplates/GetAssessmentTemplateList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAssessmentTemplateList(_response);
        });
    }

    protected processGetAssessmentTemplateList(response: Response): Promise<AssessmentTemplateBriefListDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssessmentTemplateBriefListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssessmentTemplateBriefListDto[]>(null as any);
    }
}

export interface IAuthorizationClient {

    authorizeGET(): Promise<FileResponse>;

    authorizePOST(): Promise<FileResponse>;

    exchangePOST(): Promise<FileResponse>;

    exchangeGET(): Promise<FileResponse>;

    logoutGET(): Promise<FileResponse>;

    logoutPOST(): Promise<FileResponse>;

    logoutGET2(): Promise<FileResponse>;

    logoutPOST2(): Promise<FileResponse>;
}

export class AuthorizationClient extends AuthorizedApiBase implements IAuthorizationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    authorizeGET(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/connect/authorize";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAuthorizeGET(_response);
        });
    }

    protected processAuthorizeGET(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    authorizePOST(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/connect/authorize";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAuthorizePOST(_response);
        });
    }

    protected processAuthorizePOST(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    exchangePOST(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/connect/token";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExchangePOST(_response);
        });
    }

    protected processExchangePOST(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    exchangeGET(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/connect/token";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExchangeGET(_response);
        });
    }

    protected processExchangeGET(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    logoutGET(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/connect/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLogoutGET(_response);
        });
    }

    protected processLogoutGET(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    logoutPOST(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/connect/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLogoutPOST(_response);
        });
    }

    protected processLogoutPOST(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    logoutGET2(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/connect/endsession";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLogoutGET2(_response);
        });
    }

    protected processLogoutGET2(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    logoutPOST2(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/connect/endsession";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLogoutPOST2(_response);
        });
    }

    protected processLogoutPOST2(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IBillingInformationsClient {

    getBillingInformationAssessmentWithPaginationQuery(keyword: string | null | undefined, clientGroupId: number | null | undefined, assessmentTemplateId: number | null | undefined, isProgessComplete: boolean | null | undefined, userAddedTimeStartDate: Date | null | undefined, userAddedTimeEndDate: Date | null | undefined, startTimeStartDate: Date | null | undefined, startTimeEndDate: Date | null | undefined, endTimeStartDate: Date | null | undefined, endTimeEndDate: Date | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfAssessmentDto>;

    exportBillingInformationAssessment(keyword: string | null | undefined, clientGroupId: number | null | undefined, assessmentTemplateId: number | null | undefined, isProgessComplete: boolean | null | undefined, userAddedTimeStartDate: Date | null | undefined, userAddedTimeEndDate: Date | null | undefined, startTimeStartDate: Date | null | undefined, startTimeEndDate: Date | null | undefined, endTimeStartDate: Date | null | undefined, endTimeEndDate: Date | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<FileResponse>;

    getBillingInformationAssessmentSummaryQuery(keyword: string | null | undefined, clientGroupId: number | undefined, assessmentTemplateId: number | undefined, isProgessComplete: boolean | null | undefined, userAddedTimeStartDate: Date | null | undefined, userAddedTimeEndDate: Date | null | undefined, startTimeStartDate: Date | null | undefined, startTimeEndDate: Date | null | undefined, endTimeStartDate: Date | null | undefined, endTimeEndDate: Date | null | undefined): Promise<AssessmentSummaryDto>;

    getBillingInformationAssessmentSummaryListWithPaginationQuery(keyword: string | null | undefined, assessmentTemplateId: number | null | undefined, clientGroupId: number | null | undefined, isProgessComplete: boolean | null | undefined, userAddedTimeStartDate: Date | null | undefined, userAddedTimeEndDate: Date | null | undefined, startTimeStartDate: Date | null | undefined, startTimeEndDate: Date | null | undefined, endTimeStartDate: Date | null | undefined, endTimeEndDate: Date | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfAssessmentSummaryDto>;

    exportillingInformationAssessmentSummaryList(keyword: string | null | undefined, assessmentTemplateId: number | null | undefined, clientGroupId: number | null | undefined, isProgessComplete: boolean | null | undefined, userAddedTimeStartDate: Date | null | undefined, userAddedTimeEndDate: Date | null | undefined, startTimeStartDate: Date | null | undefined, startTimeEndDate: Date | null | undefined, endTimeStartDate: Date | null | undefined, endTimeEndDate: Date | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<FileResponse>;

    getBillingInformationCourseWithPaginationQuery(keyword: string | null | undefined, clientGroupId: number | null | undefined, courseId: number | null | undefined, isProgessComplete: boolean | null | undefined, userAddedTimeStartDate: Date | null | undefined, userAddedTimeEndDate: Date | null | undefined, startTimeStartDate: Date | null | undefined, startTimeEndDate: Date | null | undefined, endTimeStartDate: Date | null | undefined, endTimeEndDate: Date | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfCourseDto>;

    exportBillingInformationCourse(keyword: string | null | undefined, clientGroupId: number | null | undefined, courseId: number | null | undefined, isProgessComplete: boolean | null | undefined, userAddedTimeStartDate: Date | null | undefined, userAddedTimeEndDate: Date | null | undefined, startTimeStartDate: Date | null | undefined, startTimeEndDate: Date | null | undefined, endTimeStartDate: Date | null | undefined, endTimeEndDate: Date | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<FileResponse>;

    getBillingInformationCourseSummaryListWithPaginationQuery(keyword: string | null | undefined, courseId: number | null | undefined, clientGroupId: number | null | undefined, isProgessComplete: boolean | null | undefined, userAddedTimeStartDate: Date | null | undefined, userAddedTimeEndDate: Date | null | undefined, startTimeStartDate: Date | null | undefined, startTimeEndDate: Date | null | undefined, endTimeStartDate: Date | null | undefined, endTimeEndDate: Date | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfCourseSummaryDto>;

    exportBillingInformationCourseSummaryList(keyword: string | null | undefined, courseId: number | null | undefined, clientGroupId: number | null | undefined, isProgessComplete: boolean | null | undefined, userAddedTimeStartDate: Date | null | undefined, userAddedTimeEndDate: Date | null | undefined, startTimeStartDate: Date | null | undefined, startTimeEndDate: Date | null | undefined, endTimeStartDate: Date | null | undefined, endTimeEndDate: Date | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<FileResponse>;

    getBillingInformationReportWithPaginationQuery(keyword: string | null | undefined, clientGroupId: number | null | undefined, reportTemplateId: number | null | undefined, userAddedTimeStartDate: Date | null | undefined, userAddedTimeEndDate: Date | null | undefined, generateTimeStartDate: Date | null | undefined, generateTimeEndDate: Date | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfReportDto>;

    exportBillingInformationReport(keyword: string | null | undefined, clientGroupId: number | null | undefined, reportTemplateId: number | null | undefined, userAddedTimeStartDate: Date | null | undefined, userAddedTimeEndDate: Date | null | undefined, generateTimeStartDate: Date | null | undefined, generateTimeEndDate: Date | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<FileResponse>;

    getBillingInformationReportSummaryQuery(keyword: string | null | undefined, clientGroupId: number | null | undefined, reportTemplateId: number | null | undefined, userAddedTimeStartDate: Date | null | undefined, userAddedTimeEndDate: Date | null | undefined, generateTimeStartDate: Date | null | undefined, generateTimeEndDate: Date | null | undefined): Promise<ReportSummaryDto>;

    getBillingInformationReportSummaryListWithPaginationQuery(keyword: string | null | undefined, clientGroupId: number | null | undefined, reportTemplateId: number[] | null | undefined, reportTemplateDisplayName: string | null | undefined, userAddedTimeStartDate: Date | null | undefined, userAddedTimeEndDate: Date | null | undefined, generateTimeStartDate: Date | null | undefined, generateTimeEndDate: Date | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfReportSummaryDto>;

    exportBillingInformationReportSummaryListQuery(keyword: string | null | undefined, clientGroupId: number | null | undefined, reportTemplateId: number[] | null | undefined, reportTemplateDisplayName: string | null | undefined, userAddedTimeStartDate: Date | null | undefined, userAddedTimeEndDate: Date | null | undefined, generateTimeStartDate: Date | null | undefined, generateTimeEndDate: Date | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<FileResponse>;

    getBillingInformationGroupReportWithPaginationQuery(keyword: string | null | undefined, clientGroupId: number | null | undefined, groupReportTemplateId: number | null | undefined, generateTimeStartDate: Date | null | undefined, generateTimeEndDate: Date | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfGroupReportDto>;

    exportBillingInformationGroupReport(keyword: string | null | undefined, clientGroupId: number | null | undefined, groupReportTemplateId: number | null | undefined, generateTimeStartDate: Date | null | undefined, generateTimeEndDate: Date | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<FileResponse>;

    getBillingInformationGroupReportSummaryQuery(keyword: string | null | undefined, clientGroupId: number | null | undefined, groupReportTemplateId: number | null | undefined, generateTimeStartDate: Date | null | undefined, generateTimeEndDate: Date | null | undefined): Promise<GroupReportSummaryDto>;

    getBillingInformationGroupReportSummaryListWithPaginationQuery(keyword: string | null | undefined, clientGroupId: number | null | undefined, groupReportTemplateId: number[] | null | undefined, groupReportTemplateDisplayName: string | null | undefined, generateTimeStartDate: Date | null | undefined, generateTimeEndDate: Date | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfGroupReportSummaryDto>;

    exportBillingInformationGroupReportSummaryListQuery(keyword: string | null | undefined, clientGroupId: number | null | undefined, groupReportTemplateId: number[] | null | undefined, groupReportTemplateDisplayName: string | null | undefined, generateTimeStartDate: Date | null | undefined, generateTimeEndDate: Date | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<FileResponse>;
}

export class BillingInformationsClient extends AuthorizedApiBase implements IBillingInformationsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getBillingInformationAssessmentWithPaginationQuery(keyword: string | null | undefined, clientGroupId: number | null | undefined, assessmentTemplateId: number | null | undefined, isProgessComplete: boolean | null | undefined, userAddedTimeStartDate: Date | null | undefined, userAddedTimeEndDate: Date | null | undefined, startTimeStartDate: Date | null | undefined, startTimeEndDate: Date | null | undefined, endTimeStartDate: Date | null | undefined, endTimeEndDate: Date | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfAssessmentDto> {
        let url_ = this.baseUrl + "/api/BillingInformations/Assessment?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (clientGroupId !== undefined && clientGroupId !== null)
            url_ += "ClientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        if (assessmentTemplateId !== undefined && assessmentTemplateId !== null)
            url_ += "AssessmentTemplateId=" + encodeURIComponent("" + assessmentTemplateId) + "&";
        if (isProgessComplete !== undefined && isProgessComplete !== null)
            url_ += "IsProgessComplete=" + encodeURIComponent("" + isProgessComplete) + "&";
        if (userAddedTimeStartDate !== undefined && userAddedTimeStartDate !== null)
            url_ += "UserAddedTimeStartDate=" + encodeURIComponent(userAddedTimeStartDate ? "" + userAddedTimeStartDate.toISOString() : "") + "&";
        if (userAddedTimeEndDate !== undefined && userAddedTimeEndDate !== null)
            url_ += "UserAddedTimeEndDate=" + encodeURIComponent(userAddedTimeEndDate ? "" + userAddedTimeEndDate.toISOString() : "") + "&";
        if (startTimeStartDate !== undefined && startTimeStartDate !== null)
            url_ += "StartTimeStartDate=" + encodeURIComponent(startTimeStartDate ? "" + startTimeStartDate.toISOString() : "") + "&";
        if (startTimeEndDate !== undefined && startTimeEndDate !== null)
            url_ += "StartTimeEndDate=" + encodeURIComponent(startTimeEndDate ? "" + startTimeEndDate.toISOString() : "") + "&";
        if (endTimeStartDate !== undefined && endTimeStartDate !== null)
            url_ += "EndTimeStartDate=" + encodeURIComponent(endTimeStartDate ? "" + endTimeStartDate.toISOString() : "") + "&";
        if (endTimeEndDate !== undefined && endTimeEndDate !== null)
            url_ += "EndTimeEndDate=" + encodeURIComponent(endTimeEndDate ? "" + endTimeEndDate.toISOString() : "") + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBillingInformationAssessmentWithPaginationQuery(_response);
        });
    }

    protected processGetBillingInformationAssessmentWithPaginationQuery(response: Response): Promise<PaginatedListOfAssessmentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfAssessmentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfAssessmentDto>(null as any);
    }

    exportBillingInformationAssessment(keyword: string | null | undefined, clientGroupId: number | null | undefined, assessmentTemplateId: number | null | undefined, isProgessComplete: boolean | null | undefined, userAddedTimeStartDate: Date | null | undefined, userAddedTimeEndDate: Date | null | undefined, startTimeStartDate: Date | null | undefined, startTimeEndDate: Date | null | undefined, endTimeStartDate: Date | null | undefined, endTimeEndDate: Date | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/BillingInformations/AssessmentExport?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (clientGroupId !== undefined && clientGroupId !== null)
            url_ += "ClientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        if (assessmentTemplateId !== undefined && assessmentTemplateId !== null)
            url_ += "AssessmentTemplateId=" + encodeURIComponent("" + assessmentTemplateId) + "&";
        if (isProgessComplete !== undefined && isProgessComplete !== null)
            url_ += "IsProgessComplete=" + encodeURIComponent("" + isProgessComplete) + "&";
        if (userAddedTimeStartDate !== undefined && userAddedTimeStartDate !== null)
            url_ += "UserAddedTimeStartDate=" + encodeURIComponent(userAddedTimeStartDate ? "" + userAddedTimeStartDate.toISOString() : "") + "&";
        if (userAddedTimeEndDate !== undefined && userAddedTimeEndDate !== null)
            url_ += "UserAddedTimeEndDate=" + encodeURIComponent(userAddedTimeEndDate ? "" + userAddedTimeEndDate.toISOString() : "") + "&";
        if (startTimeStartDate !== undefined && startTimeStartDate !== null)
            url_ += "StartTimeStartDate=" + encodeURIComponent(startTimeStartDate ? "" + startTimeStartDate.toISOString() : "") + "&";
        if (startTimeEndDate !== undefined && startTimeEndDate !== null)
            url_ += "StartTimeEndDate=" + encodeURIComponent(startTimeEndDate ? "" + startTimeEndDate.toISOString() : "") + "&";
        if (endTimeStartDate !== undefined && endTimeStartDate !== null)
            url_ += "EndTimeStartDate=" + encodeURIComponent(endTimeStartDate ? "" + endTimeStartDate.toISOString() : "") + "&";
        if (endTimeEndDate !== undefined && endTimeEndDate !== null)
            url_ += "EndTimeEndDate=" + encodeURIComponent(endTimeEndDate ? "" + endTimeEndDate.toISOString() : "") + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportBillingInformationAssessment(_response);
        });
    }

    protected processExportBillingInformationAssessment(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getBillingInformationAssessmentSummaryQuery(keyword: string | null | undefined, clientGroupId: number | undefined, assessmentTemplateId: number | undefined, isProgessComplete: boolean | null | undefined, userAddedTimeStartDate: Date | null | undefined, userAddedTimeEndDate: Date | null | undefined, startTimeStartDate: Date | null | undefined, startTimeEndDate: Date | null | undefined, endTimeStartDate: Date | null | undefined, endTimeEndDate: Date | null | undefined): Promise<AssessmentSummaryDto> {
        let url_ = this.baseUrl + "/api/BillingInformations/AssessmentSummary?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (clientGroupId === null)
            throw new Error("The parameter 'clientGroupId' cannot be null.");
        else if (clientGroupId !== undefined)
            url_ += "ClientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        if (assessmentTemplateId === null)
            throw new Error("The parameter 'assessmentTemplateId' cannot be null.");
        else if (assessmentTemplateId !== undefined)
            url_ += "AssessmentTemplateId=" + encodeURIComponent("" + assessmentTemplateId) + "&";
        if (isProgessComplete !== undefined && isProgessComplete !== null)
            url_ += "IsProgessComplete=" + encodeURIComponent("" + isProgessComplete) + "&";
        if (userAddedTimeStartDate !== undefined && userAddedTimeStartDate !== null)
            url_ += "UserAddedTimeStartDate=" + encodeURIComponent(userAddedTimeStartDate ? "" + userAddedTimeStartDate.toISOString() : "") + "&";
        if (userAddedTimeEndDate !== undefined && userAddedTimeEndDate !== null)
            url_ += "UserAddedTimeEndDate=" + encodeURIComponent(userAddedTimeEndDate ? "" + userAddedTimeEndDate.toISOString() : "") + "&";
        if (startTimeStartDate !== undefined && startTimeStartDate !== null)
            url_ += "StartTimeStartDate=" + encodeURIComponent(startTimeStartDate ? "" + startTimeStartDate.toISOString() : "") + "&";
        if (startTimeEndDate !== undefined && startTimeEndDate !== null)
            url_ += "StartTimeEndDate=" + encodeURIComponent(startTimeEndDate ? "" + startTimeEndDate.toISOString() : "") + "&";
        if (endTimeStartDate !== undefined && endTimeStartDate !== null)
            url_ += "EndTimeStartDate=" + encodeURIComponent(endTimeStartDate ? "" + endTimeStartDate.toISOString() : "") + "&";
        if (endTimeEndDate !== undefined && endTimeEndDate !== null)
            url_ += "EndTimeEndDate=" + encodeURIComponent(endTimeEndDate ? "" + endTimeEndDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBillingInformationAssessmentSummaryQuery(_response);
        });
    }

    protected processGetBillingInformationAssessmentSummaryQuery(response: Response): Promise<AssessmentSummaryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssessmentSummaryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssessmentSummaryDto>(null as any);
    }

    getBillingInformationAssessmentSummaryListWithPaginationQuery(keyword: string | null | undefined, assessmentTemplateId: number | null | undefined, clientGroupId: number | null | undefined, isProgessComplete: boolean | null | undefined, userAddedTimeStartDate: Date | null | undefined, userAddedTimeEndDate: Date | null | undefined, startTimeStartDate: Date | null | undefined, startTimeEndDate: Date | null | undefined, endTimeStartDate: Date | null | undefined, endTimeEndDate: Date | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfAssessmentSummaryDto> {
        let url_ = this.baseUrl + "/api/BillingInformations/AssessmentSummaryList?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (assessmentTemplateId !== undefined && assessmentTemplateId !== null)
            url_ += "AssessmentTemplateId=" + encodeURIComponent("" + assessmentTemplateId) + "&";
        if (clientGroupId !== undefined && clientGroupId !== null)
            url_ += "ClientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        if (isProgessComplete !== undefined && isProgessComplete !== null)
            url_ += "IsProgessComplete=" + encodeURIComponent("" + isProgessComplete) + "&";
        if (userAddedTimeStartDate !== undefined && userAddedTimeStartDate !== null)
            url_ += "UserAddedTimeStartDate=" + encodeURIComponent(userAddedTimeStartDate ? "" + userAddedTimeStartDate.toISOString() : "") + "&";
        if (userAddedTimeEndDate !== undefined && userAddedTimeEndDate !== null)
            url_ += "UserAddedTimeEndDate=" + encodeURIComponent(userAddedTimeEndDate ? "" + userAddedTimeEndDate.toISOString() : "") + "&";
        if (startTimeStartDate !== undefined && startTimeStartDate !== null)
            url_ += "StartTimeStartDate=" + encodeURIComponent(startTimeStartDate ? "" + startTimeStartDate.toISOString() : "") + "&";
        if (startTimeEndDate !== undefined && startTimeEndDate !== null)
            url_ += "StartTimeEndDate=" + encodeURIComponent(startTimeEndDate ? "" + startTimeEndDate.toISOString() : "") + "&";
        if (endTimeStartDate !== undefined && endTimeStartDate !== null)
            url_ += "EndTimeStartDate=" + encodeURIComponent(endTimeStartDate ? "" + endTimeStartDate.toISOString() : "") + "&";
        if (endTimeEndDate !== undefined && endTimeEndDate !== null)
            url_ += "EndTimeEndDate=" + encodeURIComponent(endTimeEndDate ? "" + endTimeEndDate.toISOString() : "") + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBillingInformationAssessmentSummaryListWithPaginationQuery(_response);
        });
    }

    protected processGetBillingInformationAssessmentSummaryListWithPaginationQuery(response: Response): Promise<PaginatedListOfAssessmentSummaryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfAssessmentSummaryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfAssessmentSummaryDto>(null as any);
    }

    exportillingInformationAssessmentSummaryList(keyword: string | null | undefined, assessmentTemplateId: number | null | undefined, clientGroupId: number | null | undefined, isProgessComplete: boolean | null | undefined, userAddedTimeStartDate: Date | null | undefined, userAddedTimeEndDate: Date | null | undefined, startTimeStartDate: Date | null | undefined, startTimeEndDate: Date | null | undefined, endTimeStartDate: Date | null | undefined, endTimeEndDate: Date | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/BillingInformations/AssessmentSummaryListExport?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (assessmentTemplateId !== undefined && assessmentTemplateId !== null)
            url_ += "AssessmentTemplateId=" + encodeURIComponent("" + assessmentTemplateId) + "&";
        if (clientGroupId !== undefined && clientGroupId !== null)
            url_ += "ClientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        if (isProgessComplete !== undefined && isProgessComplete !== null)
            url_ += "IsProgessComplete=" + encodeURIComponent("" + isProgessComplete) + "&";
        if (userAddedTimeStartDate !== undefined && userAddedTimeStartDate !== null)
            url_ += "UserAddedTimeStartDate=" + encodeURIComponent(userAddedTimeStartDate ? "" + userAddedTimeStartDate.toISOString() : "") + "&";
        if (userAddedTimeEndDate !== undefined && userAddedTimeEndDate !== null)
            url_ += "UserAddedTimeEndDate=" + encodeURIComponent(userAddedTimeEndDate ? "" + userAddedTimeEndDate.toISOString() : "") + "&";
        if (startTimeStartDate !== undefined && startTimeStartDate !== null)
            url_ += "StartTimeStartDate=" + encodeURIComponent(startTimeStartDate ? "" + startTimeStartDate.toISOString() : "") + "&";
        if (startTimeEndDate !== undefined && startTimeEndDate !== null)
            url_ += "StartTimeEndDate=" + encodeURIComponent(startTimeEndDate ? "" + startTimeEndDate.toISOString() : "") + "&";
        if (endTimeStartDate !== undefined && endTimeStartDate !== null)
            url_ += "EndTimeStartDate=" + encodeURIComponent(endTimeStartDate ? "" + endTimeStartDate.toISOString() : "") + "&";
        if (endTimeEndDate !== undefined && endTimeEndDate !== null)
            url_ += "EndTimeEndDate=" + encodeURIComponent(endTimeEndDate ? "" + endTimeEndDate.toISOString() : "") + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportillingInformationAssessmentSummaryList(_response);
        });
    }

    protected processExportillingInformationAssessmentSummaryList(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getBillingInformationCourseWithPaginationQuery(keyword: string | null | undefined, clientGroupId: number | null | undefined, courseId: number | null | undefined, isProgessComplete: boolean | null | undefined, userAddedTimeStartDate: Date | null | undefined, userAddedTimeEndDate: Date | null | undefined, startTimeStartDate: Date | null | undefined, startTimeEndDate: Date | null | undefined, endTimeStartDate: Date | null | undefined, endTimeEndDate: Date | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfCourseDto> {
        let url_ = this.baseUrl + "/api/BillingInformations/Course?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (clientGroupId !== undefined && clientGroupId !== null)
            url_ += "ClientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        if (courseId !== undefined && courseId !== null)
            url_ += "CourseId=" + encodeURIComponent("" + courseId) + "&";
        if (isProgessComplete !== undefined && isProgessComplete !== null)
            url_ += "IsProgessComplete=" + encodeURIComponent("" + isProgessComplete) + "&";
        if (userAddedTimeStartDate !== undefined && userAddedTimeStartDate !== null)
            url_ += "UserAddedTimeStartDate=" + encodeURIComponent(userAddedTimeStartDate ? "" + userAddedTimeStartDate.toISOString() : "") + "&";
        if (userAddedTimeEndDate !== undefined && userAddedTimeEndDate !== null)
            url_ += "UserAddedTimeEndDate=" + encodeURIComponent(userAddedTimeEndDate ? "" + userAddedTimeEndDate.toISOString() : "") + "&";
        if (startTimeStartDate !== undefined && startTimeStartDate !== null)
            url_ += "StartTimeStartDate=" + encodeURIComponent(startTimeStartDate ? "" + startTimeStartDate.toISOString() : "") + "&";
        if (startTimeEndDate !== undefined && startTimeEndDate !== null)
            url_ += "StartTimeEndDate=" + encodeURIComponent(startTimeEndDate ? "" + startTimeEndDate.toISOString() : "") + "&";
        if (endTimeStartDate !== undefined && endTimeStartDate !== null)
            url_ += "EndTimeStartDate=" + encodeURIComponent(endTimeStartDate ? "" + endTimeStartDate.toISOString() : "") + "&";
        if (endTimeEndDate !== undefined && endTimeEndDate !== null)
            url_ += "EndTimeEndDate=" + encodeURIComponent(endTimeEndDate ? "" + endTimeEndDate.toISOString() : "") + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBillingInformationCourseWithPaginationQuery(_response);
        });
    }

    protected processGetBillingInformationCourseWithPaginationQuery(response: Response): Promise<PaginatedListOfCourseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfCourseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfCourseDto>(null as any);
    }

    exportBillingInformationCourse(keyword: string | null | undefined, clientGroupId: number | null | undefined, courseId: number | null | undefined, isProgessComplete: boolean | null | undefined, userAddedTimeStartDate: Date | null | undefined, userAddedTimeEndDate: Date | null | undefined, startTimeStartDate: Date | null | undefined, startTimeEndDate: Date | null | undefined, endTimeStartDate: Date | null | undefined, endTimeEndDate: Date | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/BillingInformations/CourseExport?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (clientGroupId !== undefined && clientGroupId !== null)
            url_ += "ClientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        if (courseId !== undefined && courseId !== null)
            url_ += "CourseId=" + encodeURIComponent("" + courseId) + "&";
        if (isProgessComplete !== undefined && isProgessComplete !== null)
            url_ += "IsProgessComplete=" + encodeURIComponent("" + isProgessComplete) + "&";
        if (userAddedTimeStartDate !== undefined && userAddedTimeStartDate !== null)
            url_ += "UserAddedTimeStartDate=" + encodeURIComponent(userAddedTimeStartDate ? "" + userAddedTimeStartDate.toISOString() : "") + "&";
        if (userAddedTimeEndDate !== undefined && userAddedTimeEndDate !== null)
            url_ += "UserAddedTimeEndDate=" + encodeURIComponent(userAddedTimeEndDate ? "" + userAddedTimeEndDate.toISOString() : "") + "&";
        if (startTimeStartDate !== undefined && startTimeStartDate !== null)
            url_ += "StartTimeStartDate=" + encodeURIComponent(startTimeStartDate ? "" + startTimeStartDate.toISOString() : "") + "&";
        if (startTimeEndDate !== undefined && startTimeEndDate !== null)
            url_ += "StartTimeEndDate=" + encodeURIComponent(startTimeEndDate ? "" + startTimeEndDate.toISOString() : "") + "&";
        if (endTimeStartDate !== undefined && endTimeStartDate !== null)
            url_ += "EndTimeStartDate=" + encodeURIComponent(endTimeStartDate ? "" + endTimeStartDate.toISOString() : "") + "&";
        if (endTimeEndDate !== undefined && endTimeEndDate !== null)
            url_ += "EndTimeEndDate=" + encodeURIComponent(endTimeEndDate ? "" + endTimeEndDate.toISOString() : "") + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportBillingInformationCourse(_response);
        });
    }

    protected processExportBillingInformationCourse(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getBillingInformationCourseSummaryListWithPaginationQuery(keyword: string | null | undefined, courseId: number | null | undefined, clientGroupId: number | null | undefined, isProgessComplete: boolean | null | undefined, userAddedTimeStartDate: Date | null | undefined, userAddedTimeEndDate: Date | null | undefined, startTimeStartDate: Date | null | undefined, startTimeEndDate: Date | null | undefined, endTimeStartDate: Date | null | undefined, endTimeEndDate: Date | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfCourseSummaryDto> {
        let url_ = this.baseUrl + "/api/BillingInformations/CourseSummaryList?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (courseId !== undefined && courseId !== null)
            url_ += "CourseId=" + encodeURIComponent("" + courseId) + "&";
        if (clientGroupId !== undefined && clientGroupId !== null)
            url_ += "ClientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        if (isProgessComplete !== undefined && isProgessComplete !== null)
            url_ += "IsProgessComplete=" + encodeURIComponent("" + isProgessComplete) + "&";
        if (userAddedTimeStartDate !== undefined && userAddedTimeStartDate !== null)
            url_ += "UserAddedTimeStartDate=" + encodeURIComponent(userAddedTimeStartDate ? "" + userAddedTimeStartDate.toISOString() : "") + "&";
        if (userAddedTimeEndDate !== undefined && userAddedTimeEndDate !== null)
            url_ += "UserAddedTimeEndDate=" + encodeURIComponent(userAddedTimeEndDate ? "" + userAddedTimeEndDate.toISOString() : "") + "&";
        if (startTimeStartDate !== undefined && startTimeStartDate !== null)
            url_ += "StartTimeStartDate=" + encodeURIComponent(startTimeStartDate ? "" + startTimeStartDate.toISOString() : "") + "&";
        if (startTimeEndDate !== undefined && startTimeEndDate !== null)
            url_ += "StartTimeEndDate=" + encodeURIComponent(startTimeEndDate ? "" + startTimeEndDate.toISOString() : "") + "&";
        if (endTimeStartDate !== undefined && endTimeStartDate !== null)
            url_ += "EndTimeStartDate=" + encodeURIComponent(endTimeStartDate ? "" + endTimeStartDate.toISOString() : "") + "&";
        if (endTimeEndDate !== undefined && endTimeEndDate !== null)
            url_ += "EndTimeEndDate=" + encodeURIComponent(endTimeEndDate ? "" + endTimeEndDate.toISOString() : "") + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBillingInformationCourseSummaryListWithPaginationQuery(_response);
        });
    }

    protected processGetBillingInformationCourseSummaryListWithPaginationQuery(response: Response): Promise<PaginatedListOfCourseSummaryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfCourseSummaryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfCourseSummaryDto>(null as any);
    }

    exportBillingInformationCourseSummaryList(keyword: string | null | undefined, courseId: number | null | undefined, clientGroupId: number | null | undefined, isProgessComplete: boolean | null | undefined, userAddedTimeStartDate: Date | null | undefined, userAddedTimeEndDate: Date | null | undefined, startTimeStartDate: Date | null | undefined, startTimeEndDate: Date | null | undefined, endTimeStartDate: Date | null | undefined, endTimeEndDate: Date | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/BillingInformations/CourseSummaryListExport?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (courseId !== undefined && courseId !== null)
            url_ += "CourseId=" + encodeURIComponent("" + courseId) + "&";
        if (clientGroupId !== undefined && clientGroupId !== null)
            url_ += "ClientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        if (isProgessComplete !== undefined && isProgessComplete !== null)
            url_ += "IsProgessComplete=" + encodeURIComponent("" + isProgessComplete) + "&";
        if (userAddedTimeStartDate !== undefined && userAddedTimeStartDate !== null)
            url_ += "UserAddedTimeStartDate=" + encodeURIComponent(userAddedTimeStartDate ? "" + userAddedTimeStartDate.toISOString() : "") + "&";
        if (userAddedTimeEndDate !== undefined && userAddedTimeEndDate !== null)
            url_ += "UserAddedTimeEndDate=" + encodeURIComponent(userAddedTimeEndDate ? "" + userAddedTimeEndDate.toISOString() : "") + "&";
        if (startTimeStartDate !== undefined && startTimeStartDate !== null)
            url_ += "StartTimeStartDate=" + encodeURIComponent(startTimeStartDate ? "" + startTimeStartDate.toISOString() : "") + "&";
        if (startTimeEndDate !== undefined && startTimeEndDate !== null)
            url_ += "StartTimeEndDate=" + encodeURIComponent(startTimeEndDate ? "" + startTimeEndDate.toISOString() : "") + "&";
        if (endTimeStartDate !== undefined && endTimeStartDate !== null)
            url_ += "EndTimeStartDate=" + encodeURIComponent(endTimeStartDate ? "" + endTimeStartDate.toISOString() : "") + "&";
        if (endTimeEndDate !== undefined && endTimeEndDate !== null)
            url_ += "EndTimeEndDate=" + encodeURIComponent(endTimeEndDate ? "" + endTimeEndDate.toISOString() : "") + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportBillingInformationCourseSummaryList(_response);
        });
    }

    protected processExportBillingInformationCourseSummaryList(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getBillingInformationReportWithPaginationQuery(keyword: string | null | undefined, clientGroupId: number | null | undefined, reportTemplateId: number | null | undefined, userAddedTimeStartDate: Date | null | undefined, userAddedTimeEndDate: Date | null | undefined, generateTimeStartDate: Date | null | undefined, generateTimeEndDate: Date | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfReportDto> {
        let url_ = this.baseUrl + "/api/BillingInformations/Report?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (clientGroupId !== undefined && clientGroupId !== null)
            url_ += "ClientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        if (reportTemplateId !== undefined && reportTemplateId !== null)
            url_ += "ReportTemplateId=" + encodeURIComponent("" + reportTemplateId) + "&";
        if (userAddedTimeStartDate !== undefined && userAddedTimeStartDate !== null)
            url_ += "UserAddedTimeStartDate=" + encodeURIComponent(userAddedTimeStartDate ? "" + userAddedTimeStartDate.toISOString() : "") + "&";
        if (userAddedTimeEndDate !== undefined && userAddedTimeEndDate !== null)
            url_ += "UserAddedTimeEndDate=" + encodeURIComponent(userAddedTimeEndDate ? "" + userAddedTimeEndDate.toISOString() : "") + "&";
        if (generateTimeStartDate !== undefined && generateTimeStartDate !== null)
            url_ += "GenerateTimeStartDate=" + encodeURIComponent(generateTimeStartDate ? "" + generateTimeStartDate.toISOString() : "") + "&";
        if (generateTimeEndDate !== undefined && generateTimeEndDate !== null)
            url_ += "GenerateTimeEndDate=" + encodeURIComponent(generateTimeEndDate ? "" + generateTimeEndDate.toISOString() : "") + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBillingInformationReportWithPaginationQuery(_response);
        });
    }

    protected processGetBillingInformationReportWithPaginationQuery(response: Response): Promise<PaginatedListOfReportDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfReportDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfReportDto>(null as any);
    }

    exportBillingInformationReport(keyword: string | null | undefined, clientGroupId: number | null | undefined, reportTemplateId: number | null | undefined, userAddedTimeStartDate: Date | null | undefined, userAddedTimeEndDate: Date | null | undefined, generateTimeStartDate: Date | null | undefined, generateTimeEndDate: Date | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/BillingInformations/ReportExport?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (clientGroupId !== undefined && clientGroupId !== null)
            url_ += "ClientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        if (reportTemplateId !== undefined && reportTemplateId !== null)
            url_ += "ReportTemplateId=" + encodeURIComponent("" + reportTemplateId) + "&";
        if (userAddedTimeStartDate !== undefined && userAddedTimeStartDate !== null)
            url_ += "UserAddedTimeStartDate=" + encodeURIComponent(userAddedTimeStartDate ? "" + userAddedTimeStartDate.toISOString() : "") + "&";
        if (userAddedTimeEndDate !== undefined && userAddedTimeEndDate !== null)
            url_ += "UserAddedTimeEndDate=" + encodeURIComponent(userAddedTimeEndDate ? "" + userAddedTimeEndDate.toISOString() : "") + "&";
        if (generateTimeStartDate !== undefined && generateTimeStartDate !== null)
            url_ += "GenerateTimeStartDate=" + encodeURIComponent(generateTimeStartDate ? "" + generateTimeStartDate.toISOString() : "") + "&";
        if (generateTimeEndDate !== undefined && generateTimeEndDate !== null)
            url_ += "GenerateTimeEndDate=" + encodeURIComponent(generateTimeEndDate ? "" + generateTimeEndDate.toISOString() : "") + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportBillingInformationReport(_response);
        });
    }

    protected processExportBillingInformationReport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getBillingInformationReportSummaryQuery(keyword: string | null | undefined, clientGroupId: number | null | undefined, reportTemplateId: number | null | undefined, userAddedTimeStartDate: Date | null | undefined, userAddedTimeEndDate: Date | null | undefined, generateTimeStartDate: Date | null | undefined, generateTimeEndDate: Date | null | undefined): Promise<ReportSummaryDto> {
        let url_ = this.baseUrl + "/api/BillingInformations/ReportSummary?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (clientGroupId !== undefined && clientGroupId !== null)
            url_ += "ClientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        if (reportTemplateId !== undefined && reportTemplateId !== null)
            url_ += "ReportTemplateId=" + encodeURIComponent("" + reportTemplateId) + "&";
        if (userAddedTimeStartDate !== undefined && userAddedTimeStartDate !== null)
            url_ += "UserAddedTimeStartDate=" + encodeURIComponent(userAddedTimeStartDate ? "" + userAddedTimeStartDate.toISOString() : "") + "&";
        if (userAddedTimeEndDate !== undefined && userAddedTimeEndDate !== null)
            url_ += "UserAddedTimeEndDate=" + encodeURIComponent(userAddedTimeEndDate ? "" + userAddedTimeEndDate.toISOString() : "") + "&";
        if (generateTimeStartDate !== undefined && generateTimeStartDate !== null)
            url_ += "GenerateTimeStartDate=" + encodeURIComponent(generateTimeStartDate ? "" + generateTimeStartDate.toISOString() : "") + "&";
        if (generateTimeEndDate !== undefined && generateTimeEndDate !== null)
            url_ += "GenerateTimeEndDate=" + encodeURIComponent(generateTimeEndDate ? "" + generateTimeEndDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBillingInformationReportSummaryQuery(_response);
        });
    }

    protected processGetBillingInformationReportSummaryQuery(response: Response): Promise<ReportSummaryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportSummaryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportSummaryDto>(null as any);
    }

    getBillingInformationReportSummaryListWithPaginationQuery(keyword: string | null | undefined, clientGroupId: number | null | undefined, reportTemplateId: number[] | null | undefined, reportTemplateDisplayName: string | null | undefined, userAddedTimeStartDate: Date | null | undefined, userAddedTimeEndDate: Date | null | undefined, generateTimeStartDate: Date | null | undefined, generateTimeEndDate: Date | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfReportSummaryDto> {
        let url_ = this.baseUrl + "/api/BillingInformations/ReportSummaryList?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (clientGroupId !== undefined && clientGroupId !== null)
            url_ += "ClientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        if (reportTemplateId !== undefined && reportTemplateId !== null)
            reportTemplateId && reportTemplateId.forEach(item => { url_ += "ReportTemplateId=" + encodeURIComponent("" + item) + "&"; });
        if (reportTemplateDisplayName !== undefined && reportTemplateDisplayName !== null)
            url_ += "ReportTemplateDisplayName=" + encodeURIComponent("" + reportTemplateDisplayName) + "&";
        if (userAddedTimeStartDate !== undefined && userAddedTimeStartDate !== null)
            url_ += "UserAddedTimeStartDate=" + encodeURIComponent(userAddedTimeStartDate ? "" + userAddedTimeStartDate.toISOString() : "") + "&";
        if (userAddedTimeEndDate !== undefined && userAddedTimeEndDate !== null)
            url_ += "UserAddedTimeEndDate=" + encodeURIComponent(userAddedTimeEndDate ? "" + userAddedTimeEndDate.toISOString() : "") + "&";
        if (generateTimeStartDate !== undefined && generateTimeStartDate !== null)
            url_ += "GenerateTimeStartDate=" + encodeURIComponent(generateTimeStartDate ? "" + generateTimeStartDate.toISOString() : "") + "&";
        if (generateTimeEndDate !== undefined && generateTimeEndDate !== null)
            url_ += "GenerateTimeEndDate=" + encodeURIComponent(generateTimeEndDate ? "" + generateTimeEndDate.toISOString() : "") + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBillingInformationReportSummaryListWithPaginationQuery(_response);
        });
    }

    protected processGetBillingInformationReportSummaryListWithPaginationQuery(response: Response): Promise<PaginatedListOfReportSummaryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfReportSummaryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfReportSummaryDto>(null as any);
    }

    exportBillingInformationReportSummaryListQuery(keyword: string | null | undefined, clientGroupId: number | null | undefined, reportTemplateId: number[] | null | undefined, reportTemplateDisplayName: string | null | undefined, userAddedTimeStartDate: Date | null | undefined, userAddedTimeEndDate: Date | null | undefined, generateTimeStartDate: Date | null | undefined, generateTimeEndDate: Date | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/BillingInformations/ReportSummaryListExport?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (clientGroupId !== undefined && clientGroupId !== null)
            url_ += "ClientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        if (reportTemplateId !== undefined && reportTemplateId !== null)
            reportTemplateId && reportTemplateId.forEach(item => { url_ += "ReportTemplateId=" + encodeURIComponent("" + item) + "&"; });
        if (reportTemplateDisplayName !== undefined && reportTemplateDisplayName !== null)
            url_ += "ReportTemplateDisplayName=" + encodeURIComponent("" + reportTemplateDisplayName) + "&";
        if (userAddedTimeStartDate !== undefined && userAddedTimeStartDate !== null)
            url_ += "UserAddedTimeStartDate=" + encodeURIComponent(userAddedTimeStartDate ? "" + userAddedTimeStartDate.toISOString() : "") + "&";
        if (userAddedTimeEndDate !== undefined && userAddedTimeEndDate !== null)
            url_ += "UserAddedTimeEndDate=" + encodeURIComponent(userAddedTimeEndDate ? "" + userAddedTimeEndDate.toISOString() : "") + "&";
        if (generateTimeStartDate !== undefined && generateTimeStartDate !== null)
            url_ += "GenerateTimeStartDate=" + encodeURIComponent(generateTimeStartDate ? "" + generateTimeStartDate.toISOString() : "") + "&";
        if (generateTimeEndDate !== undefined && generateTimeEndDate !== null)
            url_ += "GenerateTimeEndDate=" + encodeURIComponent(generateTimeEndDate ? "" + generateTimeEndDate.toISOString() : "") + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportBillingInformationReportSummaryListQuery(_response);
        });
    }

    protected processExportBillingInformationReportSummaryListQuery(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getBillingInformationGroupReportWithPaginationQuery(keyword: string | null | undefined, clientGroupId: number | null | undefined, groupReportTemplateId: number | null | undefined, generateTimeStartDate: Date | null | undefined, generateTimeEndDate: Date | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfGroupReportDto> {
        let url_ = this.baseUrl + "/api/BillingInformations/GroupReport?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (clientGroupId !== undefined && clientGroupId !== null)
            url_ += "ClientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        if (groupReportTemplateId !== undefined && groupReportTemplateId !== null)
            url_ += "GroupReportTemplateId=" + encodeURIComponent("" + groupReportTemplateId) + "&";
        if (generateTimeStartDate !== undefined && generateTimeStartDate !== null)
            url_ += "GenerateTimeStartDate=" + encodeURIComponent(generateTimeStartDate ? "" + generateTimeStartDate.toISOString() : "") + "&";
        if (generateTimeEndDate !== undefined && generateTimeEndDate !== null)
            url_ += "GenerateTimeEndDate=" + encodeURIComponent(generateTimeEndDate ? "" + generateTimeEndDate.toISOString() : "") + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBillingInformationGroupReportWithPaginationQuery(_response);
        });
    }

    protected processGetBillingInformationGroupReportWithPaginationQuery(response: Response): Promise<PaginatedListOfGroupReportDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfGroupReportDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfGroupReportDto>(null as any);
    }

    exportBillingInformationGroupReport(keyword: string | null | undefined, clientGroupId: number | null | undefined, groupReportTemplateId: number | null | undefined, generateTimeStartDate: Date | null | undefined, generateTimeEndDate: Date | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/BillingInformations/GroupReportExport?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (clientGroupId !== undefined && clientGroupId !== null)
            url_ += "ClientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        if (groupReportTemplateId !== undefined && groupReportTemplateId !== null)
            url_ += "GroupReportTemplateId=" + encodeURIComponent("" + groupReportTemplateId) + "&";
        if (generateTimeStartDate !== undefined && generateTimeStartDate !== null)
            url_ += "GenerateTimeStartDate=" + encodeURIComponent(generateTimeStartDate ? "" + generateTimeStartDate.toISOString() : "") + "&";
        if (generateTimeEndDate !== undefined && generateTimeEndDate !== null)
            url_ += "GenerateTimeEndDate=" + encodeURIComponent(generateTimeEndDate ? "" + generateTimeEndDate.toISOString() : "") + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportBillingInformationGroupReport(_response);
        });
    }

    protected processExportBillingInformationGroupReport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getBillingInformationGroupReportSummaryQuery(keyword: string | null | undefined, clientGroupId: number | null | undefined, groupReportTemplateId: number | null | undefined, generateTimeStartDate: Date | null | undefined, generateTimeEndDate: Date | null | undefined): Promise<GroupReportSummaryDto> {
        let url_ = this.baseUrl + "/api/BillingInformations/GroupReportSummary?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (clientGroupId !== undefined && clientGroupId !== null)
            url_ += "ClientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        if (groupReportTemplateId !== undefined && groupReportTemplateId !== null)
            url_ += "GroupReportTemplateId=" + encodeURIComponent("" + groupReportTemplateId) + "&";
        if (generateTimeStartDate !== undefined && generateTimeStartDate !== null)
            url_ += "GenerateTimeStartDate=" + encodeURIComponent(generateTimeStartDate ? "" + generateTimeStartDate.toISOString() : "") + "&";
        if (generateTimeEndDate !== undefined && generateTimeEndDate !== null)
            url_ += "GenerateTimeEndDate=" + encodeURIComponent(generateTimeEndDate ? "" + generateTimeEndDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBillingInformationGroupReportSummaryQuery(_response);
        });
    }

    protected processGetBillingInformationGroupReportSummaryQuery(response: Response): Promise<GroupReportSummaryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupReportSummaryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupReportSummaryDto>(null as any);
    }

    getBillingInformationGroupReportSummaryListWithPaginationQuery(keyword: string | null | undefined, clientGroupId: number | null | undefined, groupReportTemplateId: number[] | null | undefined, groupReportTemplateDisplayName: string | null | undefined, generateTimeStartDate: Date | null | undefined, generateTimeEndDate: Date | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfGroupReportSummaryDto> {
        let url_ = this.baseUrl + "/api/BillingInformations/GroupReportSummaryList?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (clientGroupId !== undefined && clientGroupId !== null)
            url_ += "ClientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        if (groupReportTemplateId !== undefined && groupReportTemplateId !== null)
            groupReportTemplateId && groupReportTemplateId.forEach(item => { url_ += "GroupReportTemplateId=" + encodeURIComponent("" + item) + "&"; });
        if (groupReportTemplateDisplayName !== undefined && groupReportTemplateDisplayName !== null)
            url_ += "GroupReportTemplateDisplayName=" + encodeURIComponent("" + groupReportTemplateDisplayName) + "&";
        if (generateTimeStartDate !== undefined && generateTimeStartDate !== null)
            url_ += "GenerateTimeStartDate=" + encodeURIComponent(generateTimeStartDate ? "" + generateTimeStartDate.toISOString() : "") + "&";
        if (generateTimeEndDate !== undefined && generateTimeEndDate !== null)
            url_ += "GenerateTimeEndDate=" + encodeURIComponent(generateTimeEndDate ? "" + generateTimeEndDate.toISOString() : "") + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBillingInformationGroupReportSummaryListWithPaginationQuery(_response);
        });
    }

    protected processGetBillingInformationGroupReportSummaryListWithPaginationQuery(response: Response): Promise<PaginatedListOfGroupReportSummaryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfGroupReportSummaryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfGroupReportSummaryDto>(null as any);
    }

    exportBillingInformationGroupReportSummaryListQuery(keyword: string | null | undefined, clientGroupId: number | null | undefined, groupReportTemplateId: number[] | null | undefined, groupReportTemplateDisplayName: string | null | undefined, generateTimeStartDate: Date | null | undefined, generateTimeEndDate: Date | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/BillingInformations/GroupReportSummaryListExport?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (clientGroupId !== undefined && clientGroupId !== null)
            url_ += "ClientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        if (groupReportTemplateId !== undefined && groupReportTemplateId !== null)
            groupReportTemplateId && groupReportTemplateId.forEach(item => { url_ += "GroupReportTemplateId=" + encodeURIComponent("" + item) + "&"; });
        if (groupReportTemplateDisplayName !== undefined && groupReportTemplateDisplayName !== null)
            url_ += "GroupReportTemplateDisplayName=" + encodeURIComponent("" + groupReportTemplateDisplayName) + "&";
        if (generateTimeStartDate !== undefined && generateTimeStartDate !== null)
            url_ += "GenerateTimeStartDate=" + encodeURIComponent(generateTimeStartDate ? "" + generateTimeStartDate.toISOString() : "") + "&";
        if (generateTimeEndDate !== undefined && generateTimeEndDate !== null)
            url_ += "GenerateTimeEndDate=" + encodeURIComponent(generateTimeEndDate ? "" + generateTimeEndDate.toISOString() : "") + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportBillingInformationGroupReportSummaryListQuery(_response);
        });
    }

    protected processExportBillingInformationGroupReportSummaryListQuery(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IClientAdministratorsClient {

    getClientAdministratorWithPagination(keyword: string | null | undefined, type: ClientAdministratorType | null | undefined, clientGroupId: number | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfClientAdministratorBriefDto>;

    archiveClientAdministrator(id: string | undefined): Promise<FileResponse>;

    create(command: CreateClientAdministratorCommand): Promise<FileResponse>;

    exportClientAdministrator(type: ClientAdministratorType | null | undefined, clientGroupId: number | null | undefined): Promise<FileResponse>;

    update(command: UpdateClientAdministratorCommand): Promise<FileResponse>;

    changePassword(command: UpdateClientAdministratorPasswordCommand): Promise<Result>;

    forceChangePassword(command: ForceUpdateClientAdministratorPasswordCommand): Promise<Result>;

    changeClientGroup(command: UpdateClientAdministratorClientGroupCommand): Promise<FileResponse>;

    sendNotification(id: string): Promise<FileResponse>;

    uploadClientAdministratorPermission(file: FileParameter | null | undefined): Promise<FileResponse>;
}

export class ClientAdministratorsClient extends AuthorizedApiBase implements IClientAdministratorsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getClientAdministratorWithPagination(keyword: string | null | undefined, type: ClientAdministratorType | null | undefined, clientGroupId: number | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfClientAdministratorBriefDto> {
        let url_ = this.baseUrl + "/api/ClientAdministrators?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (type !== undefined && type !== null)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (clientGroupId !== undefined && clientGroupId !== null)
            url_ += "ClientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetClientAdministratorWithPagination(_response);
        });
    }

    protected processGetClientAdministratorWithPagination(response: Response): Promise<PaginatedListOfClientAdministratorBriefDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfClientAdministratorBriefDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfClientAdministratorBriefDto>(null as any);
    }

    archiveClientAdministrator(id: string | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientAdministrators?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processArchiveClientAdministrator(_response);
        });
    }

    protected processArchiveClientAdministrator(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    create(command: CreateClientAdministratorCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientAdministrators";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    exportClientAdministrator(type: ClientAdministratorType | null | undefined, clientGroupId: number | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientAdministrators/Export?";
        if (type !== undefined && type !== null)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (clientGroupId !== undefined && clientGroupId !== null)
            url_ += "ClientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportClientAdministrator(_response);
        });
    }

    protected processExportClientAdministrator(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    update(command: UpdateClientAdministratorCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientAdministrators/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    changePassword(command: UpdateClientAdministratorPasswordCommand): Promise<Result> {
        let url_ = this.baseUrl + "/api/ClientAdministrators/Password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    forceChangePassword(command: ForceUpdateClientAdministratorPasswordCommand): Promise<Result> {
        let url_ = this.baseUrl + "/api/ClientAdministrators/ForceChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processForceChangePassword(_response);
        });
    }

    protected processForceChangePassword(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    changeClientGroup(command: UpdateClientAdministratorClientGroupCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientAdministrators/ClientGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processChangeClientGroup(_response);
        });
    }

    protected processChangeClientGroup(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    sendNotification(id: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientAdministrators/{id}/Notification";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendNotification(_response);
        });
    }

    protected processSendNotification(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    uploadClientAdministratorPermission(file: FileParameter | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientAdministrators/UploadClientAdministratorPermission";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadClientAdministratorPermission(_response);
        });
    }

    protected processUploadClientAdministratorPermission(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IClientCourseCertificateTempsClient {

    downloadClientCourseCertificateTempFile(clientUserCourseId: number | undefined): Promise<FileResponse>;

    sendCertificateEmail(clientUserCourseId: number | undefined): Promise<FileResponse>;
}

export class ClientCourseCertificateTempsClient extends AuthorizedApiBase implements IClientCourseCertificateTempsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    downloadClientCourseCertificateTempFile(clientUserCourseId: number | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientCourseCertificateTemps/Client/DownloadCourseCertificateTempFile?";
        if (clientUserCourseId === null)
            throw new Error("The parameter 'clientUserCourseId' cannot be null.");
        else if (clientUserCourseId !== undefined)
            url_ += "clientUserCourseId=" + encodeURIComponent("" + clientUserCourseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadClientCourseCertificateTempFile(_response);
        });
    }

    protected processDownloadClientCourseCertificateTempFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    sendCertificateEmail(clientUserCourseId: number | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientCourseCertificateTemps/SendCertificateEmail?";
        if (clientUserCourseId === null)
            throw new Error("The parameter 'clientUserCourseId' cannot be null.");
        else if (clientUserCourseId !== undefined)
            url_ += "clientUserCourseId=" + encodeURIComponent("" + clientUserCourseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendCertificateEmail(_response);
        });
    }

    protected processSendCertificateEmail(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IClientGroupAssessmentTemplatesClient {

    upload(file: FileParameter | null | undefined): Promise<number>;

    export(): Promise<FileResponse>;

    getClientGroupAssessmentTemplatesWithPagination(keyword: string | null | undefined, clientGroupId: number | undefined, showWithCompletedRecordOnly: boolean | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfClientGroupAssessmentTemplateDto>;

    create(command: CreateClientGroupAssessmentTemplateCommand): Promise<number>;

    detele(command: DeleteClientGroupAssessmentTemplateCommand): Promise<FileResponse>;

    getClientGroupAssessmentTemplateOption(clientGroupId: number | null | undefined): Promise<AssessmentTemplateBriefDto[]>;

    getClientGroupSelectedAssessmentTemplate(clientGroupId: number | null | undefined): Promise<AssessmentTemplateBriefDto[]>;

    disable(command: SoftDeleteClientGroupAssessmentTemplateCommand): Promise<FileResponse>;
}

export class ClientGroupAssessmentTemplatesClient extends AuthorizedApiBase implements IClientGroupAssessmentTemplatesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    upload(file: FileParameter | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/ClientGroupAssessmentTemplates/Upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    export(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientGroupAssessmentTemplates/Export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getClientGroupAssessmentTemplatesWithPagination(keyword: string | null | undefined, clientGroupId: number | undefined, showWithCompletedRecordOnly: boolean | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfClientGroupAssessmentTemplateDto> {
        let url_ = this.baseUrl + "/api/ClientGroupAssessmentTemplates?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (clientGroupId === null)
            throw new Error("The parameter 'clientGroupId' cannot be null.");
        else if (clientGroupId !== undefined)
            url_ += "ClientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        if (showWithCompletedRecordOnly !== undefined && showWithCompletedRecordOnly !== null)
            url_ += "ShowWithCompletedRecordOnly=" + encodeURIComponent("" + showWithCompletedRecordOnly) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetClientGroupAssessmentTemplatesWithPagination(_response);
        });
    }

    protected processGetClientGroupAssessmentTemplatesWithPagination(response: Response): Promise<PaginatedListOfClientGroupAssessmentTemplateDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfClientGroupAssessmentTemplateDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfClientGroupAssessmentTemplateDto>(null as any);
    }

    create(command: CreateClientGroupAssessmentTemplateCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/ClientGroupAssessmentTemplates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    detele(command: DeleteClientGroupAssessmentTemplateCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientGroupAssessmentTemplates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDetele(_response);
        });
    }

    protected processDetele(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getClientGroupAssessmentTemplateOption(clientGroupId: number | null | undefined): Promise<AssessmentTemplateBriefDto[]> {
        let url_ = this.baseUrl + "/api/ClientGroupAssessmentTemplates/Option?";
        if (clientGroupId !== undefined && clientGroupId !== null)
            url_ += "ClientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetClientGroupAssessmentTemplateOption(_response);
        });
    }

    protected processGetClientGroupAssessmentTemplateOption(response: Response): Promise<AssessmentTemplateBriefDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssessmentTemplateBriefDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssessmentTemplateBriefDto[]>(null as any);
    }

    getClientGroupSelectedAssessmentTemplate(clientGroupId: number | null | undefined): Promise<AssessmentTemplateBriefDto[]> {
        let url_ = this.baseUrl + "/api/ClientGroupAssessmentTemplates/Selected?";
        if (clientGroupId !== undefined && clientGroupId !== null)
            url_ += "ClientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetClientGroupSelectedAssessmentTemplate(_response);
        });
    }

    protected processGetClientGroupSelectedAssessmentTemplate(response: Response): Promise<AssessmentTemplateBriefDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssessmentTemplateBriefDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssessmentTemplateBriefDto[]>(null as any);
    }

    disable(command: SoftDeleteClientGroupAssessmentTemplateCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientGroupAssessmentTemplates/Soft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDisable(_response);
        });
    }

    protected processDisable(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IClientGroupGroupReportGenerationSettingsClient {

    get(clientGroupAssessmentTemplateId: number | undefined): Promise<ClientGroupGroupReportGenerationSettingDto[]>;

    create(command: CreateClientGroupGroupReportGenerationSettingsCommand): Promise<FileResponse>;

    detele(command: DeleteClientGroupGroupReportGenerationSettingCommand): Promise<FileResponse>;

    export(): Promise<FileResponse>;

    upload(file: FileParameter | null | undefined): Promise<number>;

    getClientGroupGroupReportGenerationSettingsWithPagination(keyword: string | null | undefined, clientGroupId: number | undefined, clientgroupassessmentTemplateId: number | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfClientGroupGroupReportGenerationSettingDto>;
}

export class ClientGroupGroupReportGenerationSettingsClient extends AuthorizedApiBase implements IClientGroupGroupReportGenerationSettingsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    get(clientGroupAssessmentTemplateId: number | undefined): Promise<ClientGroupGroupReportGenerationSettingDto[]> {
        let url_ = this.baseUrl + "/api/ClientGroupGroupReportGenerationSettings?";
        if (clientGroupAssessmentTemplateId === null)
            throw new Error("The parameter 'clientGroupAssessmentTemplateId' cannot be null.");
        else if (clientGroupAssessmentTemplateId !== undefined)
            url_ += "ClientGroupAssessmentTemplateId=" + encodeURIComponent("" + clientGroupAssessmentTemplateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ClientGroupGroupReportGenerationSettingDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientGroupGroupReportGenerationSettingDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientGroupGroupReportGenerationSettingDto[]>(null as any);
    }

    create(command: CreateClientGroupGroupReportGenerationSettingsCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientGroupGroupReportGenerationSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    detele(command: DeleteClientGroupGroupReportGenerationSettingCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientGroupGroupReportGenerationSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDetele(_response);
        });
    }

    protected processDetele(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    export(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientGroupGroupReportGenerationSettings/Export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    upload(file: FileParameter | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/ClientGroupGroupReportGenerationSettings/Upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getClientGroupGroupReportGenerationSettingsWithPagination(keyword: string | null | undefined, clientGroupId: number | undefined, clientgroupassessmentTemplateId: number | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfClientGroupGroupReportGenerationSettingDto> {
        let url_ = this.baseUrl + "/api/ClientGroupGroupReportGenerationSettings/Paginated?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (clientGroupId === null)
            throw new Error("The parameter 'clientGroupId' cannot be null.");
        else if (clientGroupId !== undefined)
            url_ += "ClientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        if (clientgroupassessmentTemplateId !== undefined && clientgroupassessmentTemplateId !== null)
            url_ += "ClientgroupassessmentTemplateId=" + encodeURIComponent("" + clientgroupassessmentTemplateId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetClientGroupGroupReportGenerationSettingsWithPagination(_response);
        });
    }

    protected processGetClientGroupGroupReportGenerationSettingsWithPagination(response: Response): Promise<PaginatedListOfClientGroupGroupReportGenerationSettingDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfClientGroupGroupReportGenerationSettingDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfClientGroupGroupReportGenerationSettingDto>(null as any);
    }
}

export interface IClientGroupReportGenerationSettingsClient {

    get(clientGroupAssessmentTemplateId: number | undefined, clientGroupOnly: boolean | undefined): Promise<ClientGroupReportGenerationSettingDto[]>;

    create(command: CreateClientGroupReportGenerationSettingsCommand): Promise<FileResponse>;

    detele(command: DeleteClientGroupReportGenerationSettingCommand): Promise<FileResponse>;

    export(): Promise<FileResponse>;

    upload(file: FileParameter | null | undefined): Promise<number>;

    getClientGroupReportGenerationSettingsWithPagination(keyword: string | null | undefined, clientGroupId: number | undefined, clientgroupassessmentTemplateId: number | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfClientGroupReportGenerationSettingDto>;

    getClientGroupSelectedAssessmentTemplate(clientGroupId: number | null | undefined): Promise<ReportTemplateBriefDto[]>;

    update(command: UpdateClientGroupReportGenerationSettingCommand): Promise<FileResponse>;
}

export class ClientGroupReportGenerationSettingsClient extends AuthorizedApiBase implements IClientGroupReportGenerationSettingsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    get(clientGroupAssessmentTemplateId: number | undefined, clientGroupOnly: boolean | undefined): Promise<ClientGroupReportGenerationSettingDto[]> {
        let url_ = this.baseUrl + "/api/ClientGroupReportGenerationSettings?";
        if (clientGroupAssessmentTemplateId === null)
            throw new Error("The parameter 'clientGroupAssessmentTemplateId' cannot be null.");
        else if (clientGroupAssessmentTemplateId !== undefined)
            url_ += "ClientGroupAssessmentTemplateId=" + encodeURIComponent("" + clientGroupAssessmentTemplateId) + "&";
        if (clientGroupOnly === null)
            throw new Error("The parameter 'clientGroupOnly' cannot be null.");
        else if (clientGroupOnly !== undefined)
            url_ += "ClientGroupOnly=" + encodeURIComponent("" + clientGroupOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ClientGroupReportGenerationSettingDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientGroupReportGenerationSettingDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientGroupReportGenerationSettingDto[]>(null as any);
    }

    create(command: CreateClientGroupReportGenerationSettingsCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientGroupReportGenerationSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    detele(command: DeleteClientGroupReportGenerationSettingCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientGroupReportGenerationSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDetele(_response);
        });
    }

    protected processDetele(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    export(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientGroupReportGenerationSettings/Export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    upload(file: FileParameter | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/ClientGroupReportGenerationSettings/Upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getClientGroupReportGenerationSettingsWithPagination(keyword: string | null | undefined, clientGroupId: number | undefined, clientgroupassessmentTemplateId: number | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfClientGroupReportGenerationSettingDto> {
        let url_ = this.baseUrl + "/api/ClientGroupReportGenerationSettings/Paginated?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (clientGroupId === null)
            throw new Error("The parameter 'clientGroupId' cannot be null.");
        else if (clientGroupId !== undefined)
            url_ += "ClientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        if (clientgroupassessmentTemplateId !== undefined && clientgroupassessmentTemplateId !== null)
            url_ += "ClientgroupassessmentTemplateId=" + encodeURIComponent("" + clientgroupassessmentTemplateId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetClientGroupReportGenerationSettingsWithPagination(_response);
        });
    }

    protected processGetClientGroupReportGenerationSettingsWithPagination(response: Response): Promise<PaginatedListOfClientGroupReportGenerationSettingDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfClientGroupReportGenerationSettingDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfClientGroupReportGenerationSettingDto>(null as any);
    }

    getClientGroupSelectedAssessmentTemplate(clientGroupId: number | null | undefined): Promise<ReportTemplateBriefDto[]> {
        let url_ = this.baseUrl + "/api/ClientGroupReportGenerationSettings/SelectedReportTemplate?";
        if (clientGroupId !== undefined && clientGroupId !== null)
            url_ += "ClientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetClientGroupSelectedAssessmentTemplate(_response);
        });
    }

    protected processGetClientGroupSelectedAssessmentTemplate(response: Response): Promise<ReportTemplateBriefDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReportTemplateBriefDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportTemplateBriefDto[]>(null as any);
    }

    update(command: UpdateClientGroupReportGenerationSettingCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientGroupReportGenerationSettings/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IClientGroupsClient {

    getClientGroup(id: number): Promise<ClientGroupDto>;

    update(id: number, command: UpdateClientGroupCommand): Promise<FileResponse>;

    archiveClientGroup(id: number | undefined): Promise<FileResponse>;

    getClientGroupsWithPagination(keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfClientGroupDto>;

    create(command: CreateClientGroupCommand): Promise<number>;

    getRootClientGroupsWithPagination(keyword: string | null | undefined, clientGroupId: number | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfClientGroupDto>;

    getSubClientGroupsWithPagination(keyword: string | null | undefined, clientGroupId: number | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfClientGroupDto>;

    getClientGroupsCascader(clientGroupId: number | null | undefined, underSameClient: boolean | undefined): Promise<ClientGroupDto[]>;

    getClientGroupEmailGreeting(clientGroupId: number | undefined): Promise<ClientGroupEmailGreetingDto>;

    createTop(command: CreateTopClientGroupCommand): Promise<number>;

    updateEmailGreeting(command: UpdateClientGroupEmailGreetingCommand): Promise<FileResponse>;

    upload(file: FileParameter | null | undefined): Promise<number>;

    uploadLogo(id: number, file: FileParameter | null | undefined): Promise<number>;

    getLogo(id: number): Promise<FileResponse>;

    uploadEmails(file: FileParameter | null | undefined): Promise<FileResponse>;

    export(): Promise<FileResponse>;

    exportEmails(): Promise<FileResponse>;

    assessments(keyword: string | null | undefined, clientGroupId: number | null | undefined, assessmentTemplateId: number | null | undefined, isProgessComplete: boolean | null | undefined, isSuccessGenerateBefore: boolean | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfAssessmentDto2>;

    exportAssessments(keyword: string | null | undefined, clientGroupId: number | null | undefined, assessmentTemplateId: number | null | undefined, isProgessComplete: boolean | null | undefined, isSuccessGenerateBefore: boolean | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<FileResponse>;

    checkCanAddDeleteReportSettings(clientGroupId: number | undefined): Promise<boolean>;

    clientUsersUpload(id: number, file: FileParameter | null | undefined): Promise<number>;

    toggleGroupReportScoreJson(id: number): Promise<FileResponse>;
}

export class ClientGroupsClient extends AuthorizedApiBase implements IClientGroupsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getClientGroup(id: number): Promise<ClientGroupDto> {
        let url_ = this.baseUrl + "/api/ClientGroups/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetClientGroup(_response);
        });
    }

    protected processGetClientGroup(response: Response): Promise<ClientGroupDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientGroupDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientGroupDto>(null as any);
    }

    update(id: number, command: UpdateClientGroupCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientGroups/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    archiveClientGroup(id: number | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientGroups?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processArchiveClientGroup(_response);
        });
    }

    protected processArchiveClientGroup(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getClientGroupsWithPagination(keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfClientGroupDto> {
        let url_ = this.baseUrl + "/api/ClientGroups?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetClientGroupsWithPagination(_response);
        });
    }

    protected processGetClientGroupsWithPagination(response: Response): Promise<PaginatedListOfClientGroupDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfClientGroupDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfClientGroupDto>(null as any);
    }

    create(command: CreateClientGroupCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/ClientGroups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getRootClientGroupsWithPagination(keyword: string | null | undefined, clientGroupId: number | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfClientGroupDto> {
        let url_ = this.baseUrl + "/api/ClientGroups/root?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (clientGroupId !== undefined && clientGroupId !== null)
            url_ += "ClientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRootClientGroupsWithPagination(_response);
        });
    }

    protected processGetRootClientGroupsWithPagination(response: Response): Promise<PaginatedListOfClientGroupDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfClientGroupDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfClientGroupDto>(null as any);
    }

    getSubClientGroupsWithPagination(keyword: string | null | undefined, clientGroupId: number | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfClientGroupDto> {
        let url_ = this.baseUrl + "/api/ClientGroups/sub?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (clientGroupId === null)
            throw new Error("The parameter 'clientGroupId' cannot be null.");
        else if (clientGroupId !== undefined)
            url_ += "ClientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSubClientGroupsWithPagination(_response);
        });
    }

    protected processGetSubClientGroupsWithPagination(response: Response): Promise<PaginatedListOfClientGroupDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfClientGroupDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfClientGroupDto>(null as any);
    }

    getClientGroupsCascader(clientGroupId: number | null | undefined, underSameClient: boolean | undefined): Promise<ClientGroupDto[]> {
        let url_ = this.baseUrl + "/api/ClientGroups/cascader?";
        if (clientGroupId !== undefined && clientGroupId !== null)
            url_ += "ClientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        if (underSameClient === null)
            throw new Error("The parameter 'underSameClient' cannot be null.");
        else if (underSameClient !== undefined)
            url_ += "UnderSameClient=" + encodeURIComponent("" + underSameClient) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetClientGroupsCascader(_response);
        });
    }

    protected processGetClientGroupsCascader(response: Response): Promise<ClientGroupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientGroupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientGroupDto[]>(null as any);
    }

    getClientGroupEmailGreeting(clientGroupId: number | undefined): Promise<ClientGroupEmailGreetingDto> {
        let url_ = this.baseUrl + "/api/ClientGroups/emailgreeting?";
        if (clientGroupId === null)
            throw new Error("The parameter 'clientGroupId' cannot be null.");
        else if (clientGroupId !== undefined)
            url_ += "ClientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetClientGroupEmailGreeting(_response);
        });
    }

    protected processGetClientGroupEmailGreeting(response: Response): Promise<ClientGroupEmailGreetingDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientGroupEmailGreetingDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientGroupEmailGreetingDto>(null as any);
    }

    createTop(command: CreateTopClientGroupCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/ClientGroups/top";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateTop(_response);
        });
    }

    protected processCreateTop(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    updateEmailGreeting(command: UpdateClientGroupEmailGreetingCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientGroups/UpdateEmailGreeting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateEmailGreeting(_response);
        });
    }

    protected processUpdateEmailGreeting(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    upload(file: FileParameter | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/ClientGroups/Upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    uploadLogo(id: number, file: FileParameter | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/ClientGroups/{id}/Logo/Upload";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadLogo(_response);
        });
    }

    protected processUploadLogo(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getLogo(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientGroups/{id}/Logo";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLogo(_response);
        });
    }

    protected processGetLogo(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    uploadEmails(file: FileParameter | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientGroups/Emails/Upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadEmails(_response);
        });
    }

    protected processUploadEmails(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    export(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientGroups/Export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    exportEmails(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientGroups/Emails/Export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportEmails(_response);
        });
    }

    protected processExportEmails(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    assessments(keyword: string | null | undefined, clientGroupId: number | null | undefined, assessmentTemplateId: number | null | undefined, isProgessComplete: boolean | null | undefined, isSuccessGenerateBefore: boolean | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfAssessmentDto2> {
        let url_ = this.baseUrl + "/api/ClientGroups/Assessments?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (clientGroupId !== undefined && clientGroupId !== null)
            url_ += "ClientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        if (assessmentTemplateId !== undefined && assessmentTemplateId !== null)
            url_ += "AssessmentTemplateId=" + encodeURIComponent("" + assessmentTemplateId) + "&";
        if (isProgessComplete !== undefined && isProgessComplete !== null)
            url_ += "IsProgessComplete=" + encodeURIComponent("" + isProgessComplete) + "&";
        if (isSuccessGenerateBefore !== undefined && isSuccessGenerateBefore !== null)
            url_ += "IsSuccessGenerateBefore=" + encodeURIComponent("" + isSuccessGenerateBefore) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAssessments(_response);
        });
    }

    protected processAssessments(response: Response): Promise<PaginatedListOfAssessmentDto2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfAssessmentDto2.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfAssessmentDto2>(null as any);
    }

    exportAssessments(keyword: string | null | undefined, clientGroupId: number | null | undefined, assessmentTemplateId: number | null | undefined, isProgessComplete: boolean | null | undefined, isSuccessGenerateBefore: boolean | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientGroups/Assessments/Export?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (clientGroupId !== undefined && clientGroupId !== null)
            url_ += "ClientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        if (assessmentTemplateId !== undefined && assessmentTemplateId !== null)
            url_ += "AssessmentTemplateId=" + encodeURIComponent("" + assessmentTemplateId) + "&";
        if (isProgessComplete !== undefined && isProgessComplete !== null)
            url_ += "IsProgessComplete=" + encodeURIComponent("" + isProgessComplete) + "&";
        if (isSuccessGenerateBefore !== undefined && isSuccessGenerateBefore !== null)
            url_ += "IsSuccessGenerateBefore=" + encodeURIComponent("" + isSuccessGenerateBefore) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportAssessments(_response);
        });
    }

    protected processExportAssessments(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    checkCanAddDeleteReportSettings(clientGroupId: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ClientGroups/CheckCanAddDeleteReportSettings?";
        if (clientGroupId === null)
            throw new Error("The parameter 'clientGroupId' cannot be null.");
        else if (clientGroupId !== undefined)
            url_ += "ClientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCheckCanAddDeleteReportSettings(_response);
        });
    }

    protected processCheckCanAddDeleteReportSettings(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    clientUsersUpload(id: number, file: FileParameter | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/ClientGroups/{id}/ClientUsers/Upload";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processClientUsersUpload(_response);
        });
    }

    protected processClientUsersUpload(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    toggleGroupReportScoreJson(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientGroups/{id}/ToggleGroupReportScoreJson";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processToggleGroupReportScoreJson(_response);
        });
    }

    protected processToggleGroupReportScoreJson(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IClientsClient {

    getClientsWithPagination(keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfClientBriefDto>;

    create(command: CreateClientCommand): Promise<number>;

    update(id: number, command: UpdateClientCommand): Promise<FileResponse>;

    upload(file: FileParameter | null | undefined): Promise<number>;

    export(): Promise<FileResponse>;
}

export class ClientsClient extends AuthorizedApiBase implements IClientsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getClientsWithPagination(keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfClientBriefDto> {
        let url_ = this.baseUrl + "/api/Clients?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetClientsWithPagination(_response);
        });
    }

    protected processGetClientsWithPagination(response: Response): Promise<PaginatedListOfClientBriefDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfClientBriefDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfClientBriefDto>(null as any);
    }

    create(command: CreateClientCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Clients";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    update(id: number, command: UpdateClientCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Clients/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    upload(file: FileParameter | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Clients/Upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    export(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Clients/Export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IClientUserAssessmentsClient {

    get(): Promise<ClientUserAssessmentDto[]>;

    create(command: CreateClientUserAssessmentCommand): Promise<number>;

    getForms(id: number, lang: string | null | undefined): Promise<ClientUserAssessmentFormDto[]>;

    getQuestionSlot(id: number, assessmentId: number | undefined, assessmentFormId: number | undefined, pageNumber: number | undefined, lang: string | undefined): Promise<ClientUserAssessmentQuestionSlotDto[]>;

    submit(id: number): Promise<FileResponse>;

    updateQuestionSlot(command: UpdateClientUserAssessmentQuestionSlotCommand): Promise<FileResponse>;

    getClientUserAssessmentInCompletedQuestionSlotQuery(assessmentId: number | undefined, lang: string | null | undefined): Promise<ClientUserAssessmentQuestionSlotDto>;

    getAssessmentTemplates(): Promise<ClientUserAssessmentTemplateBriefDto[]>;

    getAssessmentTemplate(id: number, lang: string | null | undefined): Promise<ClientUserAssessmentTemplateDto>;

    createClientUserAssessmentReport(id: number, command: CreateClientUserAssessmentReportCommand): Promise<number>;

    getClientUserAssessmentLanguage(id: number | undefined): Promise<GetClientUserAssessmentLanguageDto>;
}

export class ClientUserAssessmentsClient extends AuthorizedApiBase implements IClientUserAssessmentsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    get(): Promise<ClientUserAssessmentDto[]> {
        let url_ = this.baseUrl + "/api/ClientUserAssessments";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ClientUserAssessmentDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientUserAssessmentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientUserAssessmentDto[]>(null as any);
    }

    create(command: CreateClientUserAssessmentCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/ClientUserAssessments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getForms(id: number, lang: string | null | undefined): Promise<ClientUserAssessmentFormDto[]> {
        let url_ = this.baseUrl + "/api/ClientUserAssessments/{id}/Form?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetForms(_response);
        });
    }

    protected processGetForms(response: Response): Promise<ClientUserAssessmentFormDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientUserAssessmentFormDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientUserAssessmentFormDto[]>(null as any);
    }

    getQuestionSlot(id: number, assessmentId: number | undefined, assessmentFormId: number | undefined, pageNumber: number | undefined, lang: string | undefined): Promise<ClientUserAssessmentQuestionSlotDto[]> {
        let url_ = this.baseUrl + "/api/ClientUserAssessments/{id}/QuestionSlot?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (assessmentId === null)
            throw new Error("The parameter 'assessmentId' cannot be null.");
        else if (assessmentId !== undefined)
            url_ += "AssessmentId=" + encodeURIComponent("" + assessmentId) + "&";
        if (assessmentFormId === null)
            throw new Error("The parameter 'assessmentFormId' cannot be null.");
        else if (assessmentFormId !== undefined)
            url_ += "AssessmentFormId=" + encodeURIComponent("" + assessmentFormId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "Lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetQuestionSlot(_response);
        });
    }

    protected processGetQuestionSlot(response: Response): Promise<ClientUserAssessmentQuestionSlotDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientUserAssessmentQuestionSlotDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientUserAssessmentQuestionSlotDto[]>(null as any);
    }

    submit(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientUserAssessments/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSubmit(_response);
        });
    }

    protected processSubmit(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    updateQuestionSlot(command: UpdateClientUserAssessmentQuestionSlotCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientUserAssessments/QuestionSlot";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateQuestionSlot(_response);
        });
    }

    protected processUpdateQuestionSlot(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getClientUserAssessmentInCompletedQuestionSlotQuery(assessmentId: number | undefined, lang: string | null | undefined): Promise<ClientUserAssessmentQuestionSlotDto> {
        let url_ = this.baseUrl + "/api/ClientUserAssessments/InCompleteQuestionSlot?";
        if (assessmentId === null)
            throw new Error("The parameter 'assessmentId' cannot be null.");
        else if (assessmentId !== undefined)
            url_ += "AssessmentId=" + encodeURIComponent("" + assessmentId) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "Lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetClientUserAssessmentInCompletedQuestionSlotQuery(_response);
        });
    }

    protected processGetClientUserAssessmentInCompletedQuestionSlotQuery(response: Response): Promise<ClientUserAssessmentQuestionSlotDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientUserAssessmentQuestionSlotDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientUserAssessmentQuestionSlotDto>(null as any);
    }

    getAssessmentTemplates(): Promise<ClientUserAssessmentTemplateBriefDto[]> {
        let url_ = this.baseUrl + "/api/ClientUserAssessments/Template";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAssessmentTemplates(_response);
        });
    }

    protected processGetAssessmentTemplates(response: Response): Promise<ClientUserAssessmentTemplateBriefDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientUserAssessmentTemplateBriefDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientUserAssessmentTemplateBriefDto[]>(null as any);
    }

    getAssessmentTemplate(id: number, lang: string | null | undefined): Promise<ClientUserAssessmentTemplateDto> {
        let url_ = this.baseUrl + "/api/ClientUserAssessments/Template/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAssessmentTemplate(_response);
        });
    }

    protected processGetAssessmentTemplate(response: Response): Promise<ClientUserAssessmentTemplateDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientUserAssessmentTemplateDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientUserAssessmentTemplateDto>(null as any);
    }

    createClientUserAssessmentReport(id: number, command: CreateClientUserAssessmentReportCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/ClientUserAssessments/Report/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateClientUserAssessmentReport(_response);
        });
    }

    protected processCreateClientUserAssessmentReport(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getClientUserAssessmentLanguage(id: number | undefined): Promise<GetClientUserAssessmentLanguageDto> {
        let url_ = this.baseUrl + "/api/ClientUserAssessments/GetClientUserAssessmentLanguage?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetClientUserAssessmentLanguage(_response);
        });
    }

    protected processGetClientUserAssessmentLanguage(response: Response): Promise<GetClientUserAssessmentLanguageDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetClientUserAssessmentLanguageDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetClientUserAssessmentLanguageDto>(null as any);
    }
}

export interface IClientUserCourseModulesClient {

    access(id: number): Promise<FileResponse>;
}

export class ClientUserCourseModulesClient extends AuthorizedApiBase implements IClientUserCourseModulesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    access(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientUserCourseModules/{id}/Access";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAccess(_response);
        });
    }

    protected processAccess(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IClientUserCourseModuleStepQuizResultsClient {

    create(command: CreateClientUserCourseModuleStepQuizResultCommand): Promise<boolean>;
}

export class ClientUserCourseModuleStepQuizResultsClient extends AuthorizedApiBase implements IClientUserCourseModuleStepQuizResultsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    create(command: CreateClientUserCourseModuleStepQuizResultCommand): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ClientUserCourseModuleStepQuizResults";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface IClientUserCourseModuleStepsClient {

    getById(id: number): Promise<ClientUserCourseModuleStepDto>;

    complete(id: number): Promise<number>;

    linkAssessment(id: number): Promise<boolean>;
}

export class ClientUserCourseModuleStepsClient extends AuthorizedApiBase implements IClientUserCourseModuleStepsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getById(id: number): Promise<ClientUserCourseModuleStepDto> {
        let url_ = this.baseUrl + "/api/ClientUserCourseModuleSteps/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<ClientUserCourseModuleStepDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientUserCourseModuleStepDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientUserCourseModuleStepDto>(null as any);
    }

    complete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/ClientUserCourseModuleSteps/{id}/Complete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processComplete(_response);
        });
    }

    protected processComplete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    linkAssessment(id: number): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ClientUserCourseModuleSteps/{id}/LinkAssessment";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLinkAssessment(_response);
        });
    }

    protected processLinkAssessment(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface IClientUserCoursesClient {

    getById(id: number): Promise<ClientUserCourseDto>;

    update(id: number, command: UpdateClientUserCourseCommand): Promise<FileResponse>;

    hasCertificate(id: number, lang: string | undefined): Promise<boolean>;

    create(command: CreateClientUserCourseCommand): Promise<number>;

    ensure(id: number): Promise<FileResponse>;

    changeCurrentLanguage(id: number, command: ChangeClientUserCourseCurrentLanguageCommand): Promise<FileResponse>;

    downloadNotes(id: number): Promise<FileResponse>;

    sendNotes(id: number): Promise<FileResponse>;
}

export class ClientUserCoursesClient extends AuthorizedApiBase implements IClientUserCoursesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getById(id: number): Promise<ClientUserCourseDto> {
        let url_ = this.baseUrl + "/api/ClientUserCourses/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<ClientUserCourseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientUserCourseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientUserCourseDto>(null as any);
    }

    update(id: number, command: UpdateClientUserCourseCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientUserCourses/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    hasCertificate(id: number, lang: string | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ClientUserCourses/{id}/HasCertificate?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processHasCertificate(_response);
        });
    }

    protected processHasCertificate(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    create(command: CreateClientUserCourseCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/ClientUserCourses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    ensure(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientUserCourses/{id}/Ensure";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEnsure(_response);
        });
    }

    protected processEnsure(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    changeCurrentLanguage(id: number, command: ChangeClientUserCourseCurrentLanguageCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientUserCourses/{id}/ChangeCurrentLanguage";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processChangeCurrentLanguage(_response);
        });
    }

    protected processChangeCurrentLanguage(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    downloadNotes(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientUserCourses/{id}/DownloadNotes";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadNotes(_response);
        });
    }

    protected processDownloadNotes(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    sendNotes(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientUserCourses/{id}/SendNotes";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendNotes(_response);
        });
    }

    protected processSendNotes(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IClientUserInternationalizationsClient {

    get(supportedLanguageId: string | undefined): Promise<{ [key in keyof typeof InternationalizationKey]?: string; }>;
}

export class ClientUserInternationalizationsClient extends AuthorizedApiBase implements IClientUserInternationalizationsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    get(supportedLanguageId: string | undefined): Promise<{ [key in keyof typeof InternationalizationKey]?: string; }> {
        let url_ = this.baseUrl + "/api/ClientUserInternationalizations?";
        if (supportedLanguageId === null)
            throw new Error("The parameter 'supportedLanguageId' cannot be null.");
        else if (supportedLanguageId !== undefined)
            url_ += "SupportedLanguageId=" + encodeURIComponent("" + supportedLanguageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<{ [key in keyof typeof InternationalizationKey]?: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key in keyof typeof InternationalizationKey]?: string; }>(null as any);
    }
}

export interface IClientUserQuestionChoicesClient {

    get(questionChoiceListId: number | undefined, lang: string | null | undefined): Promise<ClientUserQuestionChoiceDto[]>;
}

export class ClientUserQuestionChoicesClient extends AuthorizedApiBase implements IClientUserQuestionChoicesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    get(questionChoiceListId: number | undefined, lang: string | null | undefined): Promise<ClientUserQuestionChoiceDto[]> {
        let url_ = this.baseUrl + "/api/ClientUserQuestionChoices?";
        if (questionChoiceListId === null)
            throw new Error("The parameter 'questionChoiceListId' cannot be null.");
        else if (questionChoiceListId !== undefined)
            url_ += "QuestionChoiceListId=" + encodeURIComponent("" + questionChoiceListId) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "Lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ClientUserQuestionChoiceDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientUserQuestionChoiceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientUserQuestionChoiceDto[]>(null as any);
    }
}

export interface IClientUsersClient {

    getClientUsersWithPagination(keyword: string | null | undefined, clientGroupId: number | null | undefined, destinateClientGroupId: number | null | undefined, remark: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfClientUserBriefDto>;

    archiveClientUser(id: string | undefined): Promise<FileResponse>;

    create(command: CreateClientUserCommand): Promise<FileResponse>;

    getCurrentClientUser(): Promise<ClientUserDto>;

    exportUploadTemplate(): Promise<FileResponse>;

    upload(file: FileParameter | null | undefined): Promise<number>;

    export(clientGroupId: number | null | undefined): Promise<FileResponse>;

    update(command: UpdateClientUserCommand): Promise<FileResponse>;

    forceUpdate(command: ForceUpdateClientUserCommand): Promise<FileResponse>;

    changeClientGroup(command: UpdateClientUserClientGroupCommand): Promise<FileResponse>;

    bulkChangeClientGroup(command: BulkUpdateClientUserClientGroupCommand): Promise<FileResponse>;

    sendNotification(id: string): Promise<FileResponse>;

    sendResetPasswordEmail(command: SendResetPasswordEmailCommand): Promise<FileResponse>;

    changePassword(command: UpdateClientUserPasswordCommand): Promise<Result>;

    forceChangePassword(command: ForceUpdateClientUserPasswordCommand): Promise<Result>;

    updateEmail(command: UpdateClientUserEmailCommand): Promise<FileResponse>;

    sendClientResetPasswordEmail(command: SendClientResetPasswordEmailCommand): Promise<FileResponse>;

    clientResetPassword(command: ClientResetPasswordCommand): Promise<Result>;

    clientCheckVerificationCode(command: ClientCheckVerificationCodeCommand): Promise<boolean>;

    getClientUserPermission(): Promise<ClientUserPermissionDto>;
}

export class ClientUsersClient extends AuthorizedApiBase implements IClientUsersClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getClientUsersWithPagination(keyword: string | null | undefined, clientGroupId: number | null | undefined, destinateClientGroupId: number | null | undefined, remark: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfClientUserBriefDto> {
        let url_ = this.baseUrl + "/api/ClientUsers?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (clientGroupId !== undefined && clientGroupId !== null)
            url_ += "ClientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        if (destinateClientGroupId !== undefined && destinateClientGroupId !== null)
            url_ += "DestinateClientGroupId=" + encodeURIComponent("" + destinateClientGroupId) + "&";
        if (remark !== undefined && remark !== null)
            url_ += "Remark=" + encodeURIComponent("" + remark) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetClientUsersWithPagination(_response);
        });
    }

    protected processGetClientUsersWithPagination(response: Response): Promise<PaginatedListOfClientUserBriefDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfClientUserBriefDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfClientUserBriefDto>(null as any);
    }

    archiveClientUser(id: string | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientUsers?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processArchiveClientUser(_response);
        });
    }

    protected processArchiveClientUser(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    create(command: CreateClientUserCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getCurrentClientUser(): Promise<ClientUserDto> {
        let url_ = this.baseUrl + "/api/ClientUsers/Current";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCurrentClientUser(_response);
        });
    }

    protected processGetCurrentClientUser(response: Response): Promise<ClientUserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientUserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientUserDto>(null as any);
    }

    exportUploadTemplate(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientUsers/Template";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportUploadTemplate(_response);
        });
    }

    protected processExportUploadTemplate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    upload(file: FileParameter | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/ClientUsers/Upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    export(clientGroupId: number | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientUsers/Export?";
        if (clientGroupId !== undefined && clientGroupId !== null)
            url_ += "ClientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    update(command: UpdateClientUserCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientUsers/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    forceUpdate(command: ForceUpdateClientUserCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientUsers/ForceUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processForceUpdate(_response);
        });
    }

    protected processForceUpdate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    changeClientGroup(command: UpdateClientUserClientGroupCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientUsers/ClientGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processChangeClientGroup(_response);
        });
    }

    protected processChangeClientGroup(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    bulkChangeClientGroup(command: BulkUpdateClientUserClientGroupCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientUsers/BulkClientGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkChangeClientGroup(_response);
        });
    }

    protected processBulkChangeClientGroup(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    sendNotification(id: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientUsers/{id}/Notification";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendNotification(_response);
        });
    }

    protected processSendNotification(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    sendResetPasswordEmail(command: SendResetPasswordEmailCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientUsers/SendResetPasswordEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendResetPasswordEmail(_response);
        });
    }

    protected processSendResetPasswordEmail(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    changePassword(command: UpdateClientUserPasswordCommand): Promise<Result> {
        let url_ = this.baseUrl + "/api/ClientUsers/Password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    forceChangePassword(command: ForceUpdateClientUserPasswordCommand): Promise<Result> {
        let url_ = this.baseUrl + "/api/ClientUsers/ForceChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processForceChangePassword(_response);
        });
    }

    protected processForceChangePassword(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    updateEmail(command: UpdateClientUserEmailCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientUsers/UpdateEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateEmail(_response);
        });
    }

    protected processUpdateEmail(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    sendClientResetPasswordEmail(command: SendClientResetPasswordEmailCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientUsers/SendClientResetPasswordEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendClientResetPasswordEmail(_response);
        });
    }

    protected processSendClientResetPasswordEmail(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    clientResetPassword(command: ClientResetPasswordCommand): Promise<Result> {
        let url_ = this.baseUrl + "/api/ClientUsers/ClientResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processClientResetPassword(_response);
        });
    }

    protected processClientResetPassword(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    clientCheckVerificationCode(command: ClientCheckVerificationCodeCommand): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ClientUsers/ClientCheckVerificationCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processClientCheckVerificationCode(_response);
        });
    }

    protected processClientCheckVerificationCode(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getClientUserPermission(): Promise<ClientUserPermissionDto> {
        let url_ = this.baseUrl + "/api/ClientUsers/GetClientUserPermission";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetClientUserPermission(_response);
        });
    }

    protected processGetClientUserPermission(response: Response): Promise<ClientUserPermissionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientUserPermissionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientUserPermissionDto>(null as any);
    }
}

export interface ICourseCertificateTempFilesClient {

    downloadCourseCertificateTempFile(courseCertificateTempFileId: number | undefined): Promise<FileResponse>;

    uploadCourseCertificateTempFile(file: FileParameter | null | undefined): Promise<number>;
}

export class CourseCertificateTempFilesClient extends AuthorizedApiBase implements ICourseCertificateTempFilesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    downloadCourseCertificateTempFile(courseCertificateTempFileId: number | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/CourseCertificateTempFiles/DownloadCourseCertificateTempFile?";
        if (courseCertificateTempFileId === null)
            throw new Error("The parameter 'courseCertificateTempFileId' cannot be null.");
        else if (courseCertificateTempFileId !== undefined)
            url_ += "courseCertificateTempFileId=" + encodeURIComponent("" + courseCertificateTempFileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadCourseCertificateTempFile(_response);
        });
    }

    protected processDownloadCourseCertificateTempFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    uploadCourseCertificateTempFile(file: FileParameter | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/CourseCertificateTempFiles/UploadCourseCertificateTempFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadCourseCertificateTempFile(_response);
        });
    }

    protected processUploadCourseCertificateTempFile(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export interface ICourseCertificateTempsClient {

    getCourseCertificateTemp(courseId: number | undefined): Promise<CourseCertificateTempReqDto>;

    updateCourseCertificateTemp(command: UpdateCourseCertificateTempCommand): Promise<Unit>;
}

export class CourseCertificateTempsClient extends AuthorizedApiBase implements ICourseCertificateTempsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getCourseCertificateTemp(courseId: number | undefined): Promise<CourseCertificateTempReqDto> {
        let url_ = this.baseUrl + "/api/CourseCertificateTemps/Get?";
        if (courseId === null)
            throw new Error("The parameter 'courseId' cannot be null.");
        else if (courseId !== undefined)
            url_ += "courseId=" + encodeURIComponent("" + courseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCourseCertificateTemp(_response);
        });
    }

    protected processGetCourseCertificateTemp(response: Response): Promise<CourseCertificateTempReqDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CourseCertificateTempReqDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourseCertificateTempReqDto>(null as any);
    }

    updateCourseCertificateTemp(command: UpdateCourseCertificateTempCommand): Promise<Unit> {
        let url_ = this.baseUrl + "/api/CourseCertificateTemps/UpdateCourseCertificateTemp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCourseCertificateTemp(_response);
        });
    }

    protected processUpdateCourseCertificateTemp(response: Response): Promise<Unit> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Unit.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Unit>(null as any);
    }
}

export interface ICourseDefaultGradingsClient {

    searchCourseDefaultGradingWithPagination(courseId: number | undefined): Promise<CourseDefaultGradingDtoVm>;

    getCourseDefaultGrading(courseDefaultGradingId: number | undefined): Promise<CourseDefaultGradingReqDto>;

    createCourseDefaultGrading(command: CreateCourseDefaultGradingCommand): Promise<number>;

    updateCourseDefaultGrading(command: UpdateCourseDefaultGradingCommand): Promise<number>;

    deleteCourseDefaultGrading(courseDefaultGradingId: number | undefined): Promise<Unit>;
}

export class CourseDefaultGradingsClient extends AuthorizedApiBase implements ICourseDefaultGradingsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    searchCourseDefaultGradingWithPagination(courseId: number | undefined): Promise<CourseDefaultGradingDtoVm> {
        let url_ = this.baseUrl + "/api/CourseDefaultGradings/Search?";
        if (courseId === null)
            throw new Error("The parameter 'courseId' cannot be null.");
        else if (courseId !== undefined)
            url_ += "courseId=" + encodeURIComponent("" + courseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchCourseDefaultGradingWithPagination(_response);
        });
    }

    protected processSearchCourseDefaultGradingWithPagination(response: Response): Promise<CourseDefaultGradingDtoVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CourseDefaultGradingDtoVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourseDefaultGradingDtoVm>(null as any);
    }

    getCourseDefaultGrading(courseDefaultGradingId: number | undefined): Promise<CourseDefaultGradingReqDto> {
        let url_ = this.baseUrl + "/api/CourseDefaultGradings/Get?";
        if (courseDefaultGradingId === null)
            throw new Error("The parameter 'courseDefaultGradingId' cannot be null.");
        else if (courseDefaultGradingId !== undefined)
            url_ += "courseDefaultGradingId=" + encodeURIComponent("" + courseDefaultGradingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCourseDefaultGrading(_response);
        });
    }

    protected processGetCourseDefaultGrading(response: Response): Promise<CourseDefaultGradingReqDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CourseDefaultGradingReqDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourseDefaultGradingReqDto>(null as any);
    }

    createCourseDefaultGrading(command: CreateCourseDefaultGradingCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/CourseDefaultGradings/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCourseDefaultGrading(_response);
        });
    }

    protected processCreateCourseDefaultGrading(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    updateCourseDefaultGrading(command: UpdateCourseDefaultGradingCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/CourseDefaultGradings/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCourseDefaultGrading(_response);
        });
    }

    protected processUpdateCourseDefaultGrading(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteCourseDefaultGrading(courseDefaultGradingId: number | undefined): Promise<Unit> {
        let url_ = this.baseUrl + "/api/CourseDefaultGradings/Delete?";
        if (courseDefaultGradingId === null)
            throw new Error("The parameter 'courseDefaultGradingId' cannot be null.");
        else if (courseDefaultGradingId !== undefined)
            url_ += "courseDefaultGradingId=" + encodeURIComponent("" + courseDefaultGradingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteCourseDefaultGrading(_response);
        });
    }

    protected processDeleteCourseDefaultGrading(response: Response): Promise<Unit> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Unit.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Unit>(null as any);
    }
}

export interface ICourseFilesClient {

    downloadCoverlmage(mediaLibraryId: number | undefined): Promise<FileResponse>;

    downloadStepVideo(mediaLibraryId: number | undefined): Promise<FileResponse>;

    downloadStepMaterialFile(courseModuleStepInfoFileId: number | undefined): Promise<FileResponse>;

    uploadStepMaterialFile(file: FileParameter | null | undefined): Promise<number>;
}

export class CourseFilesClient extends AuthorizedApiBase implements ICourseFilesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    downloadCoverlmage(mediaLibraryId: number | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/CourseFiles/DownloadCoverlmage?";
        if (mediaLibraryId === null)
            throw new Error("The parameter 'mediaLibraryId' cannot be null.");
        else if (mediaLibraryId !== undefined)
            url_ += "mediaLibraryId=" + encodeURIComponent("" + mediaLibraryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadCoverlmage(_response);
        });
    }

    protected processDownloadCoverlmage(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    downloadStepVideo(mediaLibraryId: number | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/CourseFiles/DownloadStepVideo?";
        if (mediaLibraryId === null)
            throw new Error("The parameter 'mediaLibraryId' cannot be null.");
        else if (mediaLibraryId !== undefined)
            url_ += "mediaLibraryId=" + encodeURIComponent("" + mediaLibraryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadStepVideo(_response);
        });
    }

    protected processDownloadStepVideo(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    downloadStepMaterialFile(courseModuleStepInfoFileId: number | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/CourseFiles/DownloadStepMaterialFile?";
        if (courseModuleStepInfoFileId === null)
            throw new Error("The parameter 'courseModuleStepInfoFileId' cannot be null.");
        else if (courseModuleStepInfoFileId !== undefined)
            url_ += "courseModuleStepInfoFileId=" + encodeURIComponent("" + courseModuleStepInfoFileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadStepMaterialFile(_response);
        });
    }

    protected processDownloadStepMaterialFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    uploadStepMaterialFile(file: FileParameter | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/CourseFiles/UploadStepMaterialFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadStepMaterialFile(_response);
        });
    }

    protected processUploadStepMaterialFile(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export interface ICourseGroupCertificateTempFilesClient {

    downloadCGCertificateTempFile(courseGroupCertificateTempFileId: number | undefined): Promise<FileResponse>;

    uploadCGCertificateTempFile(file: FileParameter | null | undefined): Promise<number>;
}

export class CourseGroupCertificateTempFilesClient extends AuthorizedApiBase implements ICourseGroupCertificateTempFilesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    downloadCGCertificateTempFile(courseGroupCertificateTempFileId: number | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/CourseGroupCertificateTempFiles/Download?";
        if (courseGroupCertificateTempFileId === null)
            throw new Error("The parameter 'courseGroupCertificateTempFileId' cannot be null.");
        else if (courseGroupCertificateTempFileId !== undefined)
            url_ += "courseGroupCertificateTempFileId=" + encodeURIComponent("" + courseGroupCertificateTempFileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadCGCertificateTempFile(_response);
        });
    }

    protected processDownloadCGCertificateTempFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    uploadCGCertificateTempFile(file: FileParameter | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/CourseGroupCertificateTempFiles/Upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadCGCertificateTempFile(_response);
        });
    }

    protected processUploadCGCertificateTempFile(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export interface ICourseGroupCertificateTempsClient {

    getCourseGroupCertificateTemp(courseGroupSettingId: number | undefined): Promise<CourseGroupCertificateTempDtoVm>;

    updateCourseGroupCertificateTemp(command: UpdateCourseGroupCertificateTempCommand): Promise<Unit>;
}

export class CourseGroupCertificateTempsClient extends AuthorizedApiBase implements ICourseGroupCertificateTempsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getCourseGroupCertificateTemp(courseGroupSettingId: number | undefined): Promise<CourseGroupCertificateTempDtoVm> {
        let url_ = this.baseUrl + "/api/CourseGroupCertificateTemps/Get?";
        if (courseGroupSettingId === null)
            throw new Error("The parameter 'courseGroupSettingId' cannot be null.");
        else if (courseGroupSettingId !== undefined)
            url_ += "courseGroupSettingId=" + encodeURIComponent("" + courseGroupSettingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCourseGroupCertificateTemp(_response);
        });
    }

    protected processGetCourseGroupCertificateTemp(response: Response): Promise<CourseGroupCertificateTempDtoVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CourseGroupCertificateTempDtoVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourseGroupCertificateTempDtoVm>(null as any);
    }

    updateCourseGroupCertificateTemp(command: UpdateCourseGroupCertificateTempCommand): Promise<Unit> {
        let url_ = this.baseUrl + "/api/CourseGroupCertificateTemps/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCourseGroupCertificateTemp(_response);
        });
    }

    protected processUpdateCourseGroupCertificateTemp(response: Response): Promise<Unit> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Unit.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Unit>(null as any);
    }
}

export interface ICourseGroupGradingSetupsClient {

    searchCourseGroupGradingSetupWithPagination(courseGroupSettingId: number | undefined): Promise<CourseGroupGradingSetupDtoVm>;

    getCourseGroupGradingSetup(courseGroupGradingSetupId: number | undefined): Promise<CourseGroupGradingSetupReqDto>;

    createCourseGroupGradingSetup(command: CreateCourseGroupGradingSetupCommand): Promise<number>;

    updateCourseGroupGradingSetup(command: UpdateCourseGroupGradingSetupCommand): Promise<number>;

    deleteCourseGroupGradingSetup(courseGroupGradingSetupId: number | undefined): Promise<Unit>;
}

export class CourseGroupGradingSetupsClient extends AuthorizedApiBase implements ICourseGroupGradingSetupsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    searchCourseGroupGradingSetupWithPagination(courseGroupSettingId: number | undefined): Promise<CourseGroupGradingSetupDtoVm> {
        let url_ = this.baseUrl + "/api/CourseGroupGradingSetups/Search?";
        if (courseGroupSettingId === null)
            throw new Error("The parameter 'courseGroupSettingId' cannot be null.");
        else if (courseGroupSettingId !== undefined)
            url_ += "courseGroupSettingId=" + encodeURIComponent("" + courseGroupSettingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchCourseGroupGradingSetupWithPagination(_response);
        });
    }

    protected processSearchCourseGroupGradingSetupWithPagination(response: Response): Promise<CourseGroupGradingSetupDtoVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CourseGroupGradingSetupDtoVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourseGroupGradingSetupDtoVm>(null as any);
    }

    getCourseGroupGradingSetup(courseGroupGradingSetupId: number | undefined): Promise<CourseGroupGradingSetupReqDto> {
        let url_ = this.baseUrl + "/api/CourseGroupGradingSetups/Get?";
        if (courseGroupGradingSetupId === null)
            throw new Error("The parameter 'courseGroupGradingSetupId' cannot be null.");
        else if (courseGroupGradingSetupId !== undefined)
            url_ += "courseGroupGradingSetupId=" + encodeURIComponent("" + courseGroupGradingSetupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCourseGroupGradingSetup(_response);
        });
    }

    protected processGetCourseGroupGradingSetup(response: Response): Promise<CourseGroupGradingSetupReqDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CourseGroupGradingSetupReqDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourseGroupGradingSetupReqDto>(null as any);
    }

    createCourseGroupGradingSetup(command: CreateCourseGroupGradingSetupCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/CourseGroupGradingSetups/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCourseGroupGradingSetup(_response);
        });
    }

    protected processCreateCourseGroupGradingSetup(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    updateCourseGroupGradingSetup(command: UpdateCourseGroupGradingSetupCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/CourseGroupGradingSetups/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCourseGroupGradingSetup(_response);
        });
    }

    protected processUpdateCourseGroupGradingSetup(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteCourseGroupGradingSetup(courseGroupGradingSetupId: number | undefined): Promise<Unit> {
        let url_ = this.baseUrl + "/api/CourseGroupGradingSetups/Delete?";
        if (courseGroupGradingSetupId === null)
            throw new Error("The parameter 'courseGroupGradingSetupId' cannot be null.");
        else if (courseGroupGradingSetupId !== undefined)
            url_ += "courseGroupGradingSetupId=" + encodeURIComponent("" + courseGroupGradingSetupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteCourseGroupGradingSetup(_response);
        });
    }

    protected processDeleteCourseGroupGradingSetup(response: Response): Promise<Unit> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Unit.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Unit>(null as any);
    }
}

export interface ICourseGroupModulesClient {

    searchCourseGroupModuleWithPagination(courseGroupSettingId: number | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfCourseGroupModuleBriefDto>;

    getCourseGroupModule(courseGroupModuleId: number | undefined): Promise<CourseGroupModuleBriefDto>;

    updateCourseGroupGradingSetup(command: UpdateCourseGroupModuleCommand): Promise<number>;
}

export class CourseGroupModulesClient extends AuthorizedApiBase implements ICourseGroupModulesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    searchCourseGroupModuleWithPagination(courseGroupSettingId: number | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfCourseGroupModuleBriefDto> {
        let url_ = this.baseUrl + "/api/CourseGroupModules/Search?";
        if (courseGroupSettingId === null)
            throw new Error("The parameter 'courseGroupSettingId' cannot be null.");
        else if (courseGroupSettingId !== undefined)
            url_ += "CourseGroupSettingId=" + encodeURIComponent("" + courseGroupSettingId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchCourseGroupModuleWithPagination(_response);
        });
    }

    protected processSearchCourseGroupModuleWithPagination(response: Response): Promise<PaginatedListOfCourseGroupModuleBriefDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfCourseGroupModuleBriefDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfCourseGroupModuleBriefDto>(null as any);
    }

    getCourseGroupModule(courseGroupModuleId: number | undefined): Promise<CourseGroupModuleBriefDto> {
        let url_ = this.baseUrl + "/api/CourseGroupModules/Get?";
        if (courseGroupModuleId === null)
            throw new Error("The parameter 'courseGroupModuleId' cannot be null.");
        else if (courseGroupModuleId !== undefined)
            url_ += "courseGroupModuleId=" + encodeURIComponent("" + courseGroupModuleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCourseGroupModule(_response);
        });
    }

    protected processGetCourseGroupModule(response: Response): Promise<CourseGroupModuleBriefDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CourseGroupModuleBriefDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourseGroupModuleBriefDto>(null as any);
    }

    updateCourseGroupGradingSetup(command: UpdateCourseGroupModuleCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/CourseGroupModules/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCourseGroupGradingSetup(_response);
        });
    }

    protected processUpdateCourseGroupGradingSetup(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export interface ICourseGroupModuleStepsClient {

    searchCourseGroupModuleStepWithPagination(courseGroupModuleId: number | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfCourseGroupModuleStepBriefDto>;

    getCourseGroupModuleStep(courseGroupQuizExamId: number | undefined): Promise<CourseGroupModuleStepReqDto>;

    updateCourseGroupModuleStep(command: UpdateCourseGroupModuleStepCommand): Promise<number>;

    getQuizExam(courseGroupModuleStepId: number | undefined, languageId: string | undefined): Promise<CourseGroupModuleStepQuestionDto>;

    answerMatchQuestion(command: AnswerMatchCourseQuestionCommand): Promise<AnswerMatchCourseQuestionDto[]>;
}

export class CourseGroupModuleStepsClient extends AuthorizedApiBase implements ICourseGroupModuleStepsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    searchCourseGroupModuleStepWithPagination(courseGroupModuleId: number | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfCourseGroupModuleStepBriefDto> {
        let url_ = this.baseUrl + "/api/CourseGroupModuleSteps/Search?";
        if (courseGroupModuleId === null)
            throw new Error("The parameter 'courseGroupModuleId' cannot be null.");
        else if (courseGroupModuleId !== undefined)
            url_ += "CourseGroupModuleId=" + encodeURIComponent("" + courseGroupModuleId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchCourseGroupModuleStepWithPagination(_response);
        });
    }

    protected processSearchCourseGroupModuleStepWithPagination(response: Response): Promise<PaginatedListOfCourseGroupModuleStepBriefDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfCourseGroupModuleStepBriefDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfCourseGroupModuleStepBriefDto>(null as any);
    }

    getCourseGroupModuleStep(courseGroupQuizExamId: number | undefined): Promise<CourseGroupModuleStepReqDto> {
        let url_ = this.baseUrl + "/api/CourseGroupModuleSteps/Get?";
        if (courseGroupQuizExamId === null)
            throw new Error("The parameter 'courseGroupQuizExamId' cannot be null.");
        else if (courseGroupQuizExamId !== undefined)
            url_ += "courseGroupQuizExamId=" + encodeURIComponent("" + courseGroupQuizExamId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCourseGroupModuleStep(_response);
        });
    }

    protected processGetCourseGroupModuleStep(response: Response): Promise<CourseGroupModuleStepReqDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CourseGroupModuleStepReqDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourseGroupModuleStepReqDto>(null as any);
    }

    updateCourseGroupModuleStep(command: UpdateCourseGroupModuleStepCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/CourseGroupModuleSteps/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCourseGroupModuleStep(_response);
        });
    }

    protected processUpdateCourseGroupModuleStep(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getQuizExam(courseGroupModuleStepId: number | undefined, languageId: string | undefined): Promise<CourseGroupModuleStepQuestionDto> {
        let url_ = this.baseUrl + "/api/CourseGroupModuleSteps/GetQuizExam?";
        if (courseGroupModuleStepId === null)
            throw new Error("The parameter 'courseGroupModuleStepId' cannot be null.");
        else if (courseGroupModuleStepId !== undefined)
            url_ += "courseGroupModuleStepId=" + encodeURIComponent("" + courseGroupModuleStepId) + "&";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetQuizExam(_response);
        });
    }

    protected processGetQuizExam(response: Response): Promise<CourseGroupModuleStepQuestionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CourseGroupModuleStepQuestionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourseGroupModuleStepQuestionDto>(null as any);
    }

    answerMatchQuestion(command: AnswerMatchCourseQuestionCommand): Promise<AnswerMatchCourseQuestionDto[]> {
        let url_ = this.baseUrl + "/api/CourseGroupModuleSteps/AnswerMatchQuestion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAnswerMatchQuestion(_response);
        });
    }

    protected processAnswerMatchQuestion(response: Response): Promise<AnswerMatchCourseQuestionDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AnswerMatchCourseQuestionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AnswerMatchCourseQuestionDto[]>(null as any);
    }
}

export interface ICourseGroupSettingLanguagesClient {

    getCourseGroupSettingLanguages(courseGroupSettingId: number | undefined): Promise<CourseGroupSettingLanguageBriefDto[]>;
}

export class CourseGroupSettingLanguagesClient extends AuthorizedApiBase implements ICourseGroupSettingLanguagesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getCourseGroupSettingLanguages(courseGroupSettingId: number | undefined): Promise<CourseGroupSettingLanguageBriefDto[]> {
        let url_ = this.baseUrl + "/api/CourseGroupSettingLanguages/Get?";
        if (courseGroupSettingId === null)
            throw new Error("The parameter 'courseGroupSettingId' cannot be null.");
        else if (courseGroupSettingId !== undefined)
            url_ += "courseGroupSettingId=" + encodeURIComponent("" + courseGroupSettingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCourseGroupSettingLanguages(_response);
        });
    }

    protected processGetCourseGroupSettingLanguages(response: Response): Promise<CourseGroupSettingLanguageBriefDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CourseGroupSettingLanguageBriefDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourseGroupSettingLanguageBriefDto[]>(null as any);
    }
}

export interface ICourseGroupSettingsClient {

    searchCourseGroupSetting(query: SearchCourseGroupSettingWithPagination): Promise<PaginatedListOfCourseGroupSettingAdminBriefDto>;

    getCourseGroupSetting(id: number | undefined): Promise<CourseGroupSettingAdminBriefDto>;

    verifyCourseModuleStepItem(courseId: number | undefined, clientGroupId: number | undefined): Promise<VerifyReqDto>;

    getWithPagination(courseName: string | null | undefined, accessPeriodFrom: Date | null | undefined, accessPeriodTo: Date | null | undefined, courseStatuses: CourseGroupSettingStatus[] | undefined, studyStatuses: ClientUserCourseStatus[] | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfCourseGroupSettingBriefDto>;

    createCourseGroupSetting(courseId: number | undefined, clientGroupId: number | undefined): Promise<number>;

    updateCourseGroupSetting(command: UpdateCourseGroupSettingCommand): Promise<number>;

    deleteCourseGroupSetting(courseGroupSettingId: number | undefined): Promise<number>;

    checkCourseGroupSettingsPermission(clientGroupId: number | undefined): Promise<CheckCourseGroupSettingDto>;

    getCourseGroupSettingCourse(clientGroupId: number | undefined): Promise<CourseGroupSettingCourseDto[]>;
}

export class CourseGroupSettingsClient extends AuthorizedApiBase implements ICourseGroupSettingsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    searchCourseGroupSetting(query: SearchCourseGroupSettingWithPagination): Promise<PaginatedListOfCourseGroupSettingAdminBriefDto> {
        let url_ = this.baseUrl + "/api/CourseGroupSettings/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchCourseGroupSetting(_response);
        });
    }

    protected processSearchCourseGroupSetting(response: Response): Promise<PaginatedListOfCourseGroupSettingAdminBriefDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfCourseGroupSettingAdminBriefDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfCourseGroupSettingAdminBriefDto>(null as any);
    }

    getCourseGroupSetting(id: number | undefined): Promise<CourseGroupSettingAdminBriefDto> {
        let url_ = this.baseUrl + "/api/CourseGroupSettings/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCourseGroupSetting(_response);
        });
    }

    protected processGetCourseGroupSetting(response: Response): Promise<CourseGroupSettingAdminBriefDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CourseGroupSettingAdminBriefDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourseGroupSettingAdminBriefDto>(null as any);
    }

    verifyCourseModuleStepItem(courseId: number | undefined, clientGroupId: number | undefined): Promise<VerifyReqDto> {
        let url_ = this.baseUrl + "/api/CourseGroupSettings/GetVerify?";
        if (courseId === null)
            throw new Error("The parameter 'courseId' cannot be null.");
        else if (courseId !== undefined)
            url_ += "courseId=" + encodeURIComponent("" + courseId) + "&";
        if (clientGroupId === null)
            throw new Error("The parameter 'clientGroupId' cannot be null.");
        else if (clientGroupId !== undefined)
            url_ += "clientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processVerifyCourseModuleStepItem(_response);
        });
    }

    protected processVerifyCourseModuleStepItem(response: Response): Promise<VerifyReqDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VerifyReqDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VerifyReqDto>(null as any);
    }

    getWithPagination(courseName: string | null | undefined, accessPeriodFrom: Date | null | undefined, accessPeriodTo: Date | null | undefined, courseStatuses: CourseGroupSettingStatus[] | undefined, studyStatuses: ClientUserCourseStatus[] | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfCourseGroupSettingBriefDto> {
        let url_ = this.baseUrl + "/api/CourseGroupSettings/GetWithPagination?";
        if (courseName !== undefined && courseName !== null)
            url_ += "CourseName=" + encodeURIComponent("" + courseName) + "&";
        if (accessPeriodFrom !== undefined && accessPeriodFrom !== null)
            url_ += "AccessPeriodFrom=" + encodeURIComponent(accessPeriodFrom ? "" + accessPeriodFrom.toISOString() : "") + "&";
        if (accessPeriodTo !== undefined && accessPeriodTo !== null)
            url_ += "AccessPeriodTo=" + encodeURIComponent(accessPeriodTo ? "" + accessPeriodTo.toISOString() : "") + "&";
        if (courseStatuses === null)
            throw new Error("The parameter 'courseStatuses' cannot be null.");
        else if (courseStatuses !== undefined)
            courseStatuses && courseStatuses.forEach(item => { url_ += "CourseStatuses=" + encodeURIComponent("" + item) + "&"; });
        if (studyStatuses === null)
            throw new Error("The parameter 'studyStatuses' cannot be null.");
        else if (studyStatuses !== undefined)
            studyStatuses && studyStatuses.forEach(item => { url_ += "StudyStatuses=" + encodeURIComponent("" + item) + "&"; });
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetWithPagination(_response);
        });
    }

    protected processGetWithPagination(response: Response): Promise<PaginatedListOfCourseGroupSettingBriefDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfCourseGroupSettingBriefDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfCourseGroupSettingBriefDto>(null as any);
    }

    createCourseGroupSetting(courseId: number | undefined, clientGroupId: number | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/CourseGroupSettings/Create?";
        if (courseId === null)
            throw new Error("The parameter 'courseId' cannot be null.");
        else if (courseId !== undefined)
            url_ += "courseId=" + encodeURIComponent("" + courseId) + "&";
        if (clientGroupId === null)
            throw new Error("The parameter 'clientGroupId' cannot be null.");
        else if (clientGroupId !== undefined)
            url_ += "clientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCourseGroupSetting(_response);
        });
    }

    protected processCreateCourseGroupSetting(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    updateCourseGroupSetting(command: UpdateCourseGroupSettingCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/CourseGroupSettings/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCourseGroupSetting(_response);
        });
    }

    protected processUpdateCourseGroupSetting(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteCourseGroupSetting(courseGroupSettingId: number | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/CourseGroupSettings/Delete?";
        if (courseGroupSettingId === null)
            throw new Error("The parameter 'courseGroupSettingId' cannot be null.");
        else if (courseGroupSettingId !== undefined)
            url_ += "courseGroupSettingId=" + encodeURIComponent("" + courseGroupSettingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteCourseGroupSetting(_response);
        });
    }

    protected processDeleteCourseGroupSetting(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    checkCourseGroupSettingsPermission(clientGroupId: number | undefined): Promise<CheckCourseGroupSettingDto> {
        let url_ = this.baseUrl + "/api/CourseGroupSettings/CheckCourseGroupSettingsPermission?";
        if (clientGroupId === null)
            throw new Error("The parameter 'clientGroupId' cannot be null.");
        else if (clientGroupId !== undefined)
            url_ += "clientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCheckCourseGroupSettingsPermission(_response);
        });
    }

    protected processCheckCourseGroupSettingsPermission(response: Response): Promise<CheckCourseGroupSettingDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckCourseGroupSettingDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CheckCourseGroupSettingDto>(null as any);
    }

    getCourseGroupSettingCourse(clientGroupId: number | undefined): Promise<CourseGroupSettingCourseDto[]> {
        let url_ = this.baseUrl + "/api/CourseGroupSettings/GetCourseGroupSettingCourse?";
        if (clientGroupId === null)
            throw new Error("The parameter 'clientGroupId' cannot be null.");
        else if (clientGroupId !== undefined)
            url_ += "clientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCourseGroupSettingCourse(_response);
        });
    }

    protected processGetCourseGroupSettingCourse(response: Response): Promise<CourseGroupSettingCourseDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CourseGroupSettingCourseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourseGroupSettingCourseDto[]>(null as any);
    }
}

export interface ICourseInfosClient {

    getCourseLanguage(courseId: number | undefined): Promise<CourseLanguageBriefDto[]>;

    getCourseInfo(courseId: number | undefined): Promise<CourseReqDto>;

    getCourseName(courseId: number | undefined): Promise<CourseReqDto>;

    updateCourseInfo(command: UpdateCourseInfoCommand): Promise<number>;
}

export class CourseInfosClient extends AuthorizedApiBase implements ICourseInfosClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getCourseLanguage(courseId: number | undefined): Promise<CourseLanguageBriefDto[]> {
        let url_ = this.baseUrl + "/api/CourseInfos/GetCourseLanguage?";
        if (courseId === null)
            throw new Error("The parameter 'courseId' cannot be null.");
        else if (courseId !== undefined)
            url_ += "courseId=" + encodeURIComponent("" + courseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCourseLanguage(_response);
        });
    }

    protected processGetCourseLanguage(response: Response): Promise<CourseLanguageBriefDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CourseLanguageBriefDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourseLanguageBriefDto[]>(null as any);
    }

    getCourseInfo(courseId: number | undefined): Promise<CourseReqDto> {
        let url_ = this.baseUrl + "/api/CourseInfos/GetCourseInfo?";
        if (courseId === null)
            throw new Error("The parameter 'courseId' cannot be null.");
        else if (courseId !== undefined)
            url_ += "courseId=" + encodeURIComponent("" + courseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCourseInfo(_response);
        });
    }

    protected processGetCourseInfo(response: Response): Promise<CourseReqDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CourseReqDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourseReqDto>(null as any);
    }

    getCourseName(courseId: number | undefined): Promise<CourseReqDto> {
        let url_ = this.baseUrl + "/api/CourseInfos/GetCourseName?";
        if (courseId === null)
            throw new Error("The parameter 'courseId' cannot be null.");
        else if (courseId !== undefined)
            url_ += "courseId=" + encodeURIComponent("" + courseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCourseName(_response);
        });
    }

    protected processGetCourseName(response: Response): Promise<CourseReqDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CourseReqDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourseReqDto>(null as any);
    }

    updateCourseInfo(command: UpdateCourseInfoCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/CourseInfos/UpdateCourseInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCourseInfo(_response);
        });
    }

    protected processUpdateCourseInfo(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export interface ICourseModuleItemsClient {

    getCourseModuleItem(courseModuleId: number | undefined): Promise<{ [key: string]: CourseModuleItemBriefDto; }>;

    updateCourseModuleItem(command: UpdateCourseModuleItemCommand): Promise<number>;
}

export class CourseModuleItemsClient extends AuthorizedApiBase implements ICourseModuleItemsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getCourseModuleItem(courseModuleId: number | undefined): Promise<{ [key: string]: CourseModuleItemBriefDto; }> {
        let url_ = this.baseUrl + "/api/CourseModuleItems/GetCourseModuleItem?";
        if (courseModuleId === null)
            throw new Error("The parameter 'courseModuleId' cannot be null.");
        else if (courseModuleId !== undefined)
            url_ += "courseModuleId=" + encodeURIComponent("" + courseModuleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCourseModuleItem(_response);
        });
    }

    protected processGetCourseModuleItem(response: Response): Promise<{ [key: string]: CourseModuleItemBriefDto; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] ? CourseModuleItemBriefDto.fromJS(resultData200[key]) : new CourseModuleItemBriefDto();
                }
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: CourseModuleItemBriefDto; }>(null as any);
    }

    updateCourseModuleItem(command: UpdateCourseModuleItemCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/CourseModuleItems/UpdateCourseModuleItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCourseModuleItem(_response);
        });
    }

    protected processUpdateCourseModuleItem(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export interface ICourseModulesClient {

    getCourseModules(courseId: number | undefined): Promise<CourseModuleBriefDto[]>;

    createCourseModule(command: CreateCourseModuleCommand): Promise<number>;

    updateCourseModuleSort(command: UpdateCourseModuleSortCommand): Promise<Unit>;

    deleteCourseModule(courseModuleId: number | undefined): Promise<Unit>;
}

export class CourseModulesClient extends AuthorizedApiBase implements ICourseModulesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getCourseModules(courseId: number | undefined): Promise<CourseModuleBriefDto[]> {
        let url_ = this.baseUrl + "/api/CourseModules/GetCourseModules?";
        if (courseId === null)
            throw new Error("The parameter 'courseId' cannot be null.");
        else if (courseId !== undefined)
            url_ += "courseId=" + encodeURIComponent("" + courseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCourseModules(_response);
        });
    }

    protected processGetCourseModules(response: Response): Promise<CourseModuleBriefDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CourseModuleBriefDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourseModuleBriefDto[]>(null as any);
    }

    createCourseModule(command: CreateCourseModuleCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/CourseModules/CreateCourseModule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCourseModule(_response);
        });
    }

    protected processCreateCourseModule(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    updateCourseModuleSort(command: UpdateCourseModuleSortCommand): Promise<Unit> {
        let url_ = this.baseUrl + "/api/CourseModules/UpdateCourseModuleSort";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCourseModuleSort(_response);
        });
    }

    protected processUpdateCourseModuleSort(response: Response): Promise<Unit> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Unit.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Unit>(null as any);
    }

    deleteCourseModule(courseModuleId: number | undefined): Promise<Unit> {
        let url_ = this.baseUrl + "/api/CourseModules/DeleteCourseModule?";
        if (courseModuleId === null)
            throw new Error("The parameter 'courseModuleId' cannot be null.");
        else if (courseModuleId !== undefined)
            url_ += "courseModuleId=" + encodeURIComponent("" + courseModuleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteCourseModule(_response);
        });
    }

    protected processDeleteCourseModule(response: Response): Promise<Unit> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Unit.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Unit>(null as any);
    }
}

export interface ICourseModuleStepInfoFilesClient {

    uploadRichTextImage(file: FileParameter | null | undefined): Promise<number>;

    getRichTextImage(token: string | undefined): Promise<FileResponse>;

    getRichTextImageSignedUrl(fileId: number): Promise<string>;

    downloadStepAllMaterialFile(courseModuleStepItemId: number): Promise<FileResponse>;

    sendStepAllMaterialFile(courseModuleStepItemId: number): Promise<FileResponse>;

    getCourseMaterialFiles(courseModuleStepItemId: number): Promise<CourseMaterialFileDto[]>;

    downloadStepAllMaterialFileByIds(command: DownloadStepAllMaterialFileByIdsCommand): Promise<FileResponse>;

    sendStepAllMaterialFileByIds(command: SendStepAllMaterialFileByIdsCommand): Promise<FileResponse>;
}

export class CourseModuleStepInfoFilesClient extends AuthorizedApiBase implements ICourseModuleStepInfoFilesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    uploadRichTextImage(file: FileParameter | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/CourseModuleStepInfoFiles/RichTextImage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadRichTextImage(_response);
        });
    }

    protected processUploadRichTextImage(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getRichTextImage(token: string | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/CourseModuleStepInfoFiles/RichTextImage?";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRichTextImage(_response);
        });
    }

    protected processGetRichTextImage(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getRichTextImageSignedUrl(fileId: number): Promise<string> {
        let url_ = this.baseUrl + "/api/CourseModuleStepInfoFiles/RichTextImage/{fileId}/SignedUrl";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRichTextImageSignedUrl(_response);
        });
    }

    protected processGetRichTextImageSignedUrl(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    downloadStepAllMaterialFile(courseModuleStepItemId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/CourseModuleStepInfoFiles/{courseModuleStepItemId}/DownloadAll";
        if (courseModuleStepItemId === undefined || courseModuleStepItemId === null)
            throw new Error("The parameter 'courseModuleStepItemId' must be defined.");
        url_ = url_.replace("{courseModuleStepItemId}", encodeURIComponent("" + courseModuleStepItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadStepAllMaterialFile(_response);
        });
    }

    protected processDownloadStepAllMaterialFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    sendStepAllMaterialFile(courseModuleStepItemId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/CourseModuleStepInfoFiles/{courseModuleStepItemId}/SendAll";
        if (courseModuleStepItemId === undefined || courseModuleStepItemId === null)
            throw new Error("The parameter 'courseModuleStepItemId' must be defined.");
        url_ = url_.replace("{courseModuleStepItemId}", encodeURIComponent("" + courseModuleStepItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendStepAllMaterialFile(_response);
        });
    }

    protected processSendStepAllMaterialFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getCourseMaterialFiles(courseModuleStepItemId: number): Promise<CourseMaterialFileDto[]> {
        let url_ = this.baseUrl + "/api/CourseModuleStepInfoFiles/{courseModuleStepItemId}/List";
        if (courseModuleStepItemId === undefined || courseModuleStepItemId === null)
            throw new Error("The parameter 'courseModuleStepItemId' must be defined.");
        url_ = url_.replace("{courseModuleStepItemId}", encodeURIComponent("" + courseModuleStepItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCourseMaterialFiles(_response);
        });
    }

    protected processGetCourseMaterialFiles(response: Response): Promise<CourseMaterialFileDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CourseMaterialFileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourseMaterialFileDto[]>(null as any);
    }

    downloadStepAllMaterialFileByIds(command: DownloadStepAllMaterialFileByIdsCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/CourseModuleStepInfoFiles/DownloadStepAllMaterialFileByIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadStepAllMaterialFileByIds(_response);
        });
    }

    protected processDownloadStepAllMaterialFileByIds(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    sendStepAllMaterialFileByIds(command: SendStepAllMaterialFileByIdsCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/CourseModuleStepInfoFiles/SendAllByMaterialIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendStepAllMaterialFileByIds(_response);
        });
    }

    protected processSendStepAllMaterialFileByIds(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface ICourseModuleStepItemsClient {

    getCourseModuleStepItems(courseModuleStepId: number | undefined): Promise<CourseModuleStepItemsDtoVm>;

    updateCourseModuleStepItem(command: UpdateCourseModuleStepItemCommand): Promise<number>;
}

export class CourseModuleStepItemsClient extends AuthorizedApiBase implements ICourseModuleStepItemsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getCourseModuleStepItems(courseModuleStepId: number | undefined): Promise<CourseModuleStepItemsDtoVm> {
        let url_ = this.baseUrl + "/api/CourseModuleStepItems/GetCourseModuleStepItems?";
        if (courseModuleStepId === null)
            throw new Error("The parameter 'courseModuleStepId' cannot be null.");
        else if (courseModuleStepId !== undefined)
            url_ += "courseModuleStepId=" + encodeURIComponent("" + courseModuleStepId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCourseModuleStepItems(_response);
        });
    }

    protected processGetCourseModuleStepItems(response: Response): Promise<CourseModuleStepItemsDtoVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CourseModuleStepItemsDtoVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourseModuleStepItemsDtoVm>(null as any);
    }

    updateCourseModuleStepItem(command: UpdateCourseModuleStepItemCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/CourseModuleStepItems/UpdateCourseModuleStepItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCourseModuleStepItem(_response);
        });
    }

    protected processUpdateCourseModuleStepItem(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export interface ICourseModuleStepsClient {

    createCourseModuleStep(command: CreateCourseModuleStepCommand): Promise<number>;

    deleteCourseModuleStep(courseModuleStepId: number | undefined): Promise<Unit>;
}

export class CourseModuleStepsClient extends AuthorizedApiBase implements ICourseModuleStepsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    createCourseModuleStep(command: CreateCourseModuleStepCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/CourseModuleSteps/CreateCourseModuleStep";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCourseModuleStep(_response);
        });
    }

    protected processCreateCourseModuleStep(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteCourseModuleStep(courseModuleStepId: number | undefined): Promise<Unit> {
        let url_ = this.baseUrl + "/api/CourseModuleSteps/DeleteCourseModuleStep?";
        if (courseModuleStepId === null)
            throw new Error("The parameter 'courseModuleStepId' cannot be null.");
        else if (courseModuleStepId !== undefined)
            url_ += "courseModuleStepId=" + encodeURIComponent("" + courseModuleStepId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteCourseModuleStep(_response);
        });
    }

    protected processDeleteCourseModuleStep(response: Response): Promise<Unit> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Unit.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Unit>(null as any);
    }
}

export interface ICourseProgressClient {

    searchClientUserCoursesProgress(query: SearchClientUserCoursesProgressWithPagination): Promise<PaginatedListOfAdminClientUserCourseBriefDto>;

    searchQuizExamProgress(query: SearchClientUserCoursesQuizExamProgressWithPagination): Promise<PaginatedListOfAdminClientUserQuizExamBriefDto>;

    downloadCourseProgress(command: DownloadCourseProgressCommand): Promise<FileResponse>;

    downloadUserQuizExamProgress(command: DownloadUserQuizExamProgressCommand): Promise<FileResponse>;

    downloadUserQuizExamProgressAll(command: DownloadUserQuizExamProgressAllCommand): Promise<FileResponse>;

    sendCourseProgressReminder(command: SendCourseProgressReminderCommand): Promise<FileResponse>;

    sendClientUserQuizExamProgress(command: SendClientUserQuizExamProgressCommand): Promise<FileResponse>;

    getGroupCourseByLanguage(query: GetGroupCourseByLanguageQuery): Promise<PaginatedListOfGetGroupCourseByLanguageDto>;

    downloadUserQuizExamProgressAllByLanguag(command: DownloadUserQuizExamProgressAllByLanguagCommand): Promise<FileResponse>;
}

export class CourseProgressClient extends AuthorizedApiBase implements ICourseProgressClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    searchClientUserCoursesProgress(query: SearchClientUserCoursesProgressWithPagination): Promise<PaginatedListOfAdminClientUserCourseBriefDto> {
        let url_ = this.baseUrl + "/api/CourseProgress/SearchClientUserCoursesProgress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchClientUserCoursesProgress(_response);
        });
    }

    protected processSearchClientUserCoursesProgress(response: Response): Promise<PaginatedListOfAdminClientUserCourseBriefDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfAdminClientUserCourseBriefDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfAdminClientUserCourseBriefDto>(null as any);
    }

    searchQuizExamProgress(query: SearchClientUserCoursesQuizExamProgressWithPagination): Promise<PaginatedListOfAdminClientUserQuizExamBriefDto> {
        let url_ = this.baseUrl + "/api/CourseProgress/SearchQuizExamProgress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchQuizExamProgress(_response);
        });
    }

    protected processSearchQuizExamProgress(response: Response): Promise<PaginatedListOfAdminClientUserQuizExamBriefDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfAdminClientUserQuizExamBriefDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfAdminClientUserQuizExamBriefDto>(null as any);
    }

    downloadCourseProgress(command: DownloadCourseProgressCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/CourseProgress/DownloadCourseProgress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadCourseProgress(_response);
        });
    }

    protected processDownloadCourseProgress(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    downloadUserQuizExamProgress(command: DownloadUserQuizExamProgressCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/CourseProgress/DownloadUserQuizExamProgress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadUserQuizExamProgress(_response);
        });
    }

    protected processDownloadUserQuizExamProgress(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    downloadUserQuizExamProgressAll(command: DownloadUserQuizExamProgressAllCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/CourseProgress/DownloadUserQuizExamProgressAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadUserQuizExamProgressAll(_response);
        });
    }

    protected processDownloadUserQuizExamProgressAll(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    sendCourseProgressReminder(command: SendCourseProgressReminderCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/CourseProgress/SendCourseProgressReminder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendCourseProgressReminder(_response);
        });
    }

    protected processSendCourseProgressReminder(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    sendClientUserQuizExamProgress(command: SendClientUserQuizExamProgressCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/CourseProgress/SendClientUserQuizExamProgress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendClientUserQuizExamProgress(_response);
        });
    }

    protected processSendClientUserQuizExamProgress(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getGroupCourseByLanguage(query: GetGroupCourseByLanguageQuery): Promise<PaginatedListOfGetGroupCourseByLanguageDto> {
        let url_ = this.baseUrl + "/api/CourseProgress/SearchGroupCourseByLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGroupCourseByLanguage(_response);
        });
    }

    protected processGetGroupCourseByLanguage(response: Response): Promise<PaginatedListOfGetGroupCourseByLanguageDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfGetGroupCourseByLanguageDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfGetGroupCourseByLanguageDto>(null as any);
    }

    downloadUserQuizExamProgressAllByLanguag(command: DownloadUserQuizExamProgressAllByLanguagCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/CourseProgress/DownloadUserQuizExamProgressAllByLanguag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadUserQuizExamProgressAllByLanguag(_response);
        });
    }

    protected processDownloadUserQuizExamProgressAllByLanguag(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface ICourseQuestionBanksClient {

    searchQuestionBanksWithPagination(keyword: string | null | undefined, courseId: number | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfQuestionBankBriefDto>;

    getQuestionBank(id: number | undefined): Promise<CourseQuestionBankDto>;

    getQuestionBankList(courseId: number | undefined): Promise<QuestionBankBriefDto[]>;

    createCourseQuestion(questionName: string | undefined, courseId: number | undefined, singleChoiceFile: FileParameter | null | undefined, multipleChoiceFile: FileParameter | null | undefined, openEndedFile: FileParameter | null | undefined): Promise<UploadCourseQuestionDto>;

    deleteCourseQuestion(id: number | undefined): Promise<FileResponse>;

    downloadCourseQuestionBank(id: number | undefined, courseQuestionType: CourseQuestionType | null | undefined): Promise<FileResponse>;

    downloadCourseQuestionBankTemp(): Promise<FileResponse>;

    downloadCourseQuestionBank2(courseId: number | undefined, courseQuestionType: CourseQuestionType | undefined, file: FileParameter | null | undefined): Promise<UploadCourseQuestionDto>;

    updateCourseQuestionBank(questionName: string | undefined, courseId: number | undefined, id: number | undefined, deleteNmae: string | undefined, singleChoiceFile: FileParameter | null | undefined, multipleChoiceFile: FileParameter | null | undefined, openEndedFile: FileParameter | null | undefined): Promise<UploadCourseQuestionDto>;
}

export class CourseQuestionBanksClient extends AuthorizedApiBase implements ICourseQuestionBanksClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    searchQuestionBanksWithPagination(keyword: string | null | undefined, courseId: number | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfQuestionBankBriefDto> {
        let url_ = this.baseUrl + "/api/CourseQuestionBanks/Search?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (courseId === null)
            throw new Error("The parameter 'courseId' cannot be null.");
        else if (courseId !== undefined)
            url_ += "CourseId=" + encodeURIComponent("" + courseId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchQuestionBanksWithPagination(_response);
        });
    }

    protected processSearchQuestionBanksWithPagination(response: Response): Promise<PaginatedListOfQuestionBankBriefDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfQuestionBankBriefDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfQuestionBankBriefDto>(null as any);
    }

    getQuestionBank(id: number | undefined): Promise<CourseQuestionBankDto> {
        let url_ = this.baseUrl + "/api/CourseQuestionBanks/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetQuestionBank(_response);
        });
    }

    protected processGetQuestionBank(response: Response): Promise<CourseQuestionBankDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CourseQuestionBankDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourseQuestionBankDto>(null as any);
    }

    getQuestionBankList(courseId: number | undefined): Promise<QuestionBankBriefDto[]> {
        let url_ = this.baseUrl + "/api/CourseQuestionBanks/GetList?";
        if (courseId === null)
            throw new Error("The parameter 'courseId' cannot be null.");
        else if (courseId !== undefined)
            url_ += "courseId=" + encodeURIComponent("" + courseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetQuestionBankList(_response);
        });
    }

    protected processGetQuestionBankList(response: Response): Promise<QuestionBankBriefDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QuestionBankBriefDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionBankBriefDto[]>(null as any);
    }

    createCourseQuestion(questionName: string | undefined, courseId: number | undefined, singleChoiceFile: FileParameter | null | undefined, multipleChoiceFile: FileParameter | null | undefined, openEndedFile: FileParameter | null | undefined): Promise<UploadCourseQuestionDto> {
        let url_ = this.baseUrl + "/api/CourseQuestionBanks/Create?";
        if (questionName === null)
            throw new Error("The parameter 'questionName' cannot be null.");
        else if (questionName !== undefined)
            url_ += "questionName=" + encodeURIComponent("" + questionName) + "&";
        if (courseId === null)
            throw new Error("The parameter 'courseId' cannot be null.");
        else if (courseId !== undefined)
            url_ += "courseId=" + encodeURIComponent("" + courseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (singleChoiceFile !== null && singleChoiceFile !== undefined)
            content_.append("singleChoiceFile", singleChoiceFile.data, singleChoiceFile.fileName ? singleChoiceFile.fileName : "singleChoiceFile");
        if (multipleChoiceFile !== null && multipleChoiceFile !== undefined)
            content_.append("multipleChoiceFile", multipleChoiceFile.data, multipleChoiceFile.fileName ? multipleChoiceFile.fileName : "multipleChoiceFile");
        if (openEndedFile !== null && openEndedFile !== undefined)
            content_.append("openEndedFile", openEndedFile.data, openEndedFile.fileName ? openEndedFile.fileName : "openEndedFile");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCourseQuestion(_response);
        });
    }

    protected processCreateCourseQuestion(response: Response): Promise<UploadCourseQuestionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UploadCourseQuestionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UploadCourseQuestionDto>(null as any);
    }

    deleteCourseQuestion(id: number | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/CourseQuestionBanks/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteCourseQuestion(_response);
        });
    }

    protected processDeleteCourseQuestion(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    downloadCourseQuestionBank(id: number | undefined, courseQuestionType: CourseQuestionType | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/CourseQuestionBanks/Download?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (courseQuestionType !== undefined && courseQuestionType !== null)
            url_ += "courseQuestionType=" + encodeURIComponent("" + courseQuestionType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadCourseQuestionBank(_response);
        });
    }

    protected processDownloadCourseQuestionBank(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    downloadCourseQuestionBankTemp(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/CourseQuestionBanks/DownloadTemp";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadCourseQuestionBankTemp(_response);
        });
    }

    protected processDownloadCourseQuestionBankTemp(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    downloadCourseQuestionBank2(courseId: number | undefined, courseQuestionType: CourseQuestionType | undefined, file: FileParameter | null | undefined): Promise<UploadCourseQuestionDto> {
        let url_ = this.baseUrl + "/api/CourseQuestionBanks/Upload?";
        if (courseId === null)
            throw new Error("The parameter 'courseId' cannot be null.");
        else if (courseId !== undefined)
            url_ += "CourseId=" + encodeURIComponent("" + courseId) + "&";
        if (courseQuestionType === null)
            throw new Error("The parameter 'courseQuestionType' cannot be null.");
        else if (courseQuestionType !== undefined)
            url_ += "CourseQuestionType=" + encodeURIComponent("" + courseQuestionType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadCourseQuestionBank2(_response);
        });
    }

    protected processDownloadCourseQuestionBank2(response: Response): Promise<UploadCourseQuestionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UploadCourseQuestionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UploadCourseQuestionDto>(null as any);
    }

    updateCourseQuestionBank(questionName: string | undefined, courseId: number | undefined, id: number | undefined, deleteNmae: string | undefined, singleChoiceFile: FileParameter | null | undefined, multipleChoiceFile: FileParameter | null | undefined, openEndedFile: FileParameter | null | undefined): Promise<UploadCourseQuestionDto> {
        let url_ = this.baseUrl + "/api/CourseQuestionBanks/Update?";
        if (questionName === null)
            throw new Error("The parameter 'questionName' cannot be null.");
        else if (questionName !== undefined)
            url_ += "questionName=" + encodeURIComponent("" + questionName) + "&";
        if (courseId === null)
            throw new Error("The parameter 'courseId' cannot be null.");
        else if (courseId !== undefined)
            url_ += "courseId=" + encodeURIComponent("" + courseId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (deleteNmae === null)
            throw new Error("The parameter 'deleteNmae' cannot be null.");
        else if (deleteNmae !== undefined)
            url_ += "deleteNmae=" + encodeURIComponent("" + deleteNmae) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (singleChoiceFile !== null && singleChoiceFile !== undefined)
            content_.append("singleChoiceFile", singleChoiceFile.data, singleChoiceFile.fileName ? singleChoiceFile.fileName : "singleChoiceFile");
        if (multipleChoiceFile !== null && multipleChoiceFile !== undefined)
            content_.append("multipleChoiceFile", multipleChoiceFile.data, multipleChoiceFile.fileName ? multipleChoiceFile.fileName : "multipleChoiceFile");
        if (openEndedFile !== null && openEndedFile !== undefined)
            content_.append("openEndedFile", openEndedFile.data, openEndedFile.fileName ? openEndedFile.fileName : "openEndedFile");

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCourseQuestionBank(_response);
        });
    }

    protected processUpdateCourseQuestionBank(response: Response): Promise<UploadCourseQuestionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UploadCourseQuestionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UploadCourseQuestionDto>(null as any);
    }
}

export interface ICourseQuizExamQuestionBanksClient {

    searchQuestionBanksWithPagination(id: number | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<CourseQuizExamQuestionBankVm>;

    getQuestionBank(id: number | undefined): Promise<CourseQuizExamQuestionBankDto>;

    updateCourseQuizExamQuestionBank(query: UpdateCourseQuizExamQuestionBankCommand): Promise<number>;

    deleteCourseQuizExamQuestionBank(id: number | undefined, command: DeleteCourseQuizExamQuestionBankCommand): Promise<Unit>;
}

export class CourseQuizExamQuestionBanksClient extends AuthorizedApiBase implements ICourseQuizExamQuestionBanksClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    searchQuestionBanksWithPagination(id: number | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<CourseQuizExamQuestionBankVm> {
        let url_ = this.baseUrl + "/api/CourseQuizExamQuestionBanks/Search?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchQuestionBanksWithPagination(_response);
        });
    }

    protected processSearchQuestionBanksWithPagination(response: Response): Promise<CourseQuizExamQuestionBankVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CourseQuizExamQuestionBankVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourseQuizExamQuestionBankVm>(null as any);
    }

    getQuestionBank(id: number | undefined): Promise<CourseQuizExamQuestionBankDto> {
        let url_ = this.baseUrl + "/api/CourseQuizExamQuestionBanks/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetQuestionBank(_response);
        });
    }

    protected processGetQuestionBank(response: Response): Promise<CourseQuizExamQuestionBankDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CourseQuizExamQuestionBankDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourseQuizExamQuestionBankDto>(null as any);
    }

    updateCourseQuizExamQuestionBank(query: UpdateCourseQuizExamQuestionBankCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/CourseQuizExamQuestionBanks/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCourseQuizExamQuestionBank(_response);
        });
    }

    protected processUpdateCourseQuizExamQuestionBank(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteCourseQuizExamQuestionBank(id: number | undefined, command: DeleteCourseQuizExamQuestionBankCommand): Promise<Unit> {
        let url_ = this.baseUrl + "/api/CourseQuizExamQuestionBanks/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteCourseQuizExamQuestionBank(_response);
        });
    }

    protected processDeleteCourseQuizExamQuestionBank(response: Response): Promise<Unit> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Unit.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Unit>(null as any);
    }
}

export interface ICourseQuizExamsClient {

    searchCourseQuizExams(keyword: string | null | undefined, courseId: number | undefined, quizExamName: string | null | undefined, questionCount: number | null | undefined, quizScores: number | null | undefined, quizExamWeight: number | null | undefined, passingScore: number | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfCourseQuizExamBriefDto>;

    getCourseQuizExam(id: number | undefined): Promise<EditCourseQuizExamReqDto>;

    getCourseQuizExamList(courseId: number | undefined, stepId: number | undefined): Promise<CourseQuizExamListDto[]>;

    createCourseQuizExam(query: CreateCourseQuizExamCommand): Promise<number>;

    updateCourseQuizExam(query: UpdateCourseQuizExamCommand): Promise<number>;

    deleteCourseQuizExam(id: number | undefined, command: DeleteCourseQuizExamCommand): Promise<Unit>;
}

export class CourseQuizExamsClient extends AuthorizedApiBase implements ICourseQuizExamsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    searchCourseQuizExams(keyword: string | null | undefined, courseId: number | undefined, quizExamName: string | null | undefined, questionCount: number | null | undefined, quizScores: number | null | undefined, quizExamWeight: number | null | undefined, passingScore: number | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfCourseQuizExamBriefDto> {
        let url_ = this.baseUrl + "/api/CourseQuizExams/Search?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (courseId === null)
            throw new Error("The parameter 'courseId' cannot be null.");
        else if (courseId !== undefined)
            url_ += "CourseId=" + encodeURIComponent("" + courseId) + "&";
        if (quizExamName !== undefined && quizExamName !== null)
            url_ += "QuizExamName=" + encodeURIComponent("" + quizExamName) + "&";
        if (questionCount !== undefined && questionCount !== null)
            url_ += "QuestionCount=" + encodeURIComponent("" + questionCount) + "&";
        if (quizScores !== undefined && quizScores !== null)
            url_ += "QuizScores=" + encodeURIComponent("" + quizScores) + "&";
        if (quizExamWeight !== undefined && quizExamWeight !== null)
            url_ += "QuizExamWeight=" + encodeURIComponent("" + quizExamWeight) + "&";
        if (passingScore !== undefined && passingScore !== null)
            url_ += "PassingScore=" + encodeURIComponent("" + passingScore) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchCourseQuizExams(_response);
        });
    }

    protected processSearchCourseQuizExams(response: Response): Promise<PaginatedListOfCourseQuizExamBriefDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfCourseQuizExamBriefDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfCourseQuizExamBriefDto>(null as any);
    }

    getCourseQuizExam(id: number | undefined): Promise<EditCourseQuizExamReqDto> {
        let url_ = this.baseUrl + "/api/CourseQuizExams/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCourseQuizExam(_response);
        });
    }

    protected processGetCourseQuizExam(response: Response): Promise<EditCourseQuizExamReqDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditCourseQuizExamReqDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditCourseQuizExamReqDto>(null as any);
    }

    getCourseQuizExamList(courseId: number | undefined, stepId: number | undefined): Promise<CourseQuizExamListDto[]> {
        let url_ = this.baseUrl + "/api/CourseQuizExams/GetList?";
        if (courseId === null)
            throw new Error("The parameter 'courseId' cannot be null.");
        else if (courseId !== undefined)
            url_ += "courseId=" + encodeURIComponent("" + courseId) + "&";
        if (stepId === null)
            throw new Error("The parameter 'stepId' cannot be null.");
        else if (stepId !== undefined)
            url_ += "stepId=" + encodeURIComponent("" + stepId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCourseQuizExamList(_response);
        });
    }

    protected processGetCourseQuizExamList(response: Response): Promise<CourseQuizExamListDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CourseQuizExamListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourseQuizExamListDto[]>(null as any);
    }

    createCourseQuizExam(query: CreateCourseQuizExamCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/CourseQuizExams/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCourseQuizExam(_response);
        });
    }

    protected processCreateCourseQuizExam(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    updateCourseQuizExam(query: UpdateCourseQuizExamCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/CourseQuizExams/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCourseQuizExam(_response);
        });
    }

    protected processUpdateCourseQuizExam(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteCourseQuizExam(id: number | undefined, command: DeleteCourseQuizExamCommand): Promise<Unit> {
        let url_ = this.baseUrl + "/api/CourseQuizExams/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteCourseQuizExam(_response);
        });
    }

    protected processDeleteCourseQuizExam(response: Response): Promise<Unit> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Unit.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Unit>(null as any);
    }
}

export interface ICoursesClient {

    getCourseIdNameList(): Promise<CourseIdNameDto[]>;

    searchCourse(clientGroupId: number | undefined, courseName: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfCourseSelectBriefDto>;

    getCourseSupportedLanguage(courseId: number | undefined): Promise<CourseSupportedLanguageReqDto[]>;

    getCourseStatus(courseId: number | undefined): Promise<CourseBriefDto>;

    createCourse(): Promise<number>;

    deleteCourse(courseId: number | undefined): Promise<number>;

    updateStatesCourse(courseId: number | undefined, courseStatus: CourseStatus | undefined): Promise<number>;

    copyCourse(courseId: number | undefined): Promise<number>;
}

export class CoursesClient extends AuthorizedApiBase implements ICoursesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getCourseIdNameList(): Promise<CourseIdNameDto[]> {
        let url_ = this.baseUrl + "/api/Courses/GetCourseIdNameList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCourseIdNameList(_response);
        });
    }

    protected processGetCourseIdNameList(response: Response): Promise<CourseIdNameDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CourseIdNameDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourseIdNameDto[]>(null as any);
    }

    searchCourse(clientGroupId: number | undefined, courseName: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfCourseSelectBriefDto> {
        let url_ = this.baseUrl + "/api/Courses/SearchCourse?";
        if (clientGroupId === null)
            throw new Error("The parameter 'clientGroupId' cannot be null.");
        else if (clientGroupId !== undefined)
            url_ += "ClientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        if (courseName !== undefined && courseName !== null)
            url_ += "CourseName=" + encodeURIComponent("" + courseName) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchCourse(_response);
        });
    }

    protected processSearchCourse(response: Response): Promise<PaginatedListOfCourseSelectBriefDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfCourseSelectBriefDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfCourseSelectBriefDto>(null as any);
    }

    getCourseSupportedLanguage(courseId: number | undefined): Promise<CourseSupportedLanguageReqDto[]> {
        let url_ = this.baseUrl + "/api/Courses/GetCourseSupportedLanguage?";
        if (courseId === null)
            throw new Error("The parameter 'courseId' cannot be null.");
        else if (courseId !== undefined)
            url_ += "courseId=" + encodeURIComponent("" + courseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCourseSupportedLanguage(_response);
        });
    }

    protected processGetCourseSupportedLanguage(response: Response): Promise<CourseSupportedLanguageReqDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CourseSupportedLanguageReqDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourseSupportedLanguageReqDto[]>(null as any);
    }

    getCourseStatus(courseId: number | undefined): Promise<CourseBriefDto> {
        let url_ = this.baseUrl + "/api/Courses/GetCourseStatus?";
        if (courseId === null)
            throw new Error("The parameter 'courseId' cannot be null.");
        else if (courseId !== undefined)
            url_ += "courseId=" + encodeURIComponent("" + courseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCourseStatus(_response);
        });
    }

    protected processGetCourseStatus(response: Response): Promise<CourseBriefDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CourseBriefDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourseBriefDto>(null as any);
    }

    createCourse(): Promise<number> {
        let url_ = this.baseUrl + "/api/Courses/Create";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCourse(_response);
        });
    }

    protected processCreateCourse(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteCourse(courseId: number | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Courses/Delete?";
        if (courseId === null)
            throw new Error("The parameter 'courseId' cannot be null.");
        else if (courseId !== undefined)
            url_ += "courseId=" + encodeURIComponent("" + courseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteCourse(_response);
        });
    }

    protected processDeleteCourse(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    updateStatesCourse(courseId: number | undefined, courseStatus: CourseStatus | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Courses/UpdateStatesCourse?";
        if (courseId === null)
            throw new Error("The parameter 'courseId' cannot be null.");
        else if (courseId !== undefined)
            url_ += "courseId=" + encodeURIComponent("" + courseId) + "&";
        if (courseStatus === null)
            throw new Error("The parameter 'courseStatus' cannot be null.");
        else if (courseStatus !== undefined)
            url_ += "courseStatus=" + encodeURIComponent("" + courseStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateStatesCourse(_response);
        });
    }

    protected processUpdateStatesCourse(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    copyCourse(courseId: number | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Courses/CopyCourse?";
        if (courseId === null)
            throw new Error("The parameter 'courseId' cannot be null.");
        else if (courseId !== undefined)
            url_ += "courseId=" + encodeURIComponent("" + courseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCopyCourse(_response);
        });
    }

    protected processCopyCourse(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export interface IEmailClient {

    test(command: SendTestingEmailCommand): Promise<FileResponse>;
}

export class EmailClient extends AuthorizedApiBase implements IEmailClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    test(command: SendTestingEmailCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Email/Test";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTest(_response);
        });
    }

    protected processTest(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IFacetDimensionsClient {

    get(keyword: string | null | undefined, questionCategoryId: number | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfFacetDimensionDto>;

    export(): Promise<FileResponse>;

    upload(file: FileParameter | null | undefined): Promise<FileResponse>;
}

export class FacetDimensionsClient extends AuthorizedApiBase implements IFacetDimensionsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    get(keyword: string | null | undefined, questionCategoryId: number | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfFacetDimensionDto> {
        let url_ = this.baseUrl + "/api/FacetDimensions?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (questionCategoryId !== undefined && questionCategoryId !== null)
            url_ += "QuestionCategoryId=" + encodeURIComponent("" + questionCategoryId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<PaginatedListOfFacetDimensionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfFacetDimensionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfFacetDimensionDto>(null as any);
    }

    export(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/FacetDimensions/Export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    upload(file: FileParameter | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/FacetDimensions/Upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IFormQuestionsClient {

    getFormQuestionsWithPagination(formId: number | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfFormQuestionDto>;

    exportFormQuestions(): Promise<FileResponse>;

    uploadFormQuestions(file: FileParameter | null | undefined): Promise<FileResponse>;
}

export class FormQuestionsClient extends AuthorizedApiBase implements IFormQuestionsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getFormQuestionsWithPagination(formId: number | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfFormQuestionDto> {
        let url_ = this.baseUrl + "/api/FormQuestions?";
        if (formId === null)
            throw new Error("The parameter 'formId' cannot be null.");
        else if (formId !== undefined)
            url_ += "FormId=" + encodeURIComponent("" + formId) + "&";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFormQuestionsWithPagination(_response);
        });
    }

    protected processGetFormQuestionsWithPagination(response: Response): Promise<PaginatedListOfFormQuestionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfFormQuestionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfFormQuestionDto>(null as any);
    }

    exportFormQuestions(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/FormQuestions/Export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportFormQuestions(_response);
        });
    }

    protected processExportFormQuestions(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    uploadFormQuestions(file: FileParameter | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/FormQuestions/Upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadFormQuestions(_response);
        });
    }

    protected processUploadFormQuestions(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IFormsClient {

    getFormsWithPagination(keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfFormBriefDto>;

    create(command: CreateFormCommand): Promise<number>;

    get(id: number): Promise<FormDto>;

    update(id: number, command: UpdateFormCommand): Promise<FileResponse>;

    delete(id: number): Promise<FileResponse>;

    upload(file: FileParameter | null | undefined): Promise<number>;

    export(): Promise<FileResponse>;

    exportDescription(): Promise<FileResponse>;

    uploadDescription(file: FileParameter | null | undefined): Promise<number>;
}

export class FormsClient extends AuthorizedApiBase implements IFormsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getFormsWithPagination(keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfFormBriefDto> {
        let url_ = this.baseUrl + "/api/Forms?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFormsWithPagination(_response);
        });
    }

    protected processGetFormsWithPagination(response: Response): Promise<PaginatedListOfFormBriefDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfFormBriefDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfFormBriefDto>(null as any);
    }

    create(command: CreateFormCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Forms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    get(id: number): Promise<FormDto> {
        let url_ = this.baseUrl + "/api/Forms/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<FormDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FormDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormDto>(null as any);
    }

    update(id: number, command: UpdateFormCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Forms/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    delete(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Forms/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    upload(file: FileParameter | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Forms/Upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    export(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Forms/Export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    exportDescription(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Forms/Description/Export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportDescription(_response);
        });
    }

    protected processExportDescription(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    uploadDescription(file: FileParameter | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Forms/Description/Upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadDescription(_response);
        });
    }

    protected processUploadDescription(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export interface IGroupAssessmentReportsClient {

    get(clientGroupId: number | undefined, scoringKeySetId: number | undefined, normTableId: number | undefined, groupReportTemplateId: number | undefined, isIncludeDecedents: boolean | null | undefined): Promise<FileResponse>;
}

export class GroupAssessmentReportsClient extends AuthorizedApiBase implements IGroupAssessmentReportsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    get(clientGroupId: number | undefined, scoringKeySetId: number | undefined, normTableId: number | undefined, groupReportTemplateId: number | undefined, isIncludeDecedents: boolean | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/GroupAssessmentReports/Export?";
        if (clientGroupId === null)
            throw new Error("The parameter 'clientGroupId' cannot be null.");
        else if (clientGroupId !== undefined)
            url_ += "ClientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        if (scoringKeySetId === null)
            throw new Error("The parameter 'scoringKeySetId' cannot be null.");
        else if (scoringKeySetId !== undefined)
            url_ += "ScoringKeySetId=" + encodeURIComponent("" + scoringKeySetId) + "&";
        if (normTableId === null)
            throw new Error("The parameter 'normTableId' cannot be null.");
        else if (normTableId !== undefined)
            url_ += "NormTableId=" + encodeURIComponent("" + normTableId) + "&";
        if (groupReportTemplateId === null)
            throw new Error("The parameter 'groupReportTemplateId' cannot be null.");
        else if (groupReportTemplateId !== undefined)
            url_ += "GroupReportTemplateId=" + encodeURIComponent("" + groupReportTemplateId) + "&";
        if (isIncludeDecedents !== undefined && isIncludeDecedents !== null)
            url_ += "IsIncludeDecedents=" + encodeURIComponent("" + isIncludeDecedents) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IReportGenerationSettingsClient {

    export(): Promise<FileResponse>;

    getReportGenerationSettings(clientGroupId: number | null | undefined, assessmentTemplatesId: number | null | undefined): Promise<ReportGenerationSettingsDto[]>;

    getReportGenerationSettingsWithPagination(keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfReportGenerationSettingsBriefDto>;
}

export class ReportGenerationSettingsClient extends AuthorizedApiBase implements IReportGenerationSettingsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    export(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ReportGenerationSettings/Export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getReportGenerationSettings(clientGroupId: number | null | undefined, assessmentTemplatesId: number | null | undefined): Promise<ReportGenerationSettingsDto[]> {
        let url_ = this.baseUrl + "/api/ReportGenerationSettings?";
        if (clientGroupId !== undefined && clientGroupId !== null)
            url_ += "ClientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        if (assessmentTemplatesId !== undefined && assessmentTemplatesId !== null)
            url_ += "AssessmentTemplatesId=" + encodeURIComponent("" + assessmentTemplatesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetReportGenerationSettings(_response);
        });
    }

    protected processGetReportGenerationSettings(response: Response): Promise<ReportGenerationSettingsDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReportGenerationSettingsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportGenerationSettingsDto[]>(null as any);
    }

    getReportGenerationSettingsWithPagination(keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfReportGenerationSettingsBriefDto> {
        let url_ = this.baseUrl + "/api/ReportGenerationSettings/Pagination?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetReportGenerationSettingsWithPagination(_response);
        });
    }

    protected processGetReportGenerationSettingsWithPagination(response: Response): Promise<PaginatedListOfReportGenerationSettingsBriefDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfReportGenerationSettingsBriefDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfReportGenerationSettingsBriefDto>(null as any);
    }
}

export interface IGroupReportsClient {

    create(command: CreateGroupGroupReportCommand): Promise<number>;

    getGrouptReportsWithPagination(keyword: string | null | undefined, clientGroupId: number | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfGroupReportDto2>;

    archiveGroupReport(id: number | undefined): Promise<FileResponse>;

    createBySetting(command: CreateGroupGroupReportBySettingCommand): Promise<number>;

    getGroupReportScoreCheck(id: number): Promise<ScoreDto>;

    getTemplate(id: number): Promise<FileResponse>;

    convertGroupReportByAdobe(id: number): Promise<FileResponse>;

    getSupGroupByClientGroupAssessmentTemplateId(id: number): Promise<ClientGroupDto[]>;

    getSupGroupByClientGroupGroupReportGenerationSettingId(id: number): Promise<ClientGroupDto[]>;

    getSupGroupByAssessmentTemplateId(clientGroupId: number | undefined, assessmentTemplateId: number | undefined): Promise<ClientGroupDto[]>;
}

export class GroupReportsClient extends AuthorizedApiBase implements IGroupReportsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    create(command: CreateGroupGroupReportCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/GroupReports";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getGrouptReportsWithPagination(keyword: string | null | undefined, clientGroupId: number | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfGroupReportDto2> {
        let url_ = this.baseUrl + "/api/GroupReports?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (clientGroupId !== undefined && clientGroupId !== null)
            url_ += "ClientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGrouptReportsWithPagination(_response);
        });
    }

    protected processGetGrouptReportsWithPagination(response: Response): Promise<PaginatedListOfGroupReportDto2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfGroupReportDto2.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfGroupReportDto2>(null as any);
    }

    archiveGroupReport(id: number | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/GroupReports?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processArchiveGroupReport(_response);
        });
    }

    protected processArchiveGroupReport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    createBySetting(command: CreateGroupGroupReportBySettingCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/GroupReports/BySetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateBySetting(_response);
        });
    }

    protected processCreateBySetting(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getGroupReportScoreCheck(id: number): Promise<ScoreDto> {
        let url_ = this.baseUrl + "/api/GroupReports/{id}/ScoreCheck";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGroupReportScoreCheck(_response);
        });
    }

    protected processGetGroupReportScoreCheck(response: Response): Promise<ScoreDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScoreDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScoreDto>(null as any);
    }

    getTemplate(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/GroupReports/{id}/File";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTemplate(_response);
        });
    }

    protected processGetTemplate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    convertGroupReportByAdobe(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/GroupReports/{id}/ConvertPDFFile";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processConvertGroupReportByAdobe(_response);
        });
    }

    protected processConvertGroupReportByAdobe(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSupGroupByClientGroupAssessmentTemplateId(id: number): Promise<ClientGroupDto[]> {
        let url_ = this.baseUrl + "/api/GroupReports/{id}/GetSupGroupByClientGroupAssessmentTemplateId";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSupGroupByClientGroupAssessmentTemplateId(_response);
        });
    }

    protected processGetSupGroupByClientGroupAssessmentTemplateId(response: Response): Promise<ClientGroupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientGroupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientGroupDto[]>(null as any);
    }

    getSupGroupByClientGroupGroupReportGenerationSettingId(id: number): Promise<ClientGroupDto[]> {
        let url_ = this.baseUrl + "/api/GroupReports/{id}/GetSupGroupByClientGroupGroupReportGenerationSettingId";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSupGroupByClientGroupGroupReportGenerationSettingId(_response);
        });
    }

    protected processGetSupGroupByClientGroupGroupReportGenerationSettingId(response: Response): Promise<ClientGroupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientGroupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientGroupDto[]>(null as any);
    }

    getSupGroupByAssessmentTemplateId(clientGroupId: number | undefined, assessmentTemplateId: number | undefined): Promise<ClientGroupDto[]> {
        let url_ = this.baseUrl + "/api/GroupReports/GetSupGroupByAssessmentTemplateId?";
        if (clientGroupId === null)
            throw new Error("The parameter 'clientGroupId' cannot be null.");
        else if (clientGroupId !== undefined)
            url_ += "ClientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        if (assessmentTemplateId === null)
            throw new Error("The parameter 'assessmentTemplateId' cannot be null.");
        else if (assessmentTemplateId !== undefined)
            url_ += "AssessmentTemplateId=" + encodeURIComponent("" + assessmentTemplateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSupGroupByAssessmentTemplateId(_response);
        });
    }

    protected processGetSupGroupByAssessmentTemplateId(response: Response): Promise<ClientGroupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientGroupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientGroupDto[]>(null as any);
    }
}

export interface IGroupReportTemplateNormTablesClient {

    getGroupReportTemplateNormTablesWithPagination(normTableId: number | null | undefined, groupReportTemplateId: number | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfGroupReportTemplateNormTableBriefDto>;

    create(command: CreateGroupReportTemplateNormTableCommand): Promise<number>;

    delete(id: number): Promise<FileResponse>;
}

export class GroupReportTemplateNormTablesClient extends AuthorizedApiBase implements IGroupReportTemplateNormTablesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getGroupReportTemplateNormTablesWithPagination(normTableId: number | null | undefined, groupReportTemplateId: number | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfGroupReportTemplateNormTableBriefDto> {
        let url_ = this.baseUrl + "/api/GroupReportTemplateNormTables?";
        if (normTableId !== undefined && normTableId !== null)
            url_ += "NormTableId=" + encodeURIComponent("" + normTableId) + "&";
        if (groupReportTemplateId !== undefined && groupReportTemplateId !== null)
            url_ += "GroupReportTemplateId=" + encodeURIComponent("" + groupReportTemplateId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGroupReportTemplateNormTablesWithPagination(_response);
        });
    }

    protected processGetGroupReportTemplateNormTablesWithPagination(response: Response): Promise<PaginatedListOfGroupReportTemplateNormTableBriefDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfGroupReportTemplateNormTableBriefDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfGroupReportTemplateNormTableBriefDto>(null as any);
    }

    create(command: CreateGroupReportTemplateNormTableCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/GroupReportTemplateNormTables";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/GroupReportTemplateNormTables/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IGroupReportTemplatesClient {

    getGroupReportTemplatesWithPagination(keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfGroupReportTemplateBriefDto>;

    create(command: CreateGroupReportTemplateCommand): Promise<number>;

    getGroupReportTemplates(query: GetGroupReportTemplatesQuery | undefined): Promise<GroupReportTemplateBriefDto[]>;

    get(id: number): Promise<GroupReportTemplateBriefDto>;

    update(id: number, command: UpdateGroupReportTemplateCommand): Promise<FileResponse>;

    delete(id: number): Promise<FileResponse>;

    getTemplate(id: number): Promise<FileResponse>;

    uploadTemplate(id: number, file: FileParameter | null | undefined): Promise<FileResponse>;

    exportGroupReportTemplateConditions(id: number): Promise<FileResponse>;

    uploadGroupReportTemplateConditions(id: number, file: FileParameter | null | undefined): Promise<FileResponse>;
}

export class GroupReportTemplatesClient extends AuthorizedApiBase implements IGroupReportTemplatesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getGroupReportTemplatesWithPagination(keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfGroupReportTemplateBriefDto> {
        let url_ = this.baseUrl + "/api/GroupReportTemplates?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGroupReportTemplatesWithPagination(_response);
        });
    }

    protected processGetGroupReportTemplatesWithPagination(response: Response): Promise<PaginatedListOfGroupReportTemplateBriefDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfGroupReportTemplateBriefDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfGroupReportTemplateBriefDto>(null as any);
    }

    create(command: CreateGroupReportTemplateCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/GroupReportTemplates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getGroupReportTemplates(query: GetGroupReportTemplatesQuery | undefined): Promise<GroupReportTemplateBriefDto[]> {
        let url_ = this.baseUrl + "/api/GroupReportTemplates/List?";
        if (query === null)
            throw new Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGroupReportTemplates(_response);
        });
    }

    protected processGetGroupReportTemplates(response: Response): Promise<GroupReportTemplateBriefDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GroupReportTemplateBriefDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupReportTemplateBriefDto[]>(null as any);
    }

    get(id: number): Promise<GroupReportTemplateBriefDto> {
        let url_ = this.baseUrl + "/api/GroupReportTemplates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<GroupReportTemplateBriefDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupReportTemplateBriefDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupReportTemplateBriefDto>(null as any);
    }

    update(id: number, command: UpdateGroupReportTemplateCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/GroupReportTemplates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    delete(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/GroupReportTemplates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getTemplate(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/GroupReportTemplates/{id}/Template";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTemplate(_response);
        });
    }

    protected processGetTemplate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    uploadTemplate(id: number, file: FileParameter | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/GroupReportTemplates/{id}/Template";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadTemplate(_response);
        });
    }

    protected processUploadTemplate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    exportGroupReportTemplateConditions(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/GroupReportTemplates/{id}/Condition/Export";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportGroupReportTemplateConditions(_response);
        });
    }

    protected processExportGroupReportTemplateConditions(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    uploadGroupReportTemplateConditions(id: number, file: FileParameter | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/GroupReportTemplates/{id}/Condition/Upload";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadGroupReportTemplateConditions(_response);
        });
    }

    protected processUploadGroupReportTemplateConditions(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IImagesClient {

    getImage(id: number): Promise<FileResponse>;
}

export class ImagesClient extends AuthorizedApiBase implements IImagesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getImage(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Images/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetImage(_response);
        });
    }

    protected processGetImage(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IIntegrationsClient {

    connectivity(): Promise<ConnectivityResponseDto>;

    clientUser(commands: CreateClientUserCommand2): Promise<string>;

    getReportMetadata(id: number): Promise<AssessmentReportMetadataDto>;

    getReportFile(id: number): Promise<FileResponse>;

    getReportJson(id: number): Promise<IntegrationReportJsonDto>;

    getAssessmentMetadata(id: number): Promise<AssessmentMetadataDto>;

    getReportsByExternalUser(externalUserKey: string | undefined, readyFrom: Date | null | undefined, readyTo: Date | null | undefined, status: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Promise<PaginatedListOfIntegrationReportListItemDto>;

    getEvents(occurredFrom: Date | null | undefined, occurredTo: Date | null | undefined, eventType: string | null | undefined, pageSize: number | undefined, cursor: string | null | undefined): Promise<CursorPaginatedListOfIntegrationEventDto>;

    getGroupReportMetadata(id: number): Promise<IntegrationGroupReportMetadataDto>;

    getGroupReportJson(id: number): Promise<IntegrationGroupReportJsonDto>;

    getGroupReportFile(id: number): Promise<FileResponse>;

    getGroupReportGenerationOptions(clientGroupAssessmentTemplateId: number): Promise<IntegrationGroupReportGenerationOptionDto[]>;

    createGroupReportCommand(command: CreateGroupReportCommand): Promise<number>;
}

export class IntegrationsClient extends AuthorizedApiBase implements IIntegrationsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    connectivity(): Promise<ConnectivityResponseDto> {
        let url_ = this.baseUrl + "/api/integrations/connectivity";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processConnectivity(_response);
        });
    }

    protected processConnectivity(response: Response): Promise<ConnectivityResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConnectivityResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConnectivityResponseDto>(null as any);
    }

    clientUser(commands: CreateClientUserCommand2): Promise<string> {
        let url_ = this.baseUrl + "/api/integrations/clientuser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commands);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processClientUser(_response);
        });
    }

    protected processClientUser(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getReportMetadata(id: number): Promise<AssessmentReportMetadataDto> {
        let url_ = this.baseUrl + "/api/integrations/reports/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetReportMetadata(_response);
        });
    }

    protected processGetReportMetadata(response: Response): Promise<AssessmentReportMetadataDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssessmentReportMetadataDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssessmentReportMetadataDto>(null as any);
    }

    getReportFile(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/integrations/reports/{id}/file";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetReportFile(_response);
        });
    }

    protected processGetReportFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getReportJson(id: number): Promise<IntegrationReportJsonDto> {
        let url_ = this.baseUrl + "/api/integrations/reports/{id}/json";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetReportJson(_response);
        });
    }

    protected processGetReportJson(response: Response): Promise<IntegrationReportJsonDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IntegrationReportJsonDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IntegrationReportJsonDto>(null as any);
    }

    getAssessmentMetadata(id: number): Promise<AssessmentMetadataDto> {
        let url_ = this.baseUrl + "/api/integrations/assessments/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAssessmentMetadata(_response);
        });
    }

    protected processGetAssessmentMetadata(response: Response): Promise<AssessmentMetadataDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssessmentMetadataDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssessmentMetadataDto>(null as any);
    }

    getReportsByExternalUser(externalUserKey: string | undefined, readyFrom: Date | null | undefined, readyTo: Date | null | undefined, status: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Promise<PaginatedListOfIntegrationReportListItemDto> {
        let url_ = this.baseUrl + "/api/integrations/reports?";
        if (externalUserKey === null)
            throw new Error("The parameter 'externalUserKey' cannot be null.");
        else if (externalUserKey !== undefined)
            url_ += "ExternalUserKey=" + encodeURIComponent("" + externalUserKey) + "&";
        if (readyFrom !== undefined && readyFrom !== null)
            url_ += "ReadyFrom=" + encodeURIComponent(readyFrom ? "" + readyFrom.toISOString() : "") + "&";
        if (readyTo !== undefined && readyTo !== null)
            url_ += "ReadyTo=" + encodeURIComponent(readyTo ? "" + readyTo.toISOString() : "") + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetReportsByExternalUser(_response);
        });
    }

    protected processGetReportsByExternalUser(response: Response): Promise<PaginatedListOfIntegrationReportListItemDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfIntegrationReportListItemDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfIntegrationReportListItemDto>(null as any);
    }

    getEvents(occurredFrom: Date | null | undefined, occurredTo: Date | null | undefined, eventType: string | null | undefined, pageSize: number | undefined, cursor: string | null | undefined): Promise<CursorPaginatedListOfIntegrationEventDto> {
        let url_ = this.baseUrl + "/api/integrations/events?";
        if (occurredFrom !== undefined && occurredFrom !== null)
            url_ += "OccurredFrom=" + encodeURIComponent(occurredFrom ? "" + occurredFrom.toISOString() : "") + "&";
        if (occurredTo !== undefined && occurredTo !== null)
            url_ += "OccurredTo=" + encodeURIComponent(occurredTo ? "" + occurredTo.toISOString() : "") + "&";
        if (eventType !== undefined && eventType !== null)
            url_ += "EventType=" + encodeURIComponent("" + eventType) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (cursor !== undefined && cursor !== null)
            url_ += "Cursor=" + encodeURIComponent("" + cursor) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEvents(_response);
        });
    }

    protected processGetEvents(response: Response): Promise<CursorPaginatedListOfIntegrationEventDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CursorPaginatedListOfIntegrationEventDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CursorPaginatedListOfIntegrationEventDto>(null as any);
    }

    getGroupReportMetadata(id: number): Promise<IntegrationGroupReportMetadataDto> {
        let url_ = this.baseUrl + "/api/integrations/group-reports/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGroupReportMetadata(_response);
        });
    }

    protected processGetGroupReportMetadata(response: Response): Promise<IntegrationGroupReportMetadataDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IntegrationGroupReportMetadataDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IntegrationGroupReportMetadataDto>(null as any);
    }

    getGroupReportJson(id: number): Promise<IntegrationGroupReportJsonDto> {
        let url_ = this.baseUrl + "/api/integrations/group-reports/{id}/json";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGroupReportJson(_response);
        });
    }

    protected processGetGroupReportJson(response: Response): Promise<IntegrationGroupReportJsonDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IntegrationGroupReportJsonDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IntegrationGroupReportJsonDto>(null as any);
    }

    getGroupReportFile(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/integrations/group-reports/{id}/file";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGroupReportFile(_response);
        });
    }

    protected processGetGroupReportFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getGroupReportGenerationOptions(clientGroupAssessmentTemplateId: number): Promise<IntegrationGroupReportGenerationOptionDto[]> {
        let url_ = this.baseUrl + "/api/integrations/group-reports/generation-options/{clientGroupAssessmentTemplateId}";
        if (clientGroupAssessmentTemplateId === undefined || clientGroupAssessmentTemplateId === null)
            throw new Error("The parameter 'clientGroupAssessmentTemplateId' must be defined.");
        url_ = url_.replace("{clientGroupAssessmentTemplateId}", encodeURIComponent("" + clientGroupAssessmentTemplateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGroupReportGenerationOptions(_response);
        });
    }

    protected processGetGroupReportGenerationOptions(response: Response): Promise<IntegrationGroupReportGenerationOptionDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IntegrationGroupReportGenerationOptionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IntegrationGroupReportGenerationOptionDto[]>(null as any);
    }

    createGroupReportCommand(command: CreateGroupReportCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/integrations/group-reports";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateGroupReportCommand(_response);
        });
    }

    protected processCreateGroupReportCommand(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export interface IInternationalizationsClient {

    getInternationalizationsWithPagination(keys: InternationalizationKey[] | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfInternationalizationDto>;

    update(command: UpdateInternationalizationCommand): Promise<FileResponse>;

    uploadContents(file: FileParameter | null | undefined): Promise<FileResponse>;

    export(): Promise<FileResponse>;
}

export class InternationalizationsClient extends AuthorizedApiBase implements IInternationalizationsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getInternationalizationsWithPagination(keys: InternationalizationKey[] | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfInternationalizationDto> {
        let url_ = this.baseUrl + "/api/Internationalizations?";
        if (keys === null)
            throw new Error("The parameter 'keys' cannot be null.");
        else if (keys !== undefined)
            keys && keys.forEach(item => { url_ += "Keys=" + encodeURIComponent("" + item) + "&"; });
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInternationalizationsWithPagination(_response);
        });
    }

    protected processGetInternationalizationsWithPagination(response: Response): Promise<PaginatedListOfInternationalizationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfInternationalizationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfInternationalizationDto>(null as any);
    }

    update(command: UpdateInternationalizationCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Internationalizations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    uploadContents(file: FileParameter | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Internationalizations/Upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadContents(_response);
        });
    }

    protected processUploadContents(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    export(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Internationalizations/Export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface ILanguageClient {

    getLanguages(): Promise<LanguageDto[]>;

    getUserLanguage(): Promise<string>;
}

export class LanguageClient extends AuthorizedApiBase implements ILanguageClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getLanguages(): Promise<LanguageDto[]> {
        let url_ = this.baseUrl + "/api/Language";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLanguages(_response);
        });
    }

    protected processGetLanguages(response: Response): Promise<LanguageDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LanguageDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LanguageDto[]>(null as any);
    }

    getUserLanguage(): Promise<string> {
        let url_ = this.baseUrl + "/api/Language/GetUserLanguage";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserLanguage(_response);
        });
    }

    protected processGetUserLanguage(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface IMediaLibrariesClient {

    searchMediaLibraryWithPagination(name: string | null | undefined, mediaType: MediaType | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfMediaLibraryBriefDto>;

    getMediaLibrary(id: number | undefined): Promise<MediaLibraryBriefDto>;

    createMediaLibrary(command: CreateMediaLibraryCommand): Promise<number>;

    deleteBatchMediaLibrary(command: DeleteBatchMediaLibraryCommand): Promise<FileResponse>;

    updateMediaLibrary(id: number, command: UpdateMediaLibraryCommand): Promise<FileResponse>;
}

export class MediaLibrariesClient extends AuthorizedApiBase implements IMediaLibrariesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    searchMediaLibraryWithPagination(name: string | null | undefined, mediaType: MediaType | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfMediaLibraryBriefDto> {
        let url_ = this.baseUrl + "/api/MediaLibraries/Search?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (mediaType === null)
            throw new Error("The parameter 'mediaType' cannot be null.");
        else if (mediaType !== undefined)
            url_ += "MediaType=" + encodeURIComponent("" + mediaType) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchMediaLibraryWithPagination(_response);
        });
    }

    protected processSearchMediaLibraryWithPagination(response: Response): Promise<PaginatedListOfMediaLibraryBriefDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfMediaLibraryBriefDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfMediaLibraryBriefDto>(null as any);
    }

    getMediaLibrary(id: number | undefined): Promise<MediaLibraryBriefDto> {
        let url_ = this.baseUrl + "/api/MediaLibraries/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMediaLibrary(_response);
        });
    }

    protected processGetMediaLibrary(response: Response): Promise<MediaLibraryBriefDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MediaLibraryBriefDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MediaLibraryBriefDto>(null as any);
    }

    createMediaLibrary(command: CreateMediaLibraryCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/MediaLibraries/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateMediaLibrary(_response);
        });
    }

    protected processCreateMediaLibrary(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteBatchMediaLibrary(command: DeleteBatchMediaLibraryCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/MediaLibraries/DeleteBatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteBatchMediaLibrary(_response);
        });
    }

    protected processDeleteBatchMediaLibrary(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    updateMediaLibrary(id: number, command: UpdateMediaLibraryCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/MediaLibraries/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateMediaLibrary(_response);
        });
    }

    protected processUpdateMediaLibrary(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IMediaLibraryFilesClient {

    getMediaLibraryFile(id: number | undefined): Promise<FileResponse>;

    createMediaLibraryImage(file: FileParameter | null | undefined): Promise<number>;

    createMediaLibraryVideo(file: FileParameter | null | undefined): Promise<number>;
}

export class MediaLibraryFilesClient extends AuthorizedApiBase implements IMediaLibraryFilesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getMediaLibraryFile(id: number | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/MediaLibraryFiles/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMediaLibraryFile(_response);
        });
    }

    protected processGetMediaLibraryFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    createMediaLibraryImage(file: FileParameter | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/MediaLibraryFiles/CreateImage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateMediaLibraryImage(_response);
        });
    }

    protected processCreateMediaLibraryImage(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    createMediaLibraryVideo(file: FileParameter | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/MediaLibraryFiles/CreateVideo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateMediaLibraryVideo(_response);
        });
    }

    protected processCreateMediaLibraryVideo(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export interface INormTablesClient {

    getNormTablesWithPagination(keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfNormTableBriefDto>;

    upload(file: FileParameter | null | undefined): Promise<number>;

    checkNormTableScoringKeySet(id: number, scoringKeySetId: number): Promise<FacetDimensionDto[]>;

    export(): Promise<FileResponse>;

    exportDescription(): Promise<FileResponse>;

    uploadDescription(file: FileParameter | null | undefined): Promise<number>;
}

export class NormTablesClient extends AuthorizedApiBase implements INormTablesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getNormTablesWithPagination(keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfNormTableBriefDto> {
        let url_ = this.baseUrl + "/api/NormTables?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetNormTablesWithPagination(_response);
        });
    }

    protected processGetNormTablesWithPagination(response: Response): Promise<PaginatedListOfNormTableBriefDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfNormTableBriefDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfNormTableBriefDto>(null as any);
    }

    upload(file: FileParameter | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/NormTables/Upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    checkNormTableScoringKeySet(id: number, scoringKeySetId: number): Promise<FacetDimensionDto[]> {
        let url_ = this.baseUrl + "/api/NormTables/{id}/ScoringKeySet/{scoringKeySetId}/Check";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (scoringKeySetId === undefined || scoringKeySetId === null)
            throw new Error("The parameter 'scoringKeySetId' must be defined.");
        url_ = url_.replace("{scoringKeySetId}", encodeURIComponent("" + scoringKeySetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCheckNormTableScoringKeySet(_response);
        });
    }

    protected processCheckNormTableScoringKeySet(response: Response): Promise<FacetDimensionDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FacetDimensionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FacetDimensionDto[]>(null as any);
    }

    export(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/NormTables/Export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    exportDescription(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/NormTables/Norm/Export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportDescription(_response);
        });
    }

    protected processExportDescription(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    uploadDescription(file: FileParameter | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/NormTables/Norm/Upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadDescription(_response);
        });
    }

    protected processUploadDescription(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export interface IQuestionCategoriesClient {

    get(keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfQuestionCategoryDto>;

    create(command: CreateQuestionCategoryCommand): Promise<number>;

    delete(id: number): Promise<FileResponse>;
}

export class QuestionCategoriesClient extends AuthorizedApiBase implements IQuestionCategoriesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    get(keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfQuestionCategoryDto> {
        let url_ = this.baseUrl + "/api/QuestionCategories?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<PaginatedListOfQuestionCategoryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfQuestionCategoryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfQuestionCategoryDto>(null as any);
    }

    create(command: CreateQuestionCategoryCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/QuestionCategories";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/QuestionCategories/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IQuestionChoiceListsClient {

    getQuestionChoiceLists(keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfQuestionChoiceListBriefDto>;

    create(command: CreateQuestionChoiceListCommand): Promise<number>;

    update(id: number, command: UpdateQuestionChoiceListCommand): Promise<FileResponse>;

    delete(id: number): Promise<FileResponse>;

    export(): Promise<FileResponse>;

    upload(file: FileParameter | null | undefined): Promise<FileResponse>;
}

export class QuestionChoiceListsClient extends AuthorizedApiBase implements IQuestionChoiceListsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getQuestionChoiceLists(keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfQuestionChoiceListBriefDto> {
        let url_ = this.baseUrl + "/api/QuestionChoiceLists?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetQuestionChoiceLists(_response);
        });
    }

    protected processGetQuestionChoiceLists(response: Response): Promise<PaginatedListOfQuestionChoiceListBriefDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfQuestionChoiceListBriefDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfQuestionChoiceListBriefDto>(null as any);
    }

    create(command: CreateQuestionChoiceListCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/QuestionChoiceLists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    update(id: number, command: UpdateQuestionChoiceListCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/QuestionChoiceLists/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    delete(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/QuestionChoiceLists/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    export(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/QuestionChoiceLists/Export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    upload(file: FileParameter | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/QuestionChoiceLists/Upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IQuestionChoicesClient {

    getQuestionChoices(questionChoiceListId: number | null | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfQuestionChoiceDto>;

    create(command: CreateQuestionChoiceCommand): Promise<number>;

    update(id: number, command: UpdateQuestionChoiceCommand): Promise<FileResponse>;

    delete(id: number): Promise<FileResponse>;

    exportContents(): Promise<FileResponse>;

    export(): Promise<FileResponse>;

    uploadContents(file: FileParameter | null | undefined): Promise<FileResponse>;

    upload(file: FileParameter | null | undefined): Promise<FileResponse>;
}

export class QuestionChoicesClient extends AuthorizedApiBase implements IQuestionChoicesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getQuestionChoices(questionChoiceListId: number | null | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfQuestionChoiceDto> {
        let url_ = this.baseUrl + "/api/QuestionChoices?";
        if (questionChoiceListId !== undefined && questionChoiceListId !== null)
            url_ += "QuestionChoiceListId=" + encodeURIComponent("" + questionChoiceListId) + "&";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetQuestionChoices(_response);
        });
    }

    protected processGetQuestionChoices(response: Response): Promise<PaginatedListOfQuestionChoiceDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfQuestionChoiceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfQuestionChoiceDto>(null as any);
    }

    create(command: CreateQuestionChoiceCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/QuestionChoices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    update(id: number, command: UpdateQuestionChoiceCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/QuestionChoices/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    delete(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/QuestionChoices/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    exportContents(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/QuestionChoices/Content/Export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportContents(_response);
        });
    }

    protected processExportContents(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    export(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/QuestionChoices/Export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    uploadContents(file: FileParameter | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/QuestionChoices/Content/Upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadContents(_response);
        });
    }

    protected processUploadContents(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    upload(file: FileParameter | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/QuestionChoices/Upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IQuestionRelationshipsClient {

    export(): Promise<FileResponse>;

    upload(file: FileParameter | null | undefined): Promise<FileResponse>;
}

export class QuestionRelationshipsClient extends AuthorizedApiBase implements IQuestionRelationshipsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    export(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/QuestionRelationships/Export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    upload(file: FileParameter | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/QuestionRelationships/Upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IQuestionsClient {

    getQuestionsWithPagination(questionCategoryId: number | null | undefined, orderBy: string | null | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfQuestionDto>;

    exportQuestions(): Promise<FileResponse>;

    exportQuestionsContent(): Promise<FileResponse>;

    uploadQuestionsContent(file: FileParameter | null | undefined): Promise<FileResponse>;

    uploadQuestions(file: FileParameter | null | undefined): Promise<FileResponse>;
}

export class QuestionsClient extends AuthorizedApiBase implements IQuestionsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getQuestionsWithPagination(questionCategoryId: number | null | undefined, orderBy: string | null | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfQuestionDto> {
        let url_ = this.baseUrl + "/api/Questions?";
        if (questionCategoryId !== undefined && questionCategoryId !== null)
            url_ += "QuestionCategoryId=" + encodeURIComponent("" + questionCategoryId) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetQuestionsWithPagination(_response);
        });
    }

    protected processGetQuestionsWithPagination(response: Response): Promise<PaginatedListOfQuestionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfQuestionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfQuestionDto>(null as any);
    }

    exportQuestions(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Questions/Export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportQuestions(_response);
        });
    }

    protected processExportQuestions(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    exportQuestionsContent(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Questions/Content/Export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportQuestionsContent(_response);
        });
    }

    protected processExportQuestionsContent(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    uploadQuestionsContent(file: FileParameter | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Questions/Content/Upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadQuestionsContent(_response);
        });
    }

    protected processUploadQuestionsContent(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    uploadQuestions(file: FileParameter | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Questions/Upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadQuestions(_response);
        });
    }

    protected processUploadQuestions(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IRatingScalesClient {

    getRatingScalesWithPagination(pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfRatingScaleBriefDto>;

    create(command: CreateRatingScaleCommand): Promise<number>;

    get(id: number): Promise<RatingScaleDto>;

    delete(id: number): Promise<FileResponse>;

    update(id: number, command: UpdateRatingScalePointCommand): Promise<FileResponse>;
}

export class RatingScalesClient extends AuthorizedApiBase implements IRatingScalesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getRatingScalesWithPagination(pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfRatingScaleBriefDto> {
        let url_ = this.baseUrl + "/api/RatingScales?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRatingScalesWithPagination(_response);
        });
    }

    protected processGetRatingScalesWithPagination(response: Response): Promise<PaginatedListOfRatingScaleBriefDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfRatingScaleBriefDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfRatingScaleBriefDto>(null as any);
    }

    create(command: CreateRatingScaleCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/RatingScales";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    get(id: number): Promise<RatingScaleDto> {
        let url_ = this.baseUrl + "/api/RatingScales/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<RatingScaleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RatingScaleDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RatingScaleDto>(null as any);
    }

    delete(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/RatingScales/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    update(id: number, command: UpdateRatingScalePointCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/RatingScales/Point/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IRegistrationsClient {

    getRegistrationsWithPagination(registrationPeriodId: number | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfRegistrationDto>;

    create(command: CreateRegistrationCommand): Promise<RegistrationDto>;
}

export class RegistrationsClient extends AuthorizedApiBase implements IRegistrationsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getRegistrationsWithPagination(registrationPeriodId: number | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfRegistrationDto> {
        let url_ = this.baseUrl + "/api/Registrations?";
        if (registrationPeriodId !== undefined && registrationPeriodId !== null)
            url_ += "RegistrationPeriodId=" + encodeURIComponent("" + registrationPeriodId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRegistrationsWithPagination(_response);
        });
    }

    protected processGetRegistrationsWithPagination(response: Response): Promise<PaginatedListOfRegistrationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfRegistrationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfRegistrationDto>(null as any);
    }

    create(command: CreateRegistrationCommand): Promise<RegistrationDto> {
        let url_ = this.baseUrl + "/api/Registrations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<RegistrationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegistrationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegistrationDto>(null as any);
    }
}

export interface IRegistrationPeriodsClient {

    get(passphrase: string): Promise<RegistrationPeriodDto>;

    getRegistrationPeriodsWithPagination(isEnabled: boolean | null | undefined, clientGroupId: number | null | undefined, hasConfirmCode: boolean | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfRegistrationPeriodDto>;

    create(command: CreateRegistrationPeriodCommand): Promise<number>;

    update(id: number, command: UpdateRegistrationPeriodCommand): Promise<FileResponse>;

    delete(id: number): Promise<FileResponse>;

    createConfirmCodes(id: number, file: FileParameter | null | undefined): Promise<number>;

    updateConfirmCodes(id: number, file: FileParameter | null | undefined): Promise<number>;

    downloadConfirmCodes(id: number): Promise<FileResponse>;
}

export class RegistrationPeriodsClient extends AuthorizedApiBase implements IRegistrationPeriodsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    get(passphrase: string): Promise<RegistrationPeriodDto> {
        let url_ = this.baseUrl + "/api/RegistrationPeriods/{passphrase}";
        if (passphrase === undefined || passphrase === null)
            throw new Error("The parameter 'passphrase' must be defined.");
        url_ = url_.replace("{passphrase}", encodeURIComponent("" + passphrase));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<RegistrationPeriodDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegistrationPeriodDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegistrationPeriodDto>(null as any);
    }

    getRegistrationPeriodsWithPagination(isEnabled: boolean | null | undefined, clientGroupId: number | null | undefined, hasConfirmCode: boolean | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfRegistrationPeriodDto> {
        let url_ = this.baseUrl + "/api/RegistrationPeriods?";
        if (isEnabled !== undefined && isEnabled !== null)
            url_ += "IsEnabled=" + encodeURIComponent("" + isEnabled) + "&";
        if (clientGroupId !== undefined && clientGroupId !== null)
            url_ += "ClientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        if (hasConfirmCode !== undefined && hasConfirmCode !== null)
            url_ += "HasConfirmCode=" + encodeURIComponent("" + hasConfirmCode) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRegistrationPeriodsWithPagination(_response);
        });
    }

    protected processGetRegistrationPeriodsWithPagination(response: Response): Promise<PaginatedListOfRegistrationPeriodDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfRegistrationPeriodDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfRegistrationPeriodDto>(null as any);
    }

    create(command: CreateRegistrationPeriodCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/RegistrationPeriods";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    update(id: number, command: UpdateRegistrationPeriodCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/RegistrationPeriods/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    delete(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/RegistrationPeriods/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    createConfirmCodes(id: number, file: FileParameter | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/RegistrationPeriods/{id}/ConfirmCode/Create";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateConfirmCodes(_response);
        });
    }

    protected processCreateConfirmCodes(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    updateConfirmCodes(id: number, file: FileParameter | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/RegistrationPeriods/{id}/ConfirmCode/Update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateConfirmCodes(_response);
        });
    }

    protected processUpdateConfirmCodes(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    downloadConfirmCodes(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/RegistrationPeriods/{id}/ConfirmCode/Download";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadConfirmCodes(_response);
        });
    }

    protected processDownloadConfirmCodes(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IGroupReportGenerationSettingsClient {

    export(): Promise<FileResponse>;

    getGroupReportGenerationSettings(clientGroupId: number | null | undefined, assessmentTemplatesId: number | null | undefined): Promise<GroupReportGenerationSettingsDto[]>;

    getGroupReportGenerationSettingsWithPagination(keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfGroupReportGenerationSettingsBriefDto>;
}

export class GroupReportGenerationSettingsClient extends AuthorizedApiBase implements IGroupReportGenerationSettingsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    export(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/GroupReportGenerationSettings/Export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getGroupReportGenerationSettings(clientGroupId: number | null | undefined, assessmentTemplatesId: number | null | undefined): Promise<GroupReportGenerationSettingsDto[]> {
        let url_ = this.baseUrl + "/api/GroupReportGenerationSettings?";
        if (clientGroupId !== undefined && clientGroupId !== null)
            url_ += "ClientGroupId=" + encodeURIComponent("" + clientGroupId) + "&";
        if (assessmentTemplatesId !== undefined && assessmentTemplatesId !== null)
            url_ += "AssessmentTemplatesId=" + encodeURIComponent("" + assessmentTemplatesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGroupReportGenerationSettings(_response);
        });
    }

    protected processGetGroupReportGenerationSettings(response: Response): Promise<GroupReportGenerationSettingsDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GroupReportGenerationSettingsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupReportGenerationSettingsDto[]>(null as any);
    }

    getGroupReportGenerationSettingsWithPagination(keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfGroupReportGenerationSettingsBriefDto> {
        let url_ = this.baseUrl + "/api/GroupReportGenerationSettings/Pagination?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGroupReportGenerationSettingsWithPagination(_response);
        });
    }

    protected processGetGroupReportGenerationSettingsWithPagination(response: Response): Promise<PaginatedListOfGroupReportGenerationSettingsBriefDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfGroupReportGenerationSettingsBriefDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfGroupReportGenerationSettingsBriefDto>(null as any);
    }
}

export interface IReportTemplateNormTablesClient {

    getReportTemplateNormTablesWithPagination(normTableId: number | null | undefined, reportTemplateId: number | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfReportTemplateNormTableBriefDto>;

    create(command: CreateReportTemplateNormTableCommand): Promise<number>;

    delete(id: number): Promise<FileResponse>;
}

export class ReportTemplateNormTablesClient extends AuthorizedApiBase implements IReportTemplateNormTablesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getReportTemplateNormTablesWithPagination(normTableId: number | null | undefined, reportTemplateId: number | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfReportTemplateNormTableBriefDto> {
        let url_ = this.baseUrl + "/api/ReportTemplateNormTables?";
        if (normTableId !== undefined && normTableId !== null)
            url_ += "NormTableId=" + encodeURIComponent("" + normTableId) + "&";
        if (reportTemplateId !== undefined && reportTemplateId !== null)
            url_ += "ReportTemplateId=" + encodeURIComponent("" + reportTemplateId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetReportTemplateNormTablesWithPagination(_response);
        });
    }

    protected processGetReportTemplateNormTablesWithPagination(response: Response): Promise<PaginatedListOfReportTemplateNormTableBriefDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfReportTemplateNormTableBriefDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfReportTemplateNormTableBriefDto>(null as any);
    }

    create(command: CreateReportTemplateNormTableCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/ReportTemplateNormTables";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ReportTemplateNormTables/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IReportTemplatesClient {

    getReportTemplatesWithPagination(keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfReportTemplateBriefDto>;

    create(command: CreateReportTemplateCommand): Promise<number>;

    get(id: number): Promise<ReportTemplateBriefDto>;

    update(id: number, command: UpdateReportTemplateCommand): Promise<FileResponse>;

    delete(id: number): Promise<FileResponse>;

    getTemplate(id: number): Promise<FileResponse>;

    uploadTemplate(id: number, file: FileParameter | null | undefined): Promise<FileResponse>;

    exportReportTemplateConditions(id: number): Promise<FileResponse>;

    uploadReportTemplateConditions(id: number, file: FileParameter | null | undefined): Promise<FileResponse>;

    exportReportTemplateCombineTokenRules(id: number): Promise<FileResponse>;

    uploadReportTemplateCombineTokenRules(id: number, file: FileParameter | null | undefined): Promise<FileResponse>;
}

export class ReportTemplatesClient extends AuthorizedApiBase implements IReportTemplatesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getReportTemplatesWithPagination(keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfReportTemplateBriefDto> {
        let url_ = this.baseUrl + "/api/ReportTemplates?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetReportTemplatesWithPagination(_response);
        });
    }

    protected processGetReportTemplatesWithPagination(response: Response): Promise<PaginatedListOfReportTemplateBriefDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfReportTemplateBriefDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfReportTemplateBriefDto>(null as any);
    }

    create(command: CreateReportTemplateCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/ReportTemplates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    get(id: number): Promise<ReportTemplateBriefDto> {
        let url_ = this.baseUrl + "/api/ReportTemplates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ReportTemplateBriefDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportTemplateBriefDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportTemplateBriefDto>(null as any);
    }

    update(id: number, command: UpdateReportTemplateCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ReportTemplates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    delete(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ReportTemplates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getTemplate(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ReportTemplates/{id}/Template";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTemplate(_response);
        });
    }

    protected processGetTemplate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    uploadTemplate(id: number, file: FileParameter | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ReportTemplates/{id}/Template";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadTemplate(_response);
        });
    }

    protected processUploadTemplate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    exportReportTemplateConditions(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ReportTemplates/{id}/Condition/Export";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportReportTemplateConditions(_response);
        });
    }

    protected processExportReportTemplateConditions(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    uploadReportTemplateConditions(id: number, file: FileParameter | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ReportTemplates/{id}/Condition/Upload";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadReportTemplateConditions(_response);
        });
    }

    protected processUploadReportTemplateConditions(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    exportReportTemplateCombineTokenRules(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ReportTemplates/{id}/CombineToken/Export";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportReportTemplateCombineTokenRules(_response);
        });
    }

    protected processExportReportTemplateCombineTokenRules(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    uploadReportTemplateCombineTokenRules(id: number, file: FileParameter | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ReportTemplates/{id}/CombineToken/Upload";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadReportTemplateCombineTokenRules(_response);
        });
    }

    protected processUploadReportTemplateCombineTokenRules(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IScoringKeySetsClient {

    checkNormTableScoringKeySet(id: number, formId: number): Promise<QuestionBriefDto[]>;

    upload(file: FileParameter | null | undefined): Promise<number>;

    export(): Promise<FileResponse>;

    exportDescription(): Promise<FileResponse>;

    uploadDescription(file: FileParameter | null | undefined): Promise<number>;

    get(keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfScoringKeySetDto>;
}

export class ScoringKeySetsClient extends AuthorizedApiBase implements IScoringKeySetsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    checkNormTableScoringKeySet(id: number, formId: number): Promise<QuestionBriefDto[]> {
        let url_ = this.baseUrl + "/api/ScoringKeySets/{id}/Form/{formId}/Check";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCheckNormTableScoringKeySet(_response);
        });
    }

    protected processCheckNormTableScoringKeySet(response: Response): Promise<QuestionBriefDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QuestionBriefDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionBriefDto[]>(null as any);
    }

    upload(file: FileParameter | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/ScoringKeySets/Upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    export(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ScoringKeySets/Export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    exportDescription(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ScoringKeySets/ScoringKey/Export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportDescription(_response);
        });
    }

    protected processExportDescription(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    uploadDescription(file: FileParameter | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/ScoringKeySets/ScoringKey/Upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadDescription(_response);
        });
    }

    protected processUploadDescription(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    get(keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfScoringKeySetDto> {
        let url_ = this.baseUrl + "/api/ScoringKeySets?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<PaginatedListOfScoringKeySetDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfScoringKeySetDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfScoringKeySetDto>(null as any);
    }
}

export interface ISupportedLanguageClient {

    getSupportedLanguages(enable: boolean | null | undefined): Promise<LanguageDto[]>;

    create(command: CreateSupportedLanguageCommand): Promise<FileResponse>;

    getSupportedLanguagesWithPagination(enable: boolean | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfLanguageDto>;

    update(command: UpdateSupportedLanguageCommand): Promise<FileResponse>;
}

export class SupportedLanguageClient extends AuthorizedApiBase implements ISupportedLanguageClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getSupportedLanguages(enable: boolean | null | undefined): Promise<LanguageDto[]> {
        let url_ = this.baseUrl + "/api/SupportedLanguage?";
        if (enable !== undefined && enable !== null)
            url_ += "Enable=" + encodeURIComponent("" + enable) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSupportedLanguages(_response);
        });
    }

    protected processGetSupportedLanguages(response: Response): Promise<LanguageDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LanguageDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LanguageDto[]>(null as any);
    }

    create(command: CreateSupportedLanguageCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/SupportedLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSupportedLanguagesWithPagination(enable: boolean | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfLanguageDto> {
        let url_ = this.baseUrl + "/api/SupportedLanguage/Pagination?";
        if (enable !== undefined && enable !== null)
            url_ += "Enable=" + encodeURIComponent("" + enable) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSupportedLanguagesWithPagination(_response);
        });
    }

    protected processGetSupportedLanguagesWithPagination(response: Response): Promise<PaginatedListOfLanguageDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfLanguageDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfLanguageDto>(null as any);
    }

    update(command: UpdateSupportedLanguageCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/SupportedLanguage/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface ITechnicalClient {

    getTechnicals(query: GetTechnicalsQuery | undefined): Promise<TechnicalBriefDto[]>;

    create(command: CreateTechnicalCommand): Promise<string>;

    delete(id: string): Promise<FileResponse>;
}

export class TechnicalClient extends AuthorizedApiBase implements ITechnicalClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getTechnicals(query: GetTechnicalsQuery | undefined): Promise<TechnicalBriefDto[]> {
        let url_ = this.baseUrl + "/api/Technical?";
        if (query === null)
            throw new Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTechnicals(_response);
        });
    }

    protected processGetTechnicals(response: Response): Promise<TechnicalBriefDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TechnicalBriefDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TechnicalBriefDto[]>(null as any);
    }

    create(command: CreateTechnicalCommand): Promise<string> {
        let url_ = this.baseUrl + "/api/Technical";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    delete(id: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Technical/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface ITodoItemsClient {

    getTodoItemsWithPagination(listId: number | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfTodoItemBriefDto>;

    create(command: CreateTodoItemCommand): Promise<number>;

    update(id: number, command: UpdateTodoItemCommand): Promise<FileResponse>;

    delete(id: number): Promise<FileResponse>;

    updateItemDetails(id: number | undefined, command: UpdateTodoItemDetailCommand): Promise<FileResponse>;
}

export class TodoItemsClient extends AuthorizedApiBase implements ITodoItemsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getTodoItemsWithPagination(listId: number | undefined, pageNumber: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined, isOrderByAsc: boolean | undefined): Promise<PaginatedListOfTodoItemBriefDto> {
        let url_ = this.baseUrl + "/api/TodoItems?";
        if (listId === null)
            throw new Error("The parameter 'listId' cannot be null.");
        else if (listId !== undefined)
            url_ += "ListId=" + encodeURIComponent("" + listId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isOrderByAsc === null)
            throw new Error("The parameter 'isOrderByAsc' cannot be null.");
        else if (isOrderByAsc !== undefined)
            url_ += "IsOrderByAsc=" + encodeURIComponent("" + isOrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTodoItemsWithPagination(_response);
        });
    }

    protected processGetTodoItemsWithPagination(response: Response): Promise<PaginatedListOfTodoItemBriefDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfTodoItemBriefDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfTodoItemBriefDto>(null as any);
    }

    create(command: CreateTodoItemCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/TodoItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    update(id: number, command: UpdateTodoItemCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/TodoItems/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    delete(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/TodoItems/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    updateItemDetails(id: number | undefined, command: UpdateTodoItemDetailCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/TodoItems/UpdateItemDetails?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateItemDetails(_response);
        });
    }

    protected processUpdateItemDetails(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface ITodoListsClient {

    get(): Promise<TodosVm>;

    create(command: CreateTodoListCommand): Promise<number>;

    update(id: number, command: UpdateTodoListCommand): Promise<FileResponse>;

    delete(id: number): Promise<FileResponse>;
}

export class TodoListsClient extends AuthorizedApiBase implements ITodoListsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    get(): Promise<TodosVm> {
        let url_ = this.baseUrl + "/api/TodoLists";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<TodosVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TodosVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TodosVm>(null as any);
    }

    create(command: CreateTodoListCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/TodoLists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    update(id: number, command: UpdateTodoListCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/TodoLists/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    delete(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/TodoLists/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IWeatherForecastClient {

    get(): Promise<WeatherForecast[]>;
}

export class WeatherForecastClient extends AuthorizedApiBase implements IWeatherForecastClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    get(): Promise<WeatherForecast[]> {
        let url_ = this.baseUrl + "/api/WeatherForecast";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<WeatherForecast[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WeatherForecast.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WeatherForecast[]>(null as any);
    }
}

export class CreateCredentialResult implements ICreateCredentialResult {
    id?: number;
    openIddictClientId?: string;
    clientSecret?: string;
    secretVersion?: number;

    constructor(data?: ICreateCredentialResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.openIddictClientId = _data["openIddictClientId"];
            this.clientSecret = _data["clientSecret"];
            this.secretVersion = _data["secretVersion"];
        }
    }

    static fromJS(data: any): CreateCredentialResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCredentialResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["openIddictClientId"] = this.openIddictClientId;
        data["clientSecret"] = this.clientSecret;
        data["secretVersion"] = this.secretVersion;
        return data;
    }
}

export interface ICreateCredentialResult {
    id?: number;
    openIddictClientId?: string;
    clientSecret?: string;
    secretVersion?: number;
}

export class CreateCredentialBody implements ICreateCredentialBody {
    name?: string;

    constructor(data?: ICreateCredentialBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateCredentialBody {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCredentialBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateCredentialBody {
    name?: string;
}

export class RotateCredentialSecretResult implements IRotateCredentialSecretResult {
    id?: number;
    clientSecret?: string;
    secretVersion?: number;

    constructor(data?: IRotateCredentialSecretResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientSecret = _data["clientSecret"];
            this.secretVersion = _data["secretVersion"];
        }
    }

    static fromJS(data: any): RotateCredentialSecretResult {
        data = typeof data === 'object' ? data : {};
        let result = new RotateCredentialSecretResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientSecret"] = this.clientSecret;
        data["secretVersion"] = this.secretVersion;
        return data;
    }
}

export interface IRotateCredentialSecretResult {
    id?: number;
    clientSecret?: string;
    secretVersion?: number;
}

export class CredentialBriefDto implements ICredentialBriefDto {
    id?: number;
    name?: string;
    openIddictClientId?: string;
    status?: string;
    allowedScopes?: string[];
    secretVersion?: number;
    expiresAt?: Date | undefined;
    created?: Date;
    createdBy?: string | undefined;
    lastUsedAt?: Date | undefined;

    constructor(data?: ICredentialBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.openIddictClientId = _data["openIddictClientId"];
            this.status = _data["status"];
            if (Array.isArray(_data["allowedScopes"])) {
                this.allowedScopes = [] as any;
                for (let item of _data["allowedScopes"])
                    this.allowedScopes!.push(item);
            }
            this.secretVersion = _data["secretVersion"];
            this.expiresAt = _data["expiresAt"] ? new Date(_data["expiresAt"].toString()) : <any>undefined;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUsedAt = _data["lastUsedAt"] ? new Date(_data["lastUsedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CredentialBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new CredentialBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["openIddictClientId"] = this.openIddictClientId;
        data["status"] = this.status;
        if (Array.isArray(this.allowedScopes)) {
            data["allowedScopes"] = [];
            for (let item of this.allowedScopes)
                data["allowedScopes"].push(item);
        }
        data["secretVersion"] = this.secretVersion;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : <any>undefined;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUsedAt"] = this.lastUsedAt ? this.lastUsedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICredentialBriefDto {
    id?: number;
    name?: string;
    openIddictClientId?: string;
    status?: string;
    allowedScopes?: string[];
    secretVersion?: number;
    expiresAt?: Date | undefined;
    created?: Date;
    createdBy?: string | undefined;
    lastUsedAt?: Date | undefined;
}

export class CreateSubscriptionResult implements ICreateSubscriptionResult {
    id?: number;
    signingSecret?: string;
    signingSecretVersion?: number;

    constructor(data?: ICreateSubscriptionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.signingSecret = _data["signingSecret"];
            this.signingSecretVersion = _data["signingSecretVersion"];
        }
    }

    static fromJS(data: any): CreateSubscriptionResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSubscriptionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["signingSecret"] = this.signingSecret;
        data["signingSecretVersion"] = this.signingSecretVersion;
        return data;
    }
}

export interface ICreateSubscriptionResult {
    id?: number;
    signingSecret?: string;
    signingSecretVersion?: number;
}

export class CreateSubscriptionBody implements ICreateSubscriptionBody {
    name?: string;
    endpointUrl?: string;
    isActive?: boolean;

    constructor(data?: ICreateSubscriptionBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.endpointUrl = _data["endpointUrl"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateSubscriptionBody {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSubscriptionBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["endpointUrl"] = this.endpointUrl;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICreateSubscriptionBody {
    name?: string;
    endpointUrl?: string;
    isActive?: boolean;
}

export class UpdateSubscriptionBody implements IUpdateSubscriptionBody {
    name?: string;
    endpointUrl?: string;
    isActive?: boolean;

    constructor(data?: IUpdateSubscriptionBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.endpointUrl = _data["endpointUrl"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdateSubscriptionBody {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSubscriptionBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["endpointUrl"] = this.endpointUrl;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IUpdateSubscriptionBody {
    name?: string;
    endpointUrl?: string;
    isActive?: boolean;
}

export class RotateSubscriptionSecretResult implements IRotateSubscriptionSecretResult {
    id?: number;
    signingSecret?: string;
    signingSecretVersion?: number;

    constructor(data?: IRotateSubscriptionSecretResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.signingSecret = _data["signingSecret"];
            this.signingSecretVersion = _data["signingSecretVersion"];
        }
    }

    static fromJS(data: any): RotateSubscriptionSecretResult {
        data = typeof data === 'object' ? data : {};
        let result = new RotateSubscriptionSecretResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["signingSecret"] = this.signingSecret;
        data["signingSecretVersion"] = this.signingSecretVersion;
        return data;
    }
}

export interface IRotateSubscriptionSecretResult {
    id?: number;
    signingSecret?: string;
    signingSecretVersion?: number;
}

export class SubscriptionBriefDto implements ISubscriptionBriefDto {
    id?: number;
    name?: string;
    endpointUrl?: string;
    isActive?: boolean;
    signingSecretVersion?: number;

    constructor(data?: ISubscriptionBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.endpointUrl = _data["endpointUrl"];
            this.isActive = _data["isActive"];
            this.signingSecretVersion = _data["signingSecretVersion"];
        }
    }

    static fromJS(data: any): SubscriptionBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["endpointUrl"] = this.endpointUrl;
        data["isActive"] = this.isActive;
        data["signingSecretVersion"] = this.signingSecretVersion;
        return data;
    }
}

export interface ISubscriptionBriefDto {
    id?: number;
    name?: string;
    endpointUrl?: string;
    isActive?: boolean;
    signingSecretVersion?: number;
}

export class PaginatedListOfDeliveryBriefDto implements IPaginatedListOfDeliveryBriefDto {
    items?: DeliveryBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfDeliveryBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DeliveryBriefDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfDeliveryBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfDeliveryBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfDeliveryBriefDto {
    items?: DeliveryBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class DeliveryBriefDto implements IDeliveryBriefDto {
    id?: number;
    eventId?: string;
    eventType?: string;
    status?: string;
    attemptCount?: number;
    responseCode?: number | undefined;
    lastAttemptAt?: Date | undefined;
    nextRetryAt?: Date | undefined;
    errorMessage?: string | undefined;
    responseBodySnippet?: string | undefined;
    payloadJson?: string;
    created?: Date;

    constructor(data?: IDeliveryBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.eventId = _data["eventId"];
            this.eventType = _data["eventType"];
            this.status = _data["status"];
            this.attemptCount = _data["attemptCount"];
            this.responseCode = _data["responseCode"];
            this.lastAttemptAt = _data["lastAttemptAt"] ? new Date(_data["lastAttemptAt"].toString()) : <any>undefined;
            this.nextRetryAt = _data["nextRetryAt"] ? new Date(_data["nextRetryAt"].toString()) : <any>undefined;
            this.errorMessage = _data["errorMessage"];
            this.responseBodySnippet = _data["responseBodySnippet"];
            this.payloadJson = _data["payloadJson"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DeliveryBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["eventId"] = this.eventId;
        data["eventType"] = this.eventType;
        data["status"] = this.status;
        data["attemptCount"] = this.attemptCount;
        data["responseCode"] = this.responseCode;
        data["lastAttemptAt"] = this.lastAttemptAt ? this.lastAttemptAt.toISOString() : <any>undefined;
        data["nextRetryAt"] = this.nextRetryAt ? this.nextRetryAt.toISOString() : <any>undefined;
        data["errorMessage"] = this.errorMessage;
        data["responseBodySnippet"] = this.responseBodySnippet;
        data["payloadJson"] = this.payloadJson;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDeliveryBriefDto {
    id?: number;
    eventId?: string;
    eventType?: string;
    status?: string;
    attemptCount?: number;
    responseCode?: number | undefined;
    lastAttemptAt?: Date | undefined;
    nextRetryAt?: Date | undefined;
    errorMessage?: string | undefined;
    responseBodySnippet?: string | undefined;
    payloadJson?: string;
    created?: Date;
}

export class ExternalIdentityBriefDto implements IExternalIdentityBriefDto {
    id?: number;
    clientId?: number;
    clientUserId?: string;
    externalUserKey?: string;
    displayName?: string | undefined;
    lastSeenAt?: Date | undefined;

    constructor(data?: IExternalIdentityBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientId = _data["clientId"];
            this.clientUserId = _data["clientUserId"];
            this.externalUserKey = _data["externalUserKey"];
            this.displayName = _data["displayName"];
            this.lastSeenAt = _data["lastSeenAt"] ? new Date(_data["lastSeenAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ExternalIdentityBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalIdentityBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        data["clientUserId"] = this.clientUserId;
        data["externalUserKey"] = this.externalUserKey;
        data["displayName"] = this.displayName;
        data["lastSeenAt"] = this.lastSeenAt ? this.lastSeenAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IExternalIdentityBriefDto {
    id?: number;
    clientId?: number;
    clientUserId?: string;
    externalUserKey?: string;
    displayName?: string | undefined;
    lastSeenAt?: Date | undefined;
}

export class UpsertExternalIdentityBody implements IUpsertExternalIdentityBody {
    clientUserId?: string;
    externalUserKey?: string;
    displayName?: string | undefined;

    constructor(data?: IUpsertExternalIdentityBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientUserId = _data["clientUserId"];
            this.externalUserKey = _data["externalUserKey"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): UpsertExternalIdentityBody {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertExternalIdentityBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientUserId"] = this.clientUserId;
        data["externalUserKey"] = this.externalUserKey;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IUpsertExternalIdentityBody {
    clientUserId?: string;
    externalUserKey?: string;
    displayName?: string | undefined;
}

export class PaginatedListOfAdministratorBriefDto implements IPaginatedListOfAdministratorBriefDto {
    items?: AdministratorBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfAdministratorBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AdministratorBriefDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfAdministratorBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfAdministratorBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfAdministratorBriefDto {
    items?: AdministratorBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class AdministratorBriefDto implements IAdministratorBriefDto {
    id?: string;
    fullName?: string | undefined;
    userName?: string | undefined;
    preferredLanguageDisplayName?: string | undefined;
    preferredLanguageId?: string | undefined;
    email?: string | undefined;
    type?: string | undefined;

    constructor(data?: IAdministratorBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.userName = _data["userName"];
            this.preferredLanguageDisplayName = _data["preferredLanguageDisplayName"];
            this.preferredLanguageId = _data["preferredLanguageId"];
            this.email = _data["email"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): AdministratorBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdministratorBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["userName"] = this.userName;
        data["preferredLanguageDisplayName"] = this.preferredLanguageDisplayName;
        data["preferredLanguageId"] = this.preferredLanguageId;
        data["email"] = this.email;
        data["type"] = this.type;
        return data;
    }
}

export interface IAdministratorBriefDto {
    id?: string;
    fullName?: string | undefined;
    userName?: string | undefined;
    preferredLanguageDisplayName?: string | undefined;
    preferredLanguageId?: string | undefined;
    email?: string | undefined;
    type?: string | undefined;
}

export enum AdministratorType {
    Administrator = 0,
    Technical = 1,
}

export class UpdateAdministratorCommand implements IUpdateAdministratorCommand {
    id?: string;
    userName?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    preferredLanguageId?: string | undefined;

    constructor(data?: IUpdateAdministratorCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.preferredLanguageId = _data["preferredLanguageId"];
        }
    }

    static fromJS(data: any): UpdateAdministratorCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAdministratorCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["preferredLanguageId"] = this.preferredLanguageId;
        return data;
    }
}

export interface IUpdateAdministratorCommand {
    id?: string;
    userName?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    preferredLanguageId?: string | undefined;
}

export class CreateAdministratorCommand implements ICreateAdministratorCommand {
    userName?: string;
    password?: string | undefined;
    fullName?: string | undefined;
    preferredLanguageId?: string | undefined;
    email?: string | undefined;
    type?: AdministratorType;
    hasEmailNotification?: boolean | undefined;

    constructor(data?: ICreateAdministratorCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.fullName = _data["fullName"];
            this.preferredLanguageId = _data["preferredLanguageId"];
            this.email = _data["email"];
            this.type = _data["type"];
            this.hasEmailNotification = _data["hasEmailNotification"];
        }
    }

    static fromJS(data: any): CreateAdministratorCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAdministratorCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["fullName"] = this.fullName;
        data["preferredLanguageId"] = this.preferredLanguageId;
        data["email"] = this.email;
        data["type"] = this.type;
        data["hasEmailNotification"] = this.hasEmailNotification;
        return data;
    }
}

export interface ICreateAdministratorCommand {
    userName?: string;
    password?: string | undefined;
    fullName?: string | undefined;
    preferredLanguageId?: string | undefined;
    email?: string | undefined;
    type?: AdministratorType;
    hasEmailNotification?: boolean | undefined;
}

export class DeleteAdministratorCommand implements IDeleteAdministratorCommand {
    id?: string | undefined;

    constructor(data?: IDeleteAdministratorCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteAdministratorCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteAdministratorCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteAdministratorCommand {
    id?: string | undefined;
}

export class Result implements IResult {
    succeeded?: boolean;
    errors?: string[];

    constructor(data?: IResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): Result {
        data = typeof data === 'object' ? data : {};
        let result = new Result();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface IResult {
    succeeded?: boolean;
    errors?: string[];
}

export class UpdateAdministratorPasswordCommand implements IUpdateAdministratorPasswordCommand {
    oldPassword?: string;
    newPassword?: string;

    constructor(data?: IUpdateAdministratorPasswordCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldPassword = _data["oldPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): UpdateAdministratorPasswordCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAdministratorPasswordCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldPassword"] = this.oldPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IUpdateAdministratorPasswordCommand {
    oldPassword?: string;
    newPassword?: string;
}

export class ForceUpdateAdministratorPasswordCommand implements IForceUpdateAdministratorPasswordCommand {
    userId?: string;
    newPassword?: string;

    constructor(data?: IForceUpdateAdministratorPasswordCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ForceUpdateAdministratorPasswordCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ForceUpdateAdministratorPasswordCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IForceUpdateAdministratorPasswordCommand {
    userId?: string;
    newPassword?: string;
}

export class AliVodVideoBriefDto implements IAliVodVideoBriefDto {
    fileName?: string | undefined;
    width?: number | undefined;
    height?: number | undefined;
    playURL?: string | undefined;
    format?: string | undefined;

    constructor(data?: IAliVodVideoBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.playURL = _data["playURL"];
            this.format = _data["format"];
        }
    }

    static fromJS(data: any): AliVodVideoBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new AliVodVideoBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["width"] = this.width;
        data["height"] = this.height;
        data["playURL"] = this.playURL;
        data["format"] = this.format;
        return data;
    }
}

export interface IAliVodVideoBriefDto {
    fileName?: string | undefined;
    width?: number | undefined;
    height?: number | undefined;
    playURL?: string | undefined;
    format?: string | undefined;
}

export class VideoUploadCredentialResponse implements IVideoUploadCredentialResponse {
    videoId?: string;
    uploadAddress?: string;
    uploadAuth?: string;
    userId?: string;
    region?: string;

    constructor(data?: IVideoUploadCredentialResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.videoId = _data["videoId"];
            this.uploadAddress = _data["uploadAddress"];
            this.uploadAuth = _data["uploadAuth"];
            this.userId = _data["userId"];
            this.region = _data["region"];
        }
    }

    static fromJS(data: any): VideoUploadCredentialResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VideoUploadCredentialResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["videoId"] = this.videoId;
        data["uploadAddress"] = this.uploadAddress;
        data["uploadAuth"] = this.uploadAuth;
        data["userId"] = this.userId;
        data["region"] = this.region;
        return data;
    }
}

export interface IVideoUploadCredentialResponse {
    videoId?: string;
    uploadAddress?: string;
    uploadAuth?: string;
    userId?: string;
    region?: string;
}

export class CreateAliVodVideoAuthCommand implements ICreateAliVodVideoAuthCommand {
    fileName?: string;
    headLine?: string;

    constructor(data?: ICreateAliVodVideoAuthCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.headLine = _data["headLine"];
        }
    }

    static fromJS(data: any): CreateAliVodVideoAuthCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAliVodVideoAuthCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["headLine"] = this.headLine;
        return data;
    }
}

export interface ICreateAliVodVideoAuthCommand {
    fileName?: string;
    headLine?: string;
}

export class AliVodVideoDto implements IAliVodVideoDto {
    id?: number;
    fileName?: string | undefined;
    size?: number | undefined;
    width?: number | undefined;
    height?: number | undefined;
    coverURL?: string | undefined;
    playURL?: string | undefined;
    format?: string | undefined;
    videoId?: string | undefined;

    constructor(data?: IAliVodVideoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.size = _data["size"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.coverURL = _data["coverURL"];
            this.playURL = _data["playURL"];
            this.format = _data["format"];
            this.videoId = _data["videoId"];
        }
    }

    static fromJS(data: any): AliVodVideoDto {
        data = typeof data === 'object' ? data : {};
        let result = new AliVodVideoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["size"] = this.size;
        data["width"] = this.width;
        data["height"] = this.height;
        data["coverURL"] = this.coverURL;
        data["playURL"] = this.playURL;
        data["format"] = this.format;
        data["videoId"] = this.videoId;
        return data;
    }
}

export interface IAliVodVideoDto {
    id?: number;
    fileName?: string | undefined;
    size?: number | undefined;
    width?: number | undefined;
    height?: number | undefined;
    coverURL?: string | undefined;
    playURL?: string | undefined;
    format?: string | undefined;
    videoId?: string | undefined;
}

export class CreateAliVodVideoCommand implements ICreateAliVodVideoCommand {
    videoId?: string;

    constructor(data?: ICreateAliVodVideoCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.videoId = _data["videoId"];
        }
    }

    static fromJS(data: any): CreateAliVodVideoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAliVodVideoCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["videoId"] = this.videoId;
        return data;
    }
}

export interface ICreateAliVodVideoCommand {
    videoId?: string;
}

export class PlayAuthResponse implements IPlayAuthResponse {
    videoId?: string | undefined;
    playAuth?: string | undefined;
    title?: string | undefined;
    duration?: number | undefined;
    status?: string | undefined;
    expireTime?: Date;

    constructor(data?: IPlayAuthResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.videoId = _data["videoId"];
            this.playAuth = _data["playAuth"];
            this.title = _data["title"];
            this.duration = _data["duration"];
            this.status = _data["status"];
            this.expireTime = _data["expireTime"] ? new Date(_data["expireTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PlayAuthResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PlayAuthResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["videoId"] = this.videoId;
        data["playAuth"] = this.playAuth;
        data["title"] = this.title;
        data["duration"] = this.duration;
        data["status"] = this.status;
        data["expireTime"] = this.expireTime ? this.expireTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPlayAuthResponse {
    videoId?: string | undefined;
    playAuth?: string | undefined;
    title?: string | undefined;
    duration?: number | undefined;
    status?: string | undefined;
    expireTime?: Date;
}

export class CreateVideoPlayAuthCommand implements ICreateVideoPlayAuthCommand {
    videoId?: string;

    constructor(data?: ICreateVideoPlayAuthCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.videoId = _data["videoId"];
        }
    }

    static fromJS(data: any): CreateVideoPlayAuthCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateVideoPlayAuthCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["videoId"] = this.videoId;
        return data;
    }
}

export interface ICreateVideoPlayAuthCommand {
    videoId?: string;
}

export class PaginatedListOfAllCourseBriefDto implements IPaginatedListOfAllCourseBriefDto {
    items?: AllCourseBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfAllCourseBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AllCourseBriefDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfAllCourseBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfAllCourseBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfAllCourseBriefDto {
    items?: AllCourseBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class AllCourseBriefDto implements IAllCourseBriefDto {
    id?: number;
    courseName?: string;
    description?: string;
    status?: string;
    lastModifiedDate?: Date;
    isActive?: boolean;
    isDeleted?: boolean;
    coverImageUrl?: string | undefined;
    courseIdString?: string | undefined;

    constructor(data?: IAllCourseBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.courseName = _data["courseName"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.coverImageUrl = _data["coverImageUrl"];
            this.courseIdString = _data["courseIdString"];
        }
    }

    static fromJS(data: any): AllCourseBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new AllCourseBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["courseName"] = this.courseName;
        data["description"] = this.description;
        data["status"] = this.status;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["coverImageUrl"] = this.coverImageUrl;
        data["courseIdString"] = this.courseIdString;
        return data;
    }
}

export interface IAllCourseBriefDto {
    id?: number;
    courseName?: string;
    description?: string;
    status?: string;
    lastModifiedDate?: Date;
    isActive?: boolean;
    isDeleted?: boolean;
    coverImageUrl?: string | undefined;
    courseIdString?: string | undefined;
}

export enum CourseStatus {
    Draft = 0,
    Published = 1,
    Unpublished = 2,
}

export class PaginatedListOfAssessmentReportDto implements IPaginatedListOfAssessmentReportDto {
    items?: AssessmentReportDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfAssessmentReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AssessmentReportDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfAssessmentReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfAssessmentReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfAssessmentReportDto {
    items?: AssessmentReportDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class AssessmentReportDto implements IAssessmentReportDto {
    id?: number;
    assessmentClientUser?: ClientUserBriefDto | undefined;
    status?: AssessmentReportStatus;
    assessmentId?: number;
    reportTemplate?: ReportTemplateBriefDto | undefined;
    scoringKeySetId?: number;
    normTable?: NormTableBriefDto | undefined;
    scoringKeySetName?: string | undefined;
    sent?: Date | undefined;
    startedOn?: Date | undefined;
    reportTemplatePreferredLanguageDisplayName?: string | undefined;

    constructor(data?: IAssessmentReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assessmentClientUser = _data["assessmentClientUser"] ? ClientUserBriefDto.fromJS(_data["assessmentClientUser"]) : <any>undefined;
            this.status = _data["status"];
            this.assessmentId = _data["assessmentId"];
            this.reportTemplate = _data["reportTemplate"] ? ReportTemplateBriefDto.fromJS(_data["reportTemplate"]) : <any>undefined;
            this.scoringKeySetId = _data["scoringKeySetId"];
            this.normTable = _data["normTable"] ? NormTableBriefDto.fromJS(_data["normTable"]) : <any>undefined;
            this.scoringKeySetName = _data["scoringKeySetName"];
            this.sent = _data["sent"] ? new Date(_data["sent"].toString()) : <any>undefined;
            this.startedOn = _data["startedOn"] ? new Date(_data["startedOn"].toString()) : <any>undefined;
            this.reportTemplatePreferredLanguageDisplayName = _data["reportTemplatePreferredLanguageDisplayName"];
        }
    }

    static fromJS(data: any): AssessmentReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assessmentClientUser"] = this.assessmentClientUser ? this.assessmentClientUser.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["assessmentId"] = this.assessmentId;
        data["reportTemplate"] = this.reportTemplate ? this.reportTemplate.toJSON() : <any>undefined;
        data["scoringKeySetId"] = this.scoringKeySetId;
        data["normTable"] = this.normTable ? this.normTable.toJSON() : <any>undefined;
        data["scoringKeySetName"] = this.scoringKeySetName;
        data["sent"] = this.sent ? this.sent.toISOString() : <any>undefined;
        data["startedOn"] = this.startedOn ? this.startedOn.toISOString() : <any>undefined;
        data["reportTemplatePreferredLanguageDisplayName"] = this.reportTemplatePreferredLanguageDisplayName;
        return data;
    }
}

export interface IAssessmentReportDto {
    id?: number;
    assessmentClientUser?: ClientUserBriefDto | undefined;
    status?: AssessmentReportStatus;
    assessmentId?: number;
    reportTemplate?: ReportTemplateBriefDto | undefined;
    scoringKeySetId?: number;
    normTable?: NormTableBriefDto | undefined;
    scoringKeySetName?: string | undefined;
    sent?: Date | undefined;
    startedOn?: Date | undefined;
    reportTemplatePreferredLanguageDisplayName?: string | undefined;
}

export abstract class AuditableEntity implements IAuditableEntity {
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;

    constructor(data?: IAuditableEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
        }
    }

    static fromJS(data: any): AuditableEntity {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'AuditableEntity' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        return data;
    }
}

export interface IAuditableEntity {
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;
}

export class ClientUserBriefDto extends AuditableEntity implements IClientUserBriefDto {
    id?: string;
    fullName?: string | undefined;
    clientName?: string | undefined;
    clientGroupName?: string | undefined;
    userName?: string | undefined;
    preferredLanguageDisplayName?: string | undefined;
    preferredLanguageId?: string | undefined;
    email?: string | undefined;
    haveChangePassword?: boolean;
    haveEnterDetail?: boolean;
    clientGroup?: ClientGroupDto | undefined;
    remark?: string | undefined;
    firstTimeLogin?: Date | undefined;
    lastLogin?: Date | undefined;

    constructor(data?: IClientUserBriefDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.clientName = _data["clientName"];
            this.clientGroupName = _data["clientGroupName"];
            this.userName = _data["userName"];
            this.preferredLanguageDisplayName = _data["preferredLanguageDisplayName"];
            this.preferredLanguageId = _data["preferredLanguageId"];
            this.email = _data["email"];
            this.haveChangePassword = _data["haveChangePassword"];
            this.haveEnterDetail = _data["haveEnterDetail"];
            this.clientGroup = _data["clientGroup"] ? ClientGroupDto.fromJS(_data["clientGroup"]) : <any>undefined;
            this.remark = _data["remark"];
            this.firstTimeLogin = _data["firstTimeLogin"] ? new Date(_data["firstTimeLogin"].toString()) : <any>undefined;
            this.lastLogin = _data["lastLogin"] ? new Date(_data["lastLogin"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ClientUserBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientUserBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["clientName"] = this.clientName;
        data["clientGroupName"] = this.clientGroupName;
        data["userName"] = this.userName;
        data["preferredLanguageDisplayName"] = this.preferredLanguageDisplayName;
        data["preferredLanguageId"] = this.preferredLanguageId;
        data["email"] = this.email;
        data["haveChangePassword"] = this.haveChangePassword;
        data["haveEnterDetail"] = this.haveEnterDetail;
        data["clientGroup"] = this.clientGroup ? this.clientGroup.toJSON() : <any>undefined;
        data["remark"] = this.remark;
        data["firstTimeLogin"] = this.firstTimeLogin ? this.firstTimeLogin.toISOString() : <any>undefined;
        data["lastLogin"] = this.lastLogin ? this.lastLogin.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IClientUserBriefDto extends IAuditableEntity {
    id?: string;
    fullName?: string | undefined;
    clientName?: string | undefined;
    clientGroupName?: string | undefined;
    userName?: string | undefined;
    preferredLanguageDisplayName?: string | undefined;
    preferredLanguageId?: string | undefined;
    email?: string | undefined;
    haveChangePassword?: boolean;
    haveEnterDetail?: boolean;
    clientGroup?: ClientGroupDto | undefined;
    remark?: string | undefined;
    firstTimeLogin?: Date | undefined;
    lastLogin?: Date | undefined;
}

export class ClientGroupDto extends AuditableEntity implements IClientGroupDto {
    id?: number;
    name?: string | undefined;
    client?: ClientBriefDto | undefined;
    clientName?: string | undefined;
    logoFileId?: number | undefined;
    canCustomizePreferredLanguage?: boolean;
    canCustomizeEmail?: boolean;
    canCustomizePassword?: boolean;
    canCustomizeFullName?: boolean;
    customFullNameLabel?: string | undefined;
    isReportAutoSend?: boolean;
    reportAutoSendSetting?: ReportAutoSendSetting;
    triggerTime?: Date | undefined;
    emailRecipient?: string[] | undefined;
    ccRecipient?: string[] | undefined;
    accountExpiry?: Date | undefined;
    maxAccount?: number | undefined;
    maxAccountForSub?: number | undefined;
    parentGroupId?: number | undefined;
    parentGroupAccountExpiry?: Date | undefined;
    assignableAccountRemain?: number | undefined;
    registrationEmailId?: number | undefined;
    reportEmailId?: number | undefined;
    reminderEmailId?: number | undefined;
    hasSubGroup?: boolean;
    preferredLanguageId?: string;
    allowGroupReportScoreJson?: boolean;

    constructor(data?: IClientGroupDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.client = _data["client"] ? ClientBriefDto.fromJS(_data["client"]) : <any>undefined;
            this.clientName = _data["clientName"];
            this.logoFileId = _data["logoFileId"];
            this.canCustomizePreferredLanguage = _data["canCustomizePreferredLanguage"];
            this.canCustomizeEmail = _data["canCustomizeEmail"];
            this.canCustomizePassword = _data["canCustomizePassword"];
            this.canCustomizeFullName = _data["canCustomizeFullName"];
            this.customFullNameLabel = _data["customFullNameLabel"];
            this.isReportAutoSend = _data["isReportAutoSend"];
            this.reportAutoSendSetting = _data["reportAutoSendSetting"];
            this.triggerTime = _data["triggerTime"] ? new Date(_data["triggerTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["emailRecipient"])) {
                this.emailRecipient = [] as any;
                for (let item of _data["emailRecipient"])
                    this.emailRecipient!.push(item);
            }
            if (Array.isArray(_data["ccRecipient"])) {
                this.ccRecipient = [] as any;
                for (let item of _data["ccRecipient"])
                    this.ccRecipient!.push(item);
            }
            this.accountExpiry = _data["accountExpiry"] ? new Date(_data["accountExpiry"].toString()) : <any>undefined;
            this.maxAccount = _data["maxAccount"];
            this.maxAccountForSub = _data["maxAccountForSub"];
            this.parentGroupId = _data["parentGroupId"];
            this.parentGroupAccountExpiry = _data["parentGroupAccountExpiry"] ? new Date(_data["parentGroupAccountExpiry"].toString()) : <any>undefined;
            this.assignableAccountRemain = _data["assignableAccountRemain"];
            this.registrationEmailId = _data["registrationEmailId"];
            this.reportEmailId = _data["reportEmailId"];
            this.reminderEmailId = _data["reminderEmailId"];
            this.hasSubGroup = _data["hasSubGroup"];
            this.preferredLanguageId = _data["preferredLanguageId"];
            this.allowGroupReportScoreJson = _data["allowGroupReportScoreJson"];
        }
    }

    static fromJS(data: any): ClientGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["clientName"] = this.clientName;
        data["logoFileId"] = this.logoFileId;
        data["canCustomizePreferredLanguage"] = this.canCustomizePreferredLanguage;
        data["canCustomizeEmail"] = this.canCustomizeEmail;
        data["canCustomizePassword"] = this.canCustomizePassword;
        data["canCustomizeFullName"] = this.canCustomizeFullName;
        data["customFullNameLabel"] = this.customFullNameLabel;
        data["isReportAutoSend"] = this.isReportAutoSend;
        data["reportAutoSendSetting"] = this.reportAutoSendSetting;
        data["triggerTime"] = this.triggerTime ? this.triggerTime.toISOString() : <any>undefined;
        if (Array.isArray(this.emailRecipient)) {
            data["emailRecipient"] = [];
            for (let item of this.emailRecipient)
                data["emailRecipient"].push(item);
        }
        if (Array.isArray(this.ccRecipient)) {
            data["ccRecipient"] = [];
            for (let item of this.ccRecipient)
                data["ccRecipient"].push(item);
        }
        data["accountExpiry"] = this.accountExpiry ? this.accountExpiry.toISOString() : <any>undefined;
        data["maxAccount"] = this.maxAccount;
        data["maxAccountForSub"] = this.maxAccountForSub;
        data["parentGroupId"] = this.parentGroupId;
        data["parentGroupAccountExpiry"] = this.parentGroupAccountExpiry ? this.parentGroupAccountExpiry.toISOString() : <any>undefined;
        data["assignableAccountRemain"] = this.assignableAccountRemain;
        data["registrationEmailId"] = this.registrationEmailId;
        data["reportEmailId"] = this.reportEmailId;
        data["reminderEmailId"] = this.reminderEmailId;
        data["hasSubGroup"] = this.hasSubGroup;
        data["preferredLanguageId"] = this.preferredLanguageId;
        data["allowGroupReportScoreJson"] = this.allowGroupReportScoreJson;
        super.toJSON(data);
        return data;
    }
}

export interface IClientGroupDto extends IAuditableEntity {
    id?: number;
    name?: string | undefined;
    client?: ClientBriefDto | undefined;
    clientName?: string | undefined;
    logoFileId?: number | undefined;
    canCustomizePreferredLanguage?: boolean;
    canCustomizeEmail?: boolean;
    canCustomizePassword?: boolean;
    canCustomizeFullName?: boolean;
    customFullNameLabel?: string | undefined;
    isReportAutoSend?: boolean;
    reportAutoSendSetting?: ReportAutoSendSetting;
    triggerTime?: Date | undefined;
    emailRecipient?: string[] | undefined;
    ccRecipient?: string[] | undefined;
    accountExpiry?: Date | undefined;
    maxAccount?: number | undefined;
    maxAccountForSub?: number | undefined;
    parentGroupId?: number | undefined;
    parentGroupAccountExpiry?: Date | undefined;
    assignableAccountRemain?: number | undefined;
    registrationEmailId?: number | undefined;
    reportEmailId?: number | undefined;
    reminderEmailId?: number | undefined;
    hasSubGroup?: boolean;
    preferredLanguageId?: string;
    allowGroupReportScoreJson?: boolean;
}

export class ClientBriefDto implements IClientBriefDto {
    id?: number;
    name?: string | undefined;
    userNamePrefix?: string | undefined;
    created?: Date;

    constructor(data?: IClientBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.userNamePrefix = _data["userNamePrefix"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ClientBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["userNamePrefix"] = this.userNamePrefix;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }
}

export interface IClientBriefDto {
    id?: number;
    name?: string | undefined;
    userNamePrefix?: string | undefined;
    created?: Date;
}

export enum ReportAutoSendSetting {
    None = 0,
    All = 1,
    EmailList = 2,
    Attendance = 3,
}

export enum AssessmentReportStatus {
    Pending = 0,
    Processing = 1,
    Completed = 2,
    Failed = 3,
}

export class ReportTemplateBriefDto implements IReportTemplateBriefDto {
    id?: number;
    name?: string;
    displayName?: string;
    fileName?: string;
    preferredLanguageId?: string;
    preferredLanguageDisplayName?: string;
    created?: Date;
    lastModified?: Date;
    reportGenerationMethod?: ReportGenerationMethod;
    showUnmatchToken?: boolean;

    constructor(data?: IReportTemplateBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.fileName = _data["fileName"];
            this.preferredLanguageId = _data["preferredLanguageId"];
            this.preferredLanguageDisplayName = _data["preferredLanguageDisplayName"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.reportGenerationMethod = _data["reportGenerationMethod"];
            this.showUnmatchToken = _data["showUnmatchToken"];
        }
    }

    static fromJS(data: any): ReportTemplateBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportTemplateBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["fileName"] = this.fileName;
        data["preferredLanguageId"] = this.preferredLanguageId;
        data["preferredLanguageDisplayName"] = this.preferredLanguageDisplayName;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["reportGenerationMethod"] = this.reportGenerationMethod;
        data["showUnmatchToken"] = this.showUnmatchToken;
        return data;
    }
}

export interface IReportTemplateBriefDto {
    id?: number;
    name?: string;
    displayName?: string;
    fileName?: string;
    preferredLanguageId?: string;
    preferredLanguageDisplayName?: string;
    created?: Date;
    lastModified?: Date;
    reportGenerationMethod?: ReportGenerationMethod;
    showUnmatchToken?: boolean;
}

export enum ReportGenerationMethod {
    LibreOffice = 0,
    Adobe = 1,
}

export class NormTableBriefDto implements INormTableBriefDto {
    id?: number;
    name?: string | undefined;
    questionCategoryAlias?: string | undefined;
    created?: Date;

    constructor(data?: INormTableBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.questionCategoryAlias = _data["questionCategoryAlias"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NormTableBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new NormTableBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["questionCategoryAlias"] = this.questionCategoryAlias;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }
}

export interface INormTableBriefDto {
    id?: number;
    name?: string | undefined;
    questionCategoryAlias?: string | undefined;
    created?: Date;
}

export class SendAssessmentReportCommand implements ISendAssessmentReportCommand {
    id?: number;
    scheduleSendTime?: Date | undefined;
    reportAutoSendSetting?: ReportAutoSendSetting;
    to?: string[];
    cc?: string[];

    constructor(data?: ISendAssessmentReportCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.scheduleSendTime = _data["scheduleSendTime"] ? new Date(_data["scheduleSendTime"].toString()) : <any>undefined;
            this.reportAutoSendSetting = _data["reportAutoSendSetting"];
            if (Array.isArray(_data["to"])) {
                this.to = [] as any;
                for (let item of _data["to"])
                    this.to!.push(item);
            }
            if (Array.isArray(_data["cc"])) {
                this.cc = [] as any;
                for (let item of _data["cc"])
                    this.cc!.push(item);
            }
        }
    }

    static fromJS(data: any): SendAssessmentReportCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendAssessmentReportCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["scheduleSendTime"] = this.scheduleSendTime ? this.scheduleSendTime.toISOString() : <any>undefined;
        data["reportAutoSendSetting"] = this.reportAutoSendSetting;
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item);
        }
        if (Array.isArray(this.cc)) {
            data["cc"] = [];
            for (let item of this.cc)
                data["cc"].push(item);
        }
        return data;
    }
}

export interface ISendAssessmentReportCommand {
    id?: number;
    scheduleSendTime?: Date | undefined;
    reportAutoSendSetting?: ReportAutoSendSetting;
    to?: string[];
    cc?: string[];
}

export class SendAssessmentReportBulkCommand implements ISendAssessmentReportBulkCommand {
    ids?: number[];
    reportAutoSendSetting?: ReportAutoSendSetting;
    scheduleSendTime?: Date | undefined;
    to?: string[];
    cc?: string[];

    constructor(data?: ISendAssessmentReportBulkCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.reportAutoSendSetting = _data["reportAutoSendSetting"];
            this.scheduleSendTime = _data["scheduleSendTime"] ? new Date(_data["scheduleSendTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["to"])) {
                this.to = [] as any;
                for (let item of _data["to"])
                    this.to!.push(item);
            }
            if (Array.isArray(_data["cc"])) {
                this.cc = [] as any;
                for (let item of _data["cc"])
                    this.cc!.push(item);
            }
        }
    }

    static fromJS(data: any): SendAssessmentReportBulkCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendAssessmentReportBulkCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["reportAutoSendSetting"] = this.reportAutoSendSetting;
        data["scheduleSendTime"] = this.scheduleSendTime ? this.scheduleSendTime.toISOString() : <any>undefined;
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item);
        }
        if (Array.isArray(this.cc)) {
            data["cc"] = [];
            for (let item of this.cc)
                data["cc"].push(item);
        }
        return data;
    }
}

export interface ISendAssessmentReportBulkCommand {
    ids?: number[];
    reportAutoSendSetting?: ReportAutoSendSetting;
    scheduleSendTime?: Date | undefined;
    to?: string[];
    cc?: string[];
}

export class CreateAssessmentReportCommand implements ICreateAssessmentReportCommand {
    assessmentId?: number;
    scoringKeySetId?: number;
    normTableId?: number;
    reportTemplateId?: number;

    constructor(data?: ICreateAssessmentReportCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assessmentId = _data["assessmentId"];
            this.scoringKeySetId = _data["scoringKeySetId"];
            this.normTableId = _data["normTableId"];
            this.reportTemplateId = _data["reportTemplateId"];
        }
    }

    static fromJS(data: any): CreateAssessmentReportCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAssessmentReportCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assessmentId"] = this.assessmentId;
        data["scoringKeySetId"] = this.scoringKeySetId;
        data["normTableId"] = this.normTableId;
        data["reportTemplateId"] = this.reportTemplateId;
        return data;
    }
}

export interface ICreateAssessmentReportCommand {
    assessmentId?: number;
    scoringKeySetId?: number;
    normTableId?: number;
    reportTemplateId?: number;
}

export class ScoreDto implements IScoreDto {
    extremeResponseCount?: number;
    socialdesirableQuestionCount?: number;
    facetDimensionScoringNorms?: FacetDimensionScoringNormDto[] | undefined;
    consistencyChecks?: ConsistencyCheckDto[] | undefined;
    tokens?: { [key: string]: string; };
    decimalTokens?: { [key: string]: number; };

    constructor(data?: IScoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.extremeResponseCount = _data["extremeResponseCount"];
            this.socialdesirableQuestionCount = _data["socialdesirableQuestionCount"];
            if (Array.isArray(_data["facetDimensionScoringNorms"])) {
                this.facetDimensionScoringNorms = [] as any;
                for (let item of _data["facetDimensionScoringNorms"])
                    this.facetDimensionScoringNorms!.push(FacetDimensionScoringNormDto.fromJS(item));
            }
            if (Array.isArray(_data["consistencyChecks"])) {
                this.consistencyChecks = [] as any;
                for (let item of _data["consistencyChecks"])
                    this.consistencyChecks!.push(ConsistencyCheckDto.fromJS(item));
            }
            if (_data["tokens"]) {
                this.tokens = {} as any;
                for (let key in _data["tokens"]) {
                    if (_data["tokens"].hasOwnProperty(key))
                        (<any>this.tokens)![key] = _data["tokens"][key];
                }
            }
            if (_data["decimalTokens"]) {
                this.decimalTokens = {} as any;
                for (let key in _data["decimalTokens"]) {
                    if (_data["decimalTokens"].hasOwnProperty(key))
                        (<any>this.decimalTokens)![key] = _data["decimalTokens"][key];
                }
            }
        }
    }

    static fromJS(data: any): ScoreDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScoreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["extremeResponseCount"] = this.extremeResponseCount;
        data["socialdesirableQuestionCount"] = this.socialdesirableQuestionCount;
        if (Array.isArray(this.facetDimensionScoringNorms)) {
            data["facetDimensionScoringNorms"] = [];
            for (let item of this.facetDimensionScoringNorms)
                data["facetDimensionScoringNorms"].push(item.toJSON());
        }
        if (Array.isArray(this.consistencyChecks)) {
            data["consistencyChecks"] = [];
            for (let item of this.consistencyChecks)
                data["consistencyChecks"].push(item.toJSON());
        }
        if (this.tokens) {
            data["tokens"] = {};
            for (let key in this.tokens) {
                if (this.tokens.hasOwnProperty(key))
                    (<any>data["tokens"])[key] = (<any>this.tokens)[key];
            }
        }
        if (this.decimalTokens) {
            data["decimalTokens"] = {};
            for (let key in this.decimalTokens) {
                if (this.decimalTokens.hasOwnProperty(key))
                    (<any>data["decimalTokens"])[key] = (<any>this.decimalTokens)[key];
            }
        }
        return data;
    }
}

export interface IScoreDto {
    extremeResponseCount?: number;
    socialdesirableQuestionCount?: number;
    facetDimensionScoringNorms?: FacetDimensionScoringNormDto[] | undefined;
    consistencyChecks?: ConsistencyCheckDto[] | undefined;
    tokens?: { [key: string]: string; };
    decimalTokens?: { [key: string]: number; };
}

export class FacetDimensionScoringNormDto implements IFacetDimensionScoringNormDto {
    norm?: NormDto;
    score?: number;
    scoringLevel?: ScoringLevel;
    assessmentQuestionSlotScores?: AssessmentQuestionSlotScoreDto[];

    constructor(data?: IFacetDimensionScoringNormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.norm = _data["norm"] ? NormDto.fromJS(_data["norm"]) : <any>undefined;
            this.score = _data["score"];
            this.scoringLevel = _data["scoringLevel"];
            if (Array.isArray(_data["assessmentQuestionSlotScores"])) {
                this.assessmentQuestionSlotScores = [] as any;
                for (let item of _data["assessmentQuestionSlotScores"])
                    this.assessmentQuestionSlotScores!.push(AssessmentQuestionSlotScoreDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FacetDimensionScoringNormDto {
        data = typeof data === 'object' ? data : {};
        let result = new FacetDimensionScoringNormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["norm"] = this.norm ? this.norm.toJSON() : <any>undefined;
        data["score"] = this.score;
        data["scoringLevel"] = this.scoringLevel;
        if (Array.isArray(this.assessmentQuestionSlotScores)) {
            data["assessmentQuestionSlotScores"] = [];
            for (let item of this.assessmentQuestionSlotScores)
                data["assessmentQuestionSlotScores"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFacetDimensionScoringNormDto {
    norm?: NormDto;
    score?: number;
    scoringLevel?: ScoringLevel;
    assessmentQuestionSlotScores?: AssessmentQuestionSlotScoreDto[];
}

export class NormDto implements INormDto {
    facetDimension?: FacetDimensionDto;
    lowerBound?: number;
    upperBound?: number;
    percentile?: number;
    sten?: number;
    created?: Date;

    constructor(data?: INormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facetDimension = _data["facetDimension"] ? FacetDimensionDto.fromJS(_data["facetDimension"]) : <any>undefined;
            this.lowerBound = _data["lowerBound"];
            this.upperBound = _data["upperBound"];
            this.percentile = _data["percentile"];
            this.sten = _data["sten"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NormDto {
        data = typeof data === 'object' ? data : {};
        let result = new NormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facetDimension"] = this.facetDimension ? this.facetDimension.toJSON() : <any>undefined;
        data["lowerBound"] = this.lowerBound;
        data["upperBound"] = this.upperBound;
        data["percentile"] = this.percentile;
        data["sten"] = this.sten;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }
}

export interface INormDto {
    facetDimension?: FacetDimensionDto;
    lowerBound?: number;
    upperBound?: number;
    percentile?: number;
    sten?: number;
    created?: Date;
}

export class FacetDimensionDto implements IFacetDimensionDto {
    id?: number;
    itemNumber?: number;
    name?: string | undefined;
    questionCategory?: QuestionCategoryDto | undefined;
    group?: string | undefined;
    isHiddenInRanking?: boolean;

    constructor(data?: IFacetDimensionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.itemNumber = _data["itemNumber"];
            this.name = _data["name"];
            this.questionCategory = _data["questionCategory"] ? QuestionCategoryDto.fromJS(_data["questionCategory"]) : <any>undefined;
            this.group = _data["group"];
            this.isHiddenInRanking = _data["isHiddenInRanking"];
        }
    }

    static fromJS(data: any): FacetDimensionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FacetDimensionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["itemNumber"] = this.itemNumber;
        data["name"] = this.name;
        data["questionCategory"] = this.questionCategory ? this.questionCategory.toJSON() : <any>undefined;
        data["group"] = this.group;
        data["isHiddenInRanking"] = this.isHiddenInRanking;
        return data;
    }
}

export interface IFacetDimensionDto {
    id?: number;
    itemNumber?: number;
    name?: string | undefined;
    questionCategory?: QuestionCategoryDto | undefined;
    group?: string | undefined;
    isHiddenInRanking?: boolean;
}

export class QuestionCategoryDto implements IQuestionCategoryDto {
    id?: number;
    alias?: string | undefined;
    created?: Date;

    constructor(data?: IQuestionCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.alias = _data["alias"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): QuestionCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["alias"] = this.alias;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }
}

export interface IQuestionCategoryDto {
    id?: number;
    alias?: string | undefined;
    created?: Date;
}

export enum ScoringLevel {
    Low = 0,
    Medium = 1,
    High = 2,
}

export class AssessmentQuestionSlotScoreDto implements IAssessmentQuestionSlotScoreDto {
    scoringKey?: ScoringKeyDto | undefined;
    weightedScore?: number;
    score?: number;

    constructor(data?: IAssessmentQuestionSlotScoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scoringKey = _data["scoringKey"] ? ScoringKeyDto.fromJS(_data["scoringKey"]) : <any>undefined;
            this.weightedScore = _data["weightedScore"];
            this.score = _data["score"];
        }
    }

    static fromJS(data: any): AssessmentQuestionSlotScoreDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentQuestionSlotScoreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scoringKey"] = this.scoringKey ? this.scoringKey.toJSON() : <any>undefined;
        data["weightedScore"] = this.weightedScore;
        data["score"] = this.score;
        return data;
    }
}

export interface IAssessmentQuestionSlotScoreDto {
    scoringKey?: ScoringKeyDto | undefined;
    weightedScore?: number;
    score?: number;
}

export class ScoringKeyDto implements IScoringKeyDto {
    id?: number;
    questionItemNumber?: number;
    questionCategoryAlias?: string | undefined;
    weight?: number;
    questionCategory?: QuestionCategoryDto;
    facetDimension?: FacetDimensionDto;

    constructor(data?: IScoringKeyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.questionItemNumber = _data["questionItemNumber"];
            this.questionCategoryAlias = _data["questionCategoryAlias"];
            this.weight = _data["weight"];
            this.questionCategory = _data["questionCategory"] ? QuestionCategoryDto.fromJS(_data["questionCategory"]) : <any>undefined;
            this.facetDimension = _data["facetDimension"] ? FacetDimensionDto.fromJS(_data["facetDimension"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ScoringKeyDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScoringKeyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["questionItemNumber"] = this.questionItemNumber;
        data["questionCategoryAlias"] = this.questionCategoryAlias;
        data["weight"] = this.weight;
        data["questionCategory"] = this.questionCategory ? this.questionCategory.toJSON() : <any>undefined;
        data["facetDimension"] = this.facetDimension ? this.facetDimension.toJSON() : <any>undefined;
        return data;
    }
}

export interface IScoringKeyDto {
    id?: number;
    questionItemNumber?: number;
    questionCategoryAlias?: string | undefined;
    weight?: number;
    questionCategory?: QuestionCategoryDto;
    facetDimension?: FacetDimensionDto;
}

export class ConsistencyCheckDto implements IConsistencyCheckDto {
    question?: QuestionBriefDto;
    questionPointValue?: number;
    relatedToQuestion?: QuestionBriefDto;
    relatedToQuestionPointValue?: number;
    questionRelation?: QuestionRelation;
    consistencyCheckThreshold?: number;
    contraryCheckUpperThreshold?: number;
    contraryCheckLowerThreshold?: number;
    isConsistent?: boolean;

    constructor(data?: IConsistencyCheckDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.question = _data["question"] ? QuestionBriefDto.fromJS(_data["question"]) : <any>undefined;
            this.questionPointValue = _data["questionPointValue"];
            this.relatedToQuestion = _data["relatedToQuestion"] ? QuestionBriefDto.fromJS(_data["relatedToQuestion"]) : <any>undefined;
            this.relatedToQuestionPointValue = _data["relatedToQuestionPointValue"];
            this.questionRelation = _data["questionRelation"];
            this.consistencyCheckThreshold = _data["consistencyCheckThreshold"];
            this.contraryCheckUpperThreshold = _data["contraryCheckUpperThreshold"];
            this.contraryCheckLowerThreshold = _data["contraryCheckLowerThreshold"];
            this.isConsistent = _data["isConsistent"];
        }
    }

    static fromJS(data: any): ConsistencyCheckDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConsistencyCheckDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["question"] = this.question ? this.question.toJSON() : <any>undefined;
        data["questionPointValue"] = this.questionPointValue;
        data["relatedToQuestion"] = this.relatedToQuestion ? this.relatedToQuestion.toJSON() : <any>undefined;
        data["relatedToQuestionPointValue"] = this.relatedToQuestionPointValue;
        data["questionRelation"] = this.questionRelation;
        data["consistencyCheckThreshold"] = this.consistencyCheckThreshold;
        data["contraryCheckUpperThreshold"] = this.contraryCheckUpperThreshold;
        data["contraryCheckLowerThreshold"] = this.contraryCheckLowerThreshold;
        data["isConsistent"] = this.isConsistent;
        return data;
    }
}

export interface IConsistencyCheckDto {
    question?: QuestionBriefDto;
    questionPointValue?: number;
    relatedToQuestion?: QuestionBriefDto;
    relatedToQuestionPointValue?: number;
    questionRelation?: QuestionRelation;
    consistencyCheckThreshold?: number;
    contraryCheckUpperThreshold?: number;
    contraryCheckLowerThreshold?: number;
    isConsistent?: boolean;
}

export class QuestionBriefDto implements IQuestionBriefDto {
    categoryAlias?: string | undefined;
    id?: number;
    itemNumber?: number;

    constructor(data?: IQuestionBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryAlias = _data["categoryAlias"];
            this.id = _data["id"];
            this.itemNumber = _data["itemNumber"];
        }
    }

    static fromJS(data: any): QuestionBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryAlias"] = this.categoryAlias;
        data["id"] = this.id;
        data["itemNumber"] = this.itemNumber;
        return data;
    }
}

export interface IQuestionBriefDto {
    categoryAlias?: string | undefined;
    id?: number;
    itemNumber?: number;
}

export enum QuestionRelation {
    Consistent = 0,
    Contrary = 1,
}

export class SendAssessmentReminderBulkCommand implements ISendAssessmentReminderBulkCommand {
    ids?: number[];
    reportAutoSendSetting?: ReportAutoSendSetting;
    to?: string[];
    cc?: string[];

    constructor(data?: ISendAssessmentReminderBulkCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.reportAutoSendSetting = _data["reportAutoSendSetting"];
            if (Array.isArray(_data["to"])) {
                this.to = [] as any;
                for (let item of _data["to"])
                    this.to!.push(item);
            }
            if (Array.isArray(_data["cc"])) {
                this.cc = [] as any;
                for (let item of _data["cc"])
                    this.cc!.push(item);
            }
        }
    }

    static fromJS(data: any): SendAssessmentReminderBulkCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendAssessmentReminderBulkCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["reportAutoSendSetting"] = this.reportAutoSendSetting;
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item);
        }
        if (Array.isArray(this.cc)) {
            data["cc"] = [];
            for (let item of this.cc)
                data["cc"].push(item);
        }
        return data;
    }
}

export interface ISendAssessmentReminderBulkCommand {
    ids?: number[];
    reportAutoSendSetting?: ReportAutoSendSetting;
    to?: string[];
    cc?: string[];
}

export class AssessmentTemplateDto implements IAssessmentTemplateDto {
    id?: number;
    alias?: string | undefined;
    name?: { [key: string]: string; };
    introduction?: { [key: string]: string; };
    completion?: { [key: string]: string; };
    forms?: AssessmentTemplateFormDto[];

    constructor(data?: IAssessmentTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.alias = _data["alias"];
            if (_data["name"]) {
                this.name = {} as any;
                for (let key in _data["name"]) {
                    if (_data["name"].hasOwnProperty(key))
                        (<any>this.name)![key] = _data["name"][key];
                }
            }
            if (_data["introduction"]) {
                this.introduction = {} as any;
                for (let key in _data["introduction"]) {
                    if (_data["introduction"].hasOwnProperty(key))
                        (<any>this.introduction)![key] = _data["introduction"][key];
                }
            }
            if (_data["completion"]) {
                this.completion = {} as any;
                for (let key in _data["completion"]) {
                    if (_data["completion"].hasOwnProperty(key))
                        (<any>this.completion)![key] = _data["completion"][key];
                }
            }
            if (Array.isArray(_data["forms"])) {
                this.forms = [] as any;
                for (let item of _data["forms"])
                    this.forms!.push(AssessmentTemplateFormDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssessmentTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["alias"] = this.alias;
        if (this.name) {
            data["name"] = {};
            for (let key in this.name) {
                if (this.name.hasOwnProperty(key))
                    (<any>data["name"])[key] = (<any>this.name)[key];
            }
        }
        if (this.introduction) {
            data["introduction"] = {};
            for (let key in this.introduction) {
                if (this.introduction.hasOwnProperty(key))
                    (<any>data["introduction"])[key] = (<any>this.introduction)[key];
            }
        }
        if (this.completion) {
            data["completion"] = {};
            for (let key in this.completion) {
                if (this.completion.hasOwnProperty(key))
                    (<any>data["completion"])[key] = (<any>this.completion)[key];
            }
        }
        if (Array.isArray(this.forms)) {
            data["forms"] = [];
            for (let item of this.forms)
                data["forms"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAssessmentTemplateDto {
    id?: number;
    alias?: string | undefined;
    name?: { [key: string]: string; };
    introduction?: { [key: string]: string; };
    completion?: { [key: string]: string; };
    forms?: AssessmentTemplateFormDto[];
}

export class AssessmentTemplateFormDto implements IAssessmentTemplateFormDto {
    form?: FormBriefDto;
    order?: number;

    constructor(data?: IAssessmentTemplateFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.form = _data["form"] ? FormBriefDto.fromJS(_data["form"]) : <any>undefined;
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): AssessmentTemplateFormDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentTemplateFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["form"] = this.form ? this.form.toJSON() : <any>undefined;
        data["order"] = this.order;
        return data;
    }
}

export interface IAssessmentTemplateFormDto {
    form?: FormBriefDto;
    order?: number;
}

export class FormBriefDto implements IFormBriefDto {
    id?: number;
    questionCategoryAlias?: string | undefined;
    name?: string | undefined;
    isShuffle?: boolean;
    type?: FormType;
    ratingScaleTitle?: string | undefined;
    questionPerPage?: number | undefined;
    created?: Date;

    constructor(data?: IFormBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.questionCategoryAlias = _data["questionCategoryAlias"];
            this.name = _data["name"];
            this.isShuffle = _data["isShuffle"];
            this.type = _data["type"];
            this.ratingScaleTitle = _data["ratingScaleTitle"];
            this.questionPerPage = _data["questionPerPage"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FormBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["questionCategoryAlias"] = this.questionCategoryAlias;
        data["name"] = this.name;
        data["isShuffle"] = this.isShuffle;
        data["type"] = this.type;
        data["ratingScaleTitle"] = this.ratingScaleTitle;
        data["questionPerPage"] = this.questionPerPage;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }
}

export interface IFormBriefDto {
    id?: number;
    questionCategoryAlias?: string | undefined;
    name?: string | undefined;
    isShuffle?: boolean;
    type?: FormType;
    ratingScaleTitle?: string | undefined;
    questionPerPage?: number | undefined;
    created?: Date;
}

export enum FormType {
    Matrix = 0,
    Simple = 1,
}

export class PaginatedListOfAssessmentTemplateBriefDto implements IPaginatedListOfAssessmentTemplateBriefDto {
    items?: AssessmentTemplateBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfAssessmentTemplateBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AssessmentTemplateBriefDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfAssessmentTemplateBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfAssessmentTemplateBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfAssessmentTemplateBriefDto {
    items?: AssessmentTemplateBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class AssessmentTemplateBriefDto extends AuditableEntity implements IAssessmentTemplateBriefDto {
    id?: number;
    alias?: string | undefined;

    constructor(data?: IAssessmentTemplateBriefDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.alias = _data["alias"];
        }
    }

    static fromJS(data: any): AssessmentTemplateBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentTemplateBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["alias"] = this.alias;
        super.toJSON(data);
        return data;
    }
}

export interface IAssessmentTemplateBriefDto extends IAuditableEntity {
    id?: number;
    alias?: string | undefined;
}

export class PaginatedListOfAssessmentTemplateFormBriefDto implements IPaginatedListOfAssessmentTemplateFormBriefDto {
    items?: AssessmentTemplateFormBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfAssessmentTemplateFormBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AssessmentTemplateFormBriefDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfAssessmentTemplateFormBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfAssessmentTemplateFormBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfAssessmentTemplateFormBriefDto {
    items?: AssessmentTemplateFormBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class AssessmentTemplateFormBriefDto extends AuditableEntity implements IAssessmentTemplateFormBriefDto {
    assessmentTemplateAlias?: string | undefined;
    formName?: string | undefined;

    constructor(data?: IAssessmentTemplateFormBriefDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.assessmentTemplateAlias = _data["assessmentTemplateAlias"];
            this.formName = _data["formName"];
        }
    }

    static fromJS(data: any): AssessmentTemplateFormBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentTemplateFormBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assessmentTemplateAlias"] = this.assessmentTemplateAlias;
        data["formName"] = this.formName;
        super.toJSON(data);
        return data;
    }
}

export interface IAssessmentTemplateFormBriefDto extends IAuditableEntity {
    assessmentTemplateAlias?: string | undefined;
    formName?: string | undefined;
}

export class CreateAssessmentTemplateCommand implements ICreateAssessmentTemplateCommand {
    alias?: string | undefined;
    name?: { [key: string]: string; };
    introduction?: { [key: string]: string; };
    completion?: { [key: string]: string; };
    formIds?: number[];

    constructor(data?: ICreateAssessmentTemplateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alias = _data["alias"];
            if (_data["name"]) {
                this.name = {} as any;
                for (let key in _data["name"]) {
                    if (_data["name"].hasOwnProperty(key))
                        (<any>this.name)![key] = _data["name"][key];
                }
            }
            if (_data["introduction"]) {
                this.introduction = {} as any;
                for (let key in _data["introduction"]) {
                    if (_data["introduction"].hasOwnProperty(key))
                        (<any>this.introduction)![key] = _data["introduction"][key];
                }
            }
            if (_data["completion"]) {
                this.completion = {} as any;
                for (let key in _data["completion"]) {
                    if (_data["completion"].hasOwnProperty(key))
                        (<any>this.completion)![key] = _data["completion"][key];
                }
            }
            if (Array.isArray(_data["formIds"])) {
                this.formIds = [] as any;
                for (let item of _data["formIds"])
                    this.formIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateAssessmentTemplateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAssessmentTemplateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alias"] = this.alias;
        if (this.name) {
            data["name"] = {};
            for (let key in this.name) {
                if (this.name.hasOwnProperty(key))
                    (<any>data["name"])[key] = (<any>this.name)[key];
            }
        }
        if (this.introduction) {
            data["introduction"] = {};
            for (let key in this.introduction) {
                if (this.introduction.hasOwnProperty(key))
                    (<any>data["introduction"])[key] = (<any>this.introduction)[key];
            }
        }
        if (this.completion) {
            data["completion"] = {};
            for (let key in this.completion) {
                if (this.completion.hasOwnProperty(key))
                    (<any>data["completion"])[key] = (<any>this.completion)[key];
            }
        }
        if (Array.isArray(this.formIds)) {
            data["formIds"] = [];
            for (let item of this.formIds)
                data["formIds"].push(item);
        }
        return data;
    }
}

export interface ICreateAssessmentTemplateCommand {
    alias?: string | undefined;
    name?: { [key: string]: string; };
    introduction?: { [key: string]: string; };
    completion?: { [key: string]: string; };
    formIds?: number[];
}

export class UpdateAssessmentTemplateCommand implements IUpdateAssessmentTemplateCommand {
    id?: number;
    alias?: string | undefined;
    name?: { [key: string]: string; };
    introduction?: { [key: string]: string; };
    completion?: { [key: string]: string; };
    formIds?: number[];

    constructor(data?: IUpdateAssessmentTemplateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.alias = _data["alias"];
            if (_data["name"]) {
                this.name = {} as any;
                for (let key in _data["name"]) {
                    if (_data["name"].hasOwnProperty(key))
                        (<any>this.name)![key] = _data["name"][key];
                }
            }
            if (_data["introduction"]) {
                this.introduction = {} as any;
                for (let key in _data["introduction"]) {
                    if (_data["introduction"].hasOwnProperty(key))
                        (<any>this.introduction)![key] = _data["introduction"][key];
                }
            }
            if (_data["completion"]) {
                this.completion = {} as any;
                for (let key in _data["completion"]) {
                    if (_data["completion"].hasOwnProperty(key))
                        (<any>this.completion)![key] = _data["completion"][key];
                }
            }
            if (Array.isArray(_data["formIds"])) {
                this.formIds = [] as any;
                for (let item of _data["formIds"])
                    this.formIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateAssessmentTemplateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAssessmentTemplateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["alias"] = this.alias;
        if (this.name) {
            data["name"] = {};
            for (let key in this.name) {
                if (this.name.hasOwnProperty(key))
                    (<any>data["name"])[key] = (<any>this.name)[key];
            }
        }
        if (this.introduction) {
            data["introduction"] = {};
            for (let key in this.introduction) {
                if (this.introduction.hasOwnProperty(key))
                    (<any>data["introduction"])[key] = (<any>this.introduction)[key];
            }
        }
        if (this.completion) {
            data["completion"] = {};
            for (let key in this.completion) {
                if (this.completion.hasOwnProperty(key))
                    (<any>data["completion"])[key] = (<any>this.completion)[key];
            }
        }
        if (Array.isArray(this.formIds)) {
            data["formIds"] = [];
            for (let item of this.formIds)
                data["formIds"].push(item);
        }
        return data;
    }
}

export interface IUpdateAssessmentTemplateCommand {
    id?: number;
    alias?: string | undefined;
    name?: { [key: string]: string; };
    introduction?: { [key: string]: string; };
    completion?: { [key: string]: string; };
    formIds?: number[];
}

export class AssessmentTemplateBriefListDto implements IAssessmentTemplateBriefListDto {
    id?: number;
    alias?: string | undefined;

    constructor(data?: IAssessmentTemplateBriefListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.alias = _data["alias"];
        }
    }

    static fromJS(data: any): AssessmentTemplateBriefListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentTemplateBriefListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["alias"] = this.alias;
        return data;
    }
}

export interface IAssessmentTemplateBriefListDto {
    id?: number;
    alias?: string | undefined;
}

export class PaginatedListOfAssessmentDto implements IPaginatedListOfAssessmentDto {
    items?: AssessmentDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfAssessmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AssessmentDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfAssessmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfAssessmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfAssessmentDto {
    items?: AssessmentDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class AssessmentDto implements IAssessmentDto {
    clientUserId?: string | undefined;
    clientGroupAssessmentTemplateId?: number;
    name?: string | undefined;
    clientUserUserName?: string | undefined;
    clientUserEmail?: string | undefined;
    clientUserCreated?: Date | undefined;
    progress?: number;
    id?: number;
    completedOn?: Date | undefined;
    created?: Date;
    assessmentTemplateId?: number | undefined;
    assessmentTemplateAlias?: string | undefined;
    loginTimeCount?: number | undefined;
    isSuccessGenerateBefore?: boolean;

    constructor(data?: IAssessmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientUserId = _data["clientUserId"];
            this.clientGroupAssessmentTemplateId = _data["clientGroupAssessmentTemplateId"];
            this.name = _data["name"];
            this.clientUserUserName = _data["clientUserUserName"];
            this.clientUserEmail = _data["clientUserEmail"];
            this.clientUserCreated = _data["clientUserCreated"] ? new Date(_data["clientUserCreated"].toString()) : <any>undefined;
            this.progress = _data["progress"];
            this.id = _data["id"];
            this.completedOn = _data["completedOn"] ? new Date(_data["completedOn"].toString()) : <any>undefined;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.assessmentTemplateId = _data["assessmentTemplateId"];
            this.assessmentTemplateAlias = _data["assessmentTemplateAlias"];
            this.loginTimeCount = _data["loginTimeCount"];
            this.isSuccessGenerateBefore = _data["isSuccessGenerateBefore"];
        }
    }

    static fromJS(data: any): AssessmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientUserId"] = this.clientUserId;
        data["clientGroupAssessmentTemplateId"] = this.clientGroupAssessmentTemplateId;
        data["name"] = this.name;
        data["clientUserUserName"] = this.clientUserUserName;
        data["clientUserEmail"] = this.clientUserEmail;
        data["clientUserCreated"] = this.clientUserCreated ? this.clientUserCreated.toISOString() : <any>undefined;
        data["progress"] = this.progress;
        data["id"] = this.id;
        data["completedOn"] = this.completedOn ? this.completedOn.toISOString() : <any>undefined;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["assessmentTemplateId"] = this.assessmentTemplateId;
        data["assessmentTemplateAlias"] = this.assessmentTemplateAlias;
        data["loginTimeCount"] = this.loginTimeCount;
        data["isSuccessGenerateBefore"] = this.isSuccessGenerateBefore;
        return data;
    }
}

export interface IAssessmentDto {
    clientUserId?: string | undefined;
    clientGroupAssessmentTemplateId?: number;
    name?: string | undefined;
    clientUserUserName?: string | undefined;
    clientUserEmail?: string | undefined;
    clientUserCreated?: Date | undefined;
    progress?: number;
    id?: number;
    completedOn?: Date | undefined;
    created?: Date;
    assessmentTemplateId?: number | undefined;
    assessmentTemplateAlias?: string | undefined;
    loginTimeCount?: number | undefined;
    isSuccessGenerateBefore?: boolean;
}

export class AssessmentSummaryDto implements IAssessmentSummaryDto {
    assessmentId?: number;
    assessment?: string | undefined;
    parentGroupId?: number | undefined;
    parentGroup?: string | undefined;
    groupId?: number;
    group?: string | undefined;
    totalAssessmentCount?: number;
    completedAssessmentCount?: number;
    activateAccount?: number;
    deactivateAccount?: number;
    totalAccount?: number;

    constructor(data?: IAssessmentSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assessmentId = _data["assessmentId"];
            this.assessment = _data["assessment"];
            this.parentGroupId = _data["parentGroupId"];
            this.parentGroup = _data["parentGroup"];
            this.groupId = _data["groupId"];
            this.group = _data["group"];
            this.totalAssessmentCount = _data["totalAssessmentCount"];
            this.completedAssessmentCount = _data["completedAssessmentCount"];
            this.activateAccount = _data["activateAccount"];
            this.deactivateAccount = _data["deactivateAccount"];
            this.totalAccount = _data["totalAccount"];
        }
    }

    static fromJS(data: any): AssessmentSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assessmentId"] = this.assessmentId;
        data["assessment"] = this.assessment;
        data["parentGroupId"] = this.parentGroupId;
        data["parentGroup"] = this.parentGroup;
        data["groupId"] = this.groupId;
        data["group"] = this.group;
        data["totalAssessmentCount"] = this.totalAssessmentCount;
        data["completedAssessmentCount"] = this.completedAssessmentCount;
        data["activateAccount"] = this.activateAccount;
        data["deactivateAccount"] = this.deactivateAccount;
        data["totalAccount"] = this.totalAccount;
        return data;
    }
}

export interface IAssessmentSummaryDto {
    assessmentId?: number;
    assessment?: string | undefined;
    parentGroupId?: number | undefined;
    parentGroup?: string | undefined;
    groupId?: number;
    group?: string | undefined;
    totalAssessmentCount?: number;
    completedAssessmentCount?: number;
    activateAccount?: number;
    deactivateAccount?: number;
    totalAccount?: number;
}

export class PaginatedListOfAssessmentSummaryDto implements IPaginatedListOfAssessmentSummaryDto {
    items?: AssessmentSummaryDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfAssessmentSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AssessmentSummaryDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfAssessmentSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfAssessmentSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfAssessmentSummaryDto {
    items?: AssessmentSummaryDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class PaginatedListOfCourseDto implements IPaginatedListOfCourseDto {
    items?: CourseDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfCourseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CourseDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfCourseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfCourseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfCourseDto {
    items?: CourseDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class CourseDto implements ICourseDto {
    id?: number;
    clientUserId?: string | undefined;
    name?: string | undefined;
    clientUserUserName?: string | undefined;
    clientUserEmail?: string | undefined;
    clientUserCreated?: Date | undefined;
    progress?: number;
    startTime?: Date | undefined;
    completedOn?: Date | undefined;
    courseId?: number;
    courseName?: string | undefined;
    loginTimeCount?: number | undefined;

    constructor(data?: ICourseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientUserId = _data["clientUserId"];
            this.name = _data["name"];
            this.clientUserUserName = _data["clientUserUserName"];
            this.clientUserEmail = _data["clientUserEmail"];
            this.clientUserCreated = _data["clientUserCreated"] ? new Date(_data["clientUserCreated"].toString()) : <any>undefined;
            this.progress = _data["progress"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.completedOn = _data["completedOn"] ? new Date(_data["completedOn"].toString()) : <any>undefined;
            this.courseId = _data["courseId"];
            this.courseName = _data["courseName"];
            this.loginTimeCount = _data["loginTimeCount"];
        }
    }

    static fromJS(data: any): CourseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientUserId"] = this.clientUserId;
        data["name"] = this.name;
        data["clientUserUserName"] = this.clientUserUserName;
        data["clientUserEmail"] = this.clientUserEmail;
        data["clientUserCreated"] = this.clientUserCreated ? this.clientUserCreated.toISOString() : <any>undefined;
        data["progress"] = this.progress;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["completedOn"] = this.completedOn ? this.completedOn.toISOString() : <any>undefined;
        data["courseId"] = this.courseId;
        data["courseName"] = this.courseName;
        data["loginTimeCount"] = this.loginTimeCount;
        return data;
    }
}

export interface ICourseDto {
    id?: number;
    clientUserId?: string | undefined;
    name?: string | undefined;
    clientUserUserName?: string | undefined;
    clientUserEmail?: string | undefined;
    clientUserCreated?: Date | undefined;
    progress?: number;
    startTime?: Date | undefined;
    completedOn?: Date | undefined;
    courseId?: number;
    courseName?: string | undefined;
    loginTimeCount?: number | undefined;
}

export class PaginatedListOfCourseSummaryDto implements IPaginatedListOfCourseSummaryDto {
    items?: CourseSummaryDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfCourseSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CourseSummaryDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfCourseSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfCourseSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfCourseSummaryDto {
    items?: CourseSummaryDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class CourseSummaryDto implements ICourseSummaryDto {
    courseId?: number;
    course?: string | undefined;
    parentGroupId?: number | undefined;
    parentGroup?: string | undefined;
    groupId?: number;
    group?: string | undefined;
    totalCourseCount?: number;
    completedCourseCount?: number;
    activateAccount?: number;
    deactivateAccount?: number;
    totalAccount?: number;

    constructor(data?: ICourseSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseId = _data["courseId"];
            this.course = _data["course"];
            this.parentGroupId = _data["parentGroupId"];
            this.parentGroup = _data["parentGroup"];
            this.groupId = _data["groupId"];
            this.group = _data["group"];
            this.totalCourseCount = _data["totalCourseCount"];
            this.completedCourseCount = _data["completedCourseCount"];
            this.activateAccount = _data["activateAccount"];
            this.deactivateAccount = _data["deactivateAccount"];
            this.totalAccount = _data["totalAccount"];
        }
    }

    static fromJS(data: any): CourseSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseId"] = this.courseId;
        data["course"] = this.course;
        data["parentGroupId"] = this.parentGroupId;
        data["parentGroup"] = this.parentGroup;
        data["groupId"] = this.groupId;
        data["group"] = this.group;
        data["totalCourseCount"] = this.totalCourseCount;
        data["completedCourseCount"] = this.completedCourseCount;
        data["activateAccount"] = this.activateAccount;
        data["deactivateAccount"] = this.deactivateAccount;
        data["totalAccount"] = this.totalAccount;
        return data;
    }
}

export interface ICourseSummaryDto {
    courseId?: number;
    course?: string | undefined;
    parentGroupId?: number | undefined;
    parentGroup?: string | undefined;
    groupId?: number;
    group?: string | undefined;
    totalCourseCount?: number;
    completedCourseCount?: number;
    activateAccount?: number;
    deactivateAccount?: number;
    totalAccount?: number;
}

export class PaginatedListOfReportDto implements IPaginatedListOfReportDto {
    items?: ReportDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ReportDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfReportDto {
    items?: ReportDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class ReportDto implements IReportDto {
    reportId?: number;
    isGenerated?: boolean;
    reportTemplateName?: string | undefined;
    normName?: string | undefined;
    reportLanguage?: string | undefined;
    generateTime?: Date | undefined;
    clientUserId?: string | undefined;
    loginId?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    userAddedTime?: Date | undefined;

    constructor(data?: IReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.isGenerated = _data["isGenerated"];
            this.reportTemplateName = _data["reportTemplateName"];
            this.normName = _data["normName"];
            this.reportLanguage = _data["reportLanguage"];
            this.generateTime = _data["generateTime"] ? new Date(_data["generateTime"].toString()) : <any>undefined;
            this.clientUserId = _data["clientUserId"];
            this.loginId = _data["loginId"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.userAddedTime = _data["userAddedTime"] ? new Date(_data["userAddedTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["isGenerated"] = this.isGenerated;
        data["reportTemplateName"] = this.reportTemplateName;
        data["normName"] = this.normName;
        data["reportLanguage"] = this.reportLanguage;
        data["generateTime"] = this.generateTime ? this.generateTime.toISOString() : <any>undefined;
        data["clientUserId"] = this.clientUserId;
        data["loginId"] = this.loginId;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["userAddedTime"] = this.userAddedTime ? this.userAddedTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IReportDto {
    reportId?: number;
    isGenerated?: boolean;
    reportTemplateName?: string | undefined;
    normName?: string | undefined;
    reportLanguage?: string | undefined;
    generateTime?: Date | undefined;
    clientUserId?: string | undefined;
    loginId?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    userAddedTime?: Date | undefined;
}

export class ReportSummaryDto implements IReportSummaryDto {
    reportId?: number;
    report?: string | undefined;
    language?: string | undefined;
    parentGroupId?: number | undefined;
    parentGroup?: string | undefined;
    groupId?: number;
    group?: string | undefined;
    completedReportCount?: number;
    activateAccount?: number;
    deactivateAccount?: number;
    totalAccount?: number;

    constructor(data?: IReportSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.report = _data["report"];
            this.language = _data["language"];
            this.parentGroupId = _data["parentGroupId"];
            this.parentGroup = _data["parentGroup"];
            this.groupId = _data["groupId"];
            this.group = _data["group"];
            this.completedReportCount = _data["completedReportCount"];
            this.activateAccount = _data["activateAccount"];
            this.deactivateAccount = _data["deactivateAccount"];
            this.totalAccount = _data["totalAccount"];
        }
    }

    static fromJS(data: any): ReportSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["report"] = this.report;
        data["language"] = this.language;
        data["parentGroupId"] = this.parentGroupId;
        data["parentGroup"] = this.parentGroup;
        data["groupId"] = this.groupId;
        data["group"] = this.group;
        data["completedReportCount"] = this.completedReportCount;
        data["activateAccount"] = this.activateAccount;
        data["deactivateAccount"] = this.deactivateAccount;
        data["totalAccount"] = this.totalAccount;
        return data;
    }
}

export interface IReportSummaryDto {
    reportId?: number;
    report?: string | undefined;
    language?: string | undefined;
    parentGroupId?: number | undefined;
    parentGroup?: string | undefined;
    groupId?: number;
    group?: string | undefined;
    completedReportCount?: number;
    activateAccount?: number;
    deactivateAccount?: number;
    totalAccount?: number;
}

export class PaginatedListOfReportSummaryDto implements IPaginatedListOfReportSummaryDto {
    items?: ReportSummaryDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfReportSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ReportSummaryDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfReportSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfReportSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfReportSummaryDto {
    items?: ReportSummaryDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class PaginatedListOfGroupReportDto implements IPaginatedListOfGroupReportDto {
    items?: GroupReportDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfGroupReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GroupReportDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfGroupReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfGroupReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfGroupReportDto {
    items?: GroupReportDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class GroupReportDto implements IGroupReportDto {
    groupReportId?: number;
    groupReportTemplateName?: string | undefined;
    normName?: string | undefined;
    groupReportLanguage?: string | undefined;
    generateTime?: Date | undefined;
    clientUserId?: string | undefined;
    username?: string | undefined;
    fullname?: string | undefined;
    email?: string | undefined;
    userCount?: number | undefined;

    constructor(data?: IGroupReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupReportId = _data["groupReportId"];
            this.groupReportTemplateName = _data["groupReportTemplateName"];
            this.normName = _data["normName"];
            this.groupReportLanguage = _data["groupReportLanguage"];
            this.generateTime = _data["generateTime"] ? new Date(_data["generateTime"].toString()) : <any>undefined;
            this.clientUserId = _data["clientUserId"];
            this.username = _data["username"];
            this.fullname = _data["fullname"];
            this.email = _data["email"];
            this.userCount = _data["userCount"];
        }
    }

    static fromJS(data: any): GroupReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupReportId"] = this.groupReportId;
        data["groupReportTemplateName"] = this.groupReportTemplateName;
        data["normName"] = this.normName;
        data["groupReportLanguage"] = this.groupReportLanguage;
        data["generateTime"] = this.generateTime ? this.generateTime.toISOString() : <any>undefined;
        data["clientUserId"] = this.clientUserId;
        data["username"] = this.username;
        data["fullname"] = this.fullname;
        data["email"] = this.email;
        data["userCount"] = this.userCount;
        return data;
    }
}

export interface IGroupReportDto {
    groupReportId?: number;
    groupReportTemplateName?: string | undefined;
    normName?: string | undefined;
    groupReportLanguage?: string | undefined;
    generateTime?: Date | undefined;
    clientUserId?: string | undefined;
    username?: string | undefined;
    fullname?: string | undefined;
    email?: string | undefined;
    userCount?: number | undefined;
}

export class GroupReportSummaryDto implements IGroupReportSummaryDto {
    groupReportId?: number;
    groupReport?: string | undefined;
    language?: string | undefined;
    parentGroupId?: number | undefined;
    parentGroup?: string | undefined;
    groupId?: number;
    group?: string | undefined;
    reportCount?: number | undefined;

    constructor(data?: IGroupReportSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupReportId = _data["groupReportId"];
            this.groupReport = _data["groupReport"];
            this.language = _data["language"];
            this.parentGroupId = _data["parentGroupId"];
            this.parentGroup = _data["parentGroup"];
            this.groupId = _data["groupId"];
            this.group = _data["group"];
            this.reportCount = _data["reportCount"];
        }
    }

    static fromJS(data: any): GroupReportSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupReportSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupReportId"] = this.groupReportId;
        data["groupReport"] = this.groupReport;
        data["language"] = this.language;
        data["parentGroupId"] = this.parentGroupId;
        data["parentGroup"] = this.parentGroup;
        data["groupId"] = this.groupId;
        data["group"] = this.group;
        data["reportCount"] = this.reportCount;
        return data;
    }
}

export interface IGroupReportSummaryDto {
    groupReportId?: number;
    groupReport?: string | undefined;
    language?: string | undefined;
    parentGroupId?: number | undefined;
    parentGroup?: string | undefined;
    groupId?: number;
    group?: string | undefined;
    reportCount?: number | undefined;
}

export class PaginatedListOfGroupReportSummaryDto implements IPaginatedListOfGroupReportSummaryDto {
    items?: GroupReportSummaryDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfGroupReportSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GroupReportSummaryDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfGroupReportSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfGroupReportSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfGroupReportSummaryDto {
    items?: GroupReportSummaryDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class PaginatedListOfClientAdministratorBriefDto implements IPaginatedListOfClientAdministratorBriefDto {
    items?: ClientAdministratorBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfClientAdministratorBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ClientAdministratorBriefDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfClientAdministratorBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfClientAdministratorBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfClientAdministratorBriefDto {
    items?: ClientAdministratorBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class ClientAdministratorBriefDto extends AuditableEntity implements IClientAdministratorBriefDto {
    id?: string;
    client?: ClientBriefDto;
    clientGroup?: ClientGroupBriefDto;
    clientName?: string | undefined;
    clientGroupName?: string | undefined;
    fullName?: string | undefined;
    userName?: string;
    preferredLanguageDisplayName?: string | undefined;
    preferredLanguageId?: string | undefined;
    email?: string;
    type?: ClientAdministratorType;

    constructor(data?: IClientAdministratorBriefDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.client = _data["client"] ? ClientBriefDto.fromJS(_data["client"]) : <any>undefined;
            this.clientGroup = _data["clientGroup"] ? ClientGroupBriefDto.fromJS(_data["clientGroup"]) : <any>undefined;
            this.clientName = _data["clientName"];
            this.clientGroupName = _data["clientGroupName"];
            this.fullName = _data["fullName"];
            this.userName = _data["userName"];
            this.preferredLanguageDisplayName = _data["preferredLanguageDisplayName"];
            this.preferredLanguageId = _data["preferredLanguageId"];
            this.email = _data["email"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): ClientAdministratorBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientAdministratorBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["clientGroup"] = this.clientGroup ? this.clientGroup.toJSON() : <any>undefined;
        data["clientName"] = this.clientName;
        data["clientGroupName"] = this.clientGroupName;
        data["fullName"] = this.fullName;
        data["userName"] = this.userName;
        data["preferredLanguageDisplayName"] = this.preferredLanguageDisplayName;
        data["preferredLanguageId"] = this.preferredLanguageId;
        data["email"] = this.email;
        data["type"] = this.type;
        super.toJSON(data);
        return data;
    }
}

export interface IClientAdministratorBriefDto extends IAuditableEntity {
    id?: string;
    client?: ClientBriefDto;
    clientGroup?: ClientGroupBriefDto;
    clientName?: string | undefined;
    clientGroupName?: string | undefined;
    fullName?: string | undefined;
    userName?: string;
    preferredLanguageDisplayName?: string | undefined;
    preferredLanguageId?: string | undefined;
    email?: string;
    type?: ClientAdministratorType;
}

export class ClientGroupBriefDto implements IClientGroupBriefDto {
    id?: number;
    client?: ClientBriefDto;
    name?: string | undefined;
    preferredLanguageId?: string | undefined;

    constructor(data?: IClientGroupBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.client = _data["client"] ? ClientBriefDto.fromJS(_data["client"]) : <any>undefined;
            this.name = _data["name"];
            this.preferredLanguageId = _data["preferredLanguageId"];
        }
    }

    static fromJS(data: any): ClientGroupBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientGroupBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["preferredLanguageId"] = this.preferredLanguageId;
        return data;
    }
}

export interface IClientGroupBriefDto {
    id?: number;
    client?: ClientBriefDto;
    name?: string | undefined;
    preferredLanguageId?: string | undefined;
}

export enum ClientAdministratorType {
    ClientAdministrator = 0,
    Distributor = 1,
}

export class UpdateClientAdministratorCommand implements IUpdateClientAdministratorCommand {
    id?: string;
    fullName?: string | undefined;
    email?: string | undefined;
    preferredLanguageId?: string | undefined;

    constructor(data?: IUpdateClientAdministratorCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.preferredLanguageId = _data["preferredLanguageId"];
        }
    }

    static fromJS(data: any): UpdateClientAdministratorCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClientAdministratorCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["preferredLanguageId"] = this.preferredLanguageId;
        return data;
    }
}

export interface IUpdateClientAdministratorCommand {
    id?: string;
    fullName?: string | undefined;
    email?: string | undefined;
    preferredLanguageId?: string | undefined;
}

export class CreateClientAdministratorCommand implements ICreateClientAdministratorCommand {
    clientGroupId?: number;
    userName?: string | undefined;
    password?: string | undefined;
    fullName?: string | undefined;
    preferredLanguageId?: string | undefined;
    email?: string | undefined;
    hasEmailNotification?: boolean | undefined;
    type?: ClientAdministratorType;

    constructor(data?: ICreateClientAdministratorCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientGroupId = _data["clientGroupId"];
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.fullName = _data["fullName"];
            this.preferredLanguageId = _data["preferredLanguageId"];
            this.email = _data["email"];
            this.hasEmailNotification = _data["hasEmailNotification"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): CreateClientAdministratorCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClientAdministratorCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientGroupId"] = this.clientGroupId;
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["fullName"] = this.fullName;
        data["preferredLanguageId"] = this.preferredLanguageId;
        data["email"] = this.email;
        data["hasEmailNotification"] = this.hasEmailNotification;
        data["type"] = this.type;
        return data;
    }
}

export interface ICreateClientAdministratorCommand {
    clientGroupId?: number;
    userName?: string | undefined;
    password?: string | undefined;
    fullName?: string | undefined;
    preferredLanguageId?: string | undefined;
    email?: string | undefined;
    hasEmailNotification?: boolean | undefined;
    type?: ClientAdministratorType;
}

export class UpdateClientAdministratorPasswordCommand implements IUpdateClientAdministratorPasswordCommand {
    oldPassword?: string;
    newPassword?: string;

    constructor(data?: IUpdateClientAdministratorPasswordCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldPassword = _data["oldPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): UpdateClientAdministratorPasswordCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClientAdministratorPasswordCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldPassword"] = this.oldPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IUpdateClientAdministratorPasswordCommand {
    oldPassword?: string;
    newPassword?: string;
}

export class ForceUpdateClientAdministratorPasswordCommand implements IForceUpdateClientAdministratorPasswordCommand {
    userId?: string;
    newPassword?: string;

    constructor(data?: IForceUpdateClientAdministratorPasswordCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ForceUpdateClientAdministratorPasswordCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ForceUpdateClientAdministratorPasswordCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IForceUpdateClientAdministratorPasswordCommand {
    userId?: string;
    newPassword?: string;
}

export class UpdateClientAdministratorClientGroupCommand implements IUpdateClientAdministratorClientGroupCommand {
    id?: string;
    clientGroupId?: number;

    constructor(data?: IUpdateClientAdministratorClientGroupCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientGroupId = _data["clientGroupId"];
        }
    }

    static fromJS(data: any): UpdateClientAdministratorClientGroupCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClientAdministratorClientGroupCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientGroupId"] = this.clientGroupId;
        return data;
    }
}

export interface IUpdateClientAdministratorClientGroupCommand {
    id?: string;
    clientGroupId?: number;
}

export class PaginatedListOfClientGroupAssessmentTemplateDto implements IPaginatedListOfClientGroupAssessmentTemplateDto {
    items?: ClientGroupAssessmentTemplateDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfClientGroupAssessmentTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ClientGroupAssessmentTemplateDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfClientGroupAssessmentTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfClientGroupAssessmentTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfClientGroupAssessmentTemplateDto {
    items?: ClientGroupAssessmentTemplateDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class ClientGroupAssessmentTemplateDto implements IClientGroupAssessmentTemplateDto {
    id?: number;
    assessmentTemplate?: AssessmentTemplateBriefDto;
    assessmentTemplateAlias?: string | undefined;
    clientGroup?: ClientGroupDto;

    constructor(data?: IClientGroupAssessmentTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assessmentTemplate = _data["assessmentTemplate"] ? AssessmentTemplateBriefDto.fromJS(_data["assessmentTemplate"]) : <any>undefined;
            this.assessmentTemplateAlias = _data["assessmentTemplateAlias"];
            this.clientGroup = _data["clientGroup"] ? ClientGroupDto.fromJS(_data["clientGroup"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ClientGroupAssessmentTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientGroupAssessmentTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assessmentTemplate"] = this.assessmentTemplate ? this.assessmentTemplate.toJSON() : <any>undefined;
        data["assessmentTemplateAlias"] = this.assessmentTemplateAlias;
        data["clientGroup"] = this.clientGroup ? this.clientGroup.toJSON() : <any>undefined;
        return data;
    }
}

export interface IClientGroupAssessmentTemplateDto {
    id?: number;
    assessmentTemplate?: AssessmentTemplateBriefDto;
    assessmentTemplateAlias?: string | undefined;
    clientGroup?: ClientGroupDto;
}

export class CreateClientGroupAssessmentTemplateCommand implements ICreateClientGroupAssessmentTemplateCommand {
    clientGroupId?: number;
    assessmentTemplateId?: number;

    constructor(data?: ICreateClientGroupAssessmentTemplateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientGroupId = _data["clientGroupId"];
            this.assessmentTemplateId = _data["assessmentTemplateId"];
        }
    }

    static fromJS(data: any): CreateClientGroupAssessmentTemplateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClientGroupAssessmentTemplateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientGroupId"] = this.clientGroupId;
        data["assessmentTemplateId"] = this.assessmentTemplateId;
        return data;
    }
}

export interface ICreateClientGroupAssessmentTemplateCommand {
    clientGroupId?: number;
    assessmentTemplateId?: number;
}

export class DeleteClientGroupAssessmentTemplateCommand implements IDeleteClientGroupAssessmentTemplateCommand {
    id?: number;

    constructor(data?: IDeleteClientGroupAssessmentTemplateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteClientGroupAssessmentTemplateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteClientGroupAssessmentTemplateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteClientGroupAssessmentTemplateCommand {
    id?: number;
}

export class SoftDeleteClientGroupAssessmentTemplateCommand implements ISoftDeleteClientGroupAssessmentTemplateCommand {
    id?: number;

    constructor(data?: ISoftDeleteClientGroupAssessmentTemplateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SoftDeleteClientGroupAssessmentTemplateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SoftDeleteClientGroupAssessmentTemplateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ISoftDeleteClientGroupAssessmentTemplateCommand {
    id?: number;
}

export class ClientGroupGroupReportGenerationSettingDto implements IClientGroupGroupReportGenerationSettingDto {
    id?: number;
    clientGroupAssessmentTemplate?: ClientGroupAssessmentTemplateDto;
    normTableName?: string | undefined;
    normTableId?: number | undefined;
    groupReportTemplateId?: number | undefined;
    groupReportTemplateName?: string | undefined;
    groupReportTemplateDisplayName?: string | undefined;
    scoringKeySetName?: string | undefined;
    scoringKeySetId?: number | undefined;
    groupReportLanguage?: string | undefined;
    lastModified?: Date | undefined;

    constructor(data?: IClientGroupGroupReportGenerationSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientGroupAssessmentTemplate = _data["clientGroupAssessmentTemplate"] ? ClientGroupAssessmentTemplateDto.fromJS(_data["clientGroupAssessmentTemplate"]) : <any>undefined;
            this.normTableName = _data["normTableName"];
            this.normTableId = _data["normTableId"];
            this.groupReportTemplateId = _data["groupReportTemplateId"];
            this.groupReportTemplateName = _data["groupReportTemplateName"];
            this.groupReportTemplateDisplayName = _data["groupReportTemplateDisplayName"];
            this.scoringKeySetName = _data["scoringKeySetName"];
            this.scoringKeySetId = _data["scoringKeySetId"];
            this.groupReportLanguage = _data["groupReportLanguage"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ClientGroupGroupReportGenerationSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientGroupGroupReportGenerationSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientGroupAssessmentTemplate"] = this.clientGroupAssessmentTemplate ? this.clientGroupAssessmentTemplate.toJSON() : <any>undefined;
        data["normTableName"] = this.normTableName;
        data["normTableId"] = this.normTableId;
        data["groupReportTemplateId"] = this.groupReportTemplateId;
        data["groupReportTemplateName"] = this.groupReportTemplateName;
        data["groupReportTemplateDisplayName"] = this.groupReportTemplateDisplayName;
        data["scoringKeySetName"] = this.scoringKeySetName;
        data["scoringKeySetId"] = this.scoringKeySetId;
        data["groupReportLanguage"] = this.groupReportLanguage;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        return data;
    }
}

export interface IClientGroupGroupReportGenerationSettingDto {
    id?: number;
    clientGroupAssessmentTemplate?: ClientGroupAssessmentTemplateDto;
    normTableName?: string | undefined;
    normTableId?: number | undefined;
    groupReportTemplateId?: number | undefined;
    groupReportTemplateName?: string | undefined;
    groupReportTemplateDisplayName?: string | undefined;
    scoringKeySetName?: string | undefined;
    scoringKeySetId?: number | undefined;
    groupReportLanguage?: string | undefined;
    lastModified?: Date | undefined;
}

export class PaginatedListOfClientGroupGroupReportGenerationSettingDto implements IPaginatedListOfClientGroupGroupReportGenerationSettingDto {
    items?: ClientGroupGroupReportGenerationSettingDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfClientGroupGroupReportGenerationSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ClientGroupGroupReportGenerationSettingDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfClientGroupGroupReportGenerationSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfClientGroupGroupReportGenerationSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfClientGroupGroupReportGenerationSettingDto {
    items?: ClientGroupGroupReportGenerationSettingDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class CreateClientGroupGroupReportGenerationSettingsCommand implements ICreateClientGroupGroupReportGenerationSettingsCommand {
    clientGroupAssessmentTemplateId?: number;
    scoringKeySetId?: number;
    normTableId?: number;
    groupReportTemplateId?: number;

    constructor(data?: ICreateClientGroupGroupReportGenerationSettingsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientGroupAssessmentTemplateId = _data["clientGroupAssessmentTemplateId"];
            this.scoringKeySetId = _data["scoringKeySetId"];
            this.normTableId = _data["normTableId"];
            this.groupReportTemplateId = _data["groupReportTemplateId"];
        }
    }

    static fromJS(data: any): CreateClientGroupGroupReportGenerationSettingsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClientGroupGroupReportGenerationSettingsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientGroupAssessmentTemplateId"] = this.clientGroupAssessmentTemplateId;
        data["scoringKeySetId"] = this.scoringKeySetId;
        data["normTableId"] = this.normTableId;
        data["groupReportTemplateId"] = this.groupReportTemplateId;
        return data;
    }
}

export interface ICreateClientGroupGroupReportGenerationSettingsCommand {
    clientGroupAssessmentTemplateId?: number;
    scoringKeySetId?: number;
    normTableId?: number;
    groupReportTemplateId?: number;
}

export class DeleteClientGroupGroupReportGenerationSettingCommand implements IDeleteClientGroupGroupReportGenerationSettingCommand {
    id?: number;

    constructor(data?: IDeleteClientGroupGroupReportGenerationSettingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteClientGroupGroupReportGenerationSettingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteClientGroupGroupReportGenerationSettingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteClientGroupGroupReportGenerationSettingCommand {
    id?: number;
}

export class ClientGroupReportGenerationSettingDto implements IClientGroupReportGenerationSettingDto {
    id?: number;
    clientGroupAssessmentTemplate?: ClientGroupAssessmentTemplateDto;
    normTableName?: string | undefined;
    normTableId?: number | undefined;
    reportTemplateId?: number | undefined;
    reportTemplateName?: string | undefined;
    reportTemplateDisplayName?: string | undefined;
    scoringKeySetName?: string | undefined;
    scoringKeySetId?: number | undefined;
    isAutoGenerated?: boolean;
    reportLanguage?: string | undefined;
    lastModified?: Date | undefined;
    reportAutoGenerateCondition?: ReportAutoGenerateCondition;

    constructor(data?: IClientGroupReportGenerationSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientGroupAssessmentTemplate = _data["clientGroupAssessmentTemplate"] ? ClientGroupAssessmentTemplateDto.fromJS(_data["clientGroupAssessmentTemplate"]) : <any>undefined;
            this.normTableName = _data["normTableName"];
            this.normTableId = _data["normTableId"];
            this.reportTemplateId = _data["reportTemplateId"];
            this.reportTemplateName = _data["reportTemplateName"];
            this.reportTemplateDisplayName = _data["reportTemplateDisplayName"];
            this.scoringKeySetName = _data["scoringKeySetName"];
            this.scoringKeySetId = _data["scoringKeySetId"];
            this.isAutoGenerated = _data["isAutoGenerated"];
            this.reportLanguage = _data["reportLanguage"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.reportAutoGenerateCondition = _data["reportAutoGenerateCondition"];
        }
    }

    static fromJS(data: any): ClientGroupReportGenerationSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientGroupReportGenerationSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientGroupAssessmentTemplate"] = this.clientGroupAssessmentTemplate ? this.clientGroupAssessmentTemplate.toJSON() : <any>undefined;
        data["normTableName"] = this.normTableName;
        data["normTableId"] = this.normTableId;
        data["reportTemplateId"] = this.reportTemplateId;
        data["reportTemplateName"] = this.reportTemplateName;
        data["reportTemplateDisplayName"] = this.reportTemplateDisplayName;
        data["scoringKeySetName"] = this.scoringKeySetName;
        data["scoringKeySetId"] = this.scoringKeySetId;
        data["isAutoGenerated"] = this.isAutoGenerated;
        data["reportLanguage"] = this.reportLanguage;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["reportAutoGenerateCondition"] = this.reportAutoGenerateCondition;
        return data;
    }
}

export interface IClientGroupReportGenerationSettingDto {
    id?: number;
    clientGroupAssessmentTemplate?: ClientGroupAssessmentTemplateDto;
    normTableName?: string | undefined;
    normTableId?: number | undefined;
    reportTemplateId?: number | undefined;
    reportTemplateName?: string | undefined;
    reportTemplateDisplayName?: string | undefined;
    scoringKeySetName?: string | undefined;
    scoringKeySetId?: number | undefined;
    isAutoGenerated?: boolean;
    reportLanguage?: string | undefined;
    lastModified?: Date | undefined;
    reportAutoGenerateCondition?: ReportAutoGenerateCondition;
}

export enum ReportAutoGenerateCondition {
    Never = 0,
    Always = 1,
    MatchUserLanguage = 2,
    Fallback = 3,
}

export class PaginatedListOfClientGroupReportGenerationSettingDto implements IPaginatedListOfClientGroupReportGenerationSettingDto {
    items?: ClientGroupReportGenerationSettingDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfClientGroupReportGenerationSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ClientGroupReportGenerationSettingDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfClientGroupReportGenerationSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfClientGroupReportGenerationSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfClientGroupReportGenerationSettingDto {
    items?: ClientGroupReportGenerationSettingDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class CreateClientGroupReportGenerationSettingsCommand implements ICreateClientGroupReportGenerationSettingsCommand {
    clientGroupAssessmentTemplateId?: number;
    scoringKeySetId?: number;
    normTableId?: number;
    reportTemplateId?: number;
    isReportAutoGenerated?: boolean;
    reportAutoGenerateCondition?: ReportAutoGenerateCondition;

    constructor(data?: ICreateClientGroupReportGenerationSettingsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientGroupAssessmentTemplateId = _data["clientGroupAssessmentTemplateId"];
            this.scoringKeySetId = _data["scoringKeySetId"];
            this.normTableId = _data["normTableId"];
            this.reportTemplateId = _data["reportTemplateId"];
            this.isReportAutoGenerated = _data["isReportAutoGenerated"];
            this.reportAutoGenerateCondition = _data["reportAutoGenerateCondition"];
        }
    }

    static fromJS(data: any): CreateClientGroupReportGenerationSettingsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClientGroupReportGenerationSettingsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientGroupAssessmentTemplateId"] = this.clientGroupAssessmentTemplateId;
        data["scoringKeySetId"] = this.scoringKeySetId;
        data["normTableId"] = this.normTableId;
        data["reportTemplateId"] = this.reportTemplateId;
        data["isReportAutoGenerated"] = this.isReportAutoGenerated;
        data["reportAutoGenerateCondition"] = this.reportAutoGenerateCondition;
        return data;
    }
}

export interface ICreateClientGroupReportGenerationSettingsCommand {
    clientGroupAssessmentTemplateId?: number;
    scoringKeySetId?: number;
    normTableId?: number;
    reportTemplateId?: number;
    isReportAutoGenerated?: boolean;
    reportAutoGenerateCondition?: ReportAutoGenerateCondition;
}

export class UpdateClientGroupReportGenerationSettingCommand implements IUpdateClientGroupReportGenerationSettingCommand {
    id?: number;
    reportAutoGenerateCondition?: ReportAutoGenerateCondition;

    constructor(data?: IUpdateClientGroupReportGenerationSettingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reportAutoGenerateCondition = _data["reportAutoGenerateCondition"];
        }
    }

    static fromJS(data: any): UpdateClientGroupReportGenerationSettingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClientGroupReportGenerationSettingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reportAutoGenerateCondition"] = this.reportAutoGenerateCondition;
        return data;
    }
}

export interface IUpdateClientGroupReportGenerationSettingCommand {
    id?: number;
    reportAutoGenerateCondition?: ReportAutoGenerateCondition;
}

export class DeleteClientGroupReportGenerationSettingCommand implements IDeleteClientGroupReportGenerationSettingCommand {
    id?: number;

    constructor(data?: IDeleteClientGroupReportGenerationSettingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteClientGroupReportGenerationSettingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteClientGroupReportGenerationSettingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteClientGroupReportGenerationSettingCommand {
    id?: number;
}

export class PaginatedListOfClientGroupDto implements IPaginatedListOfClientGroupDto {
    items?: ClientGroupDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfClientGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ClientGroupDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfClientGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfClientGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfClientGroupDto {
    items?: ClientGroupDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class ClientGroupEmailGreetingDto implements IClientGroupEmailGreetingDto {
    registrationEmail?: { [key: string]: string; } | undefined;
    reminderEmail?: { [key: string]: string; } | undefined;
    reportEmail?: { [key: string]: string; } | undefined;
    lmsReminderEmail?: { [key: string]: string; } | undefined;
    registrationEmailCustomTitle?: { [key: string]: string; } | undefined;
    reminderEmailCustomTitle?: { [key: string]: string; } | undefined;
    reportEmailCustomTitle?: { [key: string]: string; } | undefined;
    lmsReminderCustomTitle?: { [key: string]: string; } | undefined;
    registrationCustomEmail?: { [key: string]: string; } | undefined;
    reminderCustomEmail?: { [key: string]: string; } | undefined;
    reportCustomEmail?: { [key: string]: string; } | undefined;
    lmsReminderCustomEmail?: { [key: string]: string; } | undefined;
    lmsCertificateReminderEmail?: { [key: string]: string; } | undefined;
    lmsCertificateReminderCustomTitle?: { [key: string]: string; } | undefined;
    lmsCertificateReminderCustomEmail?: { [key: string]: string; } | undefined;
    lmsVerificationCodeReminderEmail?: { [key: string]: string; } | undefined;
    lmsVerificationCodeReminderCustomTitle?: { [key: string]: string; } | undefined;
    lmsVerificationCodeReminderCustomEmail?: { [key: string]: string; } | undefined;

    constructor(data?: IClientGroupEmailGreetingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["registrationEmail"]) {
                this.registrationEmail = {} as any;
                for (let key in _data["registrationEmail"]) {
                    if (_data["registrationEmail"].hasOwnProperty(key))
                        (<any>this.registrationEmail)![key] = _data["registrationEmail"][key];
                }
            }
            if (_data["reminderEmail"]) {
                this.reminderEmail = {} as any;
                for (let key in _data["reminderEmail"]) {
                    if (_data["reminderEmail"].hasOwnProperty(key))
                        (<any>this.reminderEmail)![key] = _data["reminderEmail"][key];
                }
            }
            if (_data["reportEmail"]) {
                this.reportEmail = {} as any;
                for (let key in _data["reportEmail"]) {
                    if (_data["reportEmail"].hasOwnProperty(key))
                        (<any>this.reportEmail)![key] = _data["reportEmail"][key];
                }
            }
            if (_data["lmsReminderEmail"]) {
                this.lmsReminderEmail = {} as any;
                for (let key in _data["lmsReminderEmail"]) {
                    if (_data["lmsReminderEmail"].hasOwnProperty(key))
                        (<any>this.lmsReminderEmail)![key] = _data["lmsReminderEmail"][key];
                }
            }
            if (_data["registrationEmailCustomTitle"]) {
                this.registrationEmailCustomTitle = {} as any;
                for (let key in _data["registrationEmailCustomTitle"]) {
                    if (_data["registrationEmailCustomTitle"].hasOwnProperty(key))
                        (<any>this.registrationEmailCustomTitle)![key] = _data["registrationEmailCustomTitle"][key];
                }
            }
            if (_data["reminderEmailCustomTitle"]) {
                this.reminderEmailCustomTitle = {} as any;
                for (let key in _data["reminderEmailCustomTitle"]) {
                    if (_data["reminderEmailCustomTitle"].hasOwnProperty(key))
                        (<any>this.reminderEmailCustomTitle)![key] = _data["reminderEmailCustomTitle"][key];
                }
            }
            if (_data["reportEmailCustomTitle"]) {
                this.reportEmailCustomTitle = {} as any;
                for (let key in _data["reportEmailCustomTitle"]) {
                    if (_data["reportEmailCustomTitle"].hasOwnProperty(key))
                        (<any>this.reportEmailCustomTitle)![key] = _data["reportEmailCustomTitle"][key];
                }
            }
            if (_data["lmsReminderCustomTitle"]) {
                this.lmsReminderCustomTitle = {} as any;
                for (let key in _data["lmsReminderCustomTitle"]) {
                    if (_data["lmsReminderCustomTitle"].hasOwnProperty(key))
                        (<any>this.lmsReminderCustomTitle)![key] = _data["lmsReminderCustomTitle"][key];
                }
            }
            if (_data["registrationCustomEmail"]) {
                this.registrationCustomEmail = {} as any;
                for (let key in _data["registrationCustomEmail"]) {
                    if (_data["registrationCustomEmail"].hasOwnProperty(key))
                        (<any>this.registrationCustomEmail)![key] = _data["registrationCustomEmail"][key];
                }
            }
            if (_data["reminderCustomEmail"]) {
                this.reminderCustomEmail = {} as any;
                for (let key in _data["reminderCustomEmail"]) {
                    if (_data["reminderCustomEmail"].hasOwnProperty(key))
                        (<any>this.reminderCustomEmail)![key] = _data["reminderCustomEmail"][key];
                }
            }
            if (_data["reportCustomEmail"]) {
                this.reportCustomEmail = {} as any;
                for (let key in _data["reportCustomEmail"]) {
                    if (_data["reportCustomEmail"].hasOwnProperty(key))
                        (<any>this.reportCustomEmail)![key] = _data["reportCustomEmail"][key];
                }
            }
            if (_data["lmsReminderCustomEmail"]) {
                this.lmsReminderCustomEmail = {} as any;
                for (let key in _data["lmsReminderCustomEmail"]) {
                    if (_data["lmsReminderCustomEmail"].hasOwnProperty(key))
                        (<any>this.lmsReminderCustomEmail)![key] = _data["lmsReminderCustomEmail"][key];
                }
            }
            if (_data["lmsCertificateReminderEmail"]) {
                this.lmsCertificateReminderEmail = {} as any;
                for (let key in _data["lmsCertificateReminderEmail"]) {
                    if (_data["lmsCertificateReminderEmail"].hasOwnProperty(key))
                        (<any>this.lmsCertificateReminderEmail)![key] = _data["lmsCertificateReminderEmail"][key];
                }
            }
            if (_data["lmsCertificateReminderCustomTitle"]) {
                this.lmsCertificateReminderCustomTitle = {} as any;
                for (let key in _data["lmsCertificateReminderCustomTitle"]) {
                    if (_data["lmsCertificateReminderCustomTitle"].hasOwnProperty(key))
                        (<any>this.lmsCertificateReminderCustomTitle)![key] = _data["lmsCertificateReminderCustomTitle"][key];
                }
            }
            if (_data["lmsCertificateReminderCustomEmail"]) {
                this.lmsCertificateReminderCustomEmail = {} as any;
                for (let key in _data["lmsCertificateReminderCustomEmail"]) {
                    if (_data["lmsCertificateReminderCustomEmail"].hasOwnProperty(key))
                        (<any>this.lmsCertificateReminderCustomEmail)![key] = _data["lmsCertificateReminderCustomEmail"][key];
                }
            }
            if (_data["lmsVerificationCodeReminderEmail"]) {
                this.lmsVerificationCodeReminderEmail = {} as any;
                for (let key in _data["lmsVerificationCodeReminderEmail"]) {
                    if (_data["lmsVerificationCodeReminderEmail"].hasOwnProperty(key))
                        (<any>this.lmsVerificationCodeReminderEmail)![key] = _data["lmsVerificationCodeReminderEmail"][key];
                }
            }
            if (_data["lmsVerificationCodeReminderCustomTitle"]) {
                this.lmsVerificationCodeReminderCustomTitle = {} as any;
                for (let key in _data["lmsVerificationCodeReminderCustomTitle"]) {
                    if (_data["lmsVerificationCodeReminderCustomTitle"].hasOwnProperty(key))
                        (<any>this.lmsVerificationCodeReminderCustomTitle)![key] = _data["lmsVerificationCodeReminderCustomTitle"][key];
                }
            }
            if (_data["lmsVerificationCodeReminderCustomEmail"]) {
                this.lmsVerificationCodeReminderCustomEmail = {} as any;
                for (let key in _data["lmsVerificationCodeReminderCustomEmail"]) {
                    if (_data["lmsVerificationCodeReminderCustomEmail"].hasOwnProperty(key))
                        (<any>this.lmsVerificationCodeReminderCustomEmail)![key] = _data["lmsVerificationCodeReminderCustomEmail"][key];
                }
            }
        }
    }

    static fromJS(data: any): ClientGroupEmailGreetingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientGroupEmailGreetingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.registrationEmail) {
            data["registrationEmail"] = {};
            for (let key in this.registrationEmail) {
                if (this.registrationEmail.hasOwnProperty(key))
                    (<any>data["registrationEmail"])[key] = (<any>this.registrationEmail)[key];
            }
        }
        if (this.reminderEmail) {
            data["reminderEmail"] = {};
            for (let key in this.reminderEmail) {
                if (this.reminderEmail.hasOwnProperty(key))
                    (<any>data["reminderEmail"])[key] = (<any>this.reminderEmail)[key];
            }
        }
        if (this.reportEmail) {
            data["reportEmail"] = {};
            for (let key in this.reportEmail) {
                if (this.reportEmail.hasOwnProperty(key))
                    (<any>data["reportEmail"])[key] = (<any>this.reportEmail)[key];
            }
        }
        if (this.lmsReminderEmail) {
            data["lmsReminderEmail"] = {};
            for (let key in this.lmsReminderEmail) {
                if (this.lmsReminderEmail.hasOwnProperty(key))
                    (<any>data["lmsReminderEmail"])[key] = (<any>this.lmsReminderEmail)[key];
            }
        }
        if (this.registrationEmailCustomTitle) {
            data["registrationEmailCustomTitle"] = {};
            for (let key in this.registrationEmailCustomTitle) {
                if (this.registrationEmailCustomTitle.hasOwnProperty(key))
                    (<any>data["registrationEmailCustomTitle"])[key] = (<any>this.registrationEmailCustomTitle)[key];
            }
        }
        if (this.reminderEmailCustomTitle) {
            data["reminderEmailCustomTitle"] = {};
            for (let key in this.reminderEmailCustomTitle) {
                if (this.reminderEmailCustomTitle.hasOwnProperty(key))
                    (<any>data["reminderEmailCustomTitle"])[key] = (<any>this.reminderEmailCustomTitle)[key];
            }
        }
        if (this.reportEmailCustomTitle) {
            data["reportEmailCustomTitle"] = {};
            for (let key in this.reportEmailCustomTitle) {
                if (this.reportEmailCustomTitle.hasOwnProperty(key))
                    (<any>data["reportEmailCustomTitle"])[key] = (<any>this.reportEmailCustomTitle)[key];
            }
        }
        if (this.lmsReminderCustomTitle) {
            data["lmsReminderCustomTitle"] = {};
            for (let key in this.lmsReminderCustomTitle) {
                if (this.lmsReminderCustomTitle.hasOwnProperty(key))
                    (<any>data["lmsReminderCustomTitle"])[key] = (<any>this.lmsReminderCustomTitle)[key];
            }
        }
        if (this.registrationCustomEmail) {
            data["registrationCustomEmail"] = {};
            for (let key in this.registrationCustomEmail) {
                if (this.registrationCustomEmail.hasOwnProperty(key))
                    (<any>data["registrationCustomEmail"])[key] = (<any>this.registrationCustomEmail)[key];
            }
        }
        if (this.reminderCustomEmail) {
            data["reminderCustomEmail"] = {};
            for (let key in this.reminderCustomEmail) {
                if (this.reminderCustomEmail.hasOwnProperty(key))
                    (<any>data["reminderCustomEmail"])[key] = (<any>this.reminderCustomEmail)[key];
            }
        }
        if (this.reportCustomEmail) {
            data["reportCustomEmail"] = {};
            for (let key in this.reportCustomEmail) {
                if (this.reportCustomEmail.hasOwnProperty(key))
                    (<any>data["reportCustomEmail"])[key] = (<any>this.reportCustomEmail)[key];
            }
        }
        if (this.lmsReminderCustomEmail) {
            data["lmsReminderCustomEmail"] = {};
            for (let key in this.lmsReminderCustomEmail) {
                if (this.lmsReminderCustomEmail.hasOwnProperty(key))
                    (<any>data["lmsReminderCustomEmail"])[key] = (<any>this.lmsReminderCustomEmail)[key];
            }
        }
        if (this.lmsCertificateReminderEmail) {
            data["lmsCertificateReminderEmail"] = {};
            for (let key in this.lmsCertificateReminderEmail) {
                if (this.lmsCertificateReminderEmail.hasOwnProperty(key))
                    (<any>data["lmsCertificateReminderEmail"])[key] = (<any>this.lmsCertificateReminderEmail)[key];
            }
        }
        if (this.lmsCertificateReminderCustomTitle) {
            data["lmsCertificateReminderCustomTitle"] = {};
            for (let key in this.lmsCertificateReminderCustomTitle) {
                if (this.lmsCertificateReminderCustomTitle.hasOwnProperty(key))
                    (<any>data["lmsCertificateReminderCustomTitle"])[key] = (<any>this.lmsCertificateReminderCustomTitle)[key];
            }
        }
        if (this.lmsCertificateReminderCustomEmail) {
            data["lmsCertificateReminderCustomEmail"] = {};
            for (let key in this.lmsCertificateReminderCustomEmail) {
                if (this.lmsCertificateReminderCustomEmail.hasOwnProperty(key))
                    (<any>data["lmsCertificateReminderCustomEmail"])[key] = (<any>this.lmsCertificateReminderCustomEmail)[key];
            }
        }
        if (this.lmsVerificationCodeReminderEmail) {
            data["lmsVerificationCodeReminderEmail"] = {};
            for (let key in this.lmsVerificationCodeReminderEmail) {
                if (this.lmsVerificationCodeReminderEmail.hasOwnProperty(key))
                    (<any>data["lmsVerificationCodeReminderEmail"])[key] = (<any>this.lmsVerificationCodeReminderEmail)[key];
            }
        }
        if (this.lmsVerificationCodeReminderCustomTitle) {
            data["lmsVerificationCodeReminderCustomTitle"] = {};
            for (let key in this.lmsVerificationCodeReminderCustomTitle) {
                if (this.lmsVerificationCodeReminderCustomTitle.hasOwnProperty(key))
                    (<any>data["lmsVerificationCodeReminderCustomTitle"])[key] = (<any>this.lmsVerificationCodeReminderCustomTitle)[key];
            }
        }
        if (this.lmsVerificationCodeReminderCustomEmail) {
            data["lmsVerificationCodeReminderCustomEmail"] = {};
            for (let key in this.lmsVerificationCodeReminderCustomEmail) {
                if (this.lmsVerificationCodeReminderCustomEmail.hasOwnProperty(key))
                    (<any>data["lmsVerificationCodeReminderCustomEmail"])[key] = (<any>this.lmsVerificationCodeReminderCustomEmail)[key];
            }
        }
        return data;
    }
}

export interface IClientGroupEmailGreetingDto {
    registrationEmail?: { [key: string]: string; } | undefined;
    reminderEmail?: { [key: string]: string; } | undefined;
    reportEmail?: { [key: string]: string; } | undefined;
    lmsReminderEmail?: { [key: string]: string; } | undefined;
    registrationEmailCustomTitle?: { [key: string]: string; } | undefined;
    reminderEmailCustomTitle?: { [key: string]: string; } | undefined;
    reportEmailCustomTitle?: { [key: string]: string; } | undefined;
    lmsReminderCustomTitle?: { [key: string]: string; } | undefined;
    registrationCustomEmail?: { [key: string]: string; } | undefined;
    reminderCustomEmail?: { [key: string]: string; } | undefined;
    reportCustomEmail?: { [key: string]: string; } | undefined;
    lmsReminderCustomEmail?: { [key: string]: string; } | undefined;
    lmsCertificateReminderEmail?: { [key: string]: string; } | undefined;
    lmsCertificateReminderCustomTitle?: { [key: string]: string; } | undefined;
    lmsCertificateReminderCustomEmail?: { [key: string]: string; } | undefined;
    lmsVerificationCodeReminderEmail?: { [key: string]: string; } | undefined;
    lmsVerificationCodeReminderCustomTitle?: { [key: string]: string; } | undefined;
    lmsVerificationCodeReminderCustomEmail?: { [key: string]: string; } | undefined;
}

export class CreateClientGroupCommand implements ICreateClientGroupCommand {
    parentGroupId?: number;
    name?: string;
    copyParent?: boolean;
    canCustomizePreferredLanguage?: boolean;
    canCustomizeEmail?: boolean;
    canCustomizePassword?: boolean;
    canCustomizeFullName?: boolean;
    customFullNameLabel?: string | undefined;
    isReportAutoSend?: boolean;
    reportAutoSendSetting?: ReportAutoSendSetting;
    triggerTime?: Date | undefined;
    emailRecipient?: string[];
    ccRecipient?: string[];
    accountExpiry?: Date | undefined;
    preferredLanguageId?: string;
    maxAccount?: number | undefined;
    maxAccountForSub?: number | undefined;

    constructor(data?: ICreateClientGroupCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentGroupId = _data["parentGroupId"];
            this.name = _data["name"];
            this.copyParent = _data["copyParent"];
            this.canCustomizePreferredLanguage = _data["canCustomizePreferredLanguage"];
            this.canCustomizeEmail = _data["canCustomizeEmail"];
            this.canCustomizePassword = _data["canCustomizePassword"];
            this.canCustomizeFullName = _data["canCustomizeFullName"];
            this.customFullNameLabel = _data["customFullNameLabel"];
            this.isReportAutoSend = _data["isReportAutoSend"];
            this.reportAutoSendSetting = _data["reportAutoSendSetting"];
            this.triggerTime = _data["triggerTime"] ? new Date(_data["triggerTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["emailRecipient"])) {
                this.emailRecipient = [] as any;
                for (let item of _data["emailRecipient"])
                    this.emailRecipient!.push(item);
            }
            if (Array.isArray(_data["ccRecipient"])) {
                this.ccRecipient = [] as any;
                for (let item of _data["ccRecipient"])
                    this.ccRecipient!.push(item);
            }
            this.accountExpiry = _data["accountExpiry"] ? new Date(_data["accountExpiry"].toString()) : <any>undefined;
            this.preferredLanguageId = _data["preferredLanguageId"];
            this.maxAccount = _data["maxAccount"];
            this.maxAccountForSub = _data["maxAccountForSub"];
        }
    }

    static fromJS(data: any): CreateClientGroupCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClientGroupCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentGroupId"] = this.parentGroupId;
        data["name"] = this.name;
        data["copyParent"] = this.copyParent;
        data["canCustomizePreferredLanguage"] = this.canCustomizePreferredLanguage;
        data["canCustomizeEmail"] = this.canCustomizeEmail;
        data["canCustomizePassword"] = this.canCustomizePassword;
        data["canCustomizeFullName"] = this.canCustomizeFullName;
        data["customFullNameLabel"] = this.customFullNameLabel;
        data["isReportAutoSend"] = this.isReportAutoSend;
        data["reportAutoSendSetting"] = this.reportAutoSendSetting;
        data["triggerTime"] = this.triggerTime ? this.triggerTime.toISOString() : <any>undefined;
        if (Array.isArray(this.emailRecipient)) {
            data["emailRecipient"] = [];
            for (let item of this.emailRecipient)
                data["emailRecipient"].push(item);
        }
        if (Array.isArray(this.ccRecipient)) {
            data["ccRecipient"] = [];
            for (let item of this.ccRecipient)
                data["ccRecipient"].push(item);
        }
        data["accountExpiry"] = this.accountExpiry ? this.accountExpiry.toISOString() : <any>undefined;
        data["preferredLanguageId"] = this.preferredLanguageId;
        data["maxAccount"] = this.maxAccount;
        data["maxAccountForSub"] = this.maxAccountForSub;
        return data;
    }
}

export interface ICreateClientGroupCommand {
    parentGroupId?: number;
    name?: string;
    copyParent?: boolean;
    canCustomizePreferredLanguage?: boolean;
    canCustomizeEmail?: boolean;
    canCustomizePassword?: boolean;
    canCustomizeFullName?: boolean;
    customFullNameLabel?: string | undefined;
    isReportAutoSend?: boolean;
    reportAutoSendSetting?: ReportAutoSendSetting;
    triggerTime?: Date | undefined;
    emailRecipient?: string[];
    ccRecipient?: string[];
    accountExpiry?: Date | undefined;
    preferredLanguageId?: string;
    maxAccount?: number | undefined;
    maxAccountForSub?: number | undefined;
}

export class CreateTopClientGroupCommand implements ICreateTopClientGroupCommand {
    name?: string;
    clientId?: number;
    canCustomizePreferredLanguage?: boolean;
    canCustomizeEmail?: boolean;
    canCustomizePassword?: boolean;
    canCustomizeFullName?: boolean;
    customFullNameLabel?: string | undefined;
    isReportAutoSend?: boolean;
    reportAutoSendSetting?: ReportAutoSendSetting;
    triggerTime?: Date | undefined;
    emailRecipient?: string[];
    ccRecipient?: string[];
    accountExpiry?: Date | undefined;
    preferredLanguageId?: string;
    maxAccount?: number | undefined;
    maxAccountForSub?: number | undefined;

    constructor(data?: ICreateTopClientGroupCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.clientId = _data["clientId"];
            this.canCustomizePreferredLanguage = _data["canCustomizePreferredLanguage"];
            this.canCustomizeEmail = _data["canCustomizeEmail"];
            this.canCustomizePassword = _data["canCustomizePassword"];
            this.canCustomizeFullName = _data["canCustomizeFullName"];
            this.customFullNameLabel = _data["customFullNameLabel"];
            this.isReportAutoSend = _data["isReportAutoSend"];
            this.reportAutoSendSetting = _data["reportAutoSendSetting"];
            this.triggerTime = _data["triggerTime"] ? new Date(_data["triggerTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["emailRecipient"])) {
                this.emailRecipient = [] as any;
                for (let item of _data["emailRecipient"])
                    this.emailRecipient!.push(item);
            }
            if (Array.isArray(_data["ccRecipient"])) {
                this.ccRecipient = [] as any;
                for (let item of _data["ccRecipient"])
                    this.ccRecipient!.push(item);
            }
            this.accountExpiry = _data["accountExpiry"] ? new Date(_data["accountExpiry"].toString()) : <any>undefined;
            this.preferredLanguageId = _data["preferredLanguageId"];
            this.maxAccount = _data["maxAccount"];
            this.maxAccountForSub = _data["maxAccountForSub"];
        }
    }

    static fromJS(data: any): CreateTopClientGroupCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTopClientGroupCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        data["canCustomizePreferredLanguage"] = this.canCustomizePreferredLanguage;
        data["canCustomizeEmail"] = this.canCustomizeEmail;
        data["canCustomizePassword"] = this.canCustomizePassword;
        data["canCustomizeFullName"] = this.canCustomizeFullName;
        data["customFullNameLabel"] = this.customFullNameLabel;
        data["isReportAutoSend"] = this.isReportAutoSend;
        data["reportAutoSendSetting"] = this.reportAutoSendSetting;
        data["triggerTime"] = this.triggerTime ? this.triggerTime.toISOString() : <any>undefined;
        if (Array.isArray(this.emailRecipient)) {
            data["emailRecipient"] = [];
            for (let item of this.emailRecipient)
                data["emailRecipient"].push(item);
        }
        if (Array.isArray(this.ccRecipient)) {
            data["ccRecipient"] = [];
            for (let item of this.ccRecipient)
                data["ccRecipient"].push(item);
        }
        data["accountExpiry"] = this.accountExpiry ? this.accountExpiry.toISOString() : <any>undefined;
        data["preferredLanguageId"] = this.preferredLanguageId;
        data["maxAccount"] = this.maxAccount;
        data["maxAccountForSub"] = this.maxAccountForSub;
        return data;
    }
}

export interface ICreateTopClientGroupCommand {
    name?: string;
    clientId?: number;
    canCustomizePreferredLanguage?: boolean;
    canCustomizeEmail?: boolean;
    canCustomizePassword?: boolean;
    canCustomizeFullName?: boolean;
    customFullNameLabel?: string | undefined;
    isReportAutoSend?: boolean;
    reportAutoSendSetting?: ReportAutoSendSetting;
    triggerTime?: Date | undefined;
    emailRecipient?: string[];
    ccRecipient?: string[];
    accountExpiry?: Date | undefined;
    preferredLanguageId?: string;
    maxAccount?: number | undefined;
    maxAccountForSub?: number | undefined;
}

export class UpdateClientGroupCommand implements IUpdateClientGroupCommand {
    id?: number;
    name?: string;
    canCustomizePreferredLanguage?: boolean;
    canCustomizeEmail?: boolean;
    canCustomizePassword?: boolean;
    canCustomizeFullName?: boolean;
    customFullNameLabel?: string | undefined;
    isReportAutoSend?: boolean;
    reportAutoSendSetting?: ReportAutoSendSetting;
    triggerTime?: Date | undefined;
    emailRecipient?: string[];
    ccRecipient?: string[];
    accountExpiry?: Date | undefined;
    preferredLanguageId?: string;
    maxAccount?: number | undefined;
    maxAccountForSub?: number | undefined;

    constructor(data?: IUpdateClientGroupCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.canCustomizePreferredLanguage = _data["canCustomizePreferredLanguage"];
            this.canCustomizeEmail = _data["canCustomizeEmail"];
            this.canCustomizePassword = _data["canCustomizePassword"];
            this.canCustomizeFullName = _data["canCustomizeFullName"];
            this.customFullNameLabel = _data["customFullNameLabel"];
            this.isReportAutoSend = _data["isReportAutoSend"];
            this.reportAutoSendSetting = _data["reportAutoSendSetting"];
            this.triggerTime = _data["triggerTime"] ? new Date(_data["triggerTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["emailRecipient"])) {
                this.emailRecipient = [] as any;
                for (let item of _data["emailRecipient"])
                    this.emailRecipient!.push(item);
            }
            if (Array.isArray(_data["ccRecipient"])) {
                this.ccRecipient = [] as any;
                for (let item of _data["ccRecipient"])
                    this.ccRecipient!.push(item);
            }
            this.accountExpiry = _data["accountExpiry"] ? new Date(_data["accountExpiry"].toString()) : <any>undefined;
            this.preferredLanguageId = _data["preferredLanguageId"];
            this.maxAccount = _data["maxAccount"];
            this.maxAccountForSub = _data["maxAccountForSub"];
        }
    }

    static fromJS(data: any): UpdateClientGroupCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClientGroupCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["canCustomizePreferredLanguage"] = this.canCustomizePreferredLanguage;
        data["canCustomizeEmail"] = this.canCustomizeEmail;
        data["canCustomizePassword"] = this.canCustomizePassword;
        data["canCustomizeFullName"] = this.canCustomizeFullName;
        data["customFullNameLabel"] = this.customFullNameLabel;
        data["isReportAutoSend"] = this.isReportAutoSend;
        data["reportAutoSendSetting"] = this.reportAutoSendSetting;
        data["triggerTime"] = this.triggerTime ? this.triggerTime.toISOString() : <any>undefined;
        if (Array.isArray(this.emailRecipient)) {
            data["emailRecipient"] = [];
            for (let item of this.emailRecipient)
                data["emailRecipient"].push(item);
        }
        if (Array.isArray(this.ccRecipient)) {
            data["ccRecipient"] = [];
            for (let item of this.ccRecipient)
                data["ccRecipient"].push(item);
        }
        data["accountExpiry"] = this.accountExpiry ? this.accountExpiry.toISOString() : <any>undefined;
        data["preferredLanguageId"] = this.preferredLanguageId;
        data["maxAccount"] = this.maxAccount;
        data["maxAccountForSub"] = this.maxAccountForSub;
        return data;
    }
}

export interface IUpdateClientGroupCommand {
    id?: number;
    name?: string;
    canCustomizePreferredLanguage?: boolean;
    canCustomizeEmail?: boolean;
    canCustomizePassword?: boolean;
    canCustomizeFullName?: boolean;
    customFullNameLabel?: string | undefined;
    isReportAutoSend?: boolean;
    reportAutoSendSetting?: ReportAutoSendSetting;
    triggerTime?: Date | undefined;
    emailRecipient?: string[];
    ccRecipient?: string[];
    accountExpiry?: Date | undefined;
    preferredLanguageId?: string;
    maxAccount?: number | undefined;
    maxAccountForSub?: number | undefined;
}

export class UpdateClientGroupEmailGreetingCommand implements IUpdateClientGroupEmailGreetingCommand {
    clientGroupId?: number;
    clientGroupCustomizableEmailTypes?: ClientGroupCustomizableEmailTypes;
    content?: string;
    languageId?: string;

    constructor(data?: IUpdateClientGroupEmailGreetingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientGroupId = _data["clientGroupId"];
            this.clientGroupCustomizableEmailTypes = _data["clientGroupCustomizableEmailTypes"];
            this.content = _data["content"];
            this.languageId = _data["languageId"];
        }
    }

    static fromJS(data: any): UpdateClientGroupEmailGreetingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClientGroupEmailGreetingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientGroupId"] = this.clientGroupId;
        data["clientGroupCustomizableEmailTypes"] = this.clientGroupCustomizableEmailTypes;
        data["content"] = this.content;
        data["languageId"] = this.languageId;
        return data;
    }
}

export interface IUpdateClientGroupEmailGreetingCommand {
    clientGroupId?: number;
    clientGroupCustomizableEmailTypes?: ClientGroupCustomizableEmailTypes;
    content?: string;
    languageId?: string;
}

export enum ClientGroupCustomizableEmailTypes {
    Registration = 0,
    Report = 1,
    Reminder = 2,
    RegistrationCustomTitle = 3,
    ReportCustomTitle = 4,
    ReminderCustomTitle = 5,
    RegistrationCustomEmail = 6,
    ReportCustomEmail = 7,
    ReminderCustomEmail = 8,
    LmsReminder = 9,
    LmsReminderCustomTitle = 10,
    LmsReminderCustomEmail = 11,
    LmsCertificateReminder = 12,
    LmsCertificateReminderCustomTitle = 13,
    LmsCertificateReminderCustomEmail = 14,
    LmsVerificationCodeReminder = 15,
    LmsVerificationCodeReminderCustomTitle = 16,
    LmsVerificationCodeReminderCustomEmail = 17,
}

export class PaginatedListOfAssessmentDto2 implements IPaginatedListOfAssessmentDto2 {
    items?: AssessmentDto2[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfAssessmentDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AssessmentDto2.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfAssessmentDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfAssessmentDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfAssessmentDto2 {
    items?: AssessmentDto2[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class AssessmentDto2 extends AuditableEntity implements IAssessmentDto2 {
    clientUserId?: string | undefined;
    clientGroupAssessmentTemplateId?: number;
    name?: string | undefined;
    clientUserUserName?: string | undefined;
    clientUserEmail?: string | undefined;
    clientUserClientGroupName?: string | undefined;
    clientUser?: ClientUserBriefDto | undefined;
    progress?: number;
    id?: number;
    completedOn?: Date | undefined;
    assessmentTemplateId?: number | undefined;
    assessmentTemplateAlias?: string | undefined;
    isSuccessGenerateBefore?: boolean;

    constructor(data?: IAssessmentDto2) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.clientUserId = _data["clientUserId"];
            this.clientGroupAssessmentTemplateId = _data["clientGroupAssessmentTemplateId"];
            this.name = _data["name"];
            this.clientUserUserName = _data["clientUserUserName"];
            this.clientUserEmail = _data["clientUserEmail"];
            this.clientUserClientGroupName = _data["clientUserClientGroupName"];
            this.clientUser = _data["clientUser"] ? ClientUserBriefDto.fromJS(_data["clientUser"]) : <any>undefined;
            this.progress = _data["progress"];
            this.id = _data["id"];
            this.completedOn = _data["completedOn"] ? new Date(_data["completedOn"].toString()) : <any>undefined;
            this.assessmentTemplateId = _data["assessmentTemplateId"];
            this.assessmentTemplateAlias = _data["assessmentTemplateAlias"];
            this.isSuccessGenerateBefore = _data["isSuccessGenerateBefore"];
        }
    }

    static fromJS(data: any): AssessmentDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientUserId"] = this.clientUserId;
        data["clientGroupAssessmentTemplateId"] = this.clientGroupAssessmentTemplateId;
        data["name"] = this.name;
        data["clientUserUserName"] = this.clientUserUserName;
        data["clientUserEmail"] = this.clientUserEmail;
        data["clientUserClientGroupName"] = this.clientUserClientGroupName;
        data["clientUser"] = this.clientUser ? this.clientUser.toJSON() : <any>undefined;
        data["progress"] = this.progress;
        data["id"] = this.id;
        data["completedOn"] = this.completedOn ? this.completedOn.toISOString() : <any>undefined;
        data["assessmentTemplateId"] = this.assessmentTemplateId;
        data["assessmentTemplateAlias"] = this.assessmentTemplateAlias;
        data["isSuccessGenerateBefore"] = this.isSuccessGenerateBefore;
        super.toJSON(data);
        return data;
    }
}

export interface IAssessmentDto2 extends IAuditableEntity {
    clientUserId?: string | undefined;
    clientGroupAssessmentTemplateId?: number;
    name?: string | undefined;
    clientUserUserName?: string | undefined;
    clientUserEmail?: string | undefined;
    clientUserClientGroupName?: string | undefined;
    clientUser?: ClientUserBriefDto | undefined;
    progress?: number;
    id?: number;
    completedOn?: Date | undefined;
    assessmentTemplateId?: number | undefined;
    assessmentTemplateAlias?: string | undefined;
    isSuccessGenerateBefore?: boolean;
}

export class PaginatedListOfClientBriefDto implements IPaginatedListOfClientBriefDto {
    items?: ClientBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfClientBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ClientBriefDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfClientBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfClientBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfClientBriefDto {
    items?: ClientBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class CreateClientCommand implements ICreateClientCommand {
    name?: string;
    userNamePrefix?: string;

    constructor(data?: ICreateClientCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.userNamePrefix = _data["userNamePrefix"];
        }
    }

    static fromJS(data: any): CreateClientCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClientCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["userNamePrefix"] = this.userNamePrefix;
        return data;
    }
}

export interface ICreateClientCommand {
    name?: string;
    userNamePrefix?: string;
}

export class UpdateClientCommand implements IUpdateClientCommand {
    id?: number;
    name?: string;
    userNamePrefix?: string;

    constructor(data?: IUpdateClientCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.userNamePrefix = _data["userNamePrefix"];
        }
    }

    static fromJS(data: any): UpdateClientCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClientCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["userNamePrefix"] = this.userNamePrefix;
        return data;
    }
}

export interface IUpdateClientCommand {
    id?: number;
    name?: string;
    userNamePrefix?: string;
}

export class ClientUserAssessmentDto extends AuditableEntity implements IClientUserAssessmentDto {
    id?: number;
    clientGroupAssessmentTemplateId?: number;
    progress?: number;
    completedOn?: Date | undefined;
    isAnswered?: boolean;

    constructor(data?: IClientUserAssessmentDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.clientGroupAssessmentTemplateId = _data["clientGroupAssessmentTemplateId"];
            this.progress = _data["progress"];
            this.completedOn = _data["completedOn"] ? new Date(_data["completedOn"].toString()) : <any>undefined;
            this.isAnswered = _data["isAnswered"];
        }
    }

    static fromJS(data: any): ClientUserAssessmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientUserAssessmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientGroupAssessmentTemplateId"] = this.clientGroupAssessmentTemplateId;
        data["progress"] = this.progress;
        data["completedOn"] = this.completedOn ? this.completedOn.toISOString() : <any>undefined;
        data["isAnswered"] = this.isAnswered;
        super.toJSON(data);
        return data;
    }
}

export interface IClientUserAssessmentDto extends IAuditableEntity {
    id?: number;
    clientGroupAssessmentTemplateId?: number;
    progress?: number;
    completedOn?: Date | undefined;
    isAnswered?: boolean;
}

export class ClientUserAssessmentFormDto implements IClientUserAssessmentFormDto {
    id?: number;
    form?: ClientUserFormDto;
    formId?: number;
    pageCount?: number;
    order?: number;

    constructor(data?: IClientUserAssessmentFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.form = _data["form"] ? ClientUserFormDto.fromJS(_data["form"]) : <any>undefined;
            this.formId = _data["formId"];
            this.pageCount = _data["pageCount"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): ClientUserAssessmentFormDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientUserAssessmentFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["form"] = this.form ? this.form.toJSON() : <any>undefined;
        data["formId"] = this.formId;
        data["pageCount"] = this.pageCount;
        data["order"] = this.order;
        return data;
    }
}

export interface IClientUserAssessmentFormDto {
    id?: number;
    form?: ClientUserFormDto;
    formId?: number;
    pageCount?: number;
    order?: number;
}

export class ClientUserFormDto implements IClientUserFormDto {
    header?: string | undefined;
    footer?: string | undefined;
    type?: FormType;
    ratingScale?: ClientUserRatingScaleDto;

    constructor(data?: IClientUserFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.header = _data["header"];
            this.footer = _data["footer"];
            this.type = _data["type"];
            this.ratingScale = _data["ratingScale"] ? ClientUserRatingScaleDto.fromJS(_data["ratingScale"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ClientUserFormDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientUserFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["header"] = this.header;
        data["footer"] = this.footer;
        data["type"] = this.type;
        data["ratingScale"] = this.ratingScale ? this.ratingScale.toJSON() : <any>undefined;
        return data;
    }
}

export interface IClientUserFormDto {
    header?: string | undefined;
    footer?: string | undefined;
    type?: FormType;
    ratingScale?: ClientUserRatingScaleDto;
}

export class ClientUserRatingScaleDto implements IClientUserRatingScaleDto {
    id?: number;
    pointOfScale?: number;
    ratingScalePoints?: ClientUserRatingScalePointDto[];

    constructor(data?: IClientUserRatingScaleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pointOfScale = _data["pointOfScale"];
            if (Array.isArray(_data["ratingScalePoints"])) {
                this.ratingScalePoints = [] as any;
                for (let item of _data["ratingScalePoints"])
                    this.ratingScalePoints!.push(ClientUserRatingScalePointDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClientUserRatingScaleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientUserRatingScaleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pointOfScale"] = this.pointOfScale;
        if (Array.isArray(this.ratingScalePoints)) {
            data["ratingScalePoints"] = [];
            for (let item of this.ratingScalePoints)
                data["ratingScalePoints"].push(item.toJSON());
        }
        return data;
    }
}

export interface IClientUserRatingScaleDto {
    id?: number;
    pointOfScale?: number;
    ratingScalePoints?: ClientUserRatingScalePointDto[];
}

export class ClientUserRatingScalePointDto implements IClientUserRatingScalePointDto {
    id?: number;
    value?: number;
    label?: string | undefined;

    constructor(data?: IClientUserRatingScalePointDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): ClientUserRatingScalePointDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientUserRatingScalePointDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["label"] = this.label;
        return data;
    }
}

export interface IClientUserRatingScalePointDto {
    id?: number;
    value?: number;
    label?: string | undefined;
}

export class ClientUserAssessmentQuestionSlotDto implements IClientUserAssessmentQuestionSlotDto {
    id?: number;
    formQuestion?: ClientUserFormQuestionDto;
    order?: number;
    pageNumber?: number;
    assessmentFormId?: number;
    textAnswer?: string | undefined;
    questionChoiceId?: number | undefined;
    ratingScalePointId?: number | undefined;

    constructor(data?: IClientUserAssessmentQuestionSlotDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.formQuestion = _data["formQuestion"] ? ClientUserFormQuestionDto.fromJS(_data["formQuestion"]) : <any>undefined;
            this.order = _data["order"];
            this.pageNumber = _data["pageNumber"];
            this.assessmentFormId = _data["assessmentFormId"];
            this.textAnswer = _data["textAnswer"];
            this.questionChoiceId = _data["questionChoiceId"];
            this.ratingScalePointId = _data["ratingScalePointId"];
        }
    }

    static fromJS(data: any): ClientUserAssessmentQuestionSlotDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientUserAssessmentQuestionSlotDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["formQuestion"] = this.formQuestion ? this.formQuestion.toJSON() : <any>undefined;
        data["order"] = this.order;
        data["pageNumber"] = this.pageNumber;
        data["assessmentFormId"] = this.assessmentFormId;
        data["textAnswer"] = this.textAnswer;
        data["questionChoiceId"] = this.questionChoiceId;
        data["ratingScalePointId"] = this.ratingScalePointId;
        return data;
    }
}

export interface IClientUserAssessmentQuestionSlotDto {
    id?: number;
    formQuestion?: ClientUserFormQuestionDto;
    order?: number;
    pageNumber?: number;
    assessmentFormId?: number;
    textAnswer?: string | undefined;
    questionChoiceId?: number | undefined;
    ratingScalePointId?: number | undefined;
}

export class ClientUserFormQuestionDto implements IClientUserFormQuestionDto {
    questionContent?: string | undefined;
    isOptional?: boolean;
    questionType?: QuestionType;
    questionQuestionChoiceListId?: number | undefined;

    constructor(data?: IClientUserFormQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionContent = _data["questionContent"];
            this.isOptional = _data["isOptional"];
            this.questionType = _data["questionType"];
            this.questionQuestionChoiceListId = _data["questionQuestionChoiceListId"];
        }
    }

    static fromJS(data: any): ClientUserFormQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientUserFormQuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionContent"] = this.questionContent;
        data["isOptional"] = this.isOptional;
        data["questionType"] = this.questionType;
        data["questionQuestionChoiceListId"] = this.questionQuestionChoiceListId;
        return data;
    }
}

export interface IClientUserFormQuestionDto {
    questionContent?: string | undefined;
    isOptional?: boolean;
    questionType?: QuestionType;
    questionQuestionChoiceListId?: number | undefined;
}

export enum QuestionType {
    Scale = 0,
    Text = 1,
    SingleRadio = 2,
    SingleDropDown = 3,
}

export class UpdateClientUserAssessmentQuestionSlotCommand implements IUpdateClientUserAssessmentQuestionSlotCommand {
    id?: number;
    textAnswer?: string | undefined;
    ratingScalePointId?: number | undefined;
    questionChoiceId?: number | undefined;

    constructor(data?: IUpdateClientUserAssessmentQuestionSlotCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.textAnswer = _data["textAnswer"];
            this.ratingScalePointId = _data["ratingScalePointId"];
            this.questionChoiceId = _data["questionChoiceId"];
        }
    }

    static fromJS(data: any): UpdateClientUserAssessmentQuestionSlotCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClientUserAssessmentQuestionSlotCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["textAnswer"] = this.textAnswer;
        data["ratingScalePointId"] = this.ratingScalePointId;
        data["questionChoiceId"] = this.questionChoiceId;
        return data;
    }
}

export interface IUpdateClientUserAssessmentQuestionSlotCommand {
    id?: number;
    textAnswer?: string | undefined;
    ratingScalePointId?: number | undefined;
    questionChoiceId?: number | undefined;
}

export class ClientUserAssessmentTemplateBriefDto implements IClientUserAssessmentTemplateBriefDto {
    id?: number;
    assessmentTemplateId?: number;
    name?: string | undefined;

    constructor(data?: IClientUserAssessmentTemplateBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assessmentTemplateId = _data["assessmentTemplateId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ClientUserAssessmentTemplateBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientUserAssessmentTemplateBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assessmentTemplateId"] = this.assessmentTemplateId;
        data["name"] = this.name;
        return data;
    }
}

export interface IClientUserAssessmentTemplateBriefDto {
    id?: number;
    assessmentTemplateId?: number;
    name?: string | undefined;
}

export class ClientUserAssessmentTemplateDto implements IClientUserAssessmentTemplateDto {
    id?: number;
    name?: string | undefined;
    introduction?: string | undefined;
    completion?: string | undefined;

    constructor(data?: IClientUserAssessmentTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.introduction = _data["introduction"];
            this.completion = _data["completion"];
        }
    }

    static fromJS(data: any): ClientUserAssessmentTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientUserAssessmentTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["introduction"] = this.introduction;
        data["completion"] = this.completion;
        return data;
    }
}

export interface IClientUserAssessmentTemplateDto {
    id?: number;
    name?: string | undefined;
    introduction?: string | undefined;
    completion?: string | undefined;
}

export class CreateClientUserAssessmentCommand implements ICreateClientUserAssessmentCommand {
    clientGroupAssessmentTemplateId?: number;

    constructor(data?: ICreateClientUserAssessmentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientGroupAssessmentTemplateId = _data["clientGroupAssessmentTemplateId"];
        }
    }

    static fromJS(data: any): CreateClientUserAssessmentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClientUserAssessmentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientGroupAssessmentTemplateId"] = this.clientGroupAssessmentTemplateId;
        return data;
    }
}

export interface ICreateClientUserAssessmentCommand {
    clientGroupAssessmentTemplateId?: number;
}

export class CreateClientUserAssessmentReportCommand implements ICreateClientUserAssessmentReportCommand {
    assessmentId?: number;
    clientGroupReportGenerationSettingId?: number;

    constructor(data?: ICreateClientUserAssessmentReportCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assessmentId = _data["assessmentId"];
            this.clientGroupReportGenerationSettingId = _data["clientGroupReportGenerationSettingId"];
        }
    }

    static fromJS(data: any): CreateClientUserAssessmentReportCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClientUserAssessmentReportCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assessmentId"] = this.assessmentId;
        data["clientGroupReportGenerationSettingId"] = this.clientGroupReportGenerationSettingId;
        return data;
    }
}

export interface ICreateClientUserAssessmentReportCommand {
    assessmentId?: number;
    clientGroupReportGenerationSettingId?: number;
}

export class GetClientUserAssessmentLanguageDto implements IGetClientUserAssessmentLanguageDto {
    clientUserSupportedLanguageId?: string;
    supportedLanguages?: SupportedLanguage[];

    constructor(data?: IGetClientUserAssessmentLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientUserSupportedLanguageId = _data["clientUserSupportedLanguageId"];
            if (Array.isArray(_data["supportedLanguages"])) {
                this.supportedLanguages = [] as any;
                for (let item of _data["supportedLanguages"])
                    this.supportedLanguages!.push(SupportedLanguage.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetClientUserAssessmentLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetClientUserAssessmentLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientUserSupportedLanguageId"] = this.clientUserSupportedLanguageId;
        if (Array.isArray(this.supportedLanguages)) {
            data["supportedLanguages"] = [];
            for (let item of this.supportedLanguages)
                data["supportedLanguages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetClientUserAssessmentLanguageDto {
    clientUserSupportedLanguageId?: string;
    supportedLanguages?: SupportedLanguage[];
}

export class SupportedLanguage extends AuditableEntity implements ISupportedLanguage {
    id?: string | undefined;
    displayName?: string | undefined;
    enable?: boolean;

    constructor(data?: ISupportedLanguage) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.enable = _data["enable"];
        }
    }

    static fromJS(data: any): SupportedLanguage {
        data = typeof data === 'object' ? data : {};
        let result = new SupportedLanguage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["enable"] = this.enable;
        super.toJSON(data);
        return data;
    }
}

export interface ISupportedLanguage extends IAuditableEntity {
    id?: string | undefined;
    displayName?: string | undefined;
    enable?: boolean;
}

export class CreateClientUserCourseModuleStepQuizResultCommand implements ICreateClientUserCourseModuleStepQuizResultCommand {
    clientUserCourseModuleStepId?: number;
    courseQuizExamId?: number;
    answerMatchCourseQuestions?: AnswerMatchCourseQuestionReqDto[];

    constructor(data?: ICreateClientUserCourseModuleStepQuizResultCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientUserCourseModuleStepId = _data["clientUserCourseModuleStepId"];
            this.courseQuizExamId = _data["courseQuizExamId"];
            if (Array.isArray(_data["answerMatchCourseQuestions"])) {
                this.answerMatchCourseQuestions = [] as any;
                for (let item of _data["answerMatchCourseQuestions"])
                    this.answerMatchCourseQuestions!.push(AnswerMatchCourseQuestionReqDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateClientUserCourseModuleStepQuizResultCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClientUserCourseModuleStepQuizResultCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientUserCourseModuleStepId"] = this.clientUserCourseModuleStepId;
        data["courseQuizExamId"] = this.courseQuizExamId;
        if (Array.isArray(this.answerMatchCourseQuestions)) {
            data["answerMatchCourseQuestions"] = [];
            for (let item of this.answerMatchCourseQuestions)
                data["answerMatchCourseQuestions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateClientUserCourseModuleStepQuizResultCommand {
    clientUserCourseModuleStepId?: number;
    courseQuizExamId?: number;
    answerMatchCourseQuestions?: AnswerMatchCourseQuestionReqDto[];
}

export class AnswerMatchCourseQuestionReqDto implements IAnswerMatchCourseQuestionReqDto {
    courseQuestionId?: number;
    courseQuestionBankId?: number;
    openEndedAnswer?: string | undefined;
    choiceAnswers?: number[];

    constructor(data?: IAnswerMatchCourseQuestionReqDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseQuestionId = _data["courseQuestionId"];
            this.courseQuestionBankId = _data["courseQuestionBankId"];
            this.openEndedAnswer = _data["openEndedAnswer"];
            if (Array.isArray(_data["choiceAnswers"])) {
                this.choiceAnswers = [] as any;
                for (let item of _data["choiceAnswers"])
                    this.choiceAnswers!.push(item);
            }
        }
    }

    static fromJS(data: any): AnswerMatchCourseQuestionReqDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnswerMatchCourseQuestionReqDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseQuestionId"] = this.courseQuestionId;
        data["courseQuestionBankId"] = this.courseQuestionBankId;
        data["openEndedAnswer"] = this.openEndedAnswer;
        if (Array.isArray(this.choiceAnswers)) {
            data["choiceAnswers"] = [];
            for (let item of this.choiceAnswers)
                data["choiceAnswers"].push(item);
        }
        return data;
    }
}

export interface IAnswerMatchCourseQuestionReqDto {
    courseQuestionId?: number;
    courseQuestionBankId?: number;
    openEndedAnswer?: string | undefined;
    choiceAnswers?: number[];
}

export class ClientUserCourseModuleStepDto extends AuditableEntity implements IClientUserCourseModuleStepDto {
    id?: number;
    clientUserCourseModuleId?: number;
    courseGroupModuleStepId?: number;
    courseModuleStepType?: CourseModuleStepType;
    courseModuleStepItemId?: number;
    hasMaterial?: boolean;
    stepName?: string | undefined;
    description?: string | undefined;
    aliVodVideo?: AliVodVideoDto2 | undefined;
    retakes?: number;
    retakesAllowed?: number | undefined;
    courseGroupMessage?: CourseGroupMessageDto | undefined;
    clientGroupAssessmentTemplateId?: number | undefined;
    assessmentId?: number | undefined;
    assessment?: ClientUserAssessmentDto | undefined;
    completionText?: string | undefined;
    sortOrder?: number;
    completedAt?: Date | undefined;
    isCompleted?: boolean;
    clientUserCourseModuleStepQuizResults?: ClientUserCourseModuleStepQuizResultDto[];

    constructor(data?: IClientUserCourseModuleStepDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.clientUserCourseModuleId = _data["clientUserCourseModuleId"];
            this.courseGroupModuleStepId = _data["courseGroupModuleStepId"];
            this.courseModuleStepType = _data["courseModuleStepType"];
            this.courseModuleStepItemId = _data["courseModuleStepItemId"];
            this.hasMaterial = _data["hasMaterial"];
            this.stepName = _data["stepName"];
            this.description = _data["description"];
            this.aliVodVideo = _data["aliVodVideo"] ? AliVodVideoDto2.fromJS(_data["aliVodVideo"]) : <any>undefined;
            this.retakes = _data["retakes"];
            this.retakesAllowed = _data["retakesAllowed"];
            this.courseGroupMessage = _data["courseGroupMessage"] ? CourseGroupMessageDto.fromJS(_data["courseGroupMessage"]) : <any>undefined;
            this.clientGroupAssessmentTemplateId = _data["clientGroupAssessmentTemplateId"];
            this.assessmentId = _data["assessmentId"];
            this.assessment = _data["assessment"] ? ClientUserAssessmentDto.fromJS(_data["assessment"]) : <any>undefined;
            this.completionText = _data["completionText"];
            this.sortOrder = _data["sortOrder"];
            this.completedAt = _data["completedAt"] ? new Date(_data["completedAt"].toString()) : <any>undefined;
            this.isCompleted = _data["isCompleted"];
            if (Array.isArray(_data["clientUserCourseModuleStepQuizResults"])) {
                this.clientUserCourseModuleStepQuizResults = [] as any;
                for (let item of _data["clientUserCourseModuleStepQuizResults"])
                    this.clientUserCourseModuleStepQuizResults!.push(ClientUserCourseModuleStepQuizResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClientUserCourseModuleStepDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientUserCourseModuleStepDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientUserCourseModuleId"] = this.clientUserCourseModuleId;
        data["courseGroupModuleStepId"] = this.courseGroupModuleStepId;
        data["courseModuleStepType"] = this.courseModuleStepType;
        data["courseModuleStepItemId"] = this.courseModuleStepItemId;
        data["hasMaterial"] = this.hasMaterial;
        data["stepName"] = this.stepName;
        data["description"] = this.description;
        data["aliVodVideo"] = this.aliVodVideo ? this.aliVodVideo.toJSON() : <any>undefined;
        data["retakes"] = this.retakes;
        data["retakesAllowed"] = this.retakesAllowed;
        data["courseGroupMessage"] = this.courseGroupMessage ? this.courseGroupMessage.toJSON() : <any>undefined;
        data["clientGroupAssessmentTemplateId"] = this.clientGroupAssessmentTemplateId;
        data["assessmentId"] = this.assessmentId;
        data["assessment"] = this.assessment ? this.assessment.toJSON() : <any>undefined;
        data["completionText"] = this.completionText;
        data["sortOrder"] = this.sortOrder;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : <any>undefined;
        data["isCompleted"] = this.isCompleted;
        if (Array.isArray(this.clientUserCourseModuleStepQuizResults)) {
            data["clientUserCourseModuleStepQuizResults"] = [];
            for (let item of this.clientUserCourseModuleStepQuizResults)
                data["clientUserCourseModuleStepQuizResults"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IClientUserCourseModuleStepDto extends IAuditableEntity {
    id?: number;
    clientUserCourseModuleId?: number;
    courseGroupModuleStepId?: number;
    courseModuleStepType?: CourseModuleStepType;
    courseModuleStepItemId?: number;
    hasMaterial?: boolean;
    stepName?: string | undefined;
    description?: string | undefined;
    aliVodVideo?: AliVodVideoDto2 | undefined;
    retakes?: number;
    retakesAllowed?: number | undefined;
    courseGroupMessage?: CourseGroupMessageDto | undefined;
    clientGroupAssessmentTemplateId?: number | undefined;
    assessmentId?: number | undefined;
    assessment?: ClientUserAssessmentDto | undefined;
    completionText?: string | undefined;
    sortOrder?: number;
    completedAt?: Date | undefined;
    isCompleted?: boolean;
    clientUserCourseModuleStepQuizResults?: ClientUserCourseModuleStepQuizResultDto[];
}

export enum CourseModuleStepType {
    ImageFileTextLink = 0,
    Video = 1,
    QuizExam = 2,
    CALAssessmentPlatform = 3,
}

export class AliVodVideoDto2 extends AuditableEntity implements IAliVodVideoDto2 {
    id?: number;
    videoId?: string;
    fileName?: string | undefined;
    size?: number | undefined;
    width?: number | undefined;
    height?: number | undefined;
    coverURL?: string | undefined;
    playURL?: string | undefined;
    format?: string | undefined;

    constructor(data?: IAliVodVideoDto2) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.videoId = _data["videoId"];
            this.fileName = _data["fileName"];
            this.size = _data["size"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.coverURL = _data["coverURL"];
            this.playURL = _data["playURL"];
            this.format = _data["format"];
        }
    }

    static fromJS(data: any): AliVodVideoDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new AliVodVideoDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["videoId"] = this.videoId;
        data["fileName"] = this.fileName;
        data["size"] = this.size;
        data["width"] = this.width;
        data["height"] = this.height;
        data["coverURL"] = this.coverURL;
        data["playURL"] = this.playURL;
        data["format"] = this.format;
        super.toJSON(data);
        return data;
    }
}

export interface IAliVodVideoDto2 extends IAuditableEntity {
    id?: number;
    videoId?: string;
    fileName?: string | undefined;
    size?: number | undefined;
    width?: number | undefined;
    height?: number | undefined;
    coverURL?: string | undefined;
    playURL?: string | undefined;
    format?: string | undefined;
}

export class CourseGroupMessageDto implements ICourseGroupMessageDto {
    id?: number;
    supportedLanguageId?: string;
    passMsg?: string | undefined;
    failHasChanceMsg?: string | undefined;
    failNoChanceMsg?: string | undefined;

    constructor(data?: ICourseGroupMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.supportedLanguageId = _data["supportedLanguageId"];
            this.passMsg = _data["passMsg"];
            this.failHasChanceMsg = _data["failHasChanceMsg"];
            this.failNoChanceMsg = _data["failNoChanceMsg"];
        }
    }

    static fromJS(data: any): CourseGroupMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseGroupMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["supportedLanguageId"] = this.supportedLanguageId;
        data["passMsg"] = this.passMsg;
        data["failHasChanceMsg"] = this.failHasChanceMsg;
        data["failNoChanceMsg"] = this.failNoChanceMsg;
        return data;
    }
}

export interface ICourseGroupMessageDto {
    id?: number;
    supportedLanguageId?: string;
    passMsg?: string | undefined;
    failHasChanceMsg?: string | undefined;
    failNoChanceMsg?: string | undefined;
}

export class ClientUserCourseModuleStepQuizResultDto extends AuditableEntity implements IClientUserCourseModuleStepQuizResultDto {
    id?: number;
    clientUserCourseModuleStepId?: number;
    attemptNumber?: number;
    score?: number;
    passingScore?: number;
    isPassed?: boolean;
    isDeleted?: boolean;

    constructor(data?: IClientUserCourseModuleStepQuizResultDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.clientUserCourseModuleStepId = _data["clientUserCourseModuleStepId"];
            this.attemptNumber = _data["attemptNumber"];
            this.score = _data["score"];
            this.passingScore = _data["passingScore"];
            this.isPassed = _data["isPassed"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ClientUserCourseModuleStepQuizResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientUserCourseModuleStepQuizResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientUserCourseModuleStepId"] = this.clientUserCourseModuleStepId;
        data["attemptNumber"] = this.attemptNumber;
        data["score"] = this.score;
        data["passingScore"] = this.passingScore;
        data["isPassed"] = this.isPassed;
        data["isDeleted"] = this.isDeleted;
        super.toJSON(data);
        return data;
    }
}

export interface IClientUserCourseModuleStepQuizResultDto extends IAuditableEntity {
    id?: number;
    clientUserCourseModuleStepId?: number;
    attemptNumber?: number;
    score?: number;
    passingScore?: number;
    isPassed?: boolean;
    isDeleted?: boolean;
}

export class ClientUserCourseDto extends AuditableEntity implements IClientUserCourseDto {
    id?: number;
    courseGroupSettingId?: number;
    courseGroupSettingStatus?: CourseGroupSettingStatus;
    status?: ClientUserCourseStatus;
    isSequential?: boolean;
    progress?: number;
    finalScore?: number;
    score?: number;
    quizExamTotalScore?: number;
    isPassed?: boolean;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    durationDays?: number | undefined;
    currentLanguageId?: string | undefined;
    languageIds?: string[];
    isAllowDownloadQuizExam?: boolean | undefined;
    courseName?: string | undefined;
    description?: string | undefined;
    coverImageMediaLibraryId?: number | undefined;
    clientUserId?: string;
    lastSeenDate?: Date | undefined;
    firstClickDate?: Date | undefined;
    syncedStructureVersion?: number | undefined;
    notes?: string;
    reportAutoSendSetting?: ReportAutoSendSetting;
    isDeleted?: boolean;
    supportedLanguages?: ClientUserCourseLanguageDto[];
    clientUserCourseModules?: ClientUserCourseModuleBriefDto[];

    constructor(data?: IClientUserCourseDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.courseGroupSettingId = _data["courseGroupSettingId"];
            this.courseGroupSettingStatus = _data["courseGroupSettingStatus"];
            this.status = _data["status"];
            this.isSequential = _data["isSequential"];
            this.progress = _data["progress"];
            this.finalScore = _data["finalScore"];
            this.score = _data["score"];
            this.quizExamTotalScore = _data["quizExamTotalScore"];
            this.isPassed = _data["isPassed"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.durationDays = _data["durationDays"];
            this.currentLanguageId = _data["currentLanguageId"];
            if (Array.isArray(_data["languageIds"])) {
                this.languageIds = [] as any;
                for (let item of _data["languageIds"])
                    this.languageIds!.push(item);
            }
            this.isAllowDownloadQuizExam = _data["isAllowDownloadQuizExam"];
            this.courseName = _data["courseName"];
            this.description = _data["description"];
            this.coverImageMediaLibraryId = _data["coverImageMediaLibraryId"];
            this.clientUserId = _data["clientUserId"];
            this.lastSeenDate = _data["lastSeenDate"] ? new Date(_data["lastSeenDate"].toString()) : <any>undefined;
            this.firstClickDate = _data["firstClickDate"] ? new Date(_data["firstClickDate"].toString()) : <any>undefined;
            this.syncedStructureVersion = _data["syncedStructureVersion"];
            this.notes = _data["notes"];
            this.reportAutoSendSetting = _data["reportAutoSendSetting"];
            this.isDeleted = _data["isDeleted"];
            if (Array.isArray(_data["supportedLanguages"])) {
                this.supportedLanguages = [] as any;
                for (let item of _data["supportedLanguages"])
                    this.supportedLanguages!.push(ClientUserCourseLanguageDto.fromJS(item));
            }
            if (Array.isArray(_data["clientUserCourseModules"])) {
                this.clientUserCourseModules = [] as any;
                for (let item of _data["clientUserCourseModules"])
                    this.clientUserCourseModules!.push(ClientUserCourseModuleBriefDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClientUserCourseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientUserCourseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["courseGroupSettingId"] = this.courseGroupSettingId;
        data["courseGroupSettingStatus"] = this.courseGroupSettingStatus;
        data["status"] = this.status;
        data["isSequential"] = this.isSequential;
        data["progress"] = this.progress;
        data["finalScore"] = this.finalScore;
        data["score"] = this.score;
        data["quizExamTotalScore"] = this.quizExamTotalScore;
        data["isPassed"] = this.isPassed;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["durationDays"] = this.durationDays;
        data["currentLanguageId"] = this.currentLanguageId;
        if (Array.isArray(this.languageIds)) {
            data["languageIds"] = [];
            for (let item of this.languageIds)
                data["languageIds"].push(item);
        }
        data["isAllowDownloadQuizExam"] = this.isAllowDownloadQuizExam;
        data["courseName"] = this.courseName;
        data["description"] = this.description;
        data["coverImageMediaLibraryId"] = this.coverImageMediaLibraryId;
        data["clientUserId"] = this.clientUserId;
        data["lastSeenDate"] = this.lastSeenDate ? this.lastSeenDate.toISOString() : <any>undefined;
        data["firstClickDate"] = this.firstClickDate ? this.firstClickDate.toISOString() : <any>undefined;
        data["syncedStructureVersion"] = this.syncedStructureVersion;
        data["notes"] = this.notes;
        data["reportAutoSendSetting"] = this.reportAutoSendSetting;
        data["isDeleted"] = this.isDeleted;
        if (Array.isArray(this.supportedLanguages)) {
            data["supportedLanguages"] = [];
            for (let item of this.supportedLanguages)
                data["supportedLanguages"].push(item.toJSON());
        }
        if (Array.isArray(this.clientUserCourseModules)) {
            data["clientUserCourseModules"] = [];
            for (let item of this.clientUserCourseModules)
                data["clientUserCourseModules"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IClientUserCourseDto extends IAuditableEntity {
    id?: number;
    courseGroupSettingId?: number;
    courseGroupSettingStatus?: CourseGroupSettingStatus;
    status?: ClientUserCourseStatus;
    isSequential?: boolean;
    progress?: number;
    finalScore?: number;
    score?: number;
    quizExamTotalScore?: number;
    isPassed?: boolean;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    durationDays?: number | undefined;
    currentLanguageId?: string | undefined;
    languageIds?: string[];
    isAllowDownloadQuizExam?: boolean | undefined;
    courseName?: string | undefined;
    description?: string | undefined;
    coverImageMediaLibraryId?: number | undefined;
    clientUserId?: string;
    lastSeenDate?: Date | undefined;
    firstClickDate?: Date | undefined;
    syncedStructureVersion?: number | undefined;
    notes?: string;
    reportAutoSendSetting?: ReportAutoSendSetting;
    isDeleted?: boolean;
    supportedLanguages?: ClientUserCourseLanguageDto[];
    clientUserCourseModules?: ClientUserCourseModuleBriefDto[];
}

export enum CourseGroupSettingStatus {
    NotStarted = 0,
    InProgress = 1,
    Expired = 2,
}

export enum ClientUserCourseStatus {
    NotCompleted = 0,
    Completed = 1,
    Passed = 2,
}

export class ClientUserCourseLanguageDto implements IClientUserCourseLanguageDto {
    id?: string | undefined;
    displayName?: string | undefined;

    constructor(data?: IClientUserCourseLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): ClientUserCourseLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientUserCourseLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IClientUserCourseLanguageDto {
    id?: string | undefined;
    displayName?: string | undefined;
}

export class ClientUserCourseModuleBriefDto extends AuditableEntity implements IClientUserCourseModuleBriefDto {
    id?: number;
    clientUserCourseId?: number;
    courseModuleId?: number;
    moduleName?: string | undefined;
    sortOrder?: number;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    durationDays?: number | undefined;
    lastSeenDate?: Date | undefined;
    firstClickDate?: Date | undefined;
    clientUserCourseModuleSteps?: ClientUserCourseModuleStepBriefDto[];

    constructor(data?: IClientUserCourseModuleBriefDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.clientUserCourseId = _data["clientUserCourseId"];
            this.courseModuleId = _data["courseModuleId"];
            this.moduleName = _data["moduleName"];
            this.sortOrder = _data["sortOrder"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.durationDays = _data["durationDays"];
            this.lastSeenDate = _data["lastSeenDate"] ? new Date(_data["lastSeenDate"].toString()) : <any>undefined;
            this.firstClickDate = _data["firstClickDate"] ? new Date(_data["firstClickDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["clientUserCourseModuleSteps"])) {
                this.clientUserCourseModuleSteps = [] as any;
                for (let item of _data["clientUserCourseModuleSteps"])
                    this.clientUserCourseModuleSteps!.push(ClientUserCourseModuleStepBriefDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClientUserCourseModuleBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientUserCourseModuleBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientUserCourseId"] = this.clientUserCourseId;
        data["courseModuleId"] = this.courseModuleId;
        data["moduleName"] = this.moduleName;
        data["sortOrder"] = this.sortOrder;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["durationDays"] = this.durationDays;
        data["lastSeenDate"] = this.lastSeenDate ? this.lastSeenDate.toISOString() : <any>undefined;
        data["firstClickDate"] = this.firstClickDate ? this.firstClickDate.toISOString() : <any>undefined;
        if (Array.isArray(this.clientUserCourseModuleSteps)) {
            data["clientUserCourseModuleSteps"] = [];
            for (let item of this.clientUserCourseModuleSteps)
                data["clientUserCourseModuleSteps"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IClientUserCourseModuleBriefDto extends IAuditableEntity {
    id?: number;
    clientUserCourseId?: number;
    courseModuleId?: number;
    moduleName?: string | undefined;
    sortOrder?: number;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    durationDays?: number | undefined;
    lastSeenDate?: Date | undefined;
    firstClickDate?: Date | undefined;
    clientUserCourseModuleSteps?: ClientUserCourseModuleStepBriefDto[];
}

export class ClientUserCourseModuleStepBriefDto extends AuditableEntity implements IClientUserCourseModuleStepBriefDto {
    id?: number;
    clientUserCourseModuleId?: number;
    courseGroupModuleStepId?: number;
    courseModuleStepId?: number;
    courseModuleStepItemId?: number;
    hasMaterial?: boolean;
    assessmentId?: number | undefined;
    courseModuleStepType?: CourseModuleStepType;
    stepName?: string | undefined;
    sortOrder?: number;
    isCompleted?: boolean;
    isNextStep?: boolean;
    completedAt?: Date | undefined;

    constructor(data?: IClientUserCourseModuleStepBriefDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.clientUserCourseModuleId = _data["clientUserCourseModuleId"];
            this.courseGroupModuleStepId = _data["courseGroupModuleStepId"];
            this.courseModuleStepId = _data["courseModuleStepId"];
            this.courseModuleStepItemId = _data["courseModuleStepItemId"];
            this.hasMaterial = _data["hasMaterial"];
            this.assessmentId = _data["assessmentId"];
            this.courseModuleStepType = _data["courseModuleStepType"];
            this.stepName = _data["stepName"];
            this.sortOrder = _data["sortOrder"];
            this.isCompleted = _data["isCompleted"];
            this.isNextStep = _data["isNextStep"];
            this.completedAt = _data["completedAt"] ? new Date(_data["completedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ClientUserCourseModuleStepBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientUserCourseModuleStepBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientUserCourseModuleId"] = this.clientUserCourseModuleId;
        data["courseGroupModuleStepId"] = this.courseGroupModuleStepId;
        data["courseModuleStepId"] = this.courseModuleStepId;
        data["courseModuleStepItemId"] = this.courseModuleStepItemId;
        data["hasMaterial"] = this.hasMaterial;
        data["assessmentId"] = this.assessmentId;
        data["courseModuleStepType"] = this.courseModuleStepType;
        data["stepName"] = this.stepName;
        data["sortOrder"] = this.sortOrder;
        data["isCompleted"] = this.isCompleted;
        data["isNextStep"] = this.isNextStep;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IClientUserCourseModuleStepBriefDto extends IAuditableEntity {
    id?: number;
    clientUserCourseModuleId?: number;
    courseGroupModuleStepId?: number;
    courseModuleStepId?: number;
    courseModuleStepItemId?: number;
    hasMaterial?: boolean;
    assessmentId?: number | undefined;
    courseModuleStepType?: CourseModuleStepType;
    stepName?: string | undefined;
    sortOrder?: number;
    isCompleted?: boolean;
    isNextStep?: boolean;
    completedAt?: Date | undefined;
}

export class CreateClientUserCourseCommand implements ICreateClientUserCourseCommand {
    courseGroupSettingId?: number;

    constructor(data?: ICreateClientUserCourseCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseGroupSettingId = _data["courseGroupSettingId"];
        }
    }

    static fromJS(data: any): CreateClientUserCourseCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClientUserCourseCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseGroupSettingId"] = this.courseGroupSettingId;
        return data;
    }
}

export interface ICreateClientUserCourseCommand {
    courseGroupSettingId?: number;
}

export class UpdateClientUserCourseCommand implements IUpdateClientUserCourseCommand {
    id?: number;
    notes?: string;

    constructor(data?: IUpdateClientUserCourseCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpdateClientUserCourseCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClientUserCourseCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IUpdateClientUserCourseCommand {
    id?: number;
    notes?: string;
}

export class ChangeClientUserCourseCurrentLanguageCommand implements IChangeClientUserCourseCurrentLanguageCommand {
    id?: number;
    currentLanguageId?: string;

    constructor(data?: IChangeClientUserCourseCurrentLanguageCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.currentLanguageId = _data["currentLanguageId"];
        }
    }

    static fromJS(data: any): ChangeClientUserCourseCurrentLanguageCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeClientUserCourseCurrentLanguageCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["currentLanguageId"] = this.currentLanguageId;
        return data;
    }
}

export interface IChangeClientUserCourseCurrentLanguageCommand {
    id?: number;
    currentLanguageId?: string;
}

export enum InternationalizationKey {
    LoginPageTitle = 0,
    LoginButton = 1,
    LoginInputLabel = 2,
    LoginPasswordInputLabel = 3,
    LoginForgotPassword = 4,
    LoginForgotPasswordButton = 5,
    LoginUsernameRequired = 6,
    LoginPasswordRequired = 7,
    UserLockedOutError = 8,
    UserInvalidLoginError = 9,
    HeaderSystemTitle = 10,
    HeaderGreeting = 11,
    HeaderLogout = 12,
    FooterTrademark = 13,
    HelpboxTitle = 14,
    HelpboxMessage = 15,
    AssessmentListTitle = 16,
    AssessmentListAssessment = 17,
    AssessmentListStartDate = 18,
    AssessmentListProgress = 19,
    AssessmentListCompletionDate = 20,
    AssessmentListNoInformation = 21,
    AssessmentAgreeAndStartButton = 22,
    AssessmentNextPageButton = 23,
    AssessmentPreviousPageButton = 24,
    AssessmentSubmitButton = 25,
    AssessmentBackToMyAssessmentButton = 26,
    ProfileSubmit = 27,
    ProfileTitle = 28,
    ProfileFullName = 29,
    ProfileEmail = 30,
    ProfilePreferredLanguage = 31,
    ProfileCurrentPassword = 32,
    ProfileNewPassword = 33,
    ProfileConfirmPassword = 34,
    ProfileConfirmPasswordWarning = 35,
    ProfileRequiredWarning = 36,
    ProfileEmailTypeWarning = 37,
    ProfilePatternWarning = 38,
    SigningIn = 39,
    LoggingOut = 40,
    ChangePassword = 41,
    DefaultRegistrationEmailSubject = 42,
    DefaultRegistrationEmailTemplate = 43,
    DefaultReminderEmailTemplate = 44,
    DefaultLMSReminderEmailTemplate = 45,
    DefaultReportEmailSubject = 46,
    DefaultReportEmailTemplate = 47,
    AdministratorRegistrationEmailSubject = 48,
    AdministratorRegistrationEmailTemplate = 49,
    ForgotPasswordEmailSubject = 50,
    ForgotPasswordEmailTemplate = 51,
    ForgetPasswordConfirmationTitle = 52,
    ForgetPasswordConfirmationMessage = 53,
    ResetPasswordConfirmationTitle = 54,
    ResetPasswordConfirmationMessage = 55,
    ResetPasswordTitle = 56,
    DefaultReminderEmailSubject = 57,
    DefaultLMSReminderEmailSubject = 58,
    RegistrationPeriodHeader = 59,
    RegistrationPeriodSubmitButton = 60,
    RegistrationPeriodEmail = 61,
    RegistrationPeriodEmailTypeWarning = 62,
    RegistrationPeriodEmailRequiredWarning = 63,
    RegistrationPeriodPopupHeader = 64,
    RegistrationPeriodPopupSubHeader = 65,
    RegistrationPeriodPopupContent = 66,
    RegistrationPeriodPopupProceedButton = 67,
    StaticDeleteButton = 68,
    StaticCreateButton = 69,
    QuestionCategoryStaticAliasLabel = 70,
    QuestionCategoryContentAddAliasButton = 71,
    ClientClientContentUploadButton = 72,
    TemplateTemplateContentAddAliasButton = 73,
    ClientUserClientUserContentUploadButton = 74,
    ClientUserClientUserContentDownloadButton = 75,
    ClientClientContentDownloadButton = 76,
    FormQuestionContentDownloadButton = 77,
    FormQuestionContentUploadButton = 78,
    TemplateTemplateModalAliasLabel = 79,
    FormFormContentUploadDescButton = 80,
    ClientGroupClientGroupContentUploadButton = 81,
    FormFormContentDownloadDescButton = 82,
    ClientGroupClientGroupContentDownloadButton = 83,
    FormFormContentDownloadButton = 84,
    ClientGroupClientGroupContentUploadTemplateButton = 85,
    ClientGroupClientGroupContentUploadSettingButton = 86,
    ClientGroupClientGroupContentDownloadTemplateButton = 87,
    FormFormContentUploadButton = 88,
    ClientGroupClientUserContentDownloadButton = 89,
    ClientGroupClientGroupContentDownloadSettingButton = 90,
    ClientGroupGroupSettingLogoUploadButton = 91,
    QuestionChoiceContentUploadButton = 92,
    ClientGroupClientUserContentUploadButton = 93,
    QuestionChoiceContentUploadContentButton = 94,
    QuestionChoiceContentDownloadButton = 95,
    QuestionChoiceContentDownloadContentButton = 96,
    QuestionChoiceListContentUploadButton = 97,
    QuestionFacetDimensionContentUploadButton = 98,
    QuestionFacetDimensionContentDownloadButton = 99,
    QuestionQuestionContentUploadButton = 100,
    QuestionQuestionContentDownloadButton = 101,
    QuestionQuestionContentUploadContentButton = 102,
    QuestionQuestionContentDownloadContentButton = 103,
    QuestionQuestionContentUploadRelationshipButton = 104,
    QuestionQuestionContentDownloadRelationshipButton = 105,
    TemplateFormContentUploadButton = 106,
    TemplateFormContentDownloadButton = 107,
    TemplateTemplateContentUploadButton = 108,
    TemplateTemplateContentDownloadButton = 109,
    TemplateTemplateContentUploadDescButton = 110,
    TemplateTemplateContentDownloadDescButton = 111,
    ReportNormTableContentUploadButton = 112,
    ReportNormTableContentDownloadButton = 113,
    ReportNormTableContentUploadNormButton = 114,
    ReportNormTableContentDownloadNormButton = 115,
    QuestionChoiceListContentDownloadButton = 116,
    ReportScoringKeySetContentUploadKeyButton = 117,
    ReportScoringKeySetContentUploadButton = 118,
    ReportScoringKeySetContentDownloadButton = 119,
    ReportScoringKeySetContentDownloadKeyButton = 120,
    ReportGroupReportTemplateContentUploadButton = 121,
    ReportGroupReportTemplateContentDownloadButton = 122,
    ReportGroupReportTemplateContentDownloadConfigButton = 123,
    ReportGroupReportTemplateContentUploadConfigButton = 124,
    ReportReportTemplateContentDownloadButton = 125,
    ReportReportTemplateContentUploadConfigButton = 126,
    ReportReportTemplateContentUploadButton = 127,
    ReportReportTemplateContentDownloadConfigButton = 128,
    StaticDownloadButton = 129,
    StaticUploadingMessage = 130,
    StaticDeletingMessage = 131,
    StaticUpdatingMessage = 132,
    StaticCreatingMessage = 133,
    StaticSendingMessage = 134,
    StaticLoadingMessage = 135,
    StaticPrepareDownloadMessage = 136,
    StaticPrepareSendMessage = 137,
    StaticUploadSuccessMessage = 138,
    StaticDeleteSuccessMessage = 139,
    StaticCreateSuccessMessage = 140,
    StaticUpdateSuccessMessage = 141,
    StaticSendSuccessMessage = 142,
    StaticLoadSuccessMessage = 143,
    StaticConfirmDeleteMessage = 144,
    StaticConfirmResendMessage = 145,
    StaticConfirmDeactivationMessage = 146,
    StaticNaLabel = 147,
    StaticYesLabel = 148,
    StaticNoLabel = 149,
    StaticSearchLabel = 150,
    StaticUpdateButton = 151,
    StaticSendButton = 152,
    StaticEditButton = 153,
    StaticResetPasswordButton = 154,
    StaticDeactivateButton = 155,
    StaticActivateButton = 156,
    StaticDetailsButton = 157,
    StaticLastModifiedLabel = 158,
    StaticCreatedLabel = 159,
    StaticPasswordLabel = 160,
    StaticConfirmPasswordLabel = 161,
    StaticMissingPasswordRule = 162,
    StaticPreferredLanguageLabel = 163,
    StaticMissingPreferredLanguageRule = 164,
    StaticMissingSelectRule = 165,
    StaticCancelButton = 166,
    StaticContentLabel = 167,
    QuestionCategoryNavigationTitle = 168,
    QuestionChoiceNavigationTitle = 169,
    QuestionChoiceListNavigationTitle = 170,
    QuestionQuestionNavigationTitle = 171,
    QuestionFacetDimensionNavigationTitle = 172,
    FormFormNavigationTitle = 173,
    FormQuestionNavigationTitle = 174,
    ClientClientNavigationTitle = 175,
    ClientGroupClientGroupNavigationTitle = 176,
    ClientGroupAssessmentNavigationTitle = 177,
    ClientGroupRegistrationPeriodNavigationTitle = 178,
    ClientGroupGroupSettingNavigationTitle = 179,
    ClientGroupTemplateNavigationTitle = 180,
    ClientGroupClientUserNavigationTitle = 181,
    ClientGroupClientAdminNavigationTitle = 182,
    ClientUserClientUserNavigationTitle = 183,
    ClientAdminClientAdminNavigationTitle = 184,
    ReportScoringKeySetNavigationTitle = 185,
    ReportNormTableNavigationTitle = 186,
    ReportReportTemplateNavigationTitle = 187,
    ReportGenerationSettingNavigationTitle = 188,
    LanguageLanguageNavigationTitle = 189,
    LanguageTranslationNavigationTitle = 190,
    TemplateTemplateNavigationTitle = 191,
    TemplateFormNavigationTitle = 192,
    AssessmentAssessmentNavigationTitle = 193,
    AdministratorAdministratorNavigationTitle = 194,
    AdministratorTechAdministratorNavigationTitle = 195,
    RegistrationPeriodRegistrationPeriodNavigationTitle = 196,
    SurveySurveyNavigationTitle = 197,
    StaticQuestionTitle = 198,
    StaticTemplateTitle = 199,
    StaticFormTitle = 200,
    StaticClientTitle = 201,
    StaticClientGroupTitle = 202,
    StaticClientUserTitle = 203,
    StaticClientAdminTitle = 204,
    StaticReportTitle = 205,
    StaticAssessmentTitle = 206,
    StaticAdministratorTitle = 207,
    StaticRegistrationPeriodTitle = 208,
    StaticLanguageTitle = 209,
    StaticSurveyTitle = 210,
    StaticBillingInformationTitle = 211,
    ReportGenerationSettingContentDownloadButton = 212,
    LanguageTranslationContentDownloadButton = 213,
    LanguageTranslationContentUploadButton = 214,
    ClientGroupAssessmentContentGenerateGroupReportButton = 215,
    LanguageLanguageContentAddButton = 216,
    SurveySurveyContentAddButton = 217,
    QuestionChoiceListContentAddButton = 218,
    ClientClientContentAddButton = 219,
    ClientGroupClientGroupContentAddButton = 220,
    ClientUserClientUserContentAddButton = 221,
    ClientGroupClientUserContentAddButton = 222,
    ClientGroupClientAdminContentAddButton = 223,
    ClientAdminClientAdminContentAddButton = 224,
    ClientGroupTemplateContentAddButton = 225,
    ReportReportTemplateContentAddButton = 226,
    ReportNormTableContentAddButton = 227,
    RegistrationPeriodRegistrationPeriodContentAddButton = 228,
    AdministratorAdministratorContentAddButton = 229,
    AdministratorTechAdministratorContentAddButton = 230,
    BillingAssessmentSummaryFormTemplatePlaceholder = 231,
    AssessmentAssessmentFormAddEmailButton = 232,
    AssessmentAssessmentFormAddCcButton = 233,
    ClientGroupClientGroupFormAddEmailButton = 234,
    ClientGroupClientGroupFormAddCcButton = 235,
    LanguageLanguageModalAddTitle = 236,
    QuestionCategoryModalAddAliasTitle = 237,
    QuestionChoiceListModalAddTitle = 238,
    TemplateTemplateModalAddAliasTitle = 239,
    AssessmentAssessmentModalGenerateReportTitle = 240,
    AssessmentAssessmentModalGenerateReportButton = 241,
    AssessmentAssessmentTableGenerateReportButton = 242,
    AssessmentAssessmentTableSendEmailButton = 243,
    AssessmentAssessmentModalSendEmailTitle = 244,
    ClientGroupTemplateModalAddTitle = 245,
    ClientGroupTemplateTableCreateGenerationSettingButton = 246,
    ClientGroupTemplateTableCreateGroupGenerationSettingButton = 247,
    ClientGroupTemplateModalCreateGenerationSettingTitle = 248,
    ClientGroupClientGroupModalAddTitle = 249,
    ClientGroupClientGroupModalAddSubTitle = 250,
    ClientGroupClientGroupTableAddSubButton = 251,
    ClientGroupGroupSettingTableEditButton = 252,
    ClientGroupGroupSettingModalEditTitle = 253,
    ClientGroupClientUserModalAddTitle = 254,
    ClientAdminClientAdminModalAddTitle = 255,
    ClientAdminClientAdminTableSendRegEmailButton = 256,
    ClientAdminClientAdminTableMigrationButton = 257,
    ClientAdminClientAdminTableEditButton = 258,
    ClientAdminClientAdminModalMigrationTitle = 259,
    ClientAdminClientAdminModalEditTitle = 260,
    ClientUserClientUserTableSendRegEmailButton = 261,
    ClientUserClientUserTableMigrationButton = 262,
    ClientUserClientUserModalAddTitle = 263,
    ClientUserClientUserTableEditButton = 264,
    ClientUserClientUserModalEditTitle = 265,
    ClientClientModalAddTitle = 266,
    ClientClientTableEditButton = 267,
    ClientClientModalEditTitle = 268,
    SurveySurveyModalAddTitle = 269,
    ReportReportTemplateModalAddTitle = 270,
    ReportNormTableModalAddTitle = 271,
    RegistrationPeriodRegistrationPeriodModalReadTitle = 272,
    RegistrationPeriodRegistrationPeriodModalAddTitle = 273,
    RegistrationPeriodRegistrationPeriodTableReadButton = 274,
    RegistrationPeriodRegistrationPeriodTableEditButton = 275,
    RegistrationPeriodRegistrationPeriodModalEditTitle = 276,
    AdministratorAdministratorModalAddTitle = 277,
    AdministratorAdministratorTableEditButton = 278,
    AdministratorAdministratorModalEditTitle = 279,
    AdministratorTechAdministratorModalAddTitle = 280,
    AdministratorTechAdministratorTableEditButton = 281,
    AdministratorTechAdministratorModalEditTitle = 282,
    LanguageLanguageStaticSelectLabel = 283,
    AssessmentAssessmentStaticNameLabel = 284,
    AssessmentAssessmentStaticTriggerTimeLabel = 285,
    AssessmentAssessmentStaticAutoSendSettingLabel = 286,
    AssessmentAssessmentStaticEmailLabel = 287,
    AssessmentAssessmentStaticCcLabel = 288,
    ClientGroupTemplateStaticAliasLabel = 289,
    QuestionChoiceListStaticNameLabel = 290,
    QuestionChoiceListStaticRemarkLabel = 291,
    ClientGroupClientGroupStaticNameLabel = 292,
    ClientGroupClientGroupStaticIdLabel = 293,
    ClientGroupClientGroupStaticClientLabel = 294,
    ClientGroupClientGroupStaticCustomizeLanguageLabel = 295,
    ClientGroupClientGroupStaticCustomizeEmailLabel = 296,
    ClientGroupClientGroupStaticCustomizePasswordLabel = 297,
    ClientGroupClientGroupStaticCustomizeFullNameLabel = 298,
    ClientGroupClientGroupStaticCustomizeFullNameLabelLabel = 299,
    ClientGroupClientGroupStaticReportAutoSendLabel = 300,
    ClientGroupClientGroupStaticAutoSendSettingLabel = 301,
    ClientGroupClientGroupStaticMaxAccountLabel = 302,
    ClientGroupClientGroupStaticAccountExpiryLabel = 303,
    ClientGroupClientGroupStaticTriggerTimeLabel = 304,
    ClientGroupClientGroupStaticEmailLabel = 305,
    ClientGroupClientGroupStaticCcLabel = 306,
    ClientGroupClientGroupStaticSelectLabel = 307,
    ClientAdminClientAdminStaticTypeLabel = 308,
    ClientAdminClientAdminStaticEmailLabel = 309,
    ClientAdminClientAdminStaticLanguageLabel = 310,
    ClientAdminClientAdminStaticPasswordLabel = 311,
    ClientAdminClientAdminStaticEmailNotificationLabel = 312,
    ClientAdminClientAdminStaticFullNameLabel = 313,
    ClientAdminClientAdminStaticLoginIDLabel = 314,
    ClientUserClientUserStaticEmailLabel = 315,
    ClientUserClientUserStaticLanguageLabel = 316,
    ClientUserClientUserStaticPasswordLabel = 317,
    ClientUserClientUserStaticEmailNotificationLabel = 318,
    ClientUserClientUserStaticFullNameLabel = 319,
    ClientUserClientUserStaticLoginIDLabel = 320,
    AdministratorAdministratorStaticEmailLabel = 321,
    AdministratorAdministratorStaticLanguageLabel = 322,
    AdministratorAdministratorStaticPasswordLabel = 323,
    AdministratorAdministratorStaticFullNameLabel = 324,
    AdministratorAdministratorStaticLoginIDLabel = 325,
    ClientClientStaticSelectLabel = 326,
    ClientClientStaticNameLabel = 327,
    ClientClientStaticPrefixLabel = 328,
    SurveySurveyStaticTitleLabel = 329,
    SurveySurveyStaticPointOfScaleLabel = 330,
    ReportGroupReportTemplateStaticNameLabel = 331,
    ReportGroupReportTemplateStaticDisplayNameLabel = 332,
    ReportGroupReportTemplateStaticLanguageLabel = 333,
    ReportGroupReportTemplateStaticGenerationMethodLabel = 334,
    ReportReportTemplateStaticNameLabel = 335,
    ReportReportTemplateStaticIdLabel = 336,
    ReportReportTemplateStaticDisplayNameLabel = 337,
    ReportReportTemplateStaticGenerationMethodLabel = 338,
    ReportReportTemplateStaticLanguageLabel = 339,
    ReportReportTemplateStaticSelectLabel = 340,
    ReportNormStaticSelectLabel = 341,
    ReportScoringKeySetStaticSelectLabel = 342,
    RegistrationPeriodRegistrationPeriodStaticStartDateLabel = 343,
    RegistrationPeriodRegistrationPeriodStaticEndDateLabel = 344,
    RegistrationPeriodRegistrationPeriodStaticQuotaLabel = 345,
    RegistrationPeriodRegistrationPeriodStaticAutoLoginLabel = 346,
    RegistrationPeriodRegistrationPeriodStaticEmailNotificationLabel = 347,
    LanguageLanguageStaticSelectPlaceholder = 348,
    ReportReportTemplateStaticSelectPlaceholder = 349,
    AssessmentAssessmentStaticSelectPlaceholder = 350,
    ReportNormTableStaticSelectPlaceholder = 351,
    ReportNormStaticSelectPlaceholder = 352,
    ReportScoringKeySetStaticSelectPlaceholder = 353,
    LanguageLanguageStaticMissingSelectRule = 354,
    QuestionCategoryStaticMissingAliasRule = 355,
    QuestionChoiceListStaticMissingNameRule = 356,
    TemplateTemplateStaticMissingAliasRule = 357,
    AssessmentAssessmentStaticMissingNameRule = 358,
    AssessmentAssessmentStaticMissingAutoSendSettingRule = 359,
    AssessmentAssessmentStaticMissingEmailRule = 360,
    AssessmentAssessmentStaticInvalidEmailRule = 361,
    AssessmentAssessmentStaticMissingCcRule = 362,
    AssessmentAssessmentStaticInvalidCcRule = 363,
    ClientGroupTemplateStaticMissingAliasRule = 364,
    ClientGroupClientGroupStaticMissingSelectRule = 365,
    ClientGroupClientGroupStaticMissingNameRule = 366,
    ClientGroupClientGroupStaticMissingAutoSendSettingRule = 367,
    ClientGroupClientGroupStaticMissingEmailRule = 368,
    ClientGroupClientGroupStaticInvalidEmailRule = 369,
    ClientGroupClientGroupStaticMissingCcRule = 370,
    ClientGroupClientGroupStaticInvalidCcRule = 371,
    ClientAdminClientAdminStaticMissingTypeRule = 372,
    ClientAdminClientAdminStaticMissingFullNameRule = 373,
    ClientAdminClientAdminStaticMissingLanguageRule = 374,
    ClientAdminClientAdminStaticMissingEmailRule = 375,
    ClientAdminClientAdminStaticInvalidEmailRule = 376,
    ClientUserClientUserStaticMissingFullNameRule = 377,
    ClientUserClientUserStaticMissingLanguageRule = 378,
    ClientUserClientUserStaticMissingEmailRule = 379,
    ClientUserClientUserStaticInvalidEmailRule = 380,
    AdministratorAdministratorStaticMissingLoginIDRule = 381,
    AdministratorAdministratorStaticMissingFullNameRule = 382,
    AdministratorAdministratorStaticMissingLanguageRule = 383,
    AdministratorAdministratorStaticMissingEmailRule = 384,
    AdministratorAdministratorStaticInvalidEmailRule = 385,
    ClientClientStaticMissingSelectRule = 386,
    ClientClientStaticMissingNameRule = 387,
    ClientClientStaticMissingPrefixRule = 388,
    SurveySurveyStaticMissingTitleRule = 389,
    SurveySurveyStaticMissingPointOfScaleRule = 390,
    ReportGroupReportTemplateStaticMissingNameRule = 391,
    ReportGroupReportTemplateStaticMissingDisplayNameRule = 392,
    ReportGroupReportTemplateStaticMissingLanguageRule = 393,
    ReportReportTemplateStaticMissingNameRule = 394,
    ReportReportTemplateStaticMissingDisplayNameRule = 395,
    ReportReportTemplateStaticMissingLanguageRule = 396,
    ReportReportTemplateStaticMissingSelectRule = 397,
    ReportScoringKeySetStaticMissingSelectRule = 398,
    ReportNormTableStaticMissingSelectRule = 399,
    ReportNormStaticMissingSelectRule = 400,
    RegistrationPeriodRegistrationPeriodStaticMissingStartDateRule = 401,
    RegistrationPeriodRegistrationPeriodStaticMissingEndDateRule = 402,
    StaticConfirmMigrationMessage = 403,
    StaticResetPasswordOption1Label = 404,
    StaticResetPasswordOption2Label = 405,
    StaticPageSizeLabel = 406,
    StaticPageNumberLabel = 407,
    StaticMissingPageSizeRule = 408,
    StaticMissingPageNumberRule = 409,
    StaticExportTableButton = 410,
    WelcomeNavigationTitle = 411,
    ReportGroupReportTemplateNavigationTitle = 412,
    ClientGroupEmailCustomizationNavigationTitle = 413,
    BillingAssessmentSummaryNavigationTitle = 414,
    BillingReportSummaryNavigationTitle = 415,
    BillingGroupReportSummaryNavigationTitle = 416,
    ClientGroupTemplateFormAutoReportLabel = 417,
    BillingReportSummaryFormReportTemplatePlaceholder = 418,
    BillingGroupReportSummaryFormReportTemplatePlaceholder = 419,
    AssessmentAssessmentStaticProgressLabel = 420,
    ClientGroupClientGroupStaticLanguageLabel = 421,
    QuestionChoiceListStaticSelectLabel = 422,
    QuestionCategoryStaticSelectLabel = 423,
    ClientGroupClientGroupContentJumpToLabel = 424,
    ClientGroupAssessmentContentProgressOption1Label = 425,
    ClientGroupAssessmentContentProgressOption2Label = 426,
    BillingReportDetailContentTotalReportLabel = 427,
    BillingReportDetailContentReportLabel = 428,
    BillingReportDetailContentGroupLabel = 429,
    BillingReportDetailContentParentGroupLabel = 430,
    BillingReportDetailContentActivateAccLabel = 431,
    BillingReportDetailContentDeactivateAccabel = 432,
    BillingReportDetailContentTotalAccLabel = 433,
    BillingGroupReportDetailContentTotalReportLabel = 434,
    BillingGroupReportDetailContentReportLabel = 435,
    BillingGroupReportDetailContentGroupLabel = 436,
    BillingGroupReportDetailContentParentGroupLabel = 437,
    BillingAssessmentDetailContentAssessmentLabel = 438,
    BillingAssessmentDetailContentTotalAssessmentLabel = 439,
    BillingAssessmentDetailContentCompleteAssessmentLabel = 440,
    BillingAssessmentDetailContentGroupLabel = 441,
    BillingAssessmentDetailContentParentGroupLabel = 442,
    BillingAssessmentDetailContentActivateAccLabel = 443,
    BillingAssessmentDetailContentDeactivateAccabel = 444,
    BillingAssessmentDetailContentTotalAccLabel = 445,
    ClientGroupTemplateContentGroupButton = 446,
    ClientGroupAssessmentContentBulkGenerateButton = 447,
    ClientGroupAssessmentContentBulkDownloadButton = 448,
    ClientGroupAssessmentContentBulkSendReminderButton = 449,
    ClientGroupAssessmentContentBulkSendButton = 450,
    ClientGroupAssessmentContentGroupReportButton = 451,
    ClientGroupAssessmentContentDownloadGroupRawDataButton = 452,
    ClientGroupClientAdminContentDownloadButton = 453,
    ClientGroupClientUserContentMigrationButton = 454,
    ReportGroupReportTemplateContentEditButton = 455,
    ReportGroupReportTemplateContentAddButton = 456,
    ReportReportTemplateContentEditButton = 457,
    AssessmentAssessmentModalSendReminderTitle = 458,
    AssessmentAssessmentTableScoreCheckButton = 459,
    ClientGroupAssessmentModalDownloadGroupRawDataTitle = 460,
    ClientGroupAssessmentModalExportTableTitle = 461,
    ReportGroupReportTemplateModalEditTitle = 462,
    ReportReportTemplateModalEditTitle = 463,
    ReportGroupReportTemplateModalAddTitle = 464,
    BillingReportSummaryModalExportTableTitle = 465,
    BillingGroupReportSummaryModalExportTableTitle = 466,
    BillingReportDetailModalExportTableTitle = 467,
    BillingGroupReportDetailModalExportTableTitle = 468,
    BillingAssessmentSummaryModalExportTableTitle = 469,
    BillingAssessmentDetailModalExportTableTitle = 470,
    AssessmentAssessmentTableSendReminderButton = 471,
    AssessmentAssessmentTableRawDataButton = 472,
    ReportReportTemplateStaticFileNameLabel = 473,
    ReportReportTemplateStaticConsistencyCheckCountThresholdLabel = 474,
    ReportReportTemplateStaticExtremeResponseCheckCountThresholdLabel = 475,
    ReportNormTableStaticSelectLabel = 476,
    ReportGroupReportTemplateStaticConsistencyCheckCountMaxLabel = 477,
    ReportGroupReportTemplateStaticConsistencyCheckCountMinLabel = 478,
    ReportGroupReportTemplateStaticExtremeResponseCheckCountMaxLabel = 479,
    ReportGroupReportTemplateStaticExtremeResponseCheckCountMinLabel = 480,
    ClientGroupAssesssmentGroupReportFileTypeLabel = 481,
    ClientGroupAssesssmentGroupReportPdfLabel = 482,
    ClientGroupAssesssmentGroupReportPptLabel = 483,
    ClientUserClientUserTableArchiveButton = 484,
    StaticConfirmArchiveUser = 485,
    ClientAdminClientAdminTableArchiveButton = 486,
    StaticConfirmArchiveAdmin = 487,
    ClientGroupClientGroupTableArchiveButton = 488,
    StaticConfirmArchiveClientGroup = 489,
    StaticArchiveButton = 490,
    StaticConfirmArchive = 491,
    ReportReportTemplateStaticShowUnmatchTokenLabel = 492,
    ReportGroupReportTemplateStaticShowUnmatchTokenLabel = 493,
    StaticIsIncludeDecedentsLabel = 494,
    ClientGroupClientGroupStaticAccountExpiryTooltip = 495,
    ClientGroupClientGroupStaticMaxAccountForSubLabel = 496,
    AccountAllocateExceedLimitError = 497,
    AccountAllocateLessThanCurrentError = 498,
    AccountAllocateForSubLessThanCurrentError = 499,
    ClientGroupClientGroupAssignableAccountRemainTooltip = 500,
    ReportGroupOutlierCalculateMethodLabel = 501,
    ReportGroupSelectLabel = 502,
    ReportGroupSelectTooltip = 503,
    ReportGroupSelectPlaceholder = 504,
    RegistrationPeriodConfirmCode = 505,
    RegistrationPeriodConfirmCodeTypeWarning = 506,
    RegistrationPeriodConfirmCodeRequiredWarning = 507,
    RegistrationPeriodConfirmCodeFilter = 508,
    RegistrationPeriodConfirmCodeFilterWithConfirmCode = 509,
    RegistrationPeriodConfirmCodeFilterWithoutConfirmCode = 510,
    RegistrationPeriodUploadNewConfirmCode = 511,
    RegistrationPeriodExportConfirmCode = 512,
    RegistrationPeriodUpdateConfirmCode = 513,
    InvaildConfirmCodeError = 514,
    RegistrationPeriodRegistrationPeriodStaticConfirmCodeLabel = 515,
    ReportTitleLabel = 516,
    ClientGroupDetailRegistrationPeriodTableHeaderStartOn = 517,
    ClientGroupDetailRegistrationPeriodTableHeaderEndOn = 518,
    ClientGroupDetailRegistrationPeriodTableHeaderQuota = 519,
    ClientGroupDetailRegistrationPeriodTableHeaderRegistrationsCount = 520,
    ClientGroupDetailRegistrationPeriodTableHeaderHasConfirmCode = 521,
    ClientGroupDetailRegistrationPeriodTableHeaderHasEmailNotification = 522,
    ClientGroupDetailRegistrationPeriodTableHeaderHasLoginToken = 523,
    ClientGroupDetailRegistrationPeriodTableHeaderLink = 524,
    ClientGroupDetailRegistrationPeriodTableHeaderActivate = 525,
    ClientGroupDetailRegistrationPeriodTableHeaderAction = 526,
    ClientGroupDetailAssessmentTemplateTableHeaderAlias = 527,
    ClientGroupDetailAssessmentTemplateTableHeaderAction = 528,
    AssessmentTableHeaderName = 529,
    AssessmentTableHeaderLoginID = 530,
    AssessmentTableHeaderEmail = 531,
    AssessmentTableHeaderClientGroup = 532,
    AssessmentTableHeaderAssessmentName = 533,
    AssessmentTableHeaderProgress = 534,
    AssessmentTableHeaderTimeAdded = 535,
    AssessmentTableHeaderTimeCompleted = 536,
    AssessmentTableHeaderAction = 537,
    ClientAdminTableHeaderClientName = 538,
    ClientAdminTableHeaderClientGroup = 539,
    ClientAdminTableHeaderType = 540,
    ClientAdminTableHeaderLoginID = 541,
    ClientAdminTableHeaderFullName = 542,
    ClientAdminTableHeaderLanguage = 543,
    ClientAdminTableHeaderEmail = 544,
    ClientAdminTableHeaderTimeAdded = 545,
    ClientAdminTableHeaderTimeModified = 546,
    ClientAdminTableHeaderAction = 547,
    ClientUserTableHeaderClientName = 548,
    ClientUserTableHeaderClientGroup = 549,
    ClientUserTableHeaderLoginID = 550,
    ClientUserTableHeaderFullName = 551,
    ClientUserTableHeaderLanguage = 552,
    ClientUserTableHeaderEmail = 553,
    ClientUserTableHeaderTimeAdded = 554,
    ClientUserTableHeaderTimeModified = 555,
    ClientUserTableHeaderAction = 556,
    BillingAssessmentDetailTableHeaderLoginID = 557,
    BillingAssessmentDetailTableHeaderFullName = 558,
    BillingAssessmentDetailTableHeaderEmail = 559,
    BillingAssessmentDetailTableHeaderAssessmentProgress = 560,
    BillingAssessmentDetailTableHeaderUserAddedTime = 561,
    BillingAssessmentDetailTableHeaderLoginTimeCount = 562,
    BillingAssessmentDetailTableHeaderHaveGenerateReport = 563,
    BillingGroupDetailTableHeaderGroupReportId = 564,
    BillingGroupDetailTableHeaderGroupReportTemplateName = 565,
    BillingGroupDetailTableHeaderNorm = 566,
    BillingGroupDetailTableHeaderGroupReportLanguage = 567,
    BillingGroupDetailTableHeaderGenerateTime = 568,
    BillingGroupDetailTableHeaderUserCount = 569,
    BillingGroupDetailTableHeaderGeneratePersonName = 570,
    BillingGroupDetailTableHeaderGeneratePersonID = 571,
    BillingGroupDetailTableHeaderGeneratePersonEmail = 572,
    BillingReportDetailTableHeaderGroupReportId = 573,
    BillingReportDetailTableHeaderGroupReportTemplateName = 574,
    BillingReportDetailTableHeaderNorm = 575,
    BillingReportDetailTableHeaderGroupReportLanguage = 576,
    BillingReportDetailTableHeaderGenerateTime = 577,
    BillingReportDetailTableHeaderID = 578,
    BillingReportDetailTableHeaderName = 579,
    BillingReportDetailTableHeaderEmail = 580,
    BillingReportDetailTableHeaderUserAddedTime = 581,
    ClientGroupAssessmentAssessmentTableHeaderFullName = 582,
    ClientGroupAssessmentAssessmentTableHeaderLoginId = 583,
    ClientGroupAssessmentAssessmentTableHeaderReportId = 584,
    ClientGroupAssessmentAssessmentTableHeaderNorm = 585,
    ClientGroupAssessmentAssessmentTableHeaderReportTemplate = 586,
    ClientGroupAssessmentAssessmentTableHeaderReportLanguage = 587,
    ClientGroupAssessmentAssessmentTableHeaderReportGenerateTime = 588,
    ClientGroupAssessmentAssessmentTableHeaderStatus = 589,
    ClientGroupAssessmentAssessmentTableHeaderAction = 590,
    ClientGroupAssessmentReportTableHeaderFullName = 591,
    ClientGroupAssessmentReportTableHeaderLoginId = 592,
    ClientGroupAssessmentReportTableHeaderEmail = 593,
    ClientGroupAssessmentReportTableHeaderAssessmentName = 594,
    ClientGroupAssessmentReportTableHeaderProgress = 595,
    ClientGroupAssessmentReportTableHeaderTimeAdded = 596,
    ClientGroupAssessmentReportTableHeaderTimeCompleted = 597,
    ClientGroupAssessmentReportTableHeaderAction = 598,
    ClientGroupClientUserTableHeaderLoginId = 599,
    ClientGroupClientUserTableHeaderFullName = 600,
    ClientGroupClientUserTableHeaderLanguage = 601,
    ClientGroupClientUserTableHeaderEmail = 602,
    ClientGroupClientUserTableHeaderTimeAdded = 603,
    ClientGroupClientUserTableHeaderTimeModified = 604,
    ClientGroupClientUserTableHeaderAction = 605,
    ClientGroupClientAdminTableHeaderType = 606,
    ClientGroupClientAdminTableHeaderLoginId = 607,
    ClientGroupClientAdminTableHeaderFullName = 608,
    ClientGroupClientAdminTableHeaderLanguage = 609,
    ClientGroupClientAdminTableHeaderEmail = 610,
    ClientGroupClientAdminTableHeaderTimeAdded = 611,
    ClientGroupClientAdminTableHeaderTimeModified = 612,
    ClientGroupClientAdminTableHeaderAction = 613,
    ClientGroupAssessmentGroupReportTableHeaderGroupReportId = 614,
    ClientGroupAssessmentGroupReportTableHeaderAssessmentName = 615,
    ClientGroupAssessmentGroupReportTableHeaderNorm = 616,
    ClientGroupAssessmentGroupReportTableHeaderReportTemplate = 617,
    ClientGroupAssessmentGroupReportTableHeaderReportLanguage = 618,
    ClientGroupAssessmentGroupReportTableHeaderReportGenerateTime = 619,
    ClientGroupAssessmentGroupReportTableHeaderStatus = 620,
    ClientGroupAssessmentGroupReportTableHeaderAction = 621,
    ClientGroupUserMigrationTableHeaderAction = 622,
    ClientGroupGenerationSettingNestTableHeaderId = 623,
    ClientGroupGenerationSettingNestTableHeaderReportTemplate = 624,
    ClientGroupGenerationSettingNestTableHeaderReportLanuage = 625,
    ClientGroupGenerationSettingNestTableHeaderNormTable = 626,
    ClientGroupGenerationSettingNestTableHeaderIsAutoGenerated = 627,
    ClientGroupGenerationSettingNestTableHeaderIdAction = 628,
    LanguageTableHeaderLanguageId = 629,
    LanguageTableHeaderLabel = 630,
    LanguageTableHeaderAction = 631,
    ReportNormTableHeaderId = 632,
    ReportNormTableTableHeaderNormTableName = 633,
    ReportNormTableTableHeaderReportTemplateName = 634,
    ReportNormTableTableHeaderAction = 635,
    AssessmentReportTableHeaderReportId = 636,
    AssessmentReportTableHeaderNorm = 637,
    AssessmentReportTableHeaderReportTemplate = 638,
    AssessmentReportTableHeaderReportLanguage = 639,
    AssessmentReportTableHeaderReportGenerateTime = 640,
    AssessmentReportTableHeaderStatus = 641,
    AssessmentReportTableHeaderAction = 642,
    ClientTableHeaderName = 643,
    ClientTableHeaderUserNamePrefix = 644,
    ClientTableHeaderTimeAdded = 645,
    ClientTableHeaderAction = 646,
    FormQuestionTableHeaderId = 647,
    FormQuestionTableHeaderFormname = 648,
    FormQuestionTableHeaderQuestionCategory = 649,
    FormQuestionTableHeaderQuestionId = 650,
    FormQuestionTableHeaderOptional = 651,
    FormQuestionTableHeaderQuestionOrder = 652,
    FormQuestionTableHeaderPageNo = 653,
    FormQuestionTableHeaderTimeAdded = 654,
    FormTableHeaderQuestionCategory = 655,
    FormTableHeaderFormName = 656,
    FormTableHeaderShuffle = 657,
    FormTableHeaderType = 658,
    FormTableHeaderRatingScaleTitle = 659,
    FormTableHeaderQuestionPerPage = 660,
    FormTableHeaderTimeAdded = 661,
    FormTableHeaderAction = 662,
    TranslationTableHeaderKey = 663,
    LanguageTableHeaderId = 664,
    LanguageTableHeaderDisplayName = 665,
    LanguageTableHeaderIsEnabled = 666,
    SystemAdminTableHeaderUserName = 667,
    SystemAdminTableHeaderFullName = 668,
    SystemAdminTableHeaderLanguage = 669,
    SystemAdminTableHeaderEmail = 670,
    SystemAdminTableHeaderAction = 671,
    TechnicalTableHeaderUserName = 672,
    TechnicalTableHeaderFullName = 673,
    TechnicalTableHeaderLanguage = 674,
    TechnicalTableHeaderEmail = 675,
    TechnicalTableHeaderAction = 676,
    BillingAssessmentSummaryTableHeaderAssessment = 677,
    BillingAssessmentSummaryTableHeaderParentGroup = 678,
    BillingAssessmentSummaryTableHeaderGroup = 679,
    BillingAssessmentSummaryTableHeaderTotalAssessment = 680,
    BillingAssessmentSummaryTableHeaderCompletedAssessment = 681,
    BillingAssessmentSummaryTableHeaderActivateAccounts = 682,
    BillingAssessmentSummaryTableHeaderDeactivateAccounts = 683,
    BillingAssessmentSummaryTableHeaderTotalAccounts = 684,
    BillingAssessmentSummaryTableHeaderAction = 685,
    StaticItemPerPage = 686,
    BillingGroupSummaryTableHeaderReportTemplate = 687,
    BillingGroupSummaryTableHeaderLanguage = 688,
    BillingGroupSummaryTableHeaderParentGroup = 689,
    BillingGroupSummaryTableHeaderGroup = 690,
    BillingGroupSummaryTableHeaderGeneratedReports = 691,
    BillingGroupSummaryTableHeaderAction = 692,
    BillingReportSummaryTableHeaderReportTemplate = 693,
    BillingReportSummaryTableHeaderReportLanguage = 694,
    BillingReportSummaryTableHeaderReportParentGroup = 695,
    BillingReportSummaryTableHeaderReportGroup = 696,
    BillingReportSummaryTableHeaderReportGeneratedReports = 697,
    BillingReportSummaryTableHeaderReportActivateAccounts = 698,
    BillingReportSummaryTableHeaderReportDeactivateAccounts = 699,
    BillingReportSummaryTableHeaderReportTotalAccounts = 700,
    BillingReportSummaryTableHeaderReportAction = 701,
    ClientGroupTableHeaderId = 702,
    ClientGroupTableHeaderGroupName = 703,
    ClientGroupTableHeaderClientName = 704,
    ClientGroupTableHeaderTimeAdded = 705,
    ClientGroupTableHeaderTimeModified = 706,
    ClientGroupTableHeaderAction = 707,
    ClientGroupEmailCustomTableHeaderName = 708,
    ClientGroupEmailCustomRecordRegistrationEmailToken = 709,
    ClientGroupEmailCustomRecordRegistrationEmailTitle = 710,
    ClientGroupEmailCustomRecordRegistrationEmailTemplate = 711,
    ClientGroupEmailCustomRecordReportEmailToken = 712,
    ClientGroupEmailCustomRecordReportEmailTitle = 713,
    ClientGroupEmailCustomRecordReportEmailTemplate = 714,
    ClientGroupEmailCustomRecordReminderEmailToken = 715,
    ClientGroupEmailCustomRecordReminderEmailTitle = 716,
    ClientGroupEmailCustomRecordReminderEmailTemplate = 717,
    QuestionCategoryTableHeaderQuestionCategory = 718,
    QuestionCategoryTableHeaderTimeAdded = 719,
    QuestionCategoryTableHeaderAction = 720,
    QuestionChoiceTableHeaderId = 721,
    QuestionChoiceTableHeaderQuestionChoiceList = 722,
    QuestionChoiceTableHeaderContent = 723,
    QuestionChoiceTableHeaderAction = 724,
    QuestionChoiceListTableHeaderId = 725,
    QuestionChoiceListTableHeaderQuestionChoiceList = 726,
    QuestionChoiceListTableHeaderRemarks = 727,
    QuestionChoiceListTableHeaderAction = 728,
    QuestionFacetDimensionTableHeaderQuestionCategory = 729,
    QuestionFacetDimensionTableHeaderId = 730,
    QuestionFacetDimensionTableHeaderFacetName = 731,
    QuestionFacetDimensionTableHeaderGroup = 732,
    QuestionQuestionTableHeaderQuestionCategory = 733,
    QuestionQuestionTableHeaderId = 734,
    QuestionQuestionTableHeaderQuestionContent = 735,
    QuestionQuestionTableHeaderType = 736,
    QuestionQuestionTableHeaderTimeAdded = 737,
    RegistrationPeriodTableHeaderClientGroupName = 738,
    RegistrationPeriodTableHeaderStartOn = 739,
    RegistrationPeriodTableHeaderEndOn = 740,
    RegistrationPeriodTableHeaderQuota = 741,
    RegistrationPeriodTableHeaderRegistrationsCount = 742,
    RegistrationPeriodTableHeaderHasConfirmCode = 743,
    RegistrationPeriodTableHeaderHasEmailNotify = 744,
    RegistrationPeriodTableHeaderHasLoginToken = 745,
    RegistrationPeriodTableHeaderLink = 746,
    RegistrationPeriodTableHeaderActivate = 747,
    RegistrationPeriodTableHeaderAction = 748,
    ReportGenerationSettingTableHeaderAssessmentTemplateAlias = 749,
    ReportGenerationSettingTableHeaderFormName = 750,
    ReportGenerationSettingTableHeaderScoringKetSetName = 751,
    ReportGenerationSettingTableHeaderNormTableName = 752,
    ReportGenerationSettingTableHeaderReportTemplateName = 753,
    ReportNormTableTableHeaderName = 754,
    ReportNormTableTableHeaderQuestion = 755,
    ReportNormTableTableHeaderTimeAdded = 756,
    ReportScoringKetSettableHeaderName = 757,
    ReportScoringKetSettableHeaderQuestionCategory = 758,
    ReportScoringKetSettableHeaderConsistencyCheckThreshold = 759,
    ReportScoringKetSettableHeaderContraryCheckUpperThreshold = 760,
    ReportScoringKetSettableHeaderContraryCheckLowerThreshold = 761,
    ReportScoringKetSettableHeaderTimeAdded = 762,
    ReportGroupReportTemplateTableHeaderName = 763,
    ReportGroupReportTemplateTableHeaderDisplayName = 764,
    ReportGroupReportTemplateTableHeaderFileName = 765,
    ReportGroupReportTemplateTableHeaderLanguage = 766,
    ReportGroupReportTemplateTableHeaderTimeAdded = 767,
    ReportGroupReportTemplateTableHeaderGenerationMethod = 768,
    ReportGroupReportTemplateTableHeaderAction = 769,
    ReportReportTemplateTableHeaderName = 770,
    ReportReportTemplateTableHeaderDisplayName = 771,
    ReportReportTemplateTableHeaderFileName = 772,
    ReportReportTemplateTableHeaderLanguage = 773,
    ReportReportTemplateTableHeaderTimeAdded = 774,
    ReportReportTemplateTableHeaderGenerationMethod = 775,
    ReportReportTemplateTableHeaderAction = 776,
    SurveyTableHeaderTitle = 777,
    SurveyTableHeaderPointOfScale = 778,
    SurveyTableHeaderAction = 779,
    SurveyTableHeaderId = 780,
    SurveyTableHeaderValue = 781,
    SurveyTableHeaderContent = 782,
    TemplateTableHeaderAssessmentTemplate = 783,
    TemplateTableHeaderTimeAdded = 784,
    TemplateTableHeaderAction = 785,
    TemplateFormTableHeaderAssessmentTemplate = 786,
    TemplateFormTableHeaderForm = 787,
    TemplateFormTableHeaderTimeAdded = 788,
    StaticKeywords = 789,
    StaticStartDate = 790,
    StaticEndDate = 791,
    StaticAll = 792,
    BillingAssessmentSummaryFilterLabelClientGroup = 793,
    BillingAssessmentSummaryFilterLabelAssessmentTemplate = 794,
    BillingAssessmentSummaryFilterLabelHasCompletedAssessment = 795,
    BillingAssessmentSummaryFilterLabelUserAddedDate = 796,
    BillingAssessmentSummaryFilterLabelAssessmentStartTimeDate = 797,
    BillingAssessmentSummaryFilterLabelAssessmentEndTimeDate = 798,
    BillingAssessmentDetailFilterLabeluserAddedDate = 799,
    BillingAssessmentDetailFilterLabelAssessmentStartDate = 800,
    BillingAssessmentDetailFilterLabelAssessmentEndDate = 801,
    BillingAssessmentDetailFilterLabelCompletedAssessment = 802,
    BillingReportSummaryFilterLabelClientGroup = 803,
    BillingReportSummaryFilterLabelReportTemplate = 804,
    BillingReportSummaryFilterLabeluserAddedDate = 805,
    BillingReportSummaryFilterLabelReportGenerationDate = 806,
    BillingReportDetailFilterLabelUserAddedDate = 807,
    BillingReportDetailFilterLabelReportGenerationDate = 808,
    BillingGroupSummaryFilterLabelClientGroup = 809,
    BillingGroupSummaryFilterLabelReportTemplate = 810,
    BillingGroupSummaryFilterLabelReportGenerationDate = 811,
    ReportReportTemplateContentDownloadCombineTokenRuleButton = 812,
    ReportReportTemplateContentUploadCombineTokenRuleButton = 813,
    ClientGroupClientAdminPermissionUploadButton = 814,
    BasicInformationNavigationTitle = 815,
    DefaultGradingSetupNavigationTitle = 816,
    BasicInformationCourseCopy = 817,
    AllCourseTitle = 818,
    AllCourseSearchPlaceholder = 819,
    AllCourseFilterButton = 820,
    AllCourseSearchButton = 821,
    AllCourseSortDropBox = 822,
    AllCourseNameAZ = 823,
    AllCourseNameZA = 824,
    AllCourseAddCourseButton = 825,
    AllCourseResultsFoundMatchingHint = 826,
    AllCourseFilterTitle = 827,
    AllCourseCourseNameTitle = 828,
    AllCourseCourseStatusTitle = 829,
    AllCourseDraftStatus = 830,
    AllCoursePublishedStatus = 831,
    AllCourseUnpublishedStatus = 832,
    AllCourseApplyButton = 833,
    AllCourseLoadingHint = 834,
    AllCourseLoadingFailedHint = 835,
    AllCourseLastModifiedDateText = 836,
    AllCoursePreviousButton = 837,
    AllCourseNextButton = 838,
    AllCourseNoCoursesHint = 839,
    AllCourseClearButton = 840,
    BasicInformationCourseDelete = 841,
    BasicInformationCoursePublish = 842,
    BasicInformationCourseUnpublish = 843,
    BasicInformationCourseRepublish = 844,
    BasicInformationSaveButton = 845,
    BasicInformationInternalInformationTitle = 846,
    BasicInformationInternalInformationPlaceholder = 847,
    BasicInformationLanguageTitle = 848,
    BasicInformationPleaseSelectLanguage = 849,
    BasicInformationChooseLanguagePlaceholder = 850,
    BasicInformationPleaseEnterCourseName = 851,
    BasicInformationCoursesReadInOrder = 852,
    BasicInformationCourseName = 853,
    BasicInformationEnterCourseNamePlaceholder = 854,
    BasicInformationEnterCourseDescription = 855,
    BasicInformationDescription = 856,
    BasicInformationPleaseSelectReadOrder = 857,
    BasicInformationCoverImage = 858,
    BasicInformationUpdateSuccess = 859,
    BasicInformationPleaseFillRequiredFields = 860,
    BasicInformationCoverImageSelected = 861,
    BasicInformationDownloadingSuccess = 862,
    BasicInformationDownloadErrorNotImage = 863,
    BasicInformationDownloadingError = 864,
    BasicInformationImageFileName = 865,
    BasicInformationImageUploadDate = 866,
    BasicInformationImageAction = 867,
    BasicInformationSelectImage = 868,
    BasicInformationImageDownloadHint = 869,
    BasicInformationImageRemoveHint = 870,
    BasicInformationRemoveImage = 871,
    BasicInformationConfirm = 872,
    BasicInformationCancel = 873,
    BasicInformationSelectCoverImage = 874,
    BasicInformationCourseInformation = 875,
    BasicInformationStaticConfirmPublished = 876,
    BasicInformationStaticConfirmUnpublished = 877,
    BasicInformationStaticCopyingMessage = 878,
    BasicInformationStaticCopySuccess = 879,
    BasicInformationSwitchedToNewCopyCourse = 880,
    CreateCourseTitle = 881,
    BasicInformationModuleAddStep = 882,
    BasicInformationModuleAddStepCancel = 883,
    BasicInformationModuleAddStepApply = 884,
    BasicInformationModuleAddStepCategory = 885,
    BasicInformationModuleAddStepImageFileTextLink = 886,
    BasicInformationModuleAddStepVideo = 887,
    BasicInformationModuleAddStepQuizExam = 888,
    BasicInformationModuleAddStepCALAssessmentPlatform = 889,
    BasicInformationModuleAddStepModuleAdded = 890,
    BasicInformationModuleAddStepUpdateSortOrderSuccess = 891,
    BasicInformationModuleAddStepModuleDeleted = 892,
    BasicInformationModuleAddStepDeletedSuccess = 893,
    BasicInformationModuleAddStepSelectModuleFirst = 894,
    BasicInformationModuleAddStepRefreshAndRetry = 895,
    BasicInformationModuleAddStepModuleNotFound = 896,
    BasicInformationModuleAddStepStepAdded = 897,
    BasicInformationModuleAddStepSelectValidFile = 898,
    BasicInformationModuleAddStepSuccess = 899,
    BasicInformationModuleAddStepDownloadSuccess = 900,
    BasicInformationModuleAddStepDeleteSuccess = 901,
    BasicInformationModuleAddStepFileName = 902,
    BasicInformationModuleAddStepUploadDate = 903,
    BasicInformationModuleAddStepAction = 904,
    BasicInformationModuleAddStepSelectFile = 905,
    BasicInformationModuleAddStepUnnamedFile = 906,
    BasicInformationModuleAddStepUpdateSuccess = 907,
    BasicInformationModuleAddStepModuleDetail = 908,
    BasicInformationModuleSave = 909,
    BasicInformationModuleNamePlaceholder = 910,
    BasicInformationModuleName = 911,
    BasicInformationModuleNameHint = 912,
    BasicInformationModuleReorderModules = 913,
    BasicInformationModuleExitedReorderMode = 914,
    BasicInformationModuleSortOrderUpdated = 915,
    BasicInformationModuleList = 916,
    BasicInformationModuleAddAnotherModule = 917,
    BasicInformationModuleReorderList = 918,
    BasicInformationModuleCancel = 919,
    BasicInformationModuleApply = 920,
    BasicInformationModuleDeleteModuleHint = 921,
    BasicInformationModuleDeleteYes = 922,
    BasicInformationModuleDeleteNo = 923,
    BasicInformationModuleAddStepDeleteHint = 924,
    BasicInformationModuleAddStepDeleteYes = 925,
    BasicInformationModuleAddStepDeleteNo = 926,
    BasicInformationModuleCollapse = 927,
    BasicInformationModuleExpand = 928,
    BasicInformationModuleAddStepTitle = 929,
    BasicInformationModuleHint = 930,
    BasicInformationModuleAddStepHint = 931,
    BasicInformationModuleEnterContent = 932,
    BasicInformationModuleUpdateStepSuccess = 933,
    BasicInformationModuleStepDetail = 934,
    BasicInformationModuleAddStepSave = 935,
    BasicInformationModuleAddStepStepNameRequired = 936,
    BasicInformationModuleAddStepNameIsRequired = 937,
    BasicInformationStepNamePlaceholder = 938,
    BasicInformationStepQuizExamPlaceholder = 939,
    BasicInformationModuleAddStepEnterDescription = 940,
    BasicInformationModuleAddStepVideoEnterDescription = 941,
    BasicInformationStepNameAssessmentTextItemPlaceholder = 942,
    BasicInformationModuleAddStepAssessmentTextItemIsRequired = 943,
    BasicInformationModuleAddStepAssessmentTextItemTitle = 944,
    BasicInformationAddStepVideoTitle = 945,
    BasicInformationModuleAddStepQuizExamLabel = 946,
    BasicInformationModuleAddStepName = 947,
    BasicInformationModuleAddStepAssessmentQuestionnaireTitle = 948,
    BasicInformationModuleAddStepAssessmentPlaceholder = 949,
    BasicInformationModuleAddStepDownloadHint = 950,
    BasicInformationModuleAddStepVideoDescription = 951,
    BasicInformationModuleAddStepDescription = 952,
    BasicInformationModuleAddStepUseVideoSuccess = 953,
    BasicInformationModuleAddStepVideoDownloadSuccess = 954,
    BasicInformationModuleAddStepVideoFileName = 955,
    BasicInformationModuleAddStepVideoUploadDate = 956,
    BasicInformationModuleAddStepVideoAction = 957,
    BasicInformationModuleAddStepSelectVideo = 958,
    BasicInformationModuleAddStepVideoDownloadButton = 959,
    BasicInformationModuleAddStepVideoRemoveHint = 960,
    BasicInformationModuleAddStepVideoRemoveConfirm = 961,
    BasicInformationModuleAddStepVideoRemoveCancel = 962,
    BasicInformationModuleAddStepVideoRemove = 963,
    BasicInformationModuleAddStepVideoSelectCover = 964,
    BasicInformationModuleAddStepVideoSelectCancel = 965,
    BasicInformationModuleAddStepVideoSelectConfirm = 966,
    BasicInformationCourseLanguageCourseNameHint = 967,
    BasicInformationCourseLanguageCourseNamePlaceholder = 968,
    CertificatetemplateCourseLanguageRequired = 969,
    CertificatetemplateCompletionMessagePassTitle = 970,
    CertificatetemplateCompletionMessageFailTitle = 971,
    CertificatetemplateFileTitle = 972,
    CertificateTemplateNavigationTitle = 973,
    CertificateTemplateSaveButton = 974,
    TemplateFileTableSelectValidFile = 975,
    TemplateFileTableUploadSuccess = 976,
    TemplateFileTableDownloadingHint = 977,
    TemplateFileTableDownloadSuccess = 978,
    TemplateFileTableFileRemoved = 979,
    TemplateFileTableFileName = 980,
    TemplateFileTableUploadDate = 981,
    TemplateFileTableAction = 982,
    TemplateFileTableSelectFile = 983,
    DefaultGradingSetupCourseLanguageRequired = 984,
    CourseDefaultGradingModalLoadLanguageError = 985,
    CourseDefaultGradingModalEditTitle = 986,
    CourseDefaultGradingModalLowestFinalScore = 987,
    CourseDefaultGradingModalLowestFinalScoreRequired = 988,
    CourseDefaultGradingModalHighestFinalScore = 989,
    CourseDefaultGradingModalHighestFinalScoreRequired = 990,
    CourseDefaultGradingModalIsPassingScore = 991,
    DefaultGradingSetupFinalScoreRange = 992,
    DefaultGradingSetupGrading = 993,
    DefaultGradingSetupIsPassingScore = 994,
    DefaultGradingSetupAction = 995,
    DefaultGradingSetupDeleteConfirm = 996,
    DefaultGradingSetupDeleteButton = 997,
    DefaultGradingSetupCancelButton = 998,
    DefaultGradingSetupAddGrading = 999,
    QuestionBankCourseLanguageRequired = 1000,
    QuestionBankNavigationTitle = 1001,
    QuestionBankUploadButton = 1002,
    QuestionBankModelFileDeleted = 1003,
    QuestionBankModelUploadTitle = 1004,
    QuestionBankModelQuestionName = 1005,
    QuestionBankModelQuestionNameRequired = 1006,
    QuestionBankModelQuestionNamePlaceholder = 1007,
    QuestionBankModelSingleChoiceFile = 1008,
    QuestionBankModelMultipleChoiceFile = 1009,
    QuestionBankModelOpenEndedFile = 1010,
    QuestionBankModelUploadButton = 1011,
    QuestionBankModelReUploadButton = 1012,
    QuestionBankModelDownloadButton = 1013,
    QuestionBankModelDeleteButton = 1014,
    UpdateQuestionBankModelUploadSuccess = 1015,
    UpdateQuestionBankModelUploadCorrectFile = 1016,
    UpdateQuestionBankModelUploadTitle = 1017,
    UpdateQuestionBankModelQuestionName = 1018,
    UpdateQuestionBankModelQuestionNameRequired = 1019,
    UpdateQuestionBankModelQuestionNamePlaceholder = 1020,
    UpdateQuestionBankModelSingleChoiceFile = 1021,
    UpdateQuestionBankModelUploadButton = 1022,
    UpdateQuestionBankModelMultipleChoiceFile = 1023,
    UpdateQuestionBankModelOpenEndedFile = 1024,
    QuizExamDeleteSuccess = 1025,
    QuizExamTableHeaderQuizExamName = 1026,
    QuizExamTableHeaderQuestionCount = 1027,
    QuizExamTableHeaderQuizScores = 1028,
    QuizExamTableHeaderQuizExamWeight = 1029,
    QuizExamTableHeaderRetakesAllowed = 1030,
    QuizExamTableHeaderPassingScore = 1031,
    QuizExamTableHeaderPassMsg = 1032,
    QuizExamTableHeaderFailHasChanceMsg = 1033,
    QuizExamTableHeaderFailNoChanceMsg = 1034,
    QuizExamTableHeaderAction = 1035,
    QuizExamCourseLanguageRequired = 1036,
    QuizExamNavigationTitle = 1037,
    QuizExamFilterName = 1038,
    QuizExamFilterNotSpecified = 1039,
    QuizExamFilterQuestionCount = 1040,
    QuizExamFilterQuizScores = 1041,
    QuizExamFilterWeight = 1042,
    QuizExamFilterPassingScore = 1043,
    QuizExamFilterQuestionCountPlaceholder = 1044,
    QuizExamFilterQuizScoresPlaceholder = 1045,
    QuizExamFilterPassingScorePlaceholder = 1046,
    AddQuestionBankTitleCourseName = 1047,
    EditQuestionBankTotalQuestionCount = 1048,
    EditQuestionBankName = 1049,
    EditQuestionBankNameRequired = 1050,
    EditQuestionBankQuestionCount = 1051,
    EditQuestionBankPointsPerQuestion = 1052,
    EditQuestionBankPointsRequired = 1053,
    EditQuestionBankStaticCancelButton = 1054,
    EditQuestionBankStaticApplyButton = 1055,
    QuestionBankTableDeleteSuccess = 1056,
    QuestionBankTableQuestionBankName = 1057,
    QuestionBankTableQuestionCount = 1058,
    QuestionBankTablePointsPerQuestion = 1059,
    QuestionBankTableAction = 1060,
    QuestionBankTableQuestionCountExceed = 1061,
    QuestionBankTableUpdateSuccess = 1062,
    QuestionBankTableAlreadySelected = 1063,
    QuestionBankTableEditModalTitle = 1064,
    QuizExamHandleModalEditTitle = 1065,
    QuizExamHandleModalCreateTitle = 1066,
    QuizExamHandleModalLoadLanguageError = 1067,
    QuizExamHandleModalSequentialGeneration = 1068,
    QuizExamHandleModalRandomGeneration = 1069,
    QuizExamHandleModalPass = 1070,
    QuizExamHandleModalFailHasChance = 1071,
    QuizExamHandleModalFailNoChance = 1072,
    QuizExamHandleModalLoadDataError = 1073,
    QuizExamHandleModalSelectQuestionBank = 1074,
    QuizExamHandleModalDeleted = 1075,
    QuizExamHandleModalAlreadyExists = 1076,
    QuizExamHandleModalName = 1077,
    QuizExamHandleModalNamePlaceholder = 1078,
    QuizExamHandleModalWeight = 1079,
    QuizExamHandleModalWeightPlaceholder = 1080,
    QuizExamHandleModalRetakesAllowed = 1081,
    QuizExamHandleModalRetakesAllowedPlaceholder = 1082,
    QuizExamHandleModalPassingScore = 1083,
    QuizExamHandleModalPassingScorePlaceholder = 1084,
    QuizExamHandleModalSelectQuestionBankError = 1085,
    QuizExamHandleModalCancelButton = 1086,
    QuizExamHandleModalSaveButton = 1087,
    QuizExamHandleModalCreateButton = 1088,
    QuizExamHandleModalQuestionBankTitle = 1089,
    QuizExamHandleModalSorting = 1090,
    QuizExamHandleModalQuestionBankName = 1091,
    QuizExamHandleModalAction = 1092,
    QuizExamHandleModalAddQuestionBank = 1093,
    QuizExamHandleModalGenerationMethodTitle = 1094,
    QuizExamHandleModalQuestionTypeOrderTitle = 1095,
    QuizExamHandleModalSort = 1096,
    QuizExamHandleModalSingleChoice = 1097,
    QuizExamHandleModalMultipleChoice = 1098,
    QuizExamHandleModalOpenEnded = 1099,
    QuizExamHandleModalResultMessagesTitle = 1100,
    QuizExamHandleModalSelectQuestionBankTitle = 1101,
    ImageMediaLibraryNavigationTitle = 1102,
    ImageMediaLibraryNameAZ = 1103,
    ImageMediaLibraryNameZA = 1104,
    ImageMediaLibraryAddImage = 1105,
    VideoMediaLibraryNameAZ = 1106,
    VideoMediaLibraryNameZA = 1107,
    VideoMediaLibraryAddVideo = 1108,
    AliVodFailedToGetCredential = 1109,
    AliVodFilePreparationCompleted = 1110,
    AliVodSDKNotLoadedCorrectly = 1111,
    AliVodEditVideos = 1112,
    AliVodAddVideos = 1113,
    AliVodChange = 1114,
    AliVodExtension = 1115,
    AliVodLastModified = 1116,
    AliVodName = 1117,
    AliVodUploadDescription = 1118,
    AliVodUploadHint = 1119,
    MediaLibraryImageLastModified = 1120,
    MediaLibraryVideoLastModified = 1121,
    UpdateMediaLibraryUploadImageRequired = 1122,
    UpdateMediaLibraryContentType = 1123,
    UpdateMediaLibraryDimensions = 1124,
    UpdateMediaLibraryExtension = 1125,
    UpdateMediaLibraryLastModified = 1126,
    UpdateMediaLibraryName = 1127,
    UpdateMediaLibraryImageNameRequired = 1128,
    UpdateMediaLibraryImageChange = 1129,
    UpdateMediaLibraryVideoNotSupported = 1130,
    UpdateMediaLibraryVideoContentType = 1131,
    UpdateMediaLibraryVideoDimensions = 1132,
    UpdateMediaLibraryVideoExtension = 1133,
    UpdateMediaLibraryVideoName = 1134,
    UpdateMediaLibraryVideoNameRequired = 1135,
    UpdateMediaLibraryVideoUploadDescription = 1136,
    SettingsSendingCode = 1137,
    SettingsCodeSent = 1138,
    SettingsPasswordResetSuccess = 1139,
    SettingsPasswordResetFailed = 1140,
    SettingsResettingPassword = 1141,
    SettingsPasswordRequirements = 1142,
    SettingsVerificationIncorrect = 1143,
    SettingsVerificationFailed = 1144,
    SettingsUpdatingEmail = 1145,
    SettingsEmailUpdated = 1146,
    SettingsResetPasswordButton = 1147,
    SettingsEditButton = 1148,
    SettingsInformation = 1149,
    SettingsID = 1150,
    SettingsUsername = 1151,
    SettingsEmail = 1152,
    SettingsResetPasswordTitle = 1153,
    SettingsNewPassword = 1154,
    SettingsEnterNewPassword = 1155,
    SettingsEnterPassword = 1156,
    SettingsPasswordRules = 1157,
    SettingsPasswordRuleCapital = 1158,
    SettingsPasswordRuleNumber = 1159,
    SettingsPasswordRuleSpecial = 1160,
    SettingsPasswordRuleLength = 1161,
    SettingsConfirmNewPassword = 1162,
    SettingsEnterConfirmPassword = 1163,
    SettingsPasswordsDontMatch = 1164,
    SettingsConfirmPassword = 1165,
    SettingsResetPWConfirmButton = 1166,
    SettingsVerificationCode = 1167,
    SettingsOTP = 1168,
    SettingsEnterOTP = 1169,
    SettingsResendCodeMessage = 1170,
    SettingsResendCodeTextHint = 1171,
    SettingsVerify = 1172,
    SettingsResetPWBackButton = 1173,
    SettingsEditInformation = 1174,
    SettingsEditEmail = 1175,
    SettingsEditSaveButton = 1176,
    SettingsEditBackButton = 1177,
    SettingsCourse = 1178,
    SettingsEmailNotValid = 1179,
    DownloadCourseCertificateButtonDownloadingHint = 1180,
    DownloadCourseCertificateButtonSendingEmail = 1181,
    DownloadCourseCertificateButtonDownloadSuccessHint = 1182,
    DownloadCourseCertificateButtonSendSuccess = 1183,
    DownloadCourseCertificateButton = 1184,
    DownloadCourseCertificateButtonDownloadRadio = 1185,
    DownloadCourseCertificateButtonSendEmailRadio = 1186,
    CourseInformationCardInformationTitle = 1187,
    CourseInformationCardCourseName = 1188,
    CourseInformationCardAccessPeriod = 1189,
    CourseInformationCardLastSeenDate = 1190,
    CourseInformationCardNumberOfModules = 1191,
    CourseInformationCardProgress = 1192,
    CourseInformationCardFinalScore = 1193,
    CourseLearningProgressCardModule = 1194,
    CourseLearningProgressCardModuleName = 1195,
    CourseLearningProgressCardStep = 1196,
    CourseLearningProgressCardStepName = 1197,
    CourseLearningProgressCardAction = 1198,
    CourseLearningProgressCardLearningProgress = 1199,
    DownloadCourseNotesButtonNotes = 1200,
    DownloadCourseNotesButtonDownload = 1201,
    DownloadCourseNotesButtonSendByEmail = 1202,
    DownloadCourseNotesButtonApply = 1203,
    DownloadCourseNotesButtonHint = 1204,
    DownloadCourseMaterialsButtonDownloadMaterials = 1205,
    DownloadCourseMaterialsButtonDownloadSuccessMsg = 1206,
    DownloadCourseMaterialsButtonSendEmailFailedMsg = 1207,
    DownloadCourseMaterialsButtonCancelButton = 1208,
    DownloadCourseMaterialsButtonApplyButton = 1209,
    DownloadCourseMaterialsButtonDownload = 1210,
    DownloadCourseMaterialsButtonSendEmail = 1211,
    ClientUserCourseTableEnterCourse = 1212,
    ClientUserCourseTableCourseMaterials = 1213,
    ClientUserCourseTableCourseName = 1214,
    ClientUserCourseTableAccessPeriod = 1215,
    ClientUserCourseTableProgress = 1216,
    ClientUserCourseTableFinalScore = 1217,
    ClientUserCourseTableFinalCourseStatus = 1218,
    ClientUserCourseTableFinalStudyStatus = 1219,
    ClientUserCourseTableFinalAction = 1220,
    CourseDescriptionContentCourseDescription = 1221,
    ImageFileTextLinkContentCourseDescription = 1222,
    VideoContentCourseDescription = 1223,
    CourseModuleCardCourseDescription = 1224,
    CourseModuleCardAccessPeriod = 1225,
    CourseDetailsHeaderLearningProgress = 1226,
    CourseDetailsHeaderBackButton = 1227,
    CourseDetailsHeaderNextButton = 1228,
    CourseDetailsHeaderSubmitButton = 1229,
    QuizExamContentNote = 1230,
    QuizExamContentNoteHint = 1231,
    QuizExamContentExamQuizStatus = 1232,
    QuizExamContentStartExamQuiz = 1233,
    QuizExamResultModalConfirm = 1234,
    QuizExamResultModalPassedMsg = 1235,
    QuizExamResultModalNotPassedMsg = 1236,
    CALAssessmentPlatformContentAssessmentCompletedDetails = 1237,
    CALAssessmentPlatformContentAssessmentCompletedHint = 1238,
    CALAssessmentPlatformContentStartAssessment = 1239,
    CourseNotesButtonNotesTakingTitle = 1240,
    CourseNotesButtonNotesTakingHint = 1241,
    CourseNotesButtonNotesTakingPlaceholder = 1242,
    FilterClientUerCourseButtonCourseName = 1243,
    FilterClientUerCourseButtonCourseNamePlaceholder = 1244,
    FilterClientUerCourseButtonAccessPeriod = 1245,
    FilterClientUerCourseButtonCourseStatuses = 1246,
    FilterClientUerCourseButtonCourseStatusesPlaceholder = 1247,
    FilterClientUerCourseButtonStudyStatuses = 1248,
    FilterClientUerCourseButtonNotStarted = 1249,
    FilterClientUerCourseButtonInProgress = 1250,
    FilterClientUerCourseButtonExpired = 1251,
    FilterClientUerCourseButtonSelectStudyStatuses = 1252,
    FilterClientUerCourseButtonNotCompleted = 1253,
    FilterClientUerCourseButtonCompleted = 1254,
    FilterClientUerCourseButtonPassed = 1255,
    FilterClientUerCourseButtonResetButton = 1256,
    FilterClientUerCourseButtonApplyButton = 1257,
    ClientgroupSettingsDropDownNavigationTitle = 1258,
    ClientgroupAssessmentDropDownNavigationTitle = 1259,
    ClientgroupCourseDropDownNavigationTitle = 1260,
    ClientgroupClientDropDownNavigationTitle = 1261,
    ClientGroupClientCourseSettingNavigationTitle = 1262,
    ClientGroupCourseProgressNavigationTitle = 1263,
    CourseGroupSettingTableHeaderCourseName = 1264,
    CourseGroupSettingTableHeaderModuleCount = 1265,
    CourseGroupSettingTableHeaderLanguage = 1266,
    CourseGroupSettingUpdateSuccessMessage = 1267,
    CourseGroupSettingTableHeaderStartDate = 1268,
    CourseGroupSettingTableHeaderEndDate = 1269,
    CourseGroupSettingTableHeaderDurationDay = 1270,
    CourseGroupSettingTableHeaderIsAllowDownload = 1271,
    CourseGroupSettingTableHeaderAction = 1272,
    CourseGroupSettingNavigationTitle = 1273,
    CourseGroupSettingAddButton = 1274,
    CourseGroupSettingDeactivateConfirmMessage = 1275,
    CourseGroupSettingdeleteSuccessMessage = 1276,
    CourseGroupGradingTableHeaderFinalScoreRange = 1277,
    CourseGroupGradingTableHeaderGrading = 1278,
    CourseGroupGradingTableHeaderPassingScore = 1279,
    CourseGroupGradingTableHeaderAction = 1280,
    CourseGroupGradingNavigationTitle = 1281,
    CourseGroupGradingAddGrandingButton = 1282,
    CourseGroupGradingModalUpdateTitle = 1283,
    CourseGroupGradingModalAddTitle = 1284,
    CourseGroupGradingTableHeaderLowestFinalScore = 1285,
    CourseGroupGradingTableHeaderHighestFinalScore = 1286,
    CourseGroupCertificateTempCompletionMessagePassTitle = 1287,
    CourseGroupCertificateTempCompletionMessageFailTitle = 1288,
    CourseGroupCertificateTempNavigationTitle = 1289,
    CourseGroupCertificateTempUploadDateTitle = 1290,
    CourseGroupCertificateTempActionTitle = 1291,
    FilterTitle = 1292,
    CourseGroupModuleTableHeaderModule = 1293,
    CourseGroupModuleTableHeaderStartDate = 1294,
    CourseGroupModuleTableHeaderEndDate = 1295,
    CourseGroupModuleTableHeaderDurationDay = 1296,
    CourseGroupModuleTableHeaderAction = 1297,
    CourseGroupModuleEndDateBeforeStartDateErrorMessage = 1298,
    CourseGroupModuleUpdateSuccessMessage = 1299,
    CourseGroupModuleApplyButton = 1300,
    CourseGroupModuleEditModalTitle = 1301,
    CourseGroupModuleEditModalButton = 1302,
    CourseGroupModuleStepTableHeaderQuizExamName = 1303,
    CourseGroupModuleStepTableHeaderQuizPassingScore = 1304,
    CourseGroupModuleStepTableHeaderQuizWeight = 1305,
    CourseGroupModuleStepTableHeaderPassMsg = 1306,
    CourseGroupModuleStepTableHeaderFailHasChanceMsg = 1307,
    CourseGroupModuleStepTableHeaderFailNoChanceMsg = 1308,
    CourseGroupModuleStepTableHeaderAction = 1309,
    CourseGroupModuleStepEditButton = 1310,
    CourseGroupModuleStepEditSuccessMessage = 1311,
    CourseGroupModuleStepEditModalTitle = 1312,
    CourseGroupModuleStepApplyButton = 1313,
    CourseProgressTableHeaderID = 1314,
    CourseProgressTableHeaderUserName = 1315,
    CourseProgressTableHeaderEmail = 1316,
    CourseProgressTableHeaderCourseName = 1317,
    CourseProgressTableHeaderProgress = 1318,
    CourseProgressTableHeaderFinalScore = 1319,
    CourseProgressTableHeaderAction = 1320,
    StaticConfirmSendMessage = 1321,
    CourseProgressSendReminderEmail = 1322,
    CourseProgressReminderSending = 1323,
    CourseProgressDownload = 1324,
    CourseProgressDownloadButton = 1325,
    CourseProgressExamQuizFile = 1326,
    CourseProgressExamQuizFileDownload = 1327,
    CourseProgressExamQuizTableHeaderQuestionName = 1328,
    CourseProgressExamQuizTableHeaderScore = 1329,
    CourseProgressExamQuizTableHeaderWeight = 1330,
    CourseProgressExamQuizTableHeaderAction = 1331,
    UpdateMediaLibraryImageAddImage = 1332,
    UpdateMediaLibraryImageEditImage = 1333,
    VideoMediaLibraryNavigationTitle = 1334,
    StaticApplyButton = 1335,
    MyLearningTitle = 1336,
    SettingsTitle = 1337,
    QuestionBankTempDownloadTempButton = 1338,
    ClientGroupEmailCustomRecordLmsReminderEmailToken = 1339,
    ClientGroupEmailCustomRecordLmsReminderEmailTitle = 1340,
    ClientGroupEmailCustomRecordLmsReminderEmailTemplate = 1341,
    CourseProgressTableHeaderTimeCompleted = 1342,
    QuestionBankTableHeaderQuestionName = 1343,
    QuestionBankTableHeaderAction = 1344,
    StaticCreateCourseTitle = 1345,
    StaticAllCourseTitle = 1346,
    StaticMediaLibraryTitle = 1347,
    DownloadCourseCertificateButtonDownloadFailedHint = 1348,
    DownloadCourseCertificateButtonSendFailed = 1349,
    ClientUserCourseTableLastSeenDate = 1350,
    QuizExamResultHasRetestMessage = 1351,
    DownloadCourseAssessmentButtonSendSuccess = 1352,
    DownloadCourseMaterialsButtonSendSuccess = 1353,
    DownloadCourseNotesButtonSendSuccess = 1354,
    DownloadCourseQuizExamButtonSendSuccess = 1355,
    DownloadCourseNotesButtonCancel = 1356,
    WelcomeTitle = 1357,
    CalTitleEnter = 1358,
    CalAssessmentTitle = 1359,
    CalAssessmentDescription = 1360,
    CalCourseStudyTitle = 1361,
    CalCourseStudyDescription = 1362,
    UserCourseTitle = 1363,
    DownloadCourseAssessmentButton = 1364,
    CourseStatusNotStarted = 1365,
    CourseStatusInProgress = 1366,
    CourseStatusExpired = 1367,
    StudyStatusNotCompleted = 1368,
    StudyStatusCompleted = 1369,
    StudyStatusPassed = 1370,
    CourseModuleCardSequentialNoticeMessage = 1371,
    CourseModuleCardSequentialPromptInformation = 1372,
    CalCMSTitle = 1373,
    HeaderHiTitle = 1374,
    CourseLearningVideoPromptMessage = 1375,
    CourseLearningAssessmentPromptMessage = 1376,
    CourseLearningQuizExamPromptMessage = 1377,
    CourseChangeLanguage = 1378,
    CourseSelectLanguage = 1379,
    ClientUserCourseStatusCompletedMessage = 1380,
    ClientUserCourseStatusPassedMessage = 1381,
    CourseEndedModalNotStartedMessage = 1382,
    CourseEndedModalAccessPeriodMessage = 1383,
    CourseEndedModalEndedMessage = 1384,
    QuizExamContentExamQuizScores = 1385,
    CourseGroupSettingButtonEditCourse = 1386,
    CourseGroupSettingButtonDeactivate = 1387,
    CourseGroupSettingButtonGrading = 1388,
    CourseGroupSettingButtonCertificate = 1389,
    DownloadCourseQuizExamButtonDownloadSuccess = 1390,
    DownloadCourseQuizExamButtonQuizExam = 1391,
    DownloadCourseQuizExamButtonCancel = 1392,
    DownloadCourseQuizExamButtonApply = 1393,
    DownloadCourseQuizExamButtonDownload = 1394,
    DownloadCourseQuizExamButtonSendByEmail = 1395,
    AssessmentBackToCourseButton = 1396,
    ClientUserCourseConfirmButton = 1397,
    CourseEndedModalConfirmButton = 1398,
    CourseProgressTableHeaderLastSeenDate = 1399,
    CourseProgressTableHeaderFirstClickDate = 1400,
    DownloadCourseAssessmentButtonDownloadSuccess = 1401,
    CourseProgressTableHeaderScore = 1402,
    ClientUserCourseTableScore = 1403,
    CourseInformationCardScore = 1404,
    ClientGroupClientUserTableHeaderFirstTimeLogin = 1405,
    ClientGroupClientUserTableHeaderLastLogin = 1406,
    DefaultGradingScoreMessage = 1407,
    CourseProgressFilterLabelID = 1408,
    CourseProgressFilterLabelUserName = 1409,
    CourseProgressFilterLabelEmail = 1410,
    CourseProgressFilterLabelCourseName = 1411,
    CourseProgressFilterLabelProgress = 1412,
    CourseProgressFilterLabelFinalScore = 1413,
    FilterResetButton = 1414,
    FilterApplyButton = 1415,
    DownloadCourseMaterialsButtonNoMaterials = 1416,
    DownloadCourseMaterialsButtonSelectFileWarning = 1417,
    CancelSelectAllCheckboxTitle = 1418,
    SelectAllCheckboxTitle = 1419,
    DownloadCourseMaterialsButtonSelectFileTitle = 1420,
    DownloadCourseMaterialsButtonDownloadMethodTitle = 1421,
    DownloadCourseMaterialsAssessmentTitle = 1422,
    LoginSystemTypeAllTitle = 1423,
    LoginSystemTypeAssessmentTitle = 1424,
    LoginSystemTypeCourseTitle = 1425,
    ClientUserClientUserStaticMissingLoginSystemTypeRule = 1426,
    ClientUserClientUserStaticLoginSystemTypeLabel = 1427,
    QuizExamHandleModalDelete = 1428,
    CourseQuestionChoiceListModalAddTitle = 1429,
    CourseGroupSettingAddCourseModalTitle = 1430,
    CourseGroupCertificateTempFileTitle = 1431,
    ClientGroupEmailCustomRecordLmsCertificateReminderEmailToken = 1432,
    ClientGroupEmailCustomRecordLmsCertificateReminderEmailTitle = 1433,
    ClientGroupEmailCustomRecordLmsCertificateReminderEmailTemplate = 1434,
    BillingCourseSummaryNavigationTitle = 1435,
    BillingCourseSummaryTableHeaderCourse = 1436,
    BillingCourseSummaryTableHeaderParentGroup = 1437,
    BillingCourseSummaryTableHeaderGroup = 1438,
    BillingCourseSummaryTableHeaderTotalCourse = 1439,
    BillingCourseSummaryTableHeaderCompletedCourse = 1440,
    BillingCourseSummaryTableHeaderActivateAccounts = 1441,
    BillingCourseSummaryTableHeaderDeactivateAccounts = 1442,
    BillingCourseSummaryTableHeaderTotalAccounts = 1443,
    BillingCourseSummaryTableHeaderAction = 1444,
    BillingCourseSummaryFilterLabelClientGroup = 1445,
    BillingCourseSummaryFilterLabelCourse = 1446,
    BillingCourseSummaryFilterLabelHasCompletedCourse = 1447,
    BillingCourseSummaryFilterLabelUserAddedDate = 1448,
    BillingCourseSummaryFilterLabelCourseStartTimeDate = 1449,
    BillingCourseSummaryFilterLabelCourseEndTimeDate = 1450,
    BillingCourseSummaryFormCoursePlaceholder = 1451,
    BillingCourseSummaryModalExportTableTitle = 1452,
    BillingCourseDetailTableHeaderLoginID = 1453,
    BillingCourseDetailTableHeaderFullName = 1454,
    BillingCourseDetailTableHeaderEmail = 1455,
    BillingCourseDetailTableHeaderCourseProgress = 1456,
    BillingCourseDetailTableHeaderUserAddedTime = 1457,
    BillingCourseDetailTableHeaderCourseStartTime = 1458,
    BillingCourseDetailTableHeaderCourseEndTime = 1459,
    BillingCourseDetailTableHeaderLoginTimeCount = 1460,
    BillingCourseDetailFilterLabeluserAddedDate = 1461,
    BillingCourseDetailFilterLabelCourseStartDate = 1462,
    BillingCourseDetailFilterLabelCourseEndDate = 1463,
    BillingCourseDetailFilterLabelCompletedCourse = 1464,
    BillingCourseDetailModalExportTableTitle = 1465,
    DefaultLmsCertificateReminderCustomEmail = 1466,
    DefaultLmsCertificateReminderCustomTitle = 1467,
    DefaultLmsVerificationCodeReminderCustomEmail = 1468,
    DefaultLmsVerificationCodeReminderCustomTitle = 1469,
    ClientGroupEmailCustomRecordLmsVerificationCodeReminderEmailToken = 1470,
    ClientGroupEmailCustomRecordLmsVerificationCodeReminderEmailTitle = 1471,
    ClientGroupEmailCustomRecordLmsVerificationCodeReminderEmailTemplate = 1472,
    AllCourseLastModifiedDateNewestFirstText = 1473,
    AllCourseLastModifiedDateOldestFirstText = 1474,
    VideoContentAutoNextHint = 1475,
    MediaLibraryLastModifiedDateNewestFirstText = 1476,
    MediaLibraryLastModifiedDateOldestFirstText = 1477,
    MediaLibraryDeleteSelected = 1478,
    MediaLibrarySelectedImagesCount = 1479,
    MediaLibraryDeleteSuccess = 1480,
    MediaLibrarySelectedVideosCount = 1481,
    MediaLibraryDeleteConfirmTitle = 1482,
    MediaLibraryDeleteConfirmContent = 1483,
    MediaLibraryDeleteCancel = 1484,
    AllCourseIdString = 1485,
    DownloadCourseNotesButtonDownloadSuccess = 1486,
    ClientUserCourseStatusPassedWithoutCertificateMessage = 1487,
    UploadFileSizeCannotExceed15MB = 1488,
}

export class ClientUserQuestionChoiceDto implements IClientUserQuestionChoiceDto {
    id?: number;
    content?: string | undefined;
    order?: number | undefined;
    isPlaceHolder?: boolean;

    constructor(data?: IClientUserQuestionChoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.content = _data["content"];
            this.order = _data["order"];
            this.isPlaceHolder = _data["isPlaceHolder"];
        }
    }

    static fromJS(data: any): ClientUserQuestionChoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientUserQuestionChoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["content"] = this.content;
        data["order"] = this.order;
        data["isPlaceHolder"] = this.isPlaceHolder;
        return data;
    }
}

export interface IClientUserQuestionChoiceDto {
    id?: number;
    content?: string | undefined;
    order?: number | undefined;
    isPlaceHolder?: boolean;
}

export class PaginatedListOfClientUserBriefDto implements IPaginatedListOfClientUserBriefDto {
    items?: ClientUserBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfClientUserBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ClientUserBriefDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfClientUserBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfClientUserBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfClientUserBriefDto {
    items?: ClientUserBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class ClientUserDto implements IClientUserDto {
    id?: string;
    fullName?: string | undefined;
    email?: string | undefined;
    userName?: string | undefined;
    haveChangePassword?: boolean;
    haveEnterDetail?: boolean;
    preferredLanguage?: SupportedLanguage | undefined;
    clientGroupCanCustomizePreferredLanguage?: boolean;
    clientGroupCanCustomizeEmail?: boolean;
    clientGroupCanCustomizePassword?: boolean;
    clientGroupCanCustomizeFullName?: boolean;
    clientGroupCustomFullNameLabel?: string | undefined;
    clientGroupId?: number | undefined;
    clientGroupLogoFileId?: number | undefined;

    constructor(data?: IClientUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.userName = _data["userName"];
            this.haveChangePassword = _data["haveChangePassword"];
            this.haveEnterDetail = _data["haveEnterDetail"];
            this.preferredLanguage = _data["preferredLanguage"] ? SupportedLanguage.fromJS(_data["preferredLanguage"]) : <any>undefined;
            this.clientGroupCanCustomizePreferredLanguage = _data["clientGroupCanCustomizePreferredLanguage"];
            this.clientGroupCanCustomizeEmail = _data["clientGroupCanCustomizeEmail"];
            this.clientGroupCanCustomizePassword = _data["clientGroupCanCustomizePassword"];
            this.clientGroupCanCustomizeFullName = _data["clientGroupCanCustomizeFullName"];
            this.clientGroupCustomFullNameLabel = _data["clientGroupCustomFullNameLabel"];
            this.clientGroupId = _data["clientGroupId"];
            this.clientGroupLogoFileId = _data["clientGroupLogoFileId"];
        }
    }

    static fromJS(data: any): ClientUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["userName"] = this.userName;
        data["haveChangePassword"] = this.haveChangePassword;
        data["haveEnterDetail"] = this.haveEnterDetail;
        data["preferredLanguage"] = this.preferredLanguage ? this.preferredLanguage.toJSON() : <any>undefined;
        data["clientGroupCanCustomizePreferredLanguage"] = this.clientGroupCanCustomizePreferredLanguage;
        data["clientGroupCanCustomizeEmail"] = this.clientGroupCanCustomizeEmail;
        data["clientGroupCanCustomizePassword"] = this.clientGroupCanCustomizePassword;
        data["clientGroupCanCustomizeFullName"] = this.clientGroupCanCustomizeFullName;
        data["clientGroupCustomFullNameLabel"] = this.clientGroupCustomFullNameLabel;
        data["clientGroupId"] = this.clientGroupId;
        data["clientGroupLogoFileId"] = this.clientGroupLogoFileId;
        return data;
    }
}

export interface IClientUserDto {
    id?: string;
    fullName?: string | undefined;
    email?: string | undefined;
    userName?: string | undefined;
    haveChangePassword?: boolean;
    haveEnterDetail?: boolean;
    preferredLanguage?: SupportedLanguage | undefined;
    clientGroupCanCustomizePreferredLanguage?: boolean;
    clientGroupCanCustomizeEmail?: boolean;
    clientGroupCanCustomizePassword?: boolean;
    clientGroupCanCustomizeFullName?: boolean;
    clientGroupCustomFullNameLabel?: string | undefined;
    clientGroupId?: number | undefined;
    clientGroupLogoFileId?: number | undefined;
}

export class UpdateClientUserCommand implements IUpdateClientUserCommand {
    fullName?: string | undefined;
    email?: string | undefined;
    preferredLanguageId?: string | undefined;
    remark?: string | undefined;

    constructor(data?: IUpdateClientUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.preferredLanguageId = _data["preferredLanguageId"];
            this.remark = _data["remark"];
        }
    }

    static fromJS(data: any): UpdateClientUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClientUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["preferredLanguageId"] = this.preferredLanguageId;
        data["remark"] = this.remark;
        return data;
    }
}

export interface IUpdateClientUserCommand {
    fullName?: string | undefined;
    email?: string | undefined;
    preferredLanguageId?: string | undefined;
    remark?: string | undefined;
}

export class ForceUpdateClientUserCommand implements IForceUpdateClientUserCommand {
    id?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    preferredLanguageId?: string | undefined;
    remark?: string | undefined;

    constructor(data?: IForceUpdateClientUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.preferredLanguageId = _data["preferredLanguageId"];
            this.remark = _data["remark"];
        }
    }

    static fromJS(data: any): ForceUpdateClientUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ForceUpdateClientUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["preferredLanguageId"] = this.preferredLanguageId;
        data["remark"] = this.remark;
        return data;
    }
}

export interface IForceUpdateClientUserCommand {
    id?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    preferredLanguageId?: string | undefined;
    remark?: string | undefined;
}

export class UpdateClientUserClientGroupCommand implements IUpdateClientUserClientGroupCommand {
    id?: string;
    clientGroupId?: number;

    constructor(data?: IUpdateClientUserClientGroupCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientGroupId = _data["clientGroupId"];
        }
    }

    static fromJS(data: any): UpdateClientUserClientGroupCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClientUserClientGroupCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientGroupId"] = this.clientGroupId;
        return data;
    }
}

export interface IUpdateClientUserClientGroupCommand {
    id?: string;
    clientGroupId?: number;
}

export class BulkUpdateClientUserClientGroupCommand implements IBulkUpdateClientUserClientGroupCommand {
    ids?: string[];
    clientGroupId?: number;

    constructor(data?: IBulkUpdateClientUserClientGroupCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.clientGroupId = _data["clientGroupId"];
        }
    }

    static fromJS(data: any): BulkUpdateClientUserClientGroupCommand {
        data = typeof data === 'object' ? data : {};
        let result = new BulkUpdateClientUserClientGroupCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["clientGroupId"] = this.clientGroupId;
        return data;
    }
}

export interface IBulkUpdateClientUserClientGroupCommand {
    ids?: string[];
    clientGroupId?: number;
}

export class CreateClientUserCommand implements ICreateClientUserCommand {
    clientGroupId?: number;
    userName?: string | undefined;
    password?: string | undefined;
    fullName?: string | undefined;
    preferredLanguageId?: string | undefined;
    email?: string | undefined;
    hasEmailNotification?: boolean | undefined;
    remark?: string | undefined;

    constructor(data?: ICreateClientUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientGroupId = _data["clientGroupId"];
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.fullName = _data["fullName"];
            this.preferredLanguageId = _data["preferredLanguageId"];
            this.email = _data["email"];
            this.hasEmailNotification = _data["hasEmailNotification"];
            this.remark = _data["remark"];
        }
    }

    static fromJS(data: any): CreateClientUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClientUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientGroupId"] = this.clientGroupId;
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["fullName"] = this.fullName;
        data["preferredLanguageId"] = this.preferredLanguageId;
        data["email"] = this.email;
        data["hasEmailNotification"] = this.hasEmailNotification;
        data["remark"] = this.remark;
        return data;
    }
}

export interface ICreateClientUserCommand {
    clientGroupId?: number;
    userName?: string | undefined;
    password?: string | undefined;
    fullName?: string | undefined;
    preferredLanguageId?: string | undefined;
    email?: string | undefined;
    hasEmailNotification?: boolean | undefined;
    remark?: string | undefined;
}

export class SendResetPasswordEmailCommand implements ISendResetPasswordEmailCommand {
    userId?: string;
    defaultLanguageId?: string;

    constructor(data?: ISendResetPasswordEmailCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.defaultLanguageId = _data["defaultLanguageId"];
        }
    }

    static fromJS(data: any): SendResetPasswordEmailCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendResetPasswordEmailCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["defaultLanguageId"] = this.defaultLanguageId;
        return data;
    }
}

export interface ISendResetPasswordEmailCommand {
    userId?: string;
    defaultLanguageId?: string;
}

export class UpdateClientUserPasswordCommand implements IUpdateClientUserPasswordCommand {
    oldPassword?: string;
    newPassword?: string;

    constructor(data?: IUpdateClientUserPasswordCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldPassword = _data["oldPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): UpdateClientUserPasswordCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClientUserPasswordCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldPassword"] = this.oldPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IUpdateClientUserPasswordCommand {
    oldPassword?: string;
    newPassword?: string;
}

export class ForceUpdateClientUserPasswordCommand implements IForceUpdateClientUserPasswordCommand {
    userId?: string;
    newPassword?: string;

    constructor(data?: IForceUpdateClientUserPasswordCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ForceUpdateClientUserPasswordCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ForceUpdateClientUserPasswordCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IForceUpdateClientUserPasswordCommand {
    userId?: string;
    newPassword?: string;
}

export class UpdateClientUserEmailCommand implements IUpdateClientUserEmailCommand {
    email?: string | undefined;

    constructor(data?: IUpdateClientUserEmailCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): UpdateClientUserEmailCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClientUserEmailCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface IUpdateClientUserEmailCommand {
    email?: string | undefined;
}

export class SendClientResetPasswordEmailCommand implements ISendClientResetPasswordEmailCommand {

    constructor(data?: ISendClientResetPasswordEmailCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): SendClientResetPasswordEmailCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendClientResetPasswordEmailCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ISendClientResetPasswordEmailCommand {
}

export class ClientResetPasswordCommand implements IClientResetPasswordCommand {
    newPassword?: string;
    verificationCode?: string;

    constructor(data?: IClientResetPasswordCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newPassword = _data["newPassword"];
            this.verificationCode = _data["verificationCode"];
        }
    }

    static fromJS(data: any): ClientResetPasswordCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ClientResetPasswordCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newPassword"] = this.newPassword;
        data["verificationCode"] = this.verificationCode;
        return data;
    }
}

export interface IClientResetPasswordCommand {
    newPassword?: string;
    verificationCode?: string;
}

export class ClientCheckVerificationCodeCommand implements IClientCheckVerificationCodeCommand {
    userId?: string;
    code?: string;

    constructor(data?: IClientCheckVerificationCodeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ClientCheckVerificationCodeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ClientCheckVerificationCodeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["code"] = this.code;
        return data;
    }
}

export interface IClientCheckVerificationCodeCommand {
    userId?: string;
    code?: string;
}

export class ClientUserPermissionDto implements IClientUserPermissionDto {
    isCourse?: boolean;
    isAssessment?: boolean;

    constructor(data?: IClientUserPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isCourse = _data["isCourse"];
            this.isAssessment = _data["isAssessment"];
        }
    }

    static fromJS(data: any): ClientUserPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientUserPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isCourse"] = this.isCourse;
        data["isAssessment"] = this.isAssessment;
        return data;
    }
}

export interface IClientUserPermissionDto {
    isCourse?: boolean;
    isAssessment?: boolean;
}

export class CourseCertificateTempReqDto implements ICourseCertificateTempReqDto {
    id?: number;
    courseId?: number;
    courseCertificateTempInfos?: { [key: string]: CourseCertificateTempInfoReqDto; };

    constructor(data?: ICourseCertificateTempReqDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.courseId = _data["courseId"];
            if (_data["courseCertificateTempInfos"]) {
                this.courseCertificateTempInfos = {} as any;
                for (let key in _data["courseCertificateTempInfos"]) {
                    if (_data["courseCertificateTempInfos"].hasOwnProperty(key))
                        (<any>this.courseCertificateTempInfos)![key] = _data["courseCertificateTempInfos"][key] ? CourseCertificateTempInfoReqDto.fromJS(_data["courseCertificateTempInfos"][key]) : new CourseCertificateTempInfoReqDto();
                }
            }
        }
    }

    static fromJS(data: any): CourseCertificateTempReqDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseCertificateTempReqDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["courseId"] = this.courseId;
        if (this.courseCertificateTempInfos) {
            data["courseCertificateTempInfos"] = {};
            for (let key in this.courseCertificateTempInfos) {
                if (this.courseCertificateTempInfos.hasOwnProperty(key))
                    (<any>data["courseCertificateTempInfos"])[key] = this.courseCertificateTempInfos[key] ? this.courseCertificateTempInfos[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface ICourseCertificateTempReqDto {
    id?: number;
    courseId?: number;
    courseCertificateTempInfos?: { [key: string]: CourseCertificateTempInfoReqDto; };
}

export class CourseCertificateTempInfoReqDto implements ICourseCertificateTempInfoReqDto {
    id?: number;
    supportedLanguageId?: string | undefined;
    completionPassMsg?: string | undefined;
    completionFailMsg?: string | undefined;
    courseCertificateTempFileId?: number;
    courseCertificateTempFile?: CourseCertificateTempFileReqDto | undefined;

    constructor(data?: ICourseCertificateTempInfoReqDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.supportedLanguageId = _data["supportedLanguageId"];
            this.completionPassMsg = _data["completionPassMsg"];
            this.completionFailMsg = _data["completionFailMsg"];
            this.courseCertificateTempFileId = _data["courseCertificateTempFileId"];
            this.courseCertificateTempFile = _data["courseCertificateTempFile"] ? CourseCertificateTempFileReqDto.fromJS(_data["courseCertificateTempFile"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CourseCertificateTempInfoReqDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseCertificateTempInfoReqDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["supportedLanguageId"] = this.supportedLanguageId;
        data["completionPassMsg"] = this.completionPassMsg;
        data["completionFailMsg"] = this.completionFailMsg;
        data["courseCertificateTempFileId"] = this.courseCertificateTempFileId;
        data["courseCertificateTempFile"] = this.courseCertificateTempFile ? this.courseCertificateTempFile.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICourseCertificateTempInfoReqDto {
    id?: number;
    supportedLanguageId?: string | undefined;
    completionPassMsg?: string | undefined;
    completionFailMsg?: string | undefined;
    courseCertificateTempFileId?: number;
    courseCertificateTempFile?: CourseCertificateTempFileReqDto | undefined;
}

export class CourseCertificateTempFileReqDto implements ICourseCertificateTempFileReqDto {
    id?: number;
    fileId?: number;
    fileName?: string;
    uploadDate?: Date;

    constructor(data?: ICourseCertificateTempFileReqDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileId = _data["fileId"];
            this.fileName = _data["fileName"];
            this.uploadDate = _data["uploadDate"] ? new Date(_data["uploadDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CourseCertificateTempFileReqDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseCertificateTempFileReqDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileId"] = this.fileId;
        data["fileName"] = this.fileName;
        data["uploadDate"] = this.uploadDate ? this.uploadDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICourseCertificateTempFileReqDto {
    id?: number;
    fileId?: number;
    fileName?: string;
    uploadDate?: Date;
}

/** Represents a void type, since Void is not a valid return type in C#. */
export class Unit implements IUnit {

    constructor(data?: IUnit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): Unit {
        data = typeof data === 'object' ? data : {};
        let result = new Unit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

/** Represents a void type, since Void is not a valid return type in C#. */
export interface IUnit {
}

export class UpdateCourseCertificateTempCommand extends CourseCertificateTempReqDto implements IUpdateCourseCertificateTempCommand {

    constructor(data?: IUpdateCourseCertificateTempCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpdateCourseCertificateTempCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCourseCertificateTempCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateCourseCertificateTempCommand extends ICourseCertificateTempReqDto {
}

export class CourseDefaultGradingDtoVm implements ICourseDefaultGradingDtoVm {
    courseDefaultGradingBriefDtos?: CourseDefaultGradingBriefDto[];
    score?: number;

    constructor(data?: ICourseDefaultGradingDtoVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["courseDefaultGradingBriefDtos"])) {
                this.courseDefaultGradingBriefDtos = [] as any;
                for (let item of _data["courseDefaultGradingBriefDtos"])
                    this.courseDefaultGradingBriefDtos!.push(CourseDefaultGradingBriefDto.fromJS(item));
            }
            this.score = _data["score"];
        }
    }

    static fromJS(data: any): CourseDefaultGradingDtoVm {
        data = typeof data === 'object' ? data : {};
        let result = new CourseDefaultGradingDtoVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.courseDefaultGradingBriefDtos)) {
            data["courseDefaultGradingBriefDtos"] = [];
            for (let item of this.courseDefaultGradingBriefDtos)
                data["courseDefaultGradingBriefDtos"].push(item.toJSON());
        }
        data["score"] = this.score;
        return data;
    }
}

export interface ICourseDefaultGradingDtoVm {
    courseDefaultGradingBriefDtos?: CourseDefaultGradingBriefDto[];
    score?: number;
}

export class CourseDefaultGradingBriefDto implements ICourseDefaultGradingBriefDto {
    id?: number;
    highestFinalScore?: number;
    lowestFinalScore?: number;
    isPassingScore?: boolean;
    grading?: string;

    constructor(data?: ICourseDefaultGradingBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.highestFinalScore = _data["highestFinalScore"];
            this.lowestFinalScore = _data["lowestFinalScore"];
            this.isPassingScore = _data["isPassingScore"];
            this.grading = _data["grading"];
        }
    }

    static fromJS(data: any): CourseDefaultGradingBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseDefaultGradingBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["highestFinalScore"] = this.highestFinalScore;
        data["lowestFinalScore"] = this.lowestFinalScore;
        data["isPassingScore"] = this.isPassingScore;
        data["grading"] = this.grading;
        return data;
    }
}

export interface ICourseDefaultGradingBriefDto {
    id?: number;
    highestFinalScore?: number;
    lowestFinalScore?: number;
    isPassingScore?: boolean;
    grading?: string;
}

export class CourseDefaultGradingReqDto implements ICourseDefaultGradingReqDto {
    id?: number;
    highestFinalScore?: number;
    lowestFinalScore?: number;
    isPassingScore?: boolean;
    courseDefaultGradingInfos?: { [key: string]: CourseDefaultGradingInfoReqDto; };

    constructor(data?: ICourseDefaultGradingReqDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.highestFinalScore = _data["highestFinalScore"];
            this.lowestFinalScore = _data["lowestFinalScore"];
            this.isPassingScore = _data["isPassingScore"];
            if (_data["courseDefaultGradingInfos"]) {
                this.courseDefaultGradingInfos = {} as any;
                for (let key in _data["courseDefaultGradingInfos"]) {
                    if (_data["courseDefaultGradingInfos"].hasOwnProperty(key))
                        (<any>this.courseDefaultGradingInfos)![key] = _data["courseDefaultGradingInfos"][key] ? CourseDefaultGradingInfoReqDto.fromJS(_data["courseDefaultGradingInfos"][key]) : new CourseDefaultGradingInfoReqDto();
                }
            }
        }
    }

    static fromJS(data: any): CourseDefaultGradingReqDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseDefaultGradingReqDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["highestFinalScore"] = this.highestFinalScore;
        data["lowestFinalScore"] = this.lowestFinalScore;
        data["isPassingScore"] = this.isPassingScore;
        if (this.courseDefaultGradingInfos) {
            data["courseDefaultGradingInfos"] = {};
            for (let key in this.courseDefaultGradingInfos) {
                if (this.courseDefaultGradingInfos.hasOwnProperty(key))
                    (<any>data["courseDefaultGradingInfos"])[key] = this.courseDefaultGradingInfos[key] ? this.courseDefaultGradingInfos[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface ICourseDefaultGradingReqDto {
    id?: number;
    highestFinalScore?: number;
    lowestFinalScore?: number;
    isPassingScore?: boolean;
    courseDefaultGradingInfos?: { [key: string]: CourseDefaultGradingInfoReqDto; };
}

export class CourseDefaultGradingInfoReqDto implements ICourseDefaultGradingInfoReqDto {
    id?: number;
    supportedLanguageId?: string;
    grading?: string;

    constructor(data?: ICourseDefaultGradingInfoReqDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.supportedLanguageId = _data["supportedLanguageId"];
            this.grading = _data["grading"];
        }
    }

    static fromJS(data: any): CourseDefaultGradingInfoReqDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseDefaultGradingInfoReqDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["supportedLanguageId"] = this.supportedLanguageId;
        data["grading"] = this.grading;
        return data;
    }
}

export interface ICourseDefaultGradingInfoReqDto {
    id?: number;
    supportedLanguageId?: string;
    grading?: string;
}

export class CreateCourseDefaultGradingCommand extends CourseDefaultGradingReqDto implements ICreateCourseDefaultGradingCommand {
    courseId?: number;

    constructor(data?: ICreateCourseDefaultGradingCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.courseId = _data["courseId"];
        }
    }

    static fromJS(data: any): CreateCourseDefaultGradingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCourseDefaultGradingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseId"] = this.courseId;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateCourseDefaultGradingCommand extends ICourseDefaultGradingReqDto {
    courseId?: number;
}

export class UpdateCourseDefaultGradingCommand extends CourseDefaultGradingReqDto implements IUpdateCourseDefaultGradingCommand {

    constructor(data?: IUpdateCourseDefaultGradingCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpdateCourseDefaultGradingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCourseDefaultGradingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateCourseDefaultGradingCommand extends ICourseDefaultGradingReqDto {
}

export class CourseGroupCertificateTempDtoVm implements ICourseGroupCertificateTempDtoVm {
    courseGroupCertificateTemps?: CourseGroupCertificateTempReqDto;
    courseName?: string;

    constructor(data?: ICourseGroupCertificateTempDtoVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseGroupCertificateTemps = _data["courseGroupCertificateTemps"] ? CourseGroupCertificateTempReqDto.fromJS(_data["courseGroupCertificateTemps"]) : <any>undefined;
            this.courseName = _data["courseName"];
        }
    }

    static fromJS(data: any): CourseGroupCertificateTempDtoVm {
        data = typeof data === 'object' ? data : {};
        let result = new CourseGroupCertificateTempDtoVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseGroupCertificateTemps"] = this.courseGroupCertificateTemps ? this.courseGroupCertificateTemps.toJSON() : <any>undefined;
        data["courseName"] = this.courseName;
        return data;
    }
}

export interface ICourseGroupCertificateTempDtoVm {
    courseGroupCertificateTemps?: CourseGroupCertificateTempReqDto;
    courseName?: string;
}

export class CourseGroupCertificateTempReqDto implements ICourseGroupCertificateTempReqDto {
    id?: number;
    courseGroupSettingId?: number;
    courseGroupCertificateTempInfos?: { [key: string]: CGCertificateTempInfoReqDto; };

    constructor(data?: ICourseGroupCertificateTempReqDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.courseGroupSettingId = _data["courseGroupSettingId"];
            if (_data["courseGroupCertificateTempInfos"]) {
                this.courseGroupCertificateTempInfos = {} as any;
                for (let key in _data["courseGroupCertificateTempInfos"]) {
                    if (_data["courseGroupCertificateTempInfos"].hasOwnProperty(key))
                        (<any>this.courseGroupCertificateTempInfos)![key] = _data["courseGroupCertificateTempInfos"][key] ? CGCertificateTempInfoReqDto.fromJS(_data["courseGroupCertificateTempInfos"][key]) : new CGCertificateTempInfoReqDto();
                }
            }
        }
    }

    static fromJS(data: any): CourseGroupCertificateTempReqDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseGroupCertificateTempReqDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["courseGroupSettingId"] = this.courseGroupSettingId;
        if (this.courseGroupCertificateTempInfos) {
            data["courseGroupCertificateTempInfos"] = {};
            for (let key in this.courseGroupCertificateTempInfos) {
                if (this.courseGroupCertificateTempInfos.hasOwnProperty(key))
                    (<any>data["courseGroupCertificateTempInfos"])[key] = this.courseGroupCertificateTempInfos[key] ? this.courseGroupCertificateTempInfos[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface ICourseGroupCertificateTempReqDto {
    id?: number;
    courseGroupSettingId?: number;
    courseGroupCertificateTempInfos?: { [key: string]: CGCertificateTempInfoReqDto; };
}

export class CGCertificateTempInfoReqDto implements ICGCertificateTempInfoReqDto {
    id?: number;
    supportedLanguageId?: string | undefined;
    completionPassMsg?: string | undefined;
    completionFailMsg?: string | undefined;
    courseGroupCertificateTempFileId?: number;
    courseGroupCertificateTempFile?: CGCertificateTempFileDto | undefined;

    constructor(data?: ICGCertificateTempInfoReqDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.supportedLanguageId = _data["supportedLanguageId"];
            this.completionPassMsg = _data["completionPassMsg"];
            this.completionFailMsg = _data["completionFailMsg"];
            this.courseGroupCertificateTempFileId = _data["courseGroupCertificateTempFileId"];
            this.courseGroupCertificateTempFile = _data["courseGroupCertificateTempFile"] ? CGCertificateTempFileDto.fromJS(_data["courseGroupCertificateTempFile"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CGCertificateTempInfoReqDto {
        data = typeof data === 'object' ? data : {};
        let result = new CGCertificateTempInfoReqDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["supportedLanguageId"] = this.supportedLanguageId;
        data["completionPassMsg"] = this.completionPassMsg;
        data["completionFailMsg"] = this.completionFailMsg;
        data["courseGroupCertificateTempFileId"] = this.courseGroupCertificateTempFileId;
        data["courseGroupCertificateTempFile"] = this.courseGroupCertificateTempFile ? this.courseGroupCertificateTempFile.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICGCertificateTempInfoReqDto {
    id?: number;
    supportedLanguageId?: string | undefined;
    completionPassMsg?: string | undefined;
    completionFailMsg?: string | undefined;
    courseGroupCertificateTempFileId?: number;
    courseGroupCertificateTempFile?: CGCertificateTempFileDto | undefined;
}

export class CGCertificateTempFileDto implements ICGCertificateTempFileDto {
    id?: number;
    fileId?: number;
    fileName?: string;
    uploadDate?: Date;

    constructor(data?: ICGCertificateTempFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileId = _data["fileId"];
            this.fileName = _data["fileName"];
            this.uploadDate = _data["uploadDate"] ? new Date(_data["uploadDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CGCertificateTempFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new CGCertificateTempFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileId"] = this.fileId;
        data["fileName"] = this.fileName;
        data["uploadDate"] = this.uploadDate ? this.uploadDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICGCertificateTempFileDto {
    id?: number;
    fileId?: number;
    fileName?: string;
    uploadDate?: Date;
}

export class UpdateCourseGroupCertificateTempCommand extends CourseGroupCertificateTempReqDto implements IUpdateCourseGroupCertificateTempCommand {

    constructor(data?: IUpdateCourseGroupCertificateTempCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpdateCourseGroupCertificateTempCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCourseGroupCertificateTempCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateCourseGroupCertificateTempCommand extends ICourseGroupCertificateTempReqDto {
}

export class CourseGroupGradingSetupDtoVm implements ICourseGroupGradingSetupDtoVm {
    courseGroupGradingSetups?: CourseGroupGradingSetupBriefDto[];
    courseName?: string;
    score?: number;

    constructor(data?: ICourseGroupGradingSetupDtoVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["courseGroupGradingSetups"])) {
                this.courseGroupGradingSetups = [] as any;
                for (let item of _data["courseGroupGradingSetups"])
                    this.courseGroupGradingSetups!.push(CourseGroupGradingSetupBriefDto.fromJS(item));
            }
            this.courseName = _data["courseName"];
            this.score = _data["score"];
        }
    }

    static fromJS(data: any): CourseGroupGradingSetupDtoVm {
        data = typeof data === 'object' ? data : {};
        let result = new CourseGroupGradingSetupDtoVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.courseGroupGradingSetups)) {
            data["courseGroupGradingSetups"] = [];
            for (let item of this.courseGroupGradingSetups)
                data["courseGroupGradingSetups"].push(item.toJSON());
        }
        data["courseName"] = this.courseName;
        data["score"] = this.score;
        return data;
    }
}

export interface ICourseGroupGradingSetupDtoVm {
    courseGroupGradingSetups?: CourseGroupGradingSetupBriefDto[];
    courseName?: string;
    score?: number;
}

export class CourseGroupGradingSetupBriefDto implements ICourseGroupGradingSetupBriefDto {
    id?: number;
    highestFinalScore?: number;
    lowestFinalScore?: number;
    isPassingScore?: boolean;
    grading?: string;

    constructor(data?: ICourseGroupGradingSetupBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.highestFinalScore = _data["highestFinalScore"];
            this.lowestFinalScore = _data["lowestFinalScore"];
            this.isPassingScore = _data["isPassingScore"];
            this.grading = _data["grading"];
        }
    }

    static fromJS(data: any): CourseGroupGradingSetupBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseGroupGradingSetupBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["highestFinalScore"] = this.highestFinalScore;
        data["lowestFinalScore"] = this.lowestFinalScore;
        data["isPassingScore"] = this.isPassingScore;
        data["grading"] = this.grading;
        return data;
    }
}

export interface ICourseGroupGradingSetupBriefDto {
    id?: number;
    highestFinalScore?: number;
    lowestFinalScore?: number;
    isPassingScore?: boolean;
    grading?: string;
}

export class CourseGroupGradingSetupReqDto implements ICourseGroupGradingSetupReqDto {
    id?: number;
    highestFinalScore?: number;
    lowestFinalScore?: number;
    isPassingScore?: boolean;
    courseGroupGradingSetupInfos?: { [key: string]: CourseGroupGradingSetupInfoReqDto; };

    constructor(data?: ICourseGroupGradingSetupReqDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.highestFinalScore = _data["highestFinalScore"];
            this.lowestFinalScore = _data["lowestFinalScore"];
            this.isPassingScore = _data["isPassingScore"];
            if (_data["courseGroupGradingSetupInfos"]) {
                this.courseGroupGradingSetupInfos = {} as any;
                for (let key in _data["courseGroupGradingSetupInfos"]) {
                    if (_data["courseGroupGradingSetupInfos"].hasOwnProperty(key))
                        (<any>this.courseGroupGradingSetupInfos)![key] = _data["courseGroupGradingSetupInfos"][key] ? CourseGroupGradingSetupInfoReqDto.fromJS(_data["courseGroupGradingSetupInfos"][key]) : new CourseGroupGradingSetupInfoReqDto();
                }
            }
        }
    }

    static fromJS(data: any): CourseGroupGradingSetupReqDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseGroupGradingSetupReqDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["highestFinalScore"] = this.highestFinalScore;
        data["lowestFinalScore"] = this.lowestFinalScore;
        data["isPassingScore"] = this.isPassingScore;
        if (this.courseGroupGradingSetupInfos) {
            data["courseGroupGradingSetupInfos"] = {};
            for (let key in this.courseGroupGradingSetupInfos) {
                if (this.courseGroupGradingSetupInfos.hasOwnProperty(key))
                    (<any>data["courseGroupGradingSetupInfos"])[key] = this.courseGroupGradingSetupInfos[key] ? this.courseGroupGradingSetupInfos[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface ICourseGroupGradingSetupReqDto {
    id?: number;
    highestFinalScore?: number;
    lowestFinalScore?: number;
    isPassingScore?: boolean;
    courseGroupGradingSetupInfos?: { [key: string]: CourseGroupGradingSetupInfoReqDto; };
}

export class CourseGroupGradingSetupInfoReqDto implements ICourseGroupGradingSetupInfoReqDto {
    id?: number;
    supportedLanguageId?: string;
    grading?: string;

    constructor(data?: ICourseGroupGradingSetupInfoReqDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.supportedLanguageId = _data["supportedLanguageId"];
            this.grading = _data["grading"];
        }
    }

    static fromJS(data: any): CourseGroupGradingSetupInfoReqDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseGroupGradingSetupInfoReqDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["supportedLanguageId"] = this.supportedLanguageId;
        data["grading"] = this.grading;
        return data;
    }
}

export interface ICourseGroupGradingSetupInfoReqDto {
    id?: number;
    supportedLanguageId?: string;
    grading?: string;
}

export class CreateCourseGroupGradingSetupCommand extends CourseGroupGradingSetupReqDto implements ICreateCourseGroupGradingSetupCommand {
    courseGroupSettingId?: number;

    constructor(data?: ICreateCourseGroupGradingSetupCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.courseGroupSettingId = _data["courseGroupSettingId"];
        }
    }

    static fromJS(data: any): CreateCourseGroupGradingSetupCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCourseGroupGradingSetupCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseGroupSettingId"] = this.courseGroupSettingId;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateCourseGroupGradingSetupCommand extends ICourseGroupGradingSetupReqDto {
    courseGroupSettingId?: number;
}

export class UpdateCourseGroupGradingSetupCommand extends CourseGroupGradingSetupReqDto implements IUpdateCourseGroupGradingSetupCommand {

    constructor(data?: IUpdateCourseGroupGradingSetupCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpdateCourseGroupGradingSetupCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCourseGroupGradingSetupCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateCourseGroupGradingSetupCommand extends ICourseGroupGradingSetupReqDto {
}

export class PaginatedListOfCourseGroupModuleBriefDto implements IPaginatedListOfCourseGroupModuleBriefDto {
    items?: CourseGroupModuleBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfCourseGroupModuleBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CourseGroupModuleBriefDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfCourseGroupModuleBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfCourseGroupModuleBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfCourseGroupModuleBriefDto {
    items?: CourseGroupModuleBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class CourseGroupModuleBriefDto implements ICourseGroupModuleBriefDto {
    id?: number;
    moduleName?: string;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    durationDays?: number | undefined;

    constructor(data?: ICourseGroupModuleBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.moduleName = _data["moduleName"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.durationDays = _data["durationDays"];
        }
    }

    static fromJS(data: any): CourseGroupModuleBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseGroupModuleBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["moduleName"] = this.moduleName;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["durationDays"] = this.durationDays;
        return data;
    }
}

export interface ICourseGroupModuleBriefDto {
    id?: number;
    moduleName?: string;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    durationDays?: number | undefined;
}

export class CourseGroupModuleReqDto implements ICourseGroupModuleReqDto {
    id?: number;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    durationDays?: number | undefined;

    constructor(data?: ICourseGroupModuleReqDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.durationDays = _data["durationDays"];
        }
    }

    static fromJS(data: any): CourseGroupModuleReqDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseGroupModuleReqDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["durationDays"] = this.durationDays;
        return data;
    }
}

export interface ICourseGroupModuleReqDto {
    id?: number;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    durationDays?: number | undefined;
}

export class UpdateCourseGroupModuleCommand extends CourseGroupModuleReqDto implements IUpdateCourseGroupModuleCommand {

    constructor(data?: IUpdateCourseGroupModuleCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpdateCourseGroupModuleCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCourseGroupModuleCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateCourseGroupModuleCommand extends ICourseGroupModuleReqDto {
}

export class PaginatedListOfCourseGroupModuleStepBriefDto implements IPaginatedListOfCourseGroupModuleStepBriefDto {
    items?: CourseGroupModuleStepBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfCourseGroupModuleStepBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CourseGroupModuleStepBriefDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfCourseGroupModuleStepBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfCourseGroupModuleStepBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfCourseGroupModuleStepBriefDto {
    items?: CourseGroupModuleStepBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class CourseGroupModuleStepBriefDto implements ICourseGroupModuleStepBriefDto {
    id?: number;
    courseQuizExamId?: number;
    quizExamName?: string;
    quizPassingScoreCount?: number;
    quizPassingScore?: number;
    quizWeight?: number;
    passMsg?: string | undefined;
    failHasChanceMsg?: string | undefined;
    failNoChanceMsg?: string | undefined;

    constructor(data?: ICourseGroupModuleStepBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.courseQuizExamId = _data["courseQuizExamId"];
            this.quizExamName = _data["quizExamName"];
            this.quizPassingScoreCount = _data["quizPassingScoreCount"];
            this.quizPassingScore = _data["quizPassingScore"];
            this.quizWeight = _data["quizWeight"];
            this.passMsg = _data["passMsg"];
            this.failHasChanceMsg = _data["failHasChanceMsg"];
            this.failNoChanceMsg = _data["failNoChanceMsg"];
        }
    }

    static fromJS(data: any): CourseGroupModuleStepBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseGroupModuleStepBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["courseQuizExamId"] = this.courseQuizExamId;
        data["quizExamName"] = this.quizExamName;
        data["quizPassingScoreCount"] = this.quizPassingScoreCount;
        data["quizPassingScore"] = this.quizPassingScore;
        data["quizWeight"] = this.quizWeight;
        data["passMsg"] = this.passMsg;
        data["failHasChanceMsg"] = this.failHasChanceMsg;
        data["failNoChanceMsg"] = this.failNoChanceMsg;
        return data;
    }
}

export interface ICourseGroupModuleStepBriefDto {
    id?: number;
    courseQuizExamId?: number;
    quizExamName?: string;
    quizPassingScoreCount?: number;
    quizPassingScore?: number;
    quizWeight?: number;
    passMsg?: string | undefined;
    failHasChanceMsg?: string | undefined;
    failNoChanceMsg?: string | undefined;
}

export class CourseGroupModuleStepReqDto implements ICourseGroupModuleStepReqDto {
    id?: number;
    quizPassingScore?: number;
    quizWeight?: number;
    courseGroupMessages?: { [key: string]: CourseGroupMessageReqDto; };

    constructor(data?: ICourseGroupModuleStepReqDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.quizPassingScore = _data["quizPassingScore"];
            this.quizWeight = _data["quizWeight"];
            if (_data["courseGroupMessages"]) {
                this.courseGroupMessages = {} as any;
                for (let key in _data["courseGroupMessages"]) {
                    if (_data["courseGroupMessages"].hasOwnProperty(key))
                        (<any>this.courseGroupMessages)![key] = _data["courseGroupMessages"][key] ? CourseGroupMessageReqDto.fromJS(_data["courseGroupMessages"][key]) : new CourseGroupMessageReqDto();
                }
            }
        }
    }

    static fromJS(data: any): CourseGroupModuleStepReqDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseGroupModuleStepReqDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["quizPassingScore"] = this.quizPassingScore;
        data["quizWeight"] = this.quizWeight;
        if (this.courseGroupMessages) {
            data["courseGroupMessages"] = {};
            for (let key in this.courseGroupMessages) {
                if (this.courseGroupMessages.hasOwnProperty(key))
                    (<any>data["courseGroupMessages"])[key] = this.courseGroupMessages[key] ? this.courseGroupMessages[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface ICourseGroupModuleStepReqDto {
    id?: number;
    quizPassingScore?: number;
    quizWeight?: number;
    courseGroupMessages?: { [key: string]: CourseGroupMessageReqDto; };
}

export class CourseGroupMessageReqDto implements ICourseGroupMessageReqDto {
    id?: number;
    supportedLanguageId?: string;
    passMsg?: string | undefined;
    failHasChanceMsg?: string | undefined;
    failNoChanceMsg?: string | undefined;

    constructor(data?: ICourseGroupMessageReqDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.supportedLanguageId = _data["supportedLanguageId"];
            this.passMsg = _data["passMsg"];
            this.failHasChanceMsg = _data["failHasChanceMsg"];
            this.failNoChanceMsg = _data["failNoChanceMsg"];
        }
    }

    static fromJS(data: any): CourseGroupMessageReqDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseGroupMessageReqDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["supportedLanguageId"] = this.supportedLanguageId;
        data["passMsg"] = this.passMsg;
        data["failHasChanceMsg"] = this.failHasChanceMsg;
        data["failNoChanceMsg"] = this.failNoChanceMsg;
        return data;
    }
}

export interface ICourseGroupMessageReqDto {
    id?: number;
    supportedLanguageId?: string;
    passMsg?: string | undefined;
    failHasChanceMsg?: string | undefined;
    failNoChanceMsg?: string | undefined;
}

export class UpdateCourseGroupModuleStepCommand implements IUpdateCourseGroupModuleStepCommand {
    id?: number;
    quizPassingScore?: number;
    quizWeight?: number;
    courseGroupMessages?: { [key: string]: CourseGroupMessageReqDto; };

    constructor(data?: IUpdateCourseGroupModuleStepCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.quizPassingScore = _data["quizPassingScore"];
            this.quizWeight = _data["quizWeight"];
            if (_data["courseGroupMessages"]) {
                this.courseGroupMessages = {} as any;
                for (let key in _data["courseGroupMessages"]) {
                    if (_data["courseGroupMessages"].hasOwnProperty(key))
                        (<any>this.courseGroupMessages)![key] = _data["courseGroupMessages"][key] ? CourseGroupMessageReqDto.fromJS(_data["courseGroupMessages"][key]) : new CourseGroupMessageReqDto();
                }
            }
        }
    }

    static fromJS(data: any): UpdateCourseGroupModuleStepCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCourseGroupModuleStepCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["quizPassingScore"] = this.quizPassingScore;
        data["quizWeight"] = this.quizWeight;
        if (this.courseGroupMessages) {
            data["courseGroupMessages"] = {};
            for (let key in this.courseGroupMessages) {
                if (this.courseGroupMessages.hasOwnProperty(key))
                    (<any>data["courseGroupMessages"])[key] = this.courseGroupMessages[key] ? this.courseGroupMessages[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IUpdateCourseGroupModuleStepCommand {
    id?: number;
    quizPassingScore?: number;
    quizWeight?: number;
    courseGroupMessages?: { [key: string]: CourseGroupMessageReqDto; };
}

export class CourseGroupModuleStepQuestionDto implements ICourseGroupModuleStepQuestionDto {
    courseQuizExamId?: number;
    quizExamName?: string;
    courseGroupQuestionTranslations?: CourseGroupQuestionTranslationDto[];

    constructor(data?: ICourseGroupModuleStepQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseQuizExamId = _data["courseQuizExamId"];
            this.quizExamName = _data["quizExamName"];
            if (Array.isArray(_data["courseGroupQuestionTranslations"])) {
                this.courseGroupQuestionTranslations = [] as any;
                for (let item of _data["courseGroupQuestionTranslations"])
                    this.courseGroupQuestionTranslations!.push(CourseGroupQuestionTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CourseGroupModuleStepQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseGroupModuleStepQuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseQuizExamId"] = this.courseQuizExamId;
        data["quizExamName"] = this.quizExamName;
        if (Array.isArray(this.courseGroupQuestionTranslations)) {
            data["courseGroupQuestionTranslations"] = [];
            for (let item of this.courseGroupQuestionTranslations)
                data["courseGroupQuestionTranslations"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICourseGroupModuleStepQuestionDto {
    courseQuizExamId?: number;
    quizExamName?: string;
    courseGroupQuestionTranslations?: CourseGroupQuestionTranslationDto[];
}

export class CourseGroupQuestionTranslationDto implements ICourseGroupQuestionTranslationDto {
    courseQuestionType?: CourseQuestionType;
    courseQuestionId?: number;
    courseQuestionBankId?: number;
    supportedLanguageId?: string;
    questionContent?: string;
    order?: number;
    courseGroupChoiceTranslations?: CourseGroupChoiceTranslationDto[];

    constructor(data?: ICourseGroupQuestionTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseQuestionType = _data["courseQuestionType"];
            this.courseQuestionId = _data["courseQuestionId"];
            this.courseQuestionBankId = _data["courseQuestionBankId"];
            this.supportedLanguageId = _data["supportedLanguageId"];
            this.questionContent = _data["questionContent"];
            this.order = _data["order"];
            if (Array.isArray(_data["courseGroupChoiceTranslations"])) {
                this.courseGroupChoiceTranslations = [] as any;
                for (let item of _data["courseGroupChoiceTranslations"])
                    this.courseGroupChoiceTranslations!.push(CourseGroupChoiceTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CourseGroupQuestionTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseGroupQuestionTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseQuestionType"] = this.courseQuestionType;
        data["courseQuestionId"] = this.courseQuestionId;
        data["courseQuestionBankId"] = this.courseQuestionBankId;
        data["supportedLanguageId"] = this.supportedLanguageId;
        data["questionContent"] = this.questionContent;
        data["order"] = this.order;
        if (Array.isArray(this.courseGroupChoiceTranslations)) {
            data["courseGroupChoiceTranslations"] = [];
            for (let item of this.courseGroupChoiceTranslations)
                data["courseGroupChoiceTranslations"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICourseGroupQuestionTranslationDto {
    courseQuestionType?: CourseQuestionType;
    courseQuestionId?: number;
    courseQuestionBankId?: number;
    supportedLanguageId?: string;
    questionContent?: string;
    order?: number;
    courseGroupChoiceTranslations?: CourseGroupChoiceTranslationDto[];
}

export enum CourseQuestionType {
    SingleChoice = 0,
    MultipleChoice = 1,
    OpenEnded = 2,
}

export class CourseGroupChoiceTranslationDto implements ICourseGroupChoiceTranslationDto {
    courseQuestionChoiceId?: number;
    supportedLanguageId?: string;
    optionContent?: string;
    order?: number;

    constructor(data?: ICourseGroupChoiceTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseQuestionChoiceId = _data["courseQuestionChoiceId"];
            this.supportedLanguageId = _data["supportedLanguageId"];
            this.optionContent = _data["optionContent"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): CourseGroupChoiceTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseGroupChoiceTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseQuestionChoiceId"] = this.courseQuestionChoiceId;
        data["supportedLanguageId"] = this.supportedLanguageId;
        data["optionContent"] = this.optionContent;
        data["order"] = this.order;
        return data;
    }
}

export interface ICourseGroupChoiceTranslationDto {
    courseQuestionChoiceId?: number;
    supportedLanguageId?: string;
    optionContent?: string;
    order?: number;
}

export class AnswerMatchCourseQuestionDto implements IAnswerMatchCourseQuestionDto {
    courseQuestionsId?: number;
    finalScore?: number;

    constructor(data?: IAnswerMatchCourseQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseQuestionsId = _data["courseQuestionsId"];
            this.finalScore = _data["finalScore"];
        }
    }

    static fromJS(data: any): AnswerMatchCourseQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnswerMatchCourseQuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseQuestionsId"] = this.courseQuestionsId;
        data["finalScore"] = this.finalScore;
        return data;
    }
}

export interface IAnswerMatchCourseQuestionDto {
    courseQuestionsId?: number;
    finalScore?: number;
}

export class AnswerMatchCourseQuestionCommand implements IAnswerMatchCourseQuestionCommand {
    courseQuizExamId?: number;
    answerMatchCourseQuestions?: AnswerMatchCourseQuestionReqDto[];

    constructor(data?: IAnswerMatchCourseQuestionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseQuizExamId = _data["courseQuizExamId"];
            if (Array.isArray(_data["answerMatchCourseQuestions"])) {
                this.answerMatchCourseQuestions = [] as any;
                for (let item of _data["answerMatchCourseQuestions"])
                    this.answerMatchCourseQuestions!.push(AnswerMatchCourseQuestionReqDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AnswerMatchCourseQuestionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AnswerMatchCourseQuestionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseQuizExamId"] = this.courseQuizExamId;
        if (Array.isArray(this.answerMatchCourseQuestions)) {
            data["answerMatchCourseQuestions"] = [];
            for (let item of this.answerMatchCourseQuestions)
                data["answerMatchCourseQuestions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAnswerMatchCourseQuestionCommand {
    courseQuizExamId?: number;
    answerMatchCourseQuestions?: AnswerMatchCourseQuestionReqDto[];
}

export class CourseGroupSettingLanguageBriefDto implements ICourseGroupSettingLanguageBriefDto {
    supportedLanguageId?: string;
    displayName?: string | undefined;

    constructor(data?: ICourseGroupSettingLanguageBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supportedLanguageId = _data["supportedLanguageId"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): CourseGroupSettingLanguageBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseGroupSettingLanguageBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supportedLanguageId"] = this.supportedLanguageId;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ICourseGroupSettingLanguageBriefDto {
    supportedLanguageId?: string;
    displayName?: string | undefined;
}

export class PaginatedListOfCourseGroupSettingAdminBriefDto implements IPaginatedListOfCourseGroupSettingAdminBriefDto {
    items?: CourseGroupSettingAdminBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfCourseGroupSettingAdminBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CourseGroupSettingAdminBriefDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfCourseGroupSettingAdminBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfCourseGroupSettingAdminBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfCourseGroupSettingAdminBriefDto {
    items?: CourseGroupSettingAdminBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class CourseGroupSettingAdminBriefDto implements ICourseGroupSettingAdminBriefDto {
    id?: number;
    courseId?: number;
    courseName?: string;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    durationDays?: number;
    languageNames?: string;
    languageIds?: string[];
    isAllowDownloadQuizExam?: boolean;
    courseGroupSettingLanguages?: CourseGroupSettingLanguageBriefDto[];

    constructor(data?: ICourseGroupSettingAdminBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.courseId = _data["courseId"];
            this.courseName = _data["courseName"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.durationDays = _data["durationDays"];
            this.languageNames = _data["languageNames"];
            if (Array.isArray(_data["languageIds"])) {
                this.languageIds = [] as any;
                for (let item of _data["languageIds"])
                    this.languageIds!.push(item);
            }
            this.isAllowDownloadQuizExam = _data["isAllowDownloadQuizExam"];
            if (Array.isArray(_data["courseGroupSettingLanguages"])) {
                this.courseGroupSettingLanguages = [] as any;
                for (let item of _data["courseGroupSettingLanguages"])
                    this.courseGroupSettingLanguages!.push(CourseGroupSettingLanguageBriefDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CourseGroupSettingAdminBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseGroupSettingAdminBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["courseId"] = this.courseId;
        data["courseName"] = this.courseName;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["durationDays"] = this.durationDays;
        data["languageNames"] = this.languageNames;
        if (Array.isArray(this.languageIds)) {
            data["languageIds"] = [];
            for (let item of this.languageIds)
                data["languageIds"].push(item);
        }
        data["isAllowDownloadQuizExam"] = this.isAllowDownloadQuizExam;
        if (Array.isArray(this.courseGroupSettingLanguages)) {
            data["courseGroupSettingLanguages"] = [];
            for (let item of this.courseGroupSettingLanguages)
                data["courseGroupSettingLanguages"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICourseGroupSettingAdminBriefDto {
    id?: number;
    courseId?: number;
    courseName?: string;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    durationDays?: number;
    languageNames?: string;
    languageIds?: string[];
    isAllowDownloadQuizExam?: boolean;
    courseGroupSettingLanguages?: CourseGroupSettingLanguageBriefDto[];
}

export class PaginatedQueryBase implements IPaginatedQueryBase {
    pageNumber?: number;
    pageSize?: number;
    orderBy?: string | undefined;
    isOrderByAsc?: boolean;

    constructor(data?: IPaginatedQueryBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.orderBy = _data["orderBy"];
            this.isOrderByAsc = _data["isOrderByAsc"];
        }
    }

    static fromJS(data: any): PaginatedQueryBase {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedQueryBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["orderBy"] = this.orderBy;
        data["isOrderByAsc"] = this.isOrderByAsc;
        return data;
    }
}

export interface IPaginatedQueryBase {
    pageNumber?: number;
    pageSize?: number;
    orderBy?: string | undefined;
    isOrderByAsc?: boolean;
}

export class SearchCourseGroupSettingWithPagination extends PaginatedQueryBase implements ISearchCourseGroupSettingWithPagination {
    clientGroupId?: number;
    keywords?: string | undefined;
    courseName?: string | undefined;
    language?: string[] | undefined;
    startDate?: string[];
    endDate?: string[];

    constructor(data?: ISearchCourseGroupSettingWithPagination) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.clientGroupId = _data["clientGroupId"];
            this.keywords = _data["keywords"];
            this.courseName = _data["courseName"];
            if (Array.isArray(_data["language"])) {
                this.language = [] as any;
                for (let item of _data["language"])
                    this.language!.push(item);
            }
            if (Array.isArray(_data["startDate"])) {
                this.startDate = [] as any;
                for (let item of _data["startDate"])
                    this.startDate!.push(item);
            }
            if (Array.isArray(_data["endDate"])) {
                this.endDate = [] as any;
                for (let item of _data["endDate"])
                    this.endDate!.push(item);
            }
        }
    }

    static fromJS(data: any): SearchCourseGroupSettingWithPagination {
        data = typeof data === 'object' ? data : {};
        let result = new SearchCourseGroupSettingWithPagination();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientGroupId"] = this.clientGroupId;
        data["keywords"] = this.keywords;
        data["courseName"] = this.courseName;
        if (Array.isArray(this.language)) {
            data["language"] = [];
            for (let item of this.language)
                data["language"].push(item);
        }
        if (Array.isArray(this.startDate)) {
            data["startDate"] = [];
            for (let item of this.startDate)
                data["startDate"].push(item);
        }
        if (Array.isArray(this.endDate)) {
            data["endDate"] = [];
            for (let item of this.endDate)
                data["endDate"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISearchCourseGroupSettingWithPagination extends IPaginatedQueryBase {
    clientGroupId?: number;
    keywords?: string | undefined;
    courseName?: string | undefined;
    language?: string[] | undefined;
    startDate?: string[];
    endDate?: string[];
}

export class VerifyReqDto implements IVerifyReqDto {
    isValid?: boolean;
    msg?: string;

    constructor(data?: IVerifyReqDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isValid = _data["isValid"];
            this.msg = _data["msg"];
        }
    }

    static fromJS(data: any): VerifyReqDto {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyReqDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValid"] = this.isValid;
        data["msg"] = this.msg;
        return data;
    }
}

export interface IVerifyReqDto {
    isValid?: boolean;
    msg?: string;
}

export class PaginatedListOfCourseGroupSettingBriefDto implements IPaginatedListOfCourseGroupSettingBriefDto {
    items?: CourseGroupSettingBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfCourseGroupSettingBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CourseGroupSettingBriefDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfCourseGroupSettingBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfCourseGroupSettingBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfCourseGroupSettingBriefDto {
    items?: CourseGroupSettingBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class CourseGroupSettingBriefDto extends AuditableEntity implements ICourseGroupSettingBriefDto {
    id?: number;
    courseId?: number;
    courseName?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    durationDays?: number | undefined;
    clientUserCourseId?: number | undefined;
    courseStatus?: CourseGroupSettingStatus;
    studyStatus?: ClientUserCourseStatus;
    lastSeenDate?: Date | undefined;
    firstClickDate?: Date | undefined;
    progress?: number;
    finalScore?: number;
    score?: number;
    quizExamTotalScore?: number;

    constructor(data?: ICourseGroupSettingBriefDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.courseId = _data["courseId"];
            this.courseName = _data["courseName"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.durationDays = _data["durationDays"];
            this.clientUserCourseId = _data["clientUserCourseId"];
            this.courseStatus = _data["courseStatus"];
            this.studyStatus = _data["studyStatus"];
            this.lastSeenDate = _data["lastSeenDate"] ? new Date(_data["lastSeenDate"].toString()) : <any>undefined;
            this.firstClickDate = _data["firstClickDate"] ? new Date(_data["firstClickDate"].toString()) : <any>undefined;
            this.progress = _data["progress"];
            this.finalScore = _data["finalScore"];
            this.score = _data["score"];
            this.quizExamTotalScore = _data["quizExamTotalScore"];
        }
    }

    static fromJS(data: any): CourseGroupSettingBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseGroupSettingBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["courseId"] = this.courseId;
        data["courseName"] = this.courseName;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["durationDays"] = this.durationDays;
        data["clientUserCourseId"] = this.clientUserCourseId;
        data["courseStatus"] = this.courseStatus;
        data["studyStatus"] = this.studyStatus;
        data["lastSeenDate"] = this.lastSeenDate ? this.lastSeenDate.toISOString() : <any>undefined;
        data["firstClickDate"] = this.firstClickDate ? this.firstClickDate.toISOString() : <any>undefined;
        data["progress"] = this.progress;
        data["finalScore"] = this.finalScore;
        data["score"] = this.score;
        data["quizExamTotalScore"] = this.quizExamTotalScore;
        super.toJSON(data);
        return data;
    }
}

export interface ICourseGroupSettingBriefDto extends IAuditableEntity {
    id?: number;
    courseId?: number;
    courseName?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    durationDays?: number | undefined;
    clientUserCourseId?: number | undefined;
    courseStatus?: CourseGroupSettingStatus;
    studyStatus?: ClientUserCourseStatus;
    lastSeenDate?: Date | undefined;
    firstClickDate?: Date | undefined;
    progress?: number;
    finalScore?: number;
    score?: number;
    quizExamTotalScore?: number;
}

export class UpdateCourseGroupSettingCommand implements IUpdateCourseGroupSettingCommand {
    courseGroupSettingId?: number;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    durationDays?: number;
    languageIds?: string[];
    isAllowDownloadQuizExam?: boolean;

    constructor(data?: IUpdateCourseGroupSettingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseGroupSettingId = _data["courseGroupSettingId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.durationDays = _data["durationDays"];
            if (Array.isArray(_data["languageIds"])) {
                this.languageIds = [] as any;
                for (let item of _data["languageIds"])
                    this.languageIds!.push(item);
            }
            this.isAllowDownloadQuizExam = _data["isAllowDownloadQuizExam"];
        }
    }

    static fromJS(data: any): UpdateCourseGroupSettingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCourseGroupSettingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseGroupSettingId"] = this.courseGroupSettingId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["durationDays"] = this.durationDays;
        if (Array.isArray(this.languageIds)) {
            data["languageIds"] = [];
            for (let item of this.languageIds)
                data["languageIds"].push(item);
        }
        data["isAllowDownloadQuizExam"] = this.isAllowDownloadQuizExam;
        return data;
    }
}

export interface IUpdateCourseGroupSettingCommand {
    courseGroupSettingId?: number;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    durationDays?: number;
    languageIds?: string[];
    isAllowDownloadQuizExam?: boolean;
}

export class CheckCourseGroupSettingDto implements ICheckCourseGroupSettingDto {
    haveAddCourse?: boolean;
    haveEditCourse?: boolean;
    haveDeactivateCourse?: boolean;
    haveEditGrading?: boolean;
    haveEditCertificate?: boolean;
    haveEditModule?: boolean;
    haveEditQuizExam?: boolean;

    constructor(data?: ICheckCourseGroupSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.haveAddCourse = _data["haveAddCourse"];
            this.haveEditCourse = _data["haveEditCourse"];
            this.haveDeactivateCourse = _data["haveDeactivateCourse"];
            this.haveEditGrading = _data["haveEditGrading"];
            this.haveEditCertificate = _data["haveEditCertificate"];
            this.haveEditModule = _data["haveEditModule"];
            this.haveEditQuizExam = _data["haveEditQuizExam"];
        }
    }

    static fromJS(data: any): CheckCourseGroupSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckCourseGroupSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["haveAddCourse"] = this.haveAddCourse;
        data["haveEditCourse"] = this.haveEditCourse;
        data["haveDeactivateCourse"] = this.haveDeactivateCourse;
        data["haveEditGrading"] = this.haveEditGrading;
        data["haveEditCertificate"] = this.haveEditCertificate;
        data["haveEditModule"] = this.haveEditModule;
        data["haveEditQuizExam"] = this.haveEditQuizExam;
        return data;
    }
}

export interface ICheckCourseGroupSettingDto {
    haveAddCourse?: boolean;
    haveEditCourse?: boolean;
    haveDeactivateCourse?: boolean;
    haveEditGrading?: boolean;
    haveEditCertificate?: boolean;
    haveEditModule?: boolean;
    haveEditQuizExam?: boolean;
}

export class CourseGroupSettingCourseDto implements ICourseGroupSettingCourseDto {
    courseId?: number;
    courseName?: string;

    constructor(data?: ICourseGroupSettingCourseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseId = _data["courseId"];
            this.courseName = _data["courseName"];
        }
    }

    static fromJS(data: any): CourseGroupSettingCourseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseGroupSettingCourseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseId"] = this.courseId;
        data["courseName"] = this.courseName;
        return data;
    }
}

export interface ICourseGroupSettingCourseDto {
    courseId?: number;
    courseName?: string;
}

export class CourseLanguageBriefDto implements ICourseLanguageBriefDto {
    languageId?: string;
    displayName?: string | undefined;
    enable?: boolean;

    constructor(data?: ICourseLanguageBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageId = _data["languageId"];
            this.displayName = _data["displayName"];
            this.enable = _data["enable"];
        }
    }

    static fromJS(data: any): CourseLanguageBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseLanguageBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["displayName"] = this.displayName;
        data["enable"] = this.enable;
        return data;
    }
}

export interface ICourseLanguageBriefDto {
    languageId?: string;
    displayName?: string | undefined;
    enable?: boolean;
}

export class CourseReqDto implements ICourseReqDto {
    id?: number;
    supportedLanguageId?: string[];
    internalInformation?: string | undefined;
    isSequential?: boolean;
    courseStatus?: CourseStatus;
    courseInfos?: { [key: string]: CourseInfoDto; };
    courseIdString?: string | undefined;

    constructor(data?: ICourseReqDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["supportedLanguageId"])) {
                this.supportedLanguageId = [] as any;
                for (let item of _data["supportedLanguageId"])
                    this.supportedLanguageId!.push(item);
            }
            this.internalInformation = _data["internalInformation"];
            this.isSequential = _data["isSequential"];
            this.courseStatus = _data["courseStatus"];
            if (_data["courseInfos"]) {
                this.courseInfos = {} as any;
                for (let key in _data["courseInfos"]) {
                    if (_data["courseInfos"].hasOwnProperty(key))
                        (<any>this.courseInfos)![key] = _data["courseInfos"][key] ? CourseInfoDto.fromJS(_data["courseInfos"][key]) : new CourseInfoDto();
                }
            }
            this.courseIdString = _data["courseIdString"];
        }
    }

    static fromJS(data: any): CourseReqDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseReqDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.supportedLanguageId)) {
            data["supportedLanguageId"] = [];
            for (let item of this.supportedLanguageId)
                data["supportedLanguageId"].push(item);
        }
        data["internalInformation"] = this.internalInformation;
        data["isSequential"] = this.isSequential;
        data["courseStatus"] = this.courseStatus;
        if (this.courseInfos) {
            data["courseInfos"] = {};
            for (let key in this.courseInfos) {
                if (this.courseInfos.hasOwnProperty(key))
                    (<any>data["courseInfos"])[key] = this.courseInfos[key] ? this.courseInfos[key].toJSON() : <any>undefined;
            }
        }
        data["courseIdString"] = this.courseIdString;
        return data;
    }
}

export interface ICourseReqDto {
    id?: number;
    supportedLanguageId?: string[];
    internalInformation?: string | undefined;
    isSequential?: boolean;
    courseStatus?: CourseStatus;
    courseInfos?: { [key: string]: CourseInfoDto; };
    courseIdString?: string | undefined;
}

export class CourseInfoDto implements ICourseInfoDto {
    id?: number;
    supportedLanguageId?: string | undefined;
    courseName?: string | undefined;
    description?: string | undefined;
    courseInfoCoverImageId?: number | undefined;
    courseInfoCoverImage?: CourseInfoCourseInfoCoverImageDto | undefined;

    constructor(data?: ICourseInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.supportedLanguageId = _data["supportedLanguageId"];
            this.courseName = _data["courseName"];
            this.description = _data["description"];
            this.courseInfoCoverImageId = _data["courseInfoCoverImageId"];
            this.courseInfoCoverImage = _data["courseInfoCoverImage"] ? CourseInfoCourseInfoCoverImageDto.fromJS(_data["courseInfoCoverImage"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CourseInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["supportedLanguageId"] = this.supportedLanguageId;
        data["courseName"] = this.courseName;
        data["description"] = this.description;
        data["courseInfoCoverImageId"] = this.courseInfoCoverImageId;
        data["courseInfoCoverImage"] = this.courseInfoCoverImage ? this.courseInfoCoverImage.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICourseInfoDto {
    id?: number;
    supportedLanguageId?: string | undefined;
    courseName?: string | undefined;
    description?: string | undefined;
    courseInfoCoverImageId?: number | undefined;
    courseInfoCoverImage?: CourseInfoCourseInfoCoverImageDto | undefined;
}

export class CourseInfoCourseInfoCoverImageDto implements ICourseInfoCourseInfoCoverImageDto {
    id?: number;
    mediaLibraryId?: number;
    name?: string;
    uploadDate?: Date;

    constructor(data?: ICourseInfoCourseInfoCoverImageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mediaLibraryId = _data["mediaLibraryId"];
            this.name = _data["name"];
            this.uploadDate = _data["uploadDate"] ? new Date(_data["uploadDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CourseInfoCourseInfoCoverImageDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseInfoCourseInfoCoverImageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mediaLibraryId"] = this.mediaLibraryId;
        data["name"] = this.name;
        data["uploadDate"] = this.uploadDate ? this.uploadDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICourseInfoCourseInfoCoverImageDto {
    id?: number;
    mediaLibraryId?: number;
    name?: string;
    uploadDate?: Date;
}

export class UpdateCourseInfoCommand implements IUpdateCourseInfoCommand {
    courseId?: number;
    internalInformation?: string | undefined;
    supportedLanguageId?: string[];
    isSequential?: boolean;
    courseInfos?: { [key: string]: CourseInfoReqDto; };

    constructor(data?: IUpdateCourseInfoCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseId = _data["courseId"];
            this.internalInformation = _data["internalInformation"];
            if (Array.isArray(_data["supportedLanguageId"])) {
                this.supportedLanguageId = [] as any;
                for (let item of _data["supportedLanguageId"])
                    this.supportedLanguageId!.push(item);
            }
            this.isSequential = _data["isSequential"];
            if (_data["courseInfos"]) {
                this.courseInfos = {} as any;
                for (let key in _data["courseInfos"]) {
                    if (_data["courseInfos"].hasOwnProperty(key))
                        (<any>this.courseInfos)![key] = _data["courseInfos"][key] ? CourseInfoReqDto.fromJS(_data["courseInfos"][key]) : new CourseInfoReqDto();
                }
            }
        }
    }

    static fromJS(data: any): UpdateCourseInfoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCourseInfoCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseId"] = this.courseId;
        data["internalInformation"] = this.internalInformation;
        if (Array.isArray(this.supportedLanguageId)) {
            data["supportedLanguageId"] = [];
            for (let item of this.supportedLanguageId)
                data["supportedLanguageId"].push(item);
        }
        data["isSequential"] = this.isSequential;
        if (this.courseInfos) {
            data["courseInfos"] = {};
            for (let key in this.courseInfos) {
                if (this.courseInfos.hasOwnProperty(key))
                    (<any>data["courseInfos"])[key] = this.courseInfos[key] ? this.courseInfos[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IUpdateCourseInfoCommand {
    courseId?: number;
    internalInformation?: string | undefined;
    supportedLanguageId?: string[];
    isSequential?: boolean;
    courseInfos?: { [key: string]: CourseInfoReqDto; };
}

export class CourseInfoReqDto implements ICourseInfoReqDto {
    id?: number;
    supportedLanguageId?: string | undefined;
    courseName?: string | undefined;
    description?: string | undefined;
    courseInfoCoverImageId?: number | undefined;
    mediaLibraryId?: number;
    uploadDate?: Date;

    constructor(data?: ICourseInfoReqDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.supportedLanguageId = _data["supportedLanguageId"];
            this.courseName = _data["courseName"];
            this.description = _data["description"];
            this.courseInfoCoverImageId = _data["courseInfoCoverImageId"];
            this.mediaLibraryId = _data["mediaLibraryId"];
            this.uploadDate = _data["uploadDate"] ? new Date(_data["uploadDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CourseInfoReqDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseInfoReqDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["supportedLanguageId"] = this.supportedLanguageId;
        data["courseName"] = this.courseName;
        data["description"] = this.description;
        data["courseInfoCoverImageId"] = this.courseInfoCoverImageId;
        data["mediaLibraryId"] = this.mediaLibraryId;
        data["uploadDate"] = this.uploadDate ? this.uploadDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICourseInfoReqDto {
    id?: number;
    supportedLanguageId?: string | undefined;
    courseName?: string | undefined;
    description?: string | undefined;
    courseInfoCoverImageId?: number | undefined;
    mediaLibraryId?: number;
    uploadDate?: Date;
}

export class CourseModuleItemBriefDto implements ICourseModuleItemBriefDto {
    id?: number;
    courseModuleId?: number;
    supportedLanguageId?: string;
    moduleName?: string;

    constructor(data?: ICourseModuleItemBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.courseModuleId = _data["courseModuleId"];
            this.supportedLanguageId = _data["supportedLanguageId"];
            this.moduleName = _data["moduleName"];
        }
    }

    static fromJS(data: any): CourseModuleItemBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseModuleItemBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["courseModuleId"] = this.courseModuleId;
        data["supportedLanguageId"] = this.supportedLanguageId;
        data["moduleName"] = this.moduleName;
        return data;
    }
}

export interface ICourseModuleItemBriefDto {
    id?: number;
    courseModuleId?: number;
    supportedLanguageId?: string;
    moduleName?: string;
}

export class UpdateCourseModuleItemCommand implements IUpdateCourseModuleItemCommand {
    courseModuleId?: number;
    courseModuleItems?: { [key: string]: CourseModuleItemReqDto; };

    constructor(data?: IUpdateCourseModuleItemCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseModuleId = _data["courseModuleId"];
            if (_data["courseModuleItems"]) {
                this.courseModuleItems = {} as any;
                for (let key in _data["courseModuleItems"]) {
                    if (_data["courseModuleItems"].hasOwnProperty(key))
                        (<any>this.courseModuleItems)![key] = _data["courseModuleItems"][key] ? CourseModuleItemReqDto.fromJS(_data["courseModuleItems"][key]) : new CourseModuleItemReqDto();
                }
            }
        }
    }

    static fromJS(data: any): UpdateCourseModuleItemCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCourseModuleItemCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseModuleId"] = this.courseModuleId;
        if (this.courseModuleItems) {
            data["courseModuleItems"] = {};
            for (let key in this.courseModuleItems) {
                if (this.courseModuleItems.hasOwnProperty(key))
                    (<any>data["courseModuleItems"])[key] = this.courseModuleItems[key] ? this.courseModuleItems[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IUpdateCourseModuleItemCommand {
    courseModuleId?: number;
    courseModuleItems?: { [key: string]: CourseModuleItemReqDto; };
}

export class CourseModuleItemReqDto implements ICourseModuleItemReqDto {
    id?: number;
    supportedLanguageId?: string;
    moduleName?: string;

    constructor(data?: ICourseModuleItemReqDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.supportedLanguageId = _data["supportedLanguageId"];
            this.moduleName = _data["moduleName"];
        }
    }

    static fromJS(data: any): CourseModuleItemReqDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseModuleItemReqDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["supportedLanguageId"] = this.supportedLanguageId;
        data["moduleName"] = this.moduleName;
        return data;
    }
}

export interface ICourseModuleItemReqDto {
    id?: number;
    supportedLanguageId?: string;
    moduleName?: string;
}

export class CourseModuleBriefDto implements ICourseModuleBriefDto {
    id?: number;
    sortOrder?: number;
    courseModuleItems?: CourseModuleItemBriefDto[];
    courseModuleSteps?: CourseModuleStepBriefDto[];

    constructor(data?: ICourseModuleBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sortOrder = _data["sortOrder"];
            if (Array.isArray(_data["courseModuleItems"])) {
                this.courseModuleItems = [] as any;
                for (let item of _data["courseModuleItems"])
                    this.courseModuleItems!.push(CourseModuleItemBriefDto.fromJS(item));
            }
            if (Array.isArray(_data["courseModuleSteps"])) {
                this.courseModuleSteps = [] as any;
                for (let item of _data["courseModuleSteps"])
                    this.courseModuleSteps!.push(CourseModuleStepBriefDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CourseModuleBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseModuleBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sortOrder"] = this.sortOrder;
        if (Array.isArray(this.courseModuleItems)) {
            data["courseModuleItems"] = [];
            for (let item of this.courseModuleItems)
                data["courseModuleItems"].push(item.toJSON());
        }
        if (Array.isArray(this.courseModuleSteps)) {
            data["courseModuleSteps"] = [];
            for (let item of this.courseModuleSteps)
                data["courseModuleSteps"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICourseModuleBriefDto {
    id?: number;
    sortOrder?: number;
    courseModuleItems?: CourseModuleItemBriefDto[];
    courseModuleSteps?: CourseModuleStepBriefDto[];
}

export class CourseModuleStepBriefDto implements ICourseModuleStepBriefDto {
    id?: number;
    courseModuleId?: number;
    courseModuleStepType?: CourseModuleStepType;
    courseQuizExamId?: number | undefined;
    assessmentTemplateId?: number | undefined;
    sortOrder?: number;
    courseModuleStepItems?: CourseModuleStepItemBriefDto[];

    constructor(data?: ICourseModuleStepBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.courseModuleId = _data["courseModuleId"];
            this.courseModuleStepType = _data["courseModuleStepType"];
            this.courseQuizExamId = _data["courseQuizExamId"];
            this.assessmentTemplateId = _data["assessmentTemplateId"];
            this.sortOrder = _data["sortOrder"];
            if (Array.isArray(_data["courseModuleStepItems"])) {
                this.courseModuleStepItems = [] as any;
                for (let item of _data["courseModuleStepItems"])
                    this.courseModuleStepItems!.push(CourseModuleStepItemBriefDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CourseModuleStepBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseModuleStepBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["courseModuleId"] = this.courseModuleId;
        data["courseModuleStepType"] = this.courseModuleStepType;
        data["courseQuizExamId"] = this.courseQuizExamId;
        data["assessmentTemplateId"] = this.assessmentTemplateId;
        data["sortOrder"] = this.sortOrder;
        if (Array.isArray(this.courseModuleStepItems)) {
            data["courseModuleStepItems"] = [];
            for (let item of this.courseModuleStepItems)
                data["courseModuleStepItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICourseModuleStepBriefDto {
    id?: number;
    courseModuleId?: number;
    courseModuleStepType?: CourseModuleStepType;
    courseQuizExamId?: number | undefined;
    assessmentTemplateId?: number | undefined;
    sortOrder?: number;
    courseModuleStepItems?: CourseModuleStepItemBriefDto[];
}

export class CourseModuleStepItemBriefDto implements ICourseModuleStepItemBriefDto {
    supportedLanguageId?: string;
    stepName?: string | undefined;

    constructor(data?: ICourseModuleStepItemBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supportedLanguageId = _data["supportedLanguageId"];
            this.stepName = _data["stepName"];
        }
    }

    static fromJS(data: any): CourseModuleStepItemBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseModuleStepItemBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supportedLanguageId"] = this.supportedLanguageId;
        data["stepName"] = this.stepName;
        return data;
    }
}

export interface ICourseModuleStepItemBriefDto {
    supportedLanguageId?: string;
    stepName?: string | undefined;
}

export class CreateCourseModuleCommand implements ICreateCourseModuleCommand {
    courseId?: number;
    sortOrder?: number;

    constructor(data?: ICreateCourseModuleCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseId = _data["courseId"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): CreateCourseModuleCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCourseModuleCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseId"] = this.courseId;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface ICreateCourseModuleCommand {
    courseId?: number;
    sortOrder?: number;
}

export class UpdateCourseModuleSortCommand implements IUpdateCourseModuleSortCommand {
    courseId?: number;
    courseModules?: CourseModuleSortReqDto[];

    constructor(data?: IUpdateCourseModuleSortCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseId = _data["courseId"];
            if (Array.isArray(_data["courseModules"])) {
                this.courseModules = [] as any;
                for (let item of _data["courseModules"])
                    this.courseModules!.push(CourseModuleSortReqDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateCourseModuleSortCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCourseModuleSortCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseId"] = this.courseId;
        if (Array.isArray(this.courseModules)) {
            data["courseModules"] = [];
            for (let item of this.courseModules)
                data["courseModules"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateCourseModuleSortCommand {
    courseId?: number;
    courseModules?: CourseModuleSortReqDto[];
}

export class CourseModuleSortReqDto implements ICourseModuleSortReqDto {
    id?: number;
    sortOrder?: number;
    moduleSteps?: CourseModuleStepSortReqDto[];

    constructor(data?: ICourseModuleSortReqDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sortOrder = _data["sortOrder"];
            if (Array.isArray(_data["moduleSteps"])) {
                this.moduleSteps = [] as any;
                for (let item of _data["moduleSteps"])
                    this.moduleSteps!.push(CourseModuleStepSortReqDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CourseModuleSortReqDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseModuleSortReqDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sortOrder"] = this.sortOrder;
        if (Array.isArray(this.moduleSteps)) {
            data["moduleSteps"] = [];
            for (let item of this.moduleSteps)
                data["moduleSteps"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICourseModuleSortReqDto {
    id?: number;
    sortOrder?: number;
    moduleSteps?: CourseModuleStepSortReqDto[];
}

export class CourseModuleStepSortReqDto implements ICourseModuleStepSortReqDto {
    id?: number;
    sortOrder?: number;

    constructor(data?: ICourseModuleStepSortReqDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): CourseModuleStepSortReqDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseModuleStepSortReqDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface ICourseModuleStepSortReqDto {
    id?: number;
    sortOrder?: number;
}

export class CourseMaterialFileDto implements ICourseMaterialFileDto {
    value?: number;
    label?: string;

    constructor(data?: ICourseMaterialFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): CourseMaterialFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseMaterialFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["label"] = this.label;
        return data;
    }
}

export interface ICourseMaterialFileDto {
    value?: number;
    label?: string;
}

export class DownloadStepAllMaterialFileByIdsCommand implements IDownloadStepAllMaterialFileByIdsCommand {
    courseModuleStepItemId?: number;
    courseMaterialFileIds?: number[];

    constructor(data?: IDownloadStepAllMaterialFileByIdsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseModuleStepItemId = _data["courseModuleStepItemId"];
            if (Array.isArray(_data["courseMaterialFileIds"])) {
                this.courseMaterialFileIds = [] as any;
                for (let item of _data["courseMaterialFileIds"])
                    this.courseMaterialFileIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DownloadStepAllMaterialFileByIdsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadStepAllMaterialFileByIdsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseModuleStepItemId"] = this.courseModuleStepItemId;
        if (Array.isArray(this.courseMaterialFileIds)) {
            data["courseMaterialFileIds"] = [];
            for (let item of this.courseMaterialFileIds)
                data["courseMaterialFileIds"].push(item);
        }
        return data;
    }
}

export interface IDownloadStepAllMaterialFileByIdsCommand {
    courseModuleStepItemId?: number;
    courseMaterialFileIds?: number[];
}

export class SendStepAllMaterialFileByIdsCommand implements ISendStepAllMaterialFileByIdsCommand {
    courseModuleStepItemId?: number;
    courseMaterialFileIds?: number[];

    constructor(data?: ISendStepAllMaterialFileByIdsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseModuleStepItemId = _data["courseModuleStepItemId"];
            if (Array.isArray(_data["courseMaterialFileIds"])) {
                this.courseMaterialFileIds = [] as any;
                for (let item of _data["courseMaterialFileIds"])
                    this.courseMaterialFileIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SendStepAllMaterialFileByIdsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendStepAllMaterialFileByIdsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseModuleStepItemId"] = this.courseModuleStepItemId;
        if (Array.isArray(this.courseMaterialFileIds)) {
            data["courseMaterialFileIds"] = [];
            for (let item of this.courseMaterialFileIds)
                data["courseMaterialFileIds"].push(item);
        }
        return data;
    }
}

export interface ISendStepAllMaterialFileByIdsCommand {
    courseModuleStepItemId?: number;
    courseMaterialFileIds?: number[];
}

export class CourseModuleStepItemsDtoVm implements ICourseModuleStepItemsDtoVm {
    courseModuleStepId?: number;
    courseModuleStepType?: CourseModuleStepType;
    courseQuizExamId?: number | undefined;
    assessmentTemplateId?: number | undefined;
    courseModuleStepItems?: { [key: string]: CourseModuleStepItemDto; };

    constructor(data?: ICourseModuleStepItemsDtoVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseModuleStepId = _data["courseModuleStepId"];
            this.courseModuleStepType = _data["courseModuleStepType"];
            this.courseQuizExamId = _data["courseQuizExamId"];
            this.assessmentTemplateId = _data["assessmentTemplateId"];
            if (_data["courseModuleStepItems"]) {
                this.courseModuleStepItems = {} as any;
                for (let key in _data["courseModuleStepItems"]) {
                    if (_data["courseModuleStepItems"].hasOwnProperty(key))
                        (<any>this.courseModuleStepItems)![key] = _data["courseModuleStepItems"][key] ? CourseModuleStepItemDto.fromJS(_data["courseModuleStepItems"][key]) : new CourseModuleStepItemDto();
                }
            }
        }
    }

    static fromJS(data: any): CourseModuleStepItemsDtoVm {
        data = typeof data === 'object' ? data : {};
        let result = new CourseModuleStepItemsDtoVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseModuleStepId"] = this.courseModuleStepId;
        data["courseModuleStepType"] = this.courseModuleStepType;
        data["courseQuizExamId"] = this.courseQuizExamId;
        data["assessmentTemplateId"] = this.assessmentTemplateId;
        if (this.courseModuleStepItems) {
            data["courseModuleStepItems"] = {};
            for (let key in this.courseModuleStepItems) {
                if (this.courseModuleStepItems.hasOwnProperty(key))
                    (<any>data["courseModuleStepItems"])[key] = this.courseModuleStepItems[key] ? this.courseModuleStepItems[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface ICourseModuleStepItemsDtoVm {
    courseModuleStepId?: number;
    courseModuleStepType?: CourseModuleStepType;
    courseQuizExamId?: number | undefined;
    assessmentTemplateId?: number | undefined;
    courseModuleStepItems?: { [key: string]: CourseModuleStepItemDto; };
}

export class CourseModuleStepItemDto implements ICourseModuleStepItemDto {
    id?: number;
    courseModuleStepId?: number;
    supportedLanguageId?: string;
    stepName?: string | undefined;
    description?: string | undefined;
    completionText?: string | undefined;
    courseModuleStepInfoVideoId?: number | undefined;
    courseModuleStepInfoVideo?: CourseModuleStepInfoVideoDto | undefined;
    courseModuleStepInfoFiles?: CourseModuleStepInfoFileDto[];

    constructor(data?: ICourseModuleStepItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.courseModuleStepId = _data["courseModuleStepId"];
            this.supportedLanguageId = _data["supportedLanguageId"];
            this.stepName = _data["stepName"];
            this.description = _data["description"];
            this.completionText = _data["completionText"];
            this.courseModuleStepInfoVideoId = _data["courseModuleStepInfoVideoId"];
            this.courseModuleStepInfoVideo = _data["courseModuleStepInfoVideo"] ? CourseModuleStepInfoVideoDto.fromJS(_data["courseModuleStepInfoVideo"]) : <any>undefined;
            if (Array.isArray(_data["courseModuleStepInfoFiles"])) {
                this.courseModuleStepInfoFiles = [] as any;
                for (let item of _data["courseModuleStepInfoFiles"])
                    this.courseModuleStepInfoFiles!.push(CourseModuleStepInfoFileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CourseModuleStepItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseModuleStepItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["courseModuleStepId"] = this.courseModuleStepId;
        data["supportedLanguageId"] = this.supportedLanguageId;
        data["stepName"] = this.stepName;
        data["description"] = this.description;
        data["completionText"] = this.completionText;
        data["courseModuleStepInfoVideoId"] = this.courseModuleStepInfoVideoId;
        data["courseModuleStepInfoVideo"] = this.courseModuleStepInfoVideo ? this.courseModuleStepInfoVideo.toJSON() : <any>undefined;
        if (Array.isArray(this.courseModuleStepInfoFiles)) {
            data["courseModuleStepInfoFiles"] = [];
            for (let item of this.courseModuleStepInfoFiles)
                data["courseModuleStepInfoFiles"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICourseModuleStepItemDto {
    id?: number;
    courseModuleStepId?: number;
    supportedLanguageId?: string;
    stepName?: string | undefined;
    description?: string | undefined;
    completionText?: string | undefined;
    courseModuleStepInfoVideoId?: number | undefined;
    courseModuleStepInfoVideo?: CourseModuleStepInfoVideoDto | undefined;
    courseModuleStepInfoFiles?: CourseModuleStepInfoFileDto[];
}

export class CourseModuleStepInfoVideoDto implements ICourseModuleStepInfoVideoDto {
    id?: number;
    mediaLibraryId?: number;
    name?: string;
    uploadDate?: Date;

    constructor(data?: ICourseModuleStepInfoVideoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mediaLibraryId = _data["mediaLibraryId"];
            this.name = _data["name"];
            this.uploadDate = _data["uploadDate"] ? new Date(_data["uploadDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CourseModuleStepInfoVideoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseModuleStepInfoVideoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mediaLibraryId"] = this.mediaLibraryId;
        data["name"] = this.name;
        data["uploadDate"] = this.uploadDate ? this.uploadDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICourseModuleStepInfoVideoDto {
    id?: number;
    mediaLibraryId?: number;
    name?: string;
    uploadDate?: Date;
}

export class CourseModuleStepInfoFileDto implements ICourseModuleStepInfoFileDto {
    id?: number;
    courseModuleStepItemId?: number;
    fileId?: number;
    fileName?: string;
    uploadDate?: Date;

    constructor(data?: ICourseModuleStepInfoFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.courseModuleStepItemId = _data["courseModuleStepItemId"];
            this.fileId = _data["fileId"];
            this.fileName = _data["fileName"];
            this.uploadDate = _data["uploadDate"] ? new Date(_data["uploadDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CourseModuleStepInfoFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseModuleStepInfoFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["courseModuleStepItemId"] = this.courseModuleStepItemId;
        data["fileId"] = this.fileId;
        data["fileName"] = this.fileName;
        data["uploadDate"] = this.uploadDate ? this.uploadDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICourseModuleStepInfoFileDto {
    id?: number;
    courseModuleStepItemId?: number;
    fileId?: number;
    fileName?: string;
    uploadDate?: Date;
}

export class UpdateCourseModuleStepItemCommand implements IUpdateCourseModuleStepItemCommand {
    courseModuleStepId?: number;
    courseQuizExamId?: number | undefined;
    assessmentTemplateId?: number;
    courseModuleStepItems?: { [key: string]: CourseModuleStepItemReqDto; };

    constructor(data?: IUpdateCourseModuleStepItemCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseModuleStepId = _data["courseModuleStepId"];
            this.courseQuizExamId = _data["courseQuizExamId"];
            this.assessmentTemplateId = _data["assessmentTemplateId"];
            if (_data["courseModuleStepItems"]) {
                this.courseModuleStepItems = {} as any;
                for (let key in _data["courseModuleStepItems"]) {
                    if (_data["courseModuleStepItems"].hasOwnProperty(key))
                        (<any>this.courseModuleStepItems)![key] = _data["courseModuleStepItems"][key] ? CourseModuleStepItemReqDto.fromJS(_data["courseModuleStepItems"][key]) : new CourseModuleStepItemReqDto();
                }
            }
        }
    }

    static fromJS(data: any): UpdateCourseModuleStepItemCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCourseModuleStepItemCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseModuleStepId"] = this.courseModuleStepId;
        data["courseQuizExamId"] = this.courseQuizExamId;
        data["assessmentTemplateId"] = this.assessmentTemplateId;
        if (this.courseModuleStepItems) {
            data["courseModuleStepItems"] = {};
            for (let key in this.courseModuleStepItems) {
                if (this.courseModuleStepItems.hasOwnProperty(key))
                    (<any>data["courseModuleStepItems"])[key] = this.courseModuleStepItems[key] ? this.courseModuleStepItems[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IUpdateCourseModuleStepItemCommand {
    courseModuleStepId?: number;
    courseQuizExamId?: number | undefined;
    assessmentTemplateId?: number;
    courseModuleStepItems?: { [key: string]: CourseModuleStepItemReqDto; };
}

export class CourseModuleStepItemReqDto implements ICourseModuleStepItemReqDto {
    id?: number;
    courseModuleStepId?: number;
    stepName?: string | undefined;
    description?: string | undefined;
    completionText?: string | undefined;
    courseModuleStepInfoVideo?: CourseModuleStepInfoVideoDto | undefined;
    courseModuleStepInfoFiles?: CourseModuleStepInfoFileReqDto[];

    constructor(data?: ICourseModuleStepItemReqDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.courseModuleStepId = _data["courseModuleStepId"];
            this.stepName = _data["stepName"];
            this.description = _data["description"];
            this.completionText = _data["completionText"];
            this.courseModuleStepInfoVideo = _data["courseModuleStepInfoVideo"] ? CourseModuleStepInfoVideoDto.fromJS(_data["courseModuleStepInfoVideo"]) : <any>undefined;
            if (Array.isArray(_data["courseModuleStepInfoFiles"])) {
                this.courseModuleStepInfoFiles = [] as any;
                for (let item of _data["courseModuleStepInfoFiles"])
                    this.courseModuleStepInfoFiles!.push(CourseModuleStepInfoFileReqDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CourseModuleStepItemReqDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseModuleStepItemReqDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["courseModuleStepId"] = this.courseModuleStepId;
        data["stepName"] = this.stepName;
        data["description"] = this.description;
        data["completionText"] = this.completionText;
        data["courseModuleStepInfoVideo"] = this.courseModuleStepInfoVideo ? this.courseModuleStepInfoVideo.toJSON() : <any>undefined;
        if (Array.isArray(this.courseModuleStepInfoFiles)) {
            data["courseModuleStepInfoFiles"] = [];
            for (let item of this.courseModuleStepInfoFiles)
                data["courseModuleStepInfoFiles"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICourseModuleStepItemReqDto {
    id?: number;
    courseModuleStepId?: number;
    stepName?: string | undefined;
    description?: string | undefined;
    completionText?: string | undefined;
    courseModuleStepInfoVideo?: CourseModuleStepInfoVideoDto | undefined;
    courseModuleStepInfoFiles?: CourseModuleStepInfoFileReqDto[];
}

export class CourseModuleStepInfoFileReqDto implements ICourseModuleStepInfoFileReqDto {
    id?: number;
    courseModuleStepItemId?: number;
    fileId?: number;
    fileName?: string;
    uploadDate?: Date;

    constructor(data?: ICourseModuleStepInfoFileReqDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.courseModuleStepItemId = _data["courseModuleStepItemId"];
            this.fileId = _data["fileId"];
            this.fileName = _data["fileName"];
            this.uploadDate = _data["uploadDate"] ? new Date(_data["uploadDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CourseModuleStepInfoFileReqDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseModuleStepInfoFileReqDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["courseModuleStepItemId"] = this.courseModuleStepItemId;
        data["fileId"] = this.fileId;
        data["fileName"] = this.fileName;
        data["uploadDate"] = this.uploadDate ? this.uploadDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICourseModuleStepInfoFileReqDto {
    id?: number;
    courseModuleStepItemId?: number;
    fileId?: number;
    fileName?: string;
    uploadDate?: Date;
}

export class CreateCourseModuleStepCommand implements ICreateCourseModuleStepCommand {
    courseModuleId?: number;
    sortOrder?: number;
    courseModuleStepType?: CourseModuleStepType;

    constructor(data?: ICreateCourseModuleStepCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseModuleId = _data["courseModuleId"];
            this.sortOrder = _data["sortOrder"];
            this.courseModuleStepType = _data["courseModuleStepType"];
        }
    }

    static fromJS(data: any): CreateCourseModuleStepCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCourseModuleStepCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseModuleId"] = this.courseModuleId;
        data["sortOrder"] = this.sortOrder;
        data["courseModuleStepType"] = this.courseModuleStepType;
        return data;
    }
}

export interface ICreateCourseModuleStepCommand {
    courseModuleId?: number;
    sortOrder?: number;
    courseModuleStepType?: CourseModuleStepType;
}

export class PaginatedListOfAdminClientUserCourseBriefDto implements IPaginatedListOfAdminClientUserCourseBriefDto {
    items?: AdminClientUserCourseBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfAdminClientUserCourseBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AdminClientUserCourseBriefDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfAdminClientUserCourseBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfAdminClientUserCourseBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfAdminClientUserCourseBriefDto {
    items?: AdminClientUserCourseBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class AdminClientUserCourseBriefDto implements IAdminClientUserCourseBriefDto {
    courseGroupSettingId?: number;
    courseId?: number;
    clientGroupId?: number | undefined;
    clientUserName?: string | undefined;
    clientFullName?: string | undefined;
    email?: string | undefined;
    courseName?: string | undefined;
    progress?: number | undefined;
    finalScore?: number | undefined;
    totalScore?: number | undefined;
    score?: number | undefined;
    quizExamTotalScore?: number | undefined;
    timeCompleted?: Date | undefined;
    firstClickDate?: Date | undefined;

    constructor(data?: IAdminClientUserCourseBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseGroupSettingId = _data["courseGroupSettingId"];
            this.courseId = _data["courseId"];
            this.clientGroupId = _data["clientGroupId"];
            this.clientUserName = _data["clientUserName"];
            this.clientFullName = _data["clientFullName"];
            this.email = _data["email"];
            this.courseName = _data["courseName"];
            this.progress = _data["progress"];
            this.finalScore = _data["finalScore"];
            this.totalScore = _data["totalScore"];
            this.score = _data["score"];
            this.quizExamTotalScore = _data["quizExamTotalScore"];
            this.timeCompleted = _data["timeCompleted"] ? new Date(_data["timeCompleted"].toString()) : <any>undefined;
            this.firstClickDate = _data["firstClickDate"] ? new Date(_data["firstClickDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AdminClientUserCourseBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminClientUserCourseBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseGroupSettingId"] = this.courseGroupSettingId;
        data["courseId"] = this.courseId;
        data["clientGroupId"] = this.clientGroupId;
        data["clientUserName"] = this.clientUserName;
        data["clientFullName"] = this.clientFullName;
        data["email"] = this.email;
        data["courseName"] = this.courseName;
        data["progress"] = this.progress;
        data["finalScore"] = this.finalScore;
        data["totalScore"] = this.totalScore;
        data["score"] = this.score;
        data["quizExamTotalScore"] = this.quizExamTotalScore;
        data["timeCompleted"] = this.timeCompleted ? this.timeCompleted.toISOString() : <any>undefined;
        data["firstClickDate"] = this.firstClickDate ? this.firstClickDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAdminClientUserCourseBriefDto {
    courseGroupSettingId?: number;
    courseId?: number;
    clientGroupId?: number | undefined;
    clientUserName?: string | undefined;
    clientFullName?: string | undefined;
    email?: string | undefined;
    courseName?: string | undefined;
    progress?: number | undefined;
    finalScore?: number | undefined;
    totalScore?: number | undefined;
    score?: number | undefined;
    quizExamTotalScore?: number | undefined;
    timeCompleted?: Date | undefined;
    firstClickDate?: Date | undefined;
}

export class SearchClientUserCoursesProgressWithPagination extends PaginatedQueryBase implements ISearchClientUserCoursesProgressWithPagination {
    keyword?: string | undefined;
    clientGroupId?: number;
    clientUserName?: string | undefined;
    clientFullName?: string | undefined;
    email?: string | undefined;
    courseIds?: number[];
    progress?: number | undefined;
    finalScore?: number | undefined;

    constructor(data?: ISearchClientUserCoursesProgressWithPagination) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.keyword = _data["keyword"];
            this.clientGroupId = _data["clientGroupId"];
            this.clientUserName = _data["clientUserName"];
            this.clientFullName = _data["clientFullName"];
            this.email = _data["email"];
            if (Array.isArray(_data["courseIds"])) {
                this.courseIds = [] as any;
                for (let item of _data["courseIds"])
                    this.courseIds!.push(item);
            }
            this.progress = _data["progress"];
            this.finalScore = _data["finalScore"];
        }
    }

    static fromJS(data: any): SearchClientUserCoursesProgressWithPagination {
        data = typeof data === 'object' ? data : {};
        let result = new SearchClientUserCoursesProgressWithPagination();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keyword"] = this.keyword;
        data["clientGroupId"] = this.clientGroupId;
        data["clientUserName"] = this.clientUserName;
        data["clientFullName"] = this.clientFullName;
        data["email"] = this.email;
        if (Array.isArray(this.courseIds)) {
            data["courseIds"] = [];
            for (let item of this.courseIds)
                data["courseIds"].push(item);
        }
        data["progress"] = this.progress;
        data["finalScore"] = this.finalScore;
        super.toJSON(data);
        return data;
    }
}

export interface ISearchClientUserCoursesProgressWithPagination extends IPaginatedQueryBase {
    keyword?: string | undefined;
    clientGroupId?: number;
    clientUserName?: string | undefined;
    clientFullName?: string | undefined;
    email?: string | undefined;
    courseIds?: number[];
    progress?: number | undefined;
    finalScore?: number | undefined;
}

export class PaginatedListOfAdminClientUserQuizExamBriefDto implements IPaginatedListOfAdminClientUserQuizExamBriefDto {
    items?: AdminClientUserQuizExamBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfAdminClientUserQuizExamBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AdminClientUserQuizExamBriefDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfAdminClientUserQuizExamBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfAdminClientUserQuizExamBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfAdminClientUserQuizExamBriefDto {
    items?: AdminClientUserQuizExamBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class AdminClientUserQuizExamBriefDto implements IAdminClientUserQuizExamBriefDto {
    clientUserId?: string;
    clientUserCourseModuleStepId?: number;
    courseGroupModuleStepId?: number;
    courseQuizExamId?: number;
    clientUserName?: string;
    quizExamName?: string;
    score?: number;
    weight?: number;
    quizExamTotalScore?: number;

    constructor(data?: IAdminClientUserQuizExamBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientUserId = _data["clientUserId"];
            this.clientUserCourseModuleStepId = _data["clientUserCourseModuleStepId"];
            this.courseGroupModuleStepId = _data["courseGroupModuleStepId"];
            this.courseQuizExamId = _data["courseQuizExamId"];
            this.clientUserName = _data["clientUserName"];
            this.quizExamName = _data["quizExamName"];
            this.score = _data["score"];
            this.weight = _data["weight"];
            this.quizExamTotalScore = _data["quizExamTotalScore"];
        }
    }

    static fromJS(data: any): AdminClientUserQuizExamBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminClientUserQuizExamBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientUserId"] = this.clientUserId;
        data["clientUserCourseModuleStepId"] = this.clientUserCourseModuleStepId;
        data["courseGroupModuleStepId"] = this.courseGroupModuleStepId;
        data["courseQuizExamId"] = this.courseQuizExamId;
        data["clientUserName"] = this.clientUserName;
        data["quizExamName"] = this.quizExamName;
        data["score"] = this.score;
        data["weight"] = this.weight;
        data["quizExamTotalScore"] = this.quizExamTotalScore;
        return data;
    }
}

export interface IAdminClientUserQuizExamBriefDto {
    clientUserId?: string;
    clientUserCourseModuleStepId?: number;
    courseGroupModuleStepId?: number;
    courseQuizExamId?: number;
    clientUserName?: string;
    quizExamName?: string;
    score?: number;
    weight?: number;
    quizExamTotalScore?: number;
}

export class SearchClientUserCoursesQuizExamProgressWithPagination extends PaginatedQueryBase implements ISearchClientUserCoursesQuizExamProgressWithPagination {
    courseGroupSettingId?: number;
    clientGroupId?: number;
    clientUserName?: string;

    constructor(data?: ISearchClientUserCoursesQuizExamProgressWithPagination) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.courseGroupSettingId = _data["courseGroupSettingId"];
            this.clientGroupId = _data["clientGroupId"];
            this.clientUserName = _data["clientUserName"];
        }
    }

    static fromJS(data: any): SearchClientUserCoursesQuizExamProgressWithPagination {
        data = typeof data === 'object' ? data : {};
        let result = new SearchClientUserCoursesQuizExamProgressWithPagination();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseGroupSettingId"] = this.courseGroupSettingId;
        data["clientGroupId"] = this.clientGroupId;
        data["clientUserName"] = this.clientUserName;
        super.toJSON(data);
        return data;
    }
}

export interface ISearchClientUserCoursesQuizExamProgressWithPagination extends IPaginatedQueryBase {
    courseGroupSettingId?: number;
    clientGroupId?: number;
    clientUserName?: string;
}

export class DownloadCourseProgressCommand implements IDownloadCourseProgressCommand {
    keyword?: string | undefined;
    clientGroupId?: number;
    clientUserName?: string | undefined;
    clientFullName?: string | undefined;
    email?: string | undefined;
    courseIds?: number[];
    progress?: number | undefined;
    finalScore?: number | undefined;

    constructor(data?: IDownloadCourseProgressCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keyword = _data["keyword"];
            this.clientGroupId = _data["clientGroupId"];
            this.clientUserName = _data["clientUserName"];
            this.clientFullName = _data["clientFullName"];
            this.email = _data["email"];
            if (Array.isArray(_data["courseIds"])) {
                this.courseIds = [] as any;
                for (let item of _data["courseIds"])
                    this.courseIds!.push(item);
            }
            this.progress = _data["progress"];
            this.finalScore = _data["finalScore"];
        }
    }

    static fromJS(data: any): DownloadCourseProgressCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadCourseProgressCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keyword"] = this.keyword;
        data["clientGroupId"] = this.clientGroupId;
        data["clientUserName"] = this.clientUserName;
        data["clientFullName"] = this.clientFullName;
        data["email"] = this.email;
        if (Array.isArray(this.courseIds)) {
            data["courseIds"] = [];
            for (let item of this.courseIds)
                data["courseIds"].push(item);
        }
        data["progress"] = this.progress;
        data["finalScore"] = this.finalScore;
        return data;
    }
}

export interface IDownloadCourseProgressCommand {
    keyword?: string | undefined;
    clientGroupId?: number;
    clientUserName?: string | undefined;
    clientFullName?: string | undefined;
    email?: string | undefined;
    courseIds?: number[];
    progress?: number | undefined;
    finalScore?: number | undefined;
}

export class DownloadUserQuizExamProgressCommand implements IDownloadUserQuizExamProgressCommand {
    courseGroupModuleStepId?: number;
    clientUserId?: string;

    constructor(data?: IDownloadUserQuizExamProgressCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseGroupModuleStepId = _data["courseGroupModuleStepId"];
            this.clientUserId = _data["clientUserId"];
        }
    }

    static fromJS(data: any): DownloadUserQuizExamProgressCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadUserQuizExamProgressCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseGroupModuleStepId"] = this.courseGroupModuleStepId;
        data["clientUserId"] = this.clientUserId;
        return data;
    }
}

export interface IDownloadUserQuizExamProgressCommand {
    courseGroupModuleStepId?: number;
    clientUserId?: string;
}

export class DownloadUserQuizExamProgressAllCommand implements IDownloadUserQuizExamProgressAllCommand {
    keyword?: string | undefined;
    clientGroupId?: number;
    clientUserName?: string | undefined;
    clientFullName?: string | undefined;
    email?: string | undefined;
    courseIds?: number[];
    progress?: number | undefined;
    finalScore?: number | undefined;

    constructor(data?: IDownloadUserQuizExamProgressAllCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keyword = _data["keyword"];
            this.clientGroupId = _data["clientGroupId"];
            this.clientUserName = _data["clientUserName"];
            this.clientFullName = _data["clientFullName"];
            this.email = _data["email"];
            if (Array.isArray(_data["courseIds"])) {
                this.courseIds = [] as any;
                for (let item of _data["courseIds"])
                    this.courseIds!.push(item);
            }
            this.progress = _data["progress"];
            this.finalScore = _data["finalScore"];
        }
    }

    static fromJS(data: any): DownloadUserQuizExamProgressAllCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadUserQuizExamProgressAllCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keyword"] = this.keyword;
        data["clientGroupId"] = this.clientGroupId;
        data["clientUserName"] = this.clientUserName;
        data["clientFullName"] = this.clientFullName;
        data["email"] = this.email;
        if (Array.isArray(this.courseIds)) {
            data["courseIds"] = [];
            for (let item of this.courseIds)
                data["courseIds"].push(item);
        }
        data["progress"] = this.progress;
        data["finalScore"] = this.finalScore;
        return data;
    }
}

export interface IDownloadUserQuizExamProgressAllCommand {
    keyword?: string | undefined;
    clientGroupId?: number;
    clientUserName?: string | undefined;
    clientFullName?: string | undefined;
    email?: string | undefined;
    courseIds?: number[];
    progress?: number | undefined;
    finalScore?: number | undefined;
}

export class SendCourseProgressReminderCommand implements ISendCourseProgressReminderCommand {
    clientGroupId?: number;
    courseId?: number;
    clientUserName?: string;
    reportAutoSendSetting?: ReportAutoSendSetting;
    to?: string[];
    cc?: string[];

    constructor(data?: ISendCourseProgressReminderCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientGroupId = _data["clientGroupId"];
            this.courseId = _data["courseId"];
            this.clientUserName = _data["clientUserName"];
            this.reportAutoSendSetting = _data["reportAutoSendSetting"];
            if (Array.isArray(_data["to"])) {
                this.to = [] as any;
                for (let item of _data["to"])
                    this.to!.push(item);
            }
            if (Array.isArray(_data["cc"])) {
                this.cc = [] as any;
                for (let item of _data["cc"])
                    this.cc!.push(item);
            }
        }
    }

    static fromJS(data: any): SendCourseProgressReminderCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendCourseProgressReminderCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientGroupId"] = this.clientGroupId;
        data["courseId"] = this.courseId;
        data["clientUserName"] = this.clientUserName;
        data["reportAutoSendSetting"] = this.reportAutoSendSetting;
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item);
        }
        if (Array.isArray(this.cc)) {
            data["cc"] = [];
            for (let item of this.cc)
                data["cc"].push(item);
        }
        return data;
    }
}

export interface ISendCourseProgressReminderCommand {
    clientGroupId?: number;
    courseId?: number;
    clientUserName?: string;
    reportAutoSendSetting?: ReportAutoSendSetting;
    to?: string[];
    cc?: string[];
}

export class SendClientUserQuizExamProgressCommand implements ISendClientUserQuizExamProgressCommand {
    courseGroupModuleStepId?: number;
    clientUserId?: string;

    constructor(data?: ISendClientUserQuizExamProgressCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseGroupModuleStepId = _data["courseGroupModuleStepId"];
            this.clientUserId = _data["clientUserId"];
        }
    }

    static fromJS(data: any): SendClientUserQuizExamProgressCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendClientUserQuizExamProgressCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseGroupModuleStepId"] = this.courseGroupModuleStepId;
        data["clientUserId"] = this.clientUserId;
        return data;
    }
}

export interface ISendClientUserQuizExamProgressCommand {
    courseGroupModuleStepId?: number;
    clientUserId?: string;
}

export class PaginatedListOfGetGroupCourseByLanguageDto implements IPaginatedListOfGetGroupCourseByLanguageDto {
    items?: GetGroupCourseByLanguageDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfGetGroupCourseByLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetGroupCourseByLanguageDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfGetGroupCourseByLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfGetGroupCourseByLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfGetGroupCourseByLanguageDto {
    items?: GetGroupCourseByLanguageDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class GetGroupCourseByLanguageDto implements IGetGroupCourseByLanguageDto {
    courseGroupSettingId?: number;
    courseName?: string | undefined;

    constructor(data?: IGetGroupCourseByLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseGroupSettingId = _data["courseGroupSettingId"];
            this.courseName = _data["courseName"];
        }
    }

    static fromJS(data: any): GetGroupCourseByLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGroupCourseByLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseGroupSettingId"] = this.courseGroupSettingId;
        data["courseName"] = this.courseName;
        return data;
    }
}

export interface IGetGroupCourseByLanguageDto {
    courseGroupSettingId?: number;
    courseName?: string | undefined;
}

export class GetGroupCourseByLanguageQuery extends PaginatedQueryBase implements IGetGroupCourseByLanguageQuery {
    clientGroupId?: number;
    language?: string;

    constructor(data?: IGetGroupCourseByLanguageQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.clientGroupId = _data["clientGroupId"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): GetGroupCourseByLanguageQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetGroupCourseByLanguageQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientGroupId"] = this.clientGroupId;
        data["language"] = this.language;
        super.toJSON(data);
        return data;
    }
}

export interface IGetGroupCourseByLanguageQuery extends IPaginatedQueryBase {
    clientGroupId?: number;
    language?: string;
}

export class DownloadUserQuizExamProgressAllByLanguagCommand implements IDownloadUserQuizExamProgressAllByLanguagCommand {
    clientGroupId?: number;
    language?: string;

    constructor(data?: IDownloadUserQuizExamProgressAllByLanguagCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientGroupId = _data["clientGroupId"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): DownloadUserQuizExamProgressAllByLanguagCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadUserQuizExamProgressAllByLanguagCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientGroupId"] = this.clientGroupId;
        data["language"] = this.language;
        return data;
    }
}

export interface IDownloadUserQuizExamProgressAllByLanguagCommand {
    clientGroupId?: number;
    language?: string;
}

export class PaginatedListOfQuestionBankBriefDto implements IPaginatedListOfQuestionBankBriefDto {
    items?: QuestionBankBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfQuestionBankBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(QuestionBankBriefDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfQuestionBankBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfQuestionBankBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfQuestionBankBriefDto {
    items?: QuestionBankBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class QuestionBankBriefDto implements IQuestionBankBriefDto {
    id?: number;
    questionName?: string;

    constructor(data?: IQuestionBankBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.questionName = _data["questionName"];
        }
    }

    static fromJS(data: any): QuestionBankBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionBankBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["questionName"] = this.questionName;
        return data;
    }
}

export interface IQuestionBankBriefDto {
    id?: number;
    questionName?: string;
}

export class CourseQuestionBankDto implements ICourseQuestionBankDto {
    id?: number;
    questionName?: string;
    hasSingleChoiceQuestion?: boolean;
    hasMultipleChoiceQuestion?: boolean;
    hasOpenEndedQuestion?: boolean;

    constructor(data?: ICourseQuestionBankDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.questionName = _data["questionName"];
            this.hasSingleChoiceQuestion = _data["hasSingleChoiceQuestion"];
            this.hasMultipleChoiceQuestion = _data["hasMultipleChoiceQuestion"];
            this.hasOpenEndedQuestion = _data["hasOpenEndedQuestion"];
        }
    }

    static fromJS(data: any): CourseQuestionBankDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseQuestionBankDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["questionName"] = this.questionName;
        data["hasSingleChoiceQuestion"] = this.hasSingleChoiceQuestion;
        data["hasMultipleChoiceQuestion"] = this.hasMultipleChoiceQuestion;
        data["hasOpenEndedQuestion"] = this.hasOpenEndedQuestion;
        return data;
    }
}

export interface ICourseQuestionBankDto {
    id?: number;
    questionName?: string;
    hasSingleChoiceQuestion?: boolean;
    hasMultipleChoiceQuestion?: boolean;
    hasOpenEndedQuestion?: boolean;
}

export class UploadCourseQuestionDto implements IUploadCourseQuestionDto {
    code?: number;
    id?: number;
    errMsg?: string;

    constructor(data?: IUploadCourseQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.id = _data["id"];
            this.errMsg = _data["errMsg"];
        }
    }

    static fromJS(data: any): UploadCourseQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UploadCourseQuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["id"] = this.id;
        data["errMsg"] = this.errMsg;
        return data;
    }
}

export interface IUploadCourseQuestionDto {
    code?: number;
    id?: number;
    errMsg?: string;
}

export class CourseQuizExamQuestionBankVm implements ICourseQuizExamQuestionBankVm {
    courseQuizExamQuestionBankBriefDto?: PaginatedListOfCourseQuizExamQuestionBankBriefDto;
    totalCount?: number;
    totalPoints?: number;

    constructor(data?: ICourseQuizExamQuestionBankVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseQuizExamQuestionBankBriefDto = _data["courseQuizExamQuestionBankBriefDto"] ? PaginatedListOfCourseQuizExamQuestionBankBriefDto.fromJS(_data["courseQuizExamQuestionBankBriefDto"]) : <any>undefined;
            this.totalCount = _data["totalCount"];
            this.totalPoints = _data["totalPoints"];
        }
    }

    static fromJS(data: any): CourseQuizExamQuestionBankVm {
        data = typeof data === 'object' ? data : {};
        let result = new CourseQuizExamQuestionBankVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseQuizExamQuestionBankBriefDto"] = this.courseQuizExamQuestionBankBriefDto ? this.courseQuizExamQuestionBankBriefDto.toJSON() : <any>undefined;
        data["totalCount"] = this.totalCount;
        data["totalPoints"] = this.totalPoints;
        return data;
    }
}

export interface ICourseQuizExamQuestionBankVm {
    courseQuizExamQuestionBankBriefDto?: PaginatedListOfCourseQuizExamQuestionBankBriefDto;
    totalCount?: number;
    totalPoints?: number;
}

export class PaginatedListOfCourseQuizExamQuestionBankBriefDto implements IPaginatedListOfCourseQuizExamQuestionBankBriefDto {
    items?: CourseQuizExamQuestionBankBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfCourseQuizExamQuestionBankBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CourseQuizExamQuestionBankBriefDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfCourseQuizExamQuestionBankBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfCourseQuizExamQuestionBankBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfCourseQuizExamQuestionBankBriefDto {
    items?: CourseQuizExamQuestionBankBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class CourseQuizExamQuestionBankBriefDto implements ICourseQuizExamQuestionBankBriefDto {
    id?: number;
    courseQuizExamId?: number;
    questionBankName?: string;
    pointsPerQuestion?: number | undefined;
    questionCount?: number;
    sortOrder?: number;

    constructor(data?: ICourseQuizExamQuestionBankBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.courseQuizExamId = _data["courseQuizExamId"];
            this.questionBankName = _data["questionBankName"];
            this.pointsPerQuestion = _data["pointsPerQuestion"];
            this.questionCount = _data["questionCount"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): CourseQuizExamQuestionBankBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseQuizExamQuestionBankBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["courseQuizExamId"] = this.courseQuizExamId;
        data["questionBankName"] = this.questionBankName;
        data["pointsPerQuestion"] = this.pointsPerQuestion;
        data["questionCount"] = this.questionCount;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface ICourseQuizExamQuestionBankBriefDto {
    id?: number;
    courseQuizExamId?: number;
    questionBankName?: string;
    pointsPerQuestion?: number | undefined;
    questionCount?: number;
    sortOrder?: number;
}

export class CourseQuizExamQuestionBankDto implements ICourseQuizExamQuestionBankDto {
    id?: number;
    courseQuestionBankId?: number;
    pointsPerQuestion?: number | undefined;
    questionCount?: number;
    totalQuestionCount?: number;

    constructor(data?: ICourseQuizExamQuestionBankDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.courseQuestionBankId = _data["courseQuestionBankId"];
            this.pointsPerQuestion = _data["pointsPerQuestion"];
            this.questionCount = _data["questionCount"];
            this.totalQuestionCount = _data["totalQuestionCount"];
        }
    }

    static fromJS(data: any): CourseQuizExamQuestionBankDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseQuizExamQuestionBankDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["courseQuestionBankId"] = this.courseQuestionBankId;
        data["pointsPerQuestion"] = this.pointsPerQuestion;
        data["questionCount"] = this.questionCount;
        data["totalQuestionCount"] = this.totalQuestionCount;
        return data;
    }
}

export interface ICourseQuizExamQuestionBankDto {
    id?: number;
    courseQuestionBankId?: number;
    pointsPerQuestion?: number | undefined;
    questionCount?: number;
    totalQuestionCount?: number;
}

export class UpdateCourseQuizExamQuestionBankCommand implements IUpdateCourseQuizExamQuestionBankCommand {
    id?: number;
    courseQuestionBankId?: number;
    questionCount?: number;
    pointsPerQuestion?: number;

    constructor(data?: IUpdateCourseQuizExamQuestionBankCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.courseQuestionBankId = _data["courseQuestionBankId"];
            this.questionCount = _data["questionCount"];
            this.pointsPerQuestion = _data["pointsPerQuestion"];
        }
    }

    static fromJS(data: any): UpdateCourseQuizExamQuestionBankCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCourseQuizExamQuestionBankCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["courseQuestionBankId"] = this.courseQuestionBankId;
        data["questionCount"] = this.questionCount;
        data["pointsPerQuestion"] = this.pointsPerQuestion;
        return data;
    }
}

export interface IUpdateCourseQuizExamQuestionBankCommand {
    id?: number;
    courseQuestionBankId?: number;
    questionCount?: number;
    pointsPerQuestion?: number;
}

export class DeleteCourseQuizExamQuestionBankCommand implements IDeleteCourseQuizExamQuestionBankCommand {
    id?: number;

    constructor(data?: IDeleteCourseQuizExamQuestionBankCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteCourseQuizExamQuestionBankCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteCourseQuizExamQuestionBankCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteCourseQuizExamQuestionBankCommand {
    id?: number;
}

export class PaginatedListOfCourseQuizExamBriefDto implements IPaginatedListOfCourseQuizExamBriefDto {
    items?: CourseQuizExamBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfCourseQuizExamBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CourseQuizExamBriefDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfCourseQuizExamBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfCourseQuizExamBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfCourseQuizExamBriefDto {
    items?: CourseQuizExamBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class CourseQuizExamBriefDto implements ICourseQuizExamBriefDto {
    id?: number;
    quizExamName?: string;
    questionCount?: number;
    quizScores?: number;
    quizExamWeight?: number;
    retakesAllowed?: number;
    passingScore?: number;
    courseQuizExamMessages?: CourseQuizExamMessageBriefDto[];

    constructor(data?: ICourseQuizExamBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.quizExamName = _data["quizExamName"];
            this.questionCount = _data["questionCount"];
            this.quizScores = _data["quizScores"];
            this.quizExamWeight = _data["quizExamWeight"];
            this.retakesAllowed = _data["retakesAllowed"];
            this.passingScore = _data["passingScore"];
            if (Array.isArray(_data["courseQuizExamMessages"])) {
                this.courseQuizExamMessages = [] as any;
                for (let item of _data["courseQuizExamMessages"])
                    this.courseQuizExamMessages!.push(CourseQuizExamMessageBriefDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CourseQuizExamBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseQuizExamBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["quizExamName"] = this.quizExamName;
        data["questionCount"] = this.questionCount;
        data["quizScores"] = this.quizScores;
        data["quizExamWeight"] = this.quizExamWeight;
        data["retakesAllowed"] = this.retakesAllowed;
        data["passingScore"] = this.passingScore;
        if (Array.isArray(this.courseQuizExamMessages)) {
            data["courseQuizExamMessages"] = [];
            for (let item of this.courseQuizExamMessages)
                data["courseQuizExamMessages"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICourseQuizExamBriefDto {
    id?: number;
    quizExamName?: string;
    questionCount?: number;
    quizScores?: number;
    quizExamWeight?: number;
    retakesAllowed?: number;
    passingScore?: number;
    courseQuizExamMessages?: CourseQuizExamMessageBriefDto[];
}

export class CourseQuizExamMessageBriefDto implements ICourseQuizExamMessageBriefDto {
    supportedLanguageId?: string;
    passMsg?: string;
    failHasChanceMsg?: string;
    failNoChanceMsg?: string;

    constructor(data?: ICourseQuizExamMessageBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supportedLanguageId = _data["supportedLanguageId"];
            this.passMsg = _data["passMsg"];
            this.failHasChanceMsg = _data["failHasChanceMsg"];
            this.failNoChanceMsg = _data["failNoChanceMsg"];
        }
    }

    static fromJS(data: any): CourseQuizExamMessageBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseQuizExamMessageBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supportedLanguageId"] = this.supportedLanguageId;
        data["passMsg"] = this.passMsg;
        data["failHasChanceMsg"] = this.failHasChanceMsg;
        data["failNoChanceMsg"] = this.failNoChanceMsg;
        return data;
    }
}

export interface ICourseQuizExamMessageBriefDto {
    supportedLanguageId?: string;
    passMsg?: string;
    failHasChanceMsg?: string;
    failNoChanceMsg?: string;
}

export class EditCourseQuizExamReqDto implements IEditCourseQuizExamReqDto {
    id?: number;
    courseId?: number;
    quizExamName?: string;
    quizScores?: number | undefined;
    quizExamWeight?: number;
    retakesAllowed?: number;
    passingScore?: number;
    quizExamGenerationType?: CourseQuizExamGenerationType;
    courseQuizExamQuestionBanks?: CourseQuizExamQuestionBankReqDto[];
    courseQuizExamSequentials?: CourseQuizExamSequentialReqDto[];
    courseQuizExamMessages?: CourseQuizExamMessageReqDto[];
    courseQuizExamMessageList?: { [key: string]: CourseQuizExamMessageReqDto; };

    constructor(data?: IEditCourseQuizExamReqDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.courseId = _data["courseId"];
            this.quizExamName = _data["quizExamName"];
            this.quizScores = _data["quizScores"];
            this.quizExamWeight = _data["quizExamWeight"];
            this.retakesAllowed = _data["retakesAllowed"];
            this.passingScore = _data["passingScore"];
            this.quizExamGenerationType = _data["quizExamGenerationType"];
            if (Array.isArray(_data["courseQuizExamQuestionBanks"])) {
                this.courseQuizExamQuestionBanks = [] as any;
                for (let item of _data["courseQuizExamQuestionBanks"])
                    this.courseQuizExamQuestionBanks!.push(CourseQuizExamQuestionBankReqDto.fromJS(item));
            }
            if (Array.isArray(_data["courseQuizExamSequentials"])) {
                this.courseQuizExamSequentials = [] as any;
                for (let item of _data["courseQuizExamSequentials"])
                    this.courseQuizExamSequentials!.push(CourseQuizExamSequentialReqDto.fromJS(item));
            }
            if (Array.isArray(_data["courseQuizExamMessages"])) {
                this.courseQuizExamMessages = [] as any;
                for (let item of _data["courseQuizExamMessages"])
                    this.courseQuizExamMessages!.push(CourseQuizExamMessageReqDto.fromJS(item));
            }
            if (_data["courseQuizExamMessageList"]) {
                this.courseQuizExamMessageList = {} as any;
                for (let key in _data["courseQuizExamMessageList"]) {
                    if (_data["courseQuizExamMessageList"].hasOwnProperty(key))
                        (<any>this.courseQuizExamMessageList)![key] = _data["courseQuizExamMessageList"][key] ? CourseQuizExamMessageReqDto.fromJS(_data["courseQuizExamMessageList"][key]) : new CourseQuizExamMessageReqDto();
                }
            }
        }
    }

    static fromJS(data: any): EditCourseQuizExamReqDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditCourseQuizExamReqDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["courseId"] = this.courseId;
        data["quizExamName"] = this.quizExamName;
        data["quizScores"] = this.quizScores;
        data["quizExamWeight"] = this.quizExamWeight;
        data["retakesAllowed"] = this.retakesAllowed;
        data["passingScore"] = this.passingScore;
        data["quizExamGenerationType"] = this.quizExamGenerationType;
        if (Array.isArray(this.courseQuizExamQuestionBanks)) {
            data["courseQuizExamQuestionBanks"] = [];
            for (let item of this.courseQuizExamQuestionBanks)
                data["courseQuizExamQuestionBanks"].push(item.toJSON());
        }
        if (Array.isArray(this.courseQuizExamSequentials)) {
            data["courseQuizExamSequentials"] = [];
            for (let item of this.courseQuizExamSequentials)
                data["courseQuizExamSequentials"].push(item.toJSON());
        }
        if (Array.isArray(this.courseQuizExamMessages)) {
            data["courseQuizExamMessages"] = [];
            for (let item of this.courseQuizExamMessages)
                data["courseQuizExamMessages"].push(item.toJSON());
        }
        if (this.courseQuizExamMessageList) {
            data["courseQuizExamMessageList"] = {};
            for (let key in this.courseQuizExamMessageList) {
                if (this.courseQuizExamMessageList.hasOwnProperty(key))
                    (<any>data["courseQuizExamMessageList"])[key] = this.courseQuizExamMessageList[key] ? this.courseQuizExamMessageList[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IEditCourseQuizExamReqDto {
    id?: number;
    courseId?: number;
    quizExamName?: string;
    quizScores?: number | undefined;
    quizExamWeight?: number;
    retakesAllowed?: number;
    passingScore?: number;
    quizExamGenerationType?: CourseQuizExamGenerationType;
    courseQuizExamQuestionBanks?: CourseQuizExamQuestionBankReqDto[];
    courseQuizExamSequentials?: CourseQuizExamSequentialReqDto[];
    courseQuizExamMessages?: CourseQuizExamMessageReqDto[];
    courseQuizExamMessageList?: { [key: string]: CourseQuizExamMessageReqDto; };
}

export enum CourseQuizExamGenerationType {
    SequentialGeneration = 0,
    RandomGeneration = 1,
}

export class CourseQuizExamQuestionBankReqDto implements ICourseQuizExamQuestionBankReqDto {
    id?: number;
    courseQuizExamId?: number;
    courseQuestionBankId?: number;
    questionBankName?: string;
    sortOrder?: number;

    constructor(data?: ICourseQuizExamQuestionBankReqDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.courseQuizExamId = _data["courseQuizExamId"];
            this.courseQuestionBankId = _data["courseQuestionBankId"];
            this.questionBankName = _data["questionBankName"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): CourseQuizExamQuestionBankReqDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseQuizExamQuestionBankReqDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["courseQuizExamId"] = this.courseQuizExamId;
        data["courseQuestionBankId"] = this.courseQuestionBankId;
        data["questionBankName"] = this.questionBankName;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface ICourseQuizExamQuestionBankReqDto {
    id?: number;
    courseQuizExamId?: number;
    courseQuestionBankId?: number;
    questionBankName?: string;
    sortOrder?: number;
}

export class CourseQuizExamSequentialReqDto implements ICourseQuizExamSequentialReqDto {
    id?: number;
    courseQuizExamId?: number;
    sortOrder?: number;
    courseQuestionType?: CourseQuestionType;

    constructor(data?: ICourseQuizExamSequentialReqDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.courseQuizExamId = _data["courseQuizExamId"];
            this.sortOrder = _data["sortOrder"];
            this.courseQuestionType = _data["courseQuestionType"];
        }
    }

    static fromJS(data: any): CourseQuizExamSequentialReqDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseQuizExamSequentialReqDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["courseQuizExamId"] = this.courseQuizExamId;
        data["sortOrder"] = this.sortOrder;
        data["courseQuestionType"] = this.courseQuestionType;
        return data;
    }
}

export interface ICourseQuizExamSequentialReqDto {
    id?: number;
    courseQuizExamId?: number;
    sortOrder?: number;
    courseQuestionType?: CourseQuestionType;
}

export class CourseQuizExamMessageReqDto implements ICourseQuizExamMessageReqDto {
    id?: number;
    courseQuizExamId?: number;
    supportedLanguageId?: string;
    passMsg?: string;
    failHasChanceMsg?: string;
    failNoChanceMsg?: string;

    constructor(data?: ICourseQuizExamMessageReqDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.courseQuizExamId = _data["courseQuizExamId"];
            this.supportedLanguageId = _data["supportedLanguageId"];
            this.passMsg = _data["passMsg"];
            this.failHasChanceMsg = _data["failHasChanceMsg"];
            this.failNoChanceMsg = _data["failNoChanceMsg"];
        }
    }

    static fromJS(data: any): CourseQuizExamMessageReqDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseQuizExamMessageReqDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["courseQuizExamId"] = this.courseQuizExamId;
        data["supportedLanguageId"] = this.supportedLanguageId;
        data["passMsg"] = this.passMsg;
        data["failHasChanceMsg"] = this.failHasChanceMsg;
        data["failNoChanceMsg"] = this.failNoChanceMsg;
        return data;
    }
}

export interface ICourseQuizExamMessageReqDto {
    id?: number;
    courseQuizExamId?: number;
    supportedLanguageId?: string;
    passMsg?: string;
    failHasChanceMsg?: string;
    failNoChanceMsg?: string;
}

export class CourseQuizExamListDto implements ICourseQuizExamListDto {
    id?: number;
    quizExamName?: string;

    constructor(data?: ICourseQuizExamListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.quizExamName = _data["quizExamName"];
        }
    }

    static fromJS(data: any): CourseQuizExamListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseQuizExamListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["quizExamName"] = this.quizExamName;
        return data;
    }
}

export interface ICourseQuizExamListDto {
    id?: number;
    quizExamName?: string;
}

export class CourseQuizExamReqDto implements ICourseQuizExamReqDto {
    id?: number;
    courseId?: number;
    quizExamName?: string;
    quizScores?: number | undefined;
    quizExamWeight?: number;
    retakesAllowed?: number;
    passingScore?: number;
    quizExamGenerationType?: CourseQuizExamGenerationType;
    courseQuizExamQuestionBanks?: CourseQuizExamQuestionBankReqDto[];
    courseQuizExamSequentials?: CourseQuizExamSequentialReqDto[];
    courseQuizExamMessages?: { [key: string]: CourseQuizExamMessageReqDto; };

    constructor(data?: ICourseQuizExamReqDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.courseId = _data["courseId"];
            this.quizExamName = _data["quizExamName"];
            this.quizScores = _data["quizScores"];
            this.quizExamWeight = _data["quizExamWeight"];
            this.retakesAllowed = _data["retakesAllowed"];
            this.passingScore = _data["passingScore"];
            this.quizExamGenerationType = _data["quizExamGenerationType"];
            if (Array.isArray(_data["courseQuizExamQuestionBanks"])) {
                this.courseQuizExamQuestionBanks = [] as any;
                for (let item of _data["courseQuizExamQuestionBanks"])
                    this.courseQuizExamQuestionBanks!.push(CourseQuizExamQuestionBankReqDto.fromJS(item));
            }
            if (Array.isArray(_data["courseQuizExamSequentials"])) {
                this.courseQuizExamSequentials = [] as any;
                for (let item of _data["courseQuizExamSequentials"])
                    this.courseQuizExamSequentials!.push(CourseQuizExamSequentialReqDto.fromJS(item));
            }
            if (_data["courseQuizExamMessages"]) {
                this.courseQuizExamMessages = {} as any;
                for (let key in _data["courseQuizExamMessages"]) {
                    if (_data["courseQuizExamMessages"].hasOwnProperty(key))
                        (<any>this.courseQuizExamMessages)![key] = _data["courseQuizExamMessages"][key] ? CourseQuizExamMessageReqDto.fromJS(_data["courseQuizExamMessages"][key]) : new CourseQuizExamMessageReqDto();
                }
            }
        }
    }

    static fromJS(data: any): CourseQuizExamReqDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseQuizExamReqDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["courseId"] = this.courseId;
        data["quizExamName"] = this.quizExamName;
        data["quizScores"] = this.quizScores;
        data["quizExamWeight"] = this.quizExamWeight;
        data["retakesAllowed"] = this.retakesAllowed;
        data["passingScore"] = this.passingScore;
        data["quizExamGenerationType"] = this.quizExamGenerationType;
        if (Array.isArray(this.courseQuizExamQuestionBanks)) {
            data["courseQuizExamQuestionBanks"] = [];
            for (let item of this.courseQuizExamQuestionBanks)
                data["courseQuizExamQuestionBanks"].push(item.toJSON());
        }
        if (Array.isArray(this.courseQuizExamSequentials)) {
            data["courseQuizExamSequentials"] = [];
            for (let item of this.courseQuizExamSequentials)
                data["courseQuizExamSequentials"].push(item.toJSON());
        }
        if (this.courseQuizExamMessages) {
            data["courseQuizExamMessages"] = {};
            for (let key in this.courseQuizExamMessages) {
                if (this.courseQuizExamMessages.hasOwnProperty(key))
                    (<any>data["courseQuizExamMessages"])[key] = this.courseQuizExamMessages[key] ? this.courseQuizExamMessages[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface ICourseQuizExamReqDto {
    id?: number;
    courseId?: number;
    quizExamName?: string;
    quizScores?: number | undefined;
    quizExamWeight?: number;
    retakesAllowed?: number;
    passingScore?: number;
    quizExamGenerationType?: CourseQuizExamGenerationType;
    courseQuizExamQuestionBanks?: CourseQuizExamQuestionBankReqDto[];
    courseQuizExamSequentials?: CourseQuizExamSequentialReqDto[];
    courseQuizExamMessages?: { [key: string]: CourseQuizExamMessageReqDto; };
}

export class CreateCourseQuizExamCommand extends CourseQuizExamReqDto implements ICreateCourseQuizExamCommand {

    constructor(data?: ICreateCourseQuizExamCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CreateCourseQuizExamCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCourseQuizExamCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICreateCourseQuizExamCommand extends ICourseQuizExamReqDto {
}

export class UpdateCourseQuizExamCommand extends CourseQuizExamReqDto implements IUpdateCourseQuizExamCommand {

    constructor(data?: IUpdateCourseQuizExamCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpdateCourseQuizExamCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCourseQuizExamCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateCourseQuizExamCommand extends ICourseQuizExamReqDto {
}

export class DeleteCourseQuizExamCommand implements IDeleteCourseQuizExamCommand {
    id?: number;

    constructor(data?: IDeleteCourseQuizExamCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteCourseQuizExamCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteCourseQuizExamCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteCourseQuizExamCommand {
    id?: number;
}

export class CourseIdNameDto implements ICourseIdNameDto {
    id?: number;
    courseName?: string;

    constructor(data?: ICourseIdNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.courseName = _data["courseName"];
        }
    }

    static fromJS(data: any): CourseIdNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseIdNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["courseName"] = this.courseName;
        return data;
    }
}

export interface ICourseIdNameDto {
    id?: number;
    courseName?: string;
}

export class PaginatedListOfCourseSelectBriefDto implements IPaginatedListOfCourseSelectBriefDto {
    items?: CourseSelectBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfCourseSelectBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CourseSelectBriefDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfCourseSelectBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfCourseSelectBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfCourseSelectBriefDto {
    items?: CourseSelectBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class CourseSelectBriefDto implements ICourseSelectBriefDto {
    id?: number;
    courseName?: string;
    moduleCount?: number;
    languageId?: string;
    languageIds?: string[] | undefined;

    constructor(data?: ICourseSelectBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.courseName = _data["courseName"];
            this.moduleCount = _data["moduleCount"];
            this.languageId = _data["languageId"];
            if (Array.isArray(_data["languageIds"])) {
                this.languageIds = [] as any;
                for (let item of _data["languageIds"])
                    this.languageIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CourseSelectBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseSelectBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["courseName"] = this.courseName;
        data["moduleCount"] = this.moduleCount;
        data["languageId"] = this.languageId;
        if (Array.isArray(this.languageIds)) {
            data["languageIds"] = [];
            for (let item of this.languageIds)
                data["languageIds"].push(item);
        }
        return data;
    }
}

export interface ICourseSelectBriefDto {
    id?: number;
    courseName?: string;
    moduleCount?: number;
    languageId?: string;
    languageIds?: string[] | undefined;
}

export class CourseSupportedLanguageReqDto implements ICourseSupportedLanguageReqDto {
    id?: string;
    displayName?: string;

    constructor(data?: ICourseSupportedLanguageReqDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): CourseSupportedLanguageReqDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseSupportedLanguageReqDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ICourseSupportedLanguageReqDto {
    id?: string;
    displayName?: string;
}

export class CourseBriefDto implements ICourseBriefDto {
    courseStatus?: CourseStatus;
    courseInfos?: CourseNameInfoDto[];

    constructor(data?: ICourseBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseStatus = _data["courseStatus"];
            if (Array.isArray(_data["courseInfos"])) {
                this.courseInfos = [] as any;
                for (let item of _data["courseInfos"])
                    this.courseInfos!.push(CourseNameInfoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CourseBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseStatus"] = this.courseStatus;
        if (Array.isArray(this.courseInfos)) {
            data["courseInfos"] = [];
            for (let item of this.courseInfos)
                data["courseInfos"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICourseBriefDto {
    courseStatus?: CourseStatus;
    courseInfos?: CourseNameInfoDto[];
}

export class CourseNameInfoDto implements ICourseNameInfoDto {
    supportedLanguageId?: string | undefined;
    courseName?: string | undefined;

    constructor(data?: ICourseNameInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supportedLanguageId = _data["supportedLanguageId"];
            this.courseName = _data["courseName"];
        }
    }

    static fromJS(data: any): CourseNameInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseNameInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supportedLanguageId"] = this.supportedLanguageId;
        data["courseName"] = this.courseName;
        return data;
    }
}

export interface ICourseNameInfoDto {
    supportedLanguageId?: string | undefined;
    courseName?: string | undefined;
}

export class SendTestingEmailCommand implements ISendTestingEmailCommand {
    email?: string;

    constructor(data?: ISendTestingEmailCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): SendTestingEmailCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendTestingEmailCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface ISendTestingEmailCommand {
    email?: string;
}

export class PaginatedListOfFacetDimensionDto implements IPaginatedListOfFacetDimensionDto {
    items?: FacetDimensionDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfFacetDimensionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FacetDimensionDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfFacetDimensionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfFacetDimensionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfFacetDimensionDto {
    items?: FacetDimensionDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class PaginatedListOfFormQuestionDto implements IPaginatedListOfFormQuestionDto {
    items?: FormQuestionDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfFormQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FormQuestionDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfFormQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfFormQuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfFormQuestionDto {
    items?: FormQuestionDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class FormQuestionDto implements IFormQuestionDto {
    id?: number;
    formName?: string | undefined;
    questionItemNumber?: number;
    questionCategoryAlias?: string | undefined;
    questionId?: number;
    isOptional?: boolean;
    order?: number;
    pageNumber?: number;
    created?: Date;

    constructor(data?: IFormQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.formName = _data["formName"];
            this.questionItemNumber = _data["questionItemNumber"];
            this.questionCategoryAlias = _data["questionCategoryAlias"];
            this.questionId = _data["questionId"];
            this.isOptional = _data["isOptional"];
            this.order = _data["order"];
            this.pageNumber = _data["pageNumber"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FormQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormQuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["formName"] = this.formName;
        data["questionItemNumber"] = this.questionItemNumber;
        data["questionCategoryAlias"] = this.questionCategoryAlias;
        data["questionId"] = this.questionId;
        data["isOptional"] = this.isOptional;
        data["order"] = this.order;
        data["pageNumber"] = this.pageNumber;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }
}

export interface IFormQuestionDto {
    id?: number;
    formName?: string | undefined;
    questionItemNumber?: number;
    questionCategoryAlias?: string | undefined;
    questionId?: number;
    isOptional?: boolean;
    order?: number;
    pageNumber?: number;
    created?: Date;
}

export class PaginatedListOfFormBriefDto implements IPaginatedListOfFormBriefDto {
    items?: FormBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfFormBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FormBriefDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfFormBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfFormBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfFormBriefDto {
    items?: FormBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class FormDto implements IFormDto {
    id?: number;
    questionCategoryAlias?: string | undefined;
    type?: FormType;
    name?: string | undefined;
    isShuffle?: boolean;
    header?: { [key: string]: string; } | undefined;
    footer?: { [key: string]: string; } | undefined;

    constructor(data?: IFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.questionCategoryAlias = _data["questionCategoryAlias"];
            this.type = _data["type"];
            this.name = _data["name"];
            this.isShuffle = _data["isShuffle"];
            if (_data["header"]) {
                this.header = {} as any;
                for (let key in _data["header"]) {
                    if (_data["header"].hasOwnProperty(key))
                        (<any>this.header)![key] = _data["header"][key];
                }
            }
            if (_data["footer"]) {
                this.footer = {} as any;
                for (let key in _data["footer"]) {
                    if (_data["footer"].hasOwnProperty(key))
                        (<any>this.footer)![key] = _data["footer"][key];
                }
            }
        }
    }

    static fromJS(data: any): FormDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["questionCategoryAlias"] = this.questionCategoryAlias;
        data["type"] = this.type;
        data["name"] = this.name;
        data["isShuffle"] = this.isShuffle;
        if (this.header) {
            data["header"] = {};
            for (let key in this.header) {
                if (this.header.hasOwnProperty(key))
                    (<any>data["header"])[key] = (<any>this.header)[key];
            }
        }
        if (this.footer) {
            data["footer"] = {};
            for (let key in this.footer) {
                if (this.footer.hasOwnProperty(key))
                    (<any>data["footer"])[key] = (<any>this.footer)[key];
            }
        }
        return data;
    }
}

export interface IFormDto {
    id?: number;
    questionCategoryAlias?: string | undefined;
    type?: FormType;
    name?: string | undefined;
    isShuffle?: boolean;
    header?: { [key: string]: string; } | undefined;
    footer?: { [key: string]: string; } | undefined;
}

export class CreateFormCommand implements ICreateFormCommand {
    questionCategoryId?: number;
    questionResponseType?: QuestionType;
    questionPerPage?: number;
    type?: FormType;
    ratingScaleId?: number | undefined;
    name?: string | undefined;
    isShuffle?: boolean;
    header?: { [key: string]: string; };
    footer?: { [key: string]: string; };

    constructor(data?: ICreateFormCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionCategoryId = _data["questionCategoryId"];
            this.questionResponseType = _data["questionResponseType"];
            this.questionPerPage = _data["questionPerPage"];
            this.type = _data["type"];
            this.ratingScaleId = _data["ratingScaleId"];
            this.name = _data["name"];
            this.isShuffle = _data["isShuffle"];
            if (_data["header"]) {
                this.header = {} as any;
                for (let key in _data["header"]) {
                    if (_data["header"].hasOwnProperty(key))
                        (<any>this.header)![key] = _data["header"][key];
                }
            }
            if (_data["footer"]) {
                this.footer = {} as any;
                for (let key in _data["footer"]) {
                    if (_data["footer"].hasOwnProperty(key))
                        (<any>this.footer)![key] = _data["footer"][key];
                }
            }
        }
    }

    static fromJS(data: any): CreateFormCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFormCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionCategoryId"] = this.questionCategoryId;
        data["questionResponseType"] = this.questionResponseType;
        data["questionPerPage"] = this.questionPerPage;
        data["type"] = this.type;
        data["ratingScaleId"] = this.ratingScaleId;
        data["name"] = this.name;
        data["isShuffle"] = this.isShuffle;
        if (this.header) {
            data["header"] = {};
            for (let key in this.header) {
                if (this.header.hasOwnProperty(key))
                    (<any>data["header"])[key] = (<any>this.header)[key];
            }
        }
        if (this.footer) {
            data["footer"] = {};
            for (let key in this.footer) {
                if (this.footer.hasOwnProperty(key))
                    (<any>data["footer"])[key] = (<any>this.footer)[key];
            }
        }
        return data;
    }
}

export interface ICreateFormCommand {
    questionCategoryId?: number;
    questionResponseType?: QuestionType;
    questionPerPage?: number;
    type?: FormType;
    ratingScaleId?: number | undefined;
    name?: string | undefined;
    isShuffle?: boolean;
    header?: { [key: string]: string; };
    footer?: { [key: string]: string; };
}

export class UpdateFormCommand implements IUpdateFormCommand {
    id?: number;
    name?: string | undefined;
    isShuffle?: boolean;
    header?: { [key: string]: string; };
    footer?: { [key: string]: string; };

    constructor(data?: IUpdateFormCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isShuffle = _data["isShuffle"];
            if (_data["header"]) {
                this.header = {} as any;
                for (let key in _data["header"]) {
                    if (_data["header"].hasOwnProperty(key))
                        (<any>this.header)![key] = _data["header"][key];
                }
            }
            if (_data["footer"]) {
                this.footer = {} as any;
                for (let key in _data["footer"]) {
                    if (_data["footer"].hasOwnProperty(key))
                        (<any>this.footer)![key] = _data["footer"][key];
                }
            }
        }
    }

    static fromJS(data: any): UpdateFormCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFormCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isShuffle"] = this.isShuffle;
        if (this.header) {
            data["header"] = {};
            for (let key in this.header) {
                if (this.header.hasOwnProperty(key))
                    (<any>data["header"])[key] = (<any>this.header)[key];
            }
        }
        if (this.footer) {
            data["footer"] = {};
            for (let key in this.footer) {
                if (this.footer.hasOwnProperty(key))
                    (<any>data["footer"])[key] = (<any>this.footer)[key];
            }
        }
        return data;
    }
}

export interface IUpdateFormCommand {
    id?: number;
    name?: string | undefined;
    isShuffle?: boolean;
    header?: { [key: string]: string; };
    footer?: { [key: string]: string; };
}

export class ReportGenerationSettingsDto implements IReportGenerationSettingsDto {
    assessmentTemplate?: AssessmentTemplateBriefDto;
    form?: FormBriefDto;
    scoringKeySet?: ScoringKeySetDto;
    normTable?: NormTableBriefDto;
    reportTemplate?: ReportTemplateBriefDto;

    constructor(data?: IReportGenerationSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assessmentTemplate = _data["assessmentTemplate"] ? AssessmentTemplateBriefDto.fromJS(_data["assessmentTemplate"]) : <any>undefined;
            this.form = _data["form"] ? FormBriefDto.fromJS(_data["form"]) : <any>undefined;
            this.scoringKeySet = _data["scoringKeySet"] ? ScoringKeySetDto.fromJS(_data["scoringKeySet"]) : <any>undefined;
            this.normTable = _data["normTable"] ? NormTableBriefDto.fromJS(_data["normTable"]) : <any>undefined;
            this.reportTemplate = _data["reportTemplate"] ? ReportTemplateBriefDto.fromJS(_data["reportTemplate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ReportGenerationSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportGenerationSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assessmentTemplate"] = this.assessmentTemplate ? this.assessmentTemplate.toJSON() : <any>undefined;
        data["form"] = this.form ? this.form.toJSON() : <any>undefined;
        data["scoringKeySet"] = this.scoringKeySet ? this.scoringKeySet.toJSON() : <any>undefined;
        data["normTable"] = this.normTable ? this.normTable.toJSON() : <any>undefined;
        data["reportTemplate"] = this.reportTemplate ? this.reportTemplate.toJSON() : <any>undefined;
        return data;
    }
}

export interface IReportGenerationSettingsDto {
    assessmentTemplate?: AssessmentTemplateBriefDto;
    form?: FormBriefDto;
    scoringKeySet?: ScoringKeySetDto;
    normTable?: NormTableBriefDto;
    reportTemplate?: ReportTemplateBriefDto;
}

export class ScoringKeySetDto implements IScoringKeySetDto {
    id?: number;
    name?: string | undefined;
    questionCategoryAlias?: string | undefined;
    created?: Date;
    consistencyCheckThreshold?: number;
    contraryCheckUpperThreshold?: number;
    contraryCheckLowerThreshold?: number;

    constructor(data?: IScoringKeySetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.questionCategoryAlias = _data["questionCategoryAlias"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.consistencyCheckThreshold = _data["consistencyCheckThreshold"];
            this.contraryCheckUpperThreshold = _data["contraryCheckUpperThreshold"];
            this.contraryCheckLowerThreshold = _data["contraryCheckLowerThreshold"];
        }
    }

    static fromJS(data: any): ScoringKeySetDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScoringKeySetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["questionCategoryAlias"] = this.questionCategoryAlias;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["consistencyCheckThreshold"] = this.consistencyCheckThreshold;
        data["contraryCheckUpperThreshold"] = this.contraryCheckUpperThreshold;
        data["contraryCheckLowerThreshold"] = this.contraryCheckLowerThreshold;
        return data;
    }
}

export interface IScoringKeySetDto {
    id?: number;
    name?: string | undefined;
    questionCategoryAlias?: string | undefined;
    created?: Date;
    consistencyCheckThreshold?: number;
    contraryCheckUpperThreshold?: number;
    contraryCheckLowerThreshold?: number;
}

export class PaginatedListOfReportGenerationSettingsBriefDto implements IPaginatedListOfReportGenerationSettingsBriefDto {
    items?: ReportGenerationSettingsBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfReportGenerationSettingsBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ReportGenerationSettingsBriefDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfReportGenerationSettingsBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfReportGenerationSettingsBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfReportGenerationSettingsBriefDto {
    items?: ReportGenerationSettingsBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class ReportGenerationSettingsBriefDto implements IReportGenerationSettingsBriefDto {
    assessmentTemplateAlias?: string | undefined;
    formName?: string | undefined;
    scoringKeySetName?: string | undefined;
    normTableName?: string | undefined;
    reportTemplateName?: string | undefined;

    constructor(data?: IReportGenerationSettingsBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assessmentTemplateAlias = _data["assessmentTemplateAlias"];
            this.formName = _data["formName"];
            this.scoringKeySetName = _data["scoringKeySetName"];
            this.normTableName = _data["normTableName"];
            this.reportTemplateName = _data["reportTemplateName"];
        }
    }

    static fromJS(data: any): ReportGenerationSettingsBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportGenerationSettingsBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assessmentTemplateAlias"] = this.assessmentTemplateAlias;
        data["formName"] = this.formName;
        data["scoringKeySetName"] = this.scoringKeySetName;
        data["normTableName"] = this.normTableName;
        data["reportTemplateName"] = this.reportTemplateName;
        return data;
    }
}

export interface IReportGenerationSettingsBriefDto {
    assessmentTemplateAlias?: string | undefined;
    formName?: string | undefined;
    scoringKeySetName?: string | undefined;
    normTableName?: string | undefined;
    reportTemplateName?: string | undefined;
}

export class CreateGroupGroupReportCommand implements ICreateGroupGroupReportCommand {
    clientGroupAssessmentTemplateId?: number;
    scoringKeySetId?: number;
    normTableId?: number;
    groupReportTemplateId?: number;
    powerpointFormat?: boolean | undefined;
    clientGroupsIdList?: number[];
    reportTitle?: string | undefined;

    constructor(data?: ICreateGroupGroupReportCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientGroupAssessmentTemplateId = _data["clientGroupAssessmentTemplateId"];
            this.scoringKeySetId = _data["scoringKeySetId"];
            this.normTableId = _data["normTableId"];
            this.groupReportTemplateId = _data["groupReportTemplateId"];
            this.powerpointFormat = _data["powerpointFormat"];
            if (Array.isArray(_data["clientGroupsIdList"])) {
                this.clientGroupsIdList = [] as any;
                for (let item of _data["clientGroupsIdList"])
                    this.clientGroupsIdList!.push(item);
            }
            this.reportTitle = _data["reportTitle"];
        }
    }

    static fromJS(data: any): CreateGroupGroupReportCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGroupGroupReportCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientGroupAssessmentTemplateId"] = this.clientGroupAssessmentTemplateId;
        data["scoringKeySetId"] = this.scoringKeySetId;
        data["normTableId"] = this.normTableId;
        data["groupReportTemplateId"] = this.groupReportTemplateId;
        data["powerpointFormat"] = this.powerpointFormat;
        if (Array.isArray(this.clientGroupsIdList)) {
            data["clientGroupsIdList"] = [];
            for (let item of this.clientGroupsIdList)
                data["clientGroupsIdList"].push(item);
        }
        data["reportTitle"] = this.reportTitle;
        return data;
    }
}

export interface ICreateGroupGroupReportCommand {
    clientGroupAssessmentTemplateId?: number;
    scoringKeySetId?: number;
    normTableId?: number;
    groupReportTemplateId?: number;
    powerpointFormat?: boolean | undefined;
    clientGroupsIdList?: number[];
    reportTitle?: string | undefined;
}

export class CreateGroupGroupReportBySettingCommand implements ICreateGroupGroupReportBySettingCommand {
    clientGroupGroupReportGenerationSettingId?: number;
    clientGroupsIdList?: number[];
    reportTitle?: string | undefined;

    constructor(data?: ICreateGroupGroupReportBySettingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientGroupGroupReportGenerationSettingId = _data["clientGroupGroupReportGenerationSettingId"];
            if (Array.isArray(_data["clientGroupsIdList"])) {
                this.clientGroupsIdList = [] as any;
                for (let item of _data["clientGroupsIdList"])
                    this.clientGroupsIdList!.push(item);
            }
            this.reportTitle = _data["reportTitle"];
        }
    }

    static fromJS(data: any): CreateGroupGroupReportBySettingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGroupGroupReportBySettingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientGroupGroupReportGenerationSettingId"] = this.clientGroupGroupReportGenerationSettingId;
        if (Array.isArray(this.clientGroupsIdList)) {
            data["clientGroupsIdList"] = [];
            for (let item of this.clientGroupsIdList)
                data["clientGroupsIdList"].push(item);
        }
        data["reportTitle"] = this.reportTitle;
        return data;
    }
}

export interface ICreateGroupGroupReportBySettingCommand {
    clientGroupGroupReportGenerationSettingId?: number;
    clientGroupsIdList?: number[];
    reportTitle?: string | undefined;
}

export class PaginatedListOfGroupReportDto2 implements IPaginatedListOfGroupReportDto2 {
    items?: GroupReportDto2[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfGroupReportDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GroupReportDto2.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfGroupReportDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfGroupReportDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfGroupReportDto2 {
    items?: GroupReportDto2[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class GroupReportDto2 implements IGroupReportDto2 {
    id?: number;
    groupReportTemplate?: GroupReportTemplateBriefDto | undefined;
    assessmentTemplateId?: number;
    assessmentTemplateAlias?: string;
    scoringKeySetId?: number;
    normTable?: NormTableBriefDto | undefined;
    scoringKeySetName?: string | undefined;
    groupReportTemplateDisplayName?: string | undefined;
    reportTemplatePreferredLanguageDisplayName?: string | undefined;
    normTableName?: string | undefined;
    created?: Date;
    hasScoreCheck?: boolean;
    status?: AssessmentReportStatus;

    constructor(data?: IGroupReportDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.groupReportTemplate = _data["groupReportTemplate"] ? GroupReportTemplateBriefDto.fromJS(_data["groupReportTemplate"]) : <any>undefined;
            this.assessmentTemplateId = _data["assessmentTemplateId"];
            this.assessmentTemplateAlias = _data["assessmentTemplateAlias"];
            this.scoringKeySetId = _data["scoringKeySetId"];
            this.normTable = _data["normTable"] ? NormTableBriefDto.fromJS(_data["normTable"]) : <any>undefined;
            this.scoringKeySetName = _data["scoringKeySetName"];
            this.groupReportTemplateDisplayName = _data["groupReportTemplateDisplayName"];
            this.reportTemplatePreferredLanguageDisplayName = _data["reportTemplatePreferredLanguageDisplayName"];
            this.normTableName = _data["normTableName"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.hasScoreCheck = _data["hasScoreCheck"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): GroupReportDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new GroupReportDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["groupReportTemplate"] = this.groupReportTemplate ? this.groupReportTemplate.toJSON() : <any>undefined;
        data["assessmentTemplateId"] = this.assessmentTemplateId;
        data["assessmentTemplateAlias"] = this.assessmentTemplateAlias;
        data["scoringKeySetId"] = this.scoringKeySetId;
        data["normTable"] = this.normTable ? this.normTable.toJSON() : <any>undefined;
        data["scoringKeySetName"] = this.scoringKeySetName;
        data["groupReportTemplateDisplayName"] = this.groupReportTemplateDisplayName;
        data["reportTemplatePreferredLanguageDisplayName"] = this.reportTemplatePreferredLanguageDisplayName;
        data["normTableName"] = this.normTableName;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["hasScoreCheck"] = this.hasScoreCheck;
        data["status"] = this.status;
        return data;
    }
}

export interface IGroupReportDto2 {
    id?: number;
    groupReportTemplate?: GroupReportTemplateBriefDto | undefined;
    assessmentTemplateId?: number;
    assessmentTemplateAlias?: string;
    scoringKeySetId?: number;
    normTable?: NormTableBriefDto | undefined;
    scoringKeySetName?: string | undefined;
    groupReportTemplateDisplayName?: string | undefined;
    reportTemplatePreferredLanguageDisplayName?: string | undefined;
    normTableName?: string | undefined;
    created?: Date;
    hasScoreCheck?: boolean;
    status?: AssessmentReportStatus;
}

export class GroupReportTemplateBriefDto implements IGroupReportTemplateBriefDto {
    id?: number;
    name?: string;
    displayName?: string;
    fileName?: string;
    preferredLanguageId?: string;
    preferredLanguageDisplayName?: string;
    consistencyCheckCountMin?: number | undefined;
    consistencyCheckCountMax?: number | undefined;
    extremeResponseCheckCountMin?: number | undefined;
    extremeResponseCheckCountMax?: number | undefined;
    type?: GroupReportTemplateType | undefined;
    created?: Date;
    lastModified?: Date;
    reportGenerationMethod?: ReportGenerationMethod;
    outlierCalculateMethod?: OutlierCalculateMethod;
    showUnmatchToken?: boolean;

    constructor(data?: IGroupReportTemplateBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.fileName = _data["fileName"];
            this.preferredLanguageId = _data["preferredLanguageId"];
            this.preferredLanguageDisplayName = _data["preferredLanguageDisplayName"];
            this.consistencyCheckCountMin = _data["consistencyCheckCountMin"];
            this.consistencyCheckCountMax = _data["consistencyCheckCountMax"];
            this.extremeResponseCheckCountMin = _data["extremeResponseCheckCountMin"];
            this.extremeResponseCheckCountMax = _data["extremeResponseCheckCountMax"];
            this.type = _data["type"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.reportGenerationMethod = _data["reportGenerationMethod"];
            this.outlierCalculateMethod = _data["outlierCalculateMethod"];
            this.showUnmatchToken = _data["showUnmatchToken"];
        }
    }

    static fromJS(data: any): GroupReportTemplateBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupReportTemplateBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["fileName"] = this.fileName;
        data["preferredLanguageId"] = this.preferredLanguageId;
        data["preferredLanguageDisplayName"] = this.preferredLanguageDisplayName;
        data["consistencyCheckCountMin"] = this.consistencyCheckCountMin;
        data["consistencyCheckCountMax"] = this.consistencyCheckCountMax;
        data["extremeResponseCheckCountMin"] = this.extremeResponseCheckCountMin;
        data["extremeResponseCheckCountMax"] = this.extremeResponseCheckCountMax;
        data["type"] = this.type;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["reportGenerationMethod"] = this.reportGenerationMethod;
        data["outlierCalculateMethod"] = this.outlierCalculateMethod;
        data["showUnmatchToken"] = this.showUnmatchToken;
        return data;
    }
}

export interface IGroupReportTemplateBriefDto {
    id?: number;
    name?: string;
    displayName?: string;
    fileName?: string;
    preferredLanguageId?: string;
    preferredLanguageDisplayName?: string;
    consistencyCheckCountMin?: number | undefined;
    consistencyCheckCountMax?: number | undefined;
    extremeResponseCheckCountMin?: number | undefined;
    extremeResponseCheckCountMax?: number | undefined;
    type?: GroupReportTemplateType | undefined;
    created?: Date;
    lastModified?: Date;
    reportGenerationMethod?: ReportGenerationMethod;
    outlierCalculateMethod?: OutlierCalculateMethod;
    showUnmatchToken?: boolean;
}

export enum GroupReportTemplateType {
    Excel = 0,
    Powerpoint = 1,
}

export enum OutlierCalculateMethod {
    OriginalGroupSD = 0,
    FacetDimensionPresetSD = 1,
}

export class PaginatedListOfGroupReportTemplateNormTableBriefDto implements IPaginatedListOfGroupReportTemplateNormTableBriefDto {
    items?: GroupReportTemplateNormTableBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfGroupReportTemplateNormTableBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GroupReportTemplateNormTableBriefDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfGroupReportTemplateNormTableBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfGroupReportTemplateNormTableBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfGroupReportTemplateNormTableBriefDto {
    items?: GroupReportTemplateNormTableBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class GroupReportTemplateNormTableBriefDto implements IGroupReportTemplateNormTableBriefDto {
    id?: number;
    normTable?: NormTableBriefDto;
    groupReportTemplate?: GroupReportTemplateBriefDto;

    constructor(data?: IGroupReportTemplateNormTableBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.normTable = _data["normTable"] ? NormTableBriefDto.fromJS(_data["normTable"]) : <any>undefined;
            this.groupReportTemplate = _data["groupReportTemplate"] ? GroupReportTemplateBriefDto.fromJS(_data["groupReportTemplate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GroupReportTemplateNormTableBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupReportTemplateNormTableBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["normTable"] = this.normTable ? this.normTable.toJSON() : <any>undefined;
        data["groupReportTemplate"] = this.groupReportTemplate ? this.groupReportTemplate.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGroupReportTemplateNormTableBriefDto {
    id?: number;
    normTable?: NormTableBriefDto;
    groupReportTemplate?: GroupReportTemplateBriefDto;
}

export class CreateGroupReportTemplateNormTableCommand implements ICreateGroupReportTemplateNormTableCommand {
    groupReportTemplateId?: number;
    normTableId?: number;

    constructor(data?: ICreateGroupReportTemplateNormTableCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupReportTemplateId = _data["groupReportTemplateId"];
            this.normTableId = _data["normTableId"];
        }
    }

    static fromJS(data: any): CreateGroupReportTemplateNormTableCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGroupReportTemplateNormTableCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupReportTemplateId"] = this.groupReportTemplateId;
        data["normTableId"] = this.normTableId;
        return data;
    }
}

export interface ICreateGroupReportTemplateNormTableCommand {
    groupReportTemplateId?: number;
    normTableId?: number;
}

export class PaginatedListOfGroupReportTemplateBriefDto implements IPaginatedListOfGroupReportTemplateBriefDto {
    items?: GroupReportTemplateBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfGroupReportTemplateBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GroupReportTemplateBriefDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfGroupReportTemplateBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfGroupReportTemplateBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfGroupReportTemplateBriefDto {
    items?: GroupReportTemplateBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class GetGroupReportTemplatesQuery implements IGetGroupReportTemplatesQuery {

    constructor(data?: IGetGroupReportTemplatesQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetGroupReportTemplatesQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetGroupReportTemplatesQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetGroupReportTemplatesQuery {
}

export class CreateGroupReportTemplateCommand implements ICreateGroupReportTemplateCommand {
    name?: string;
    displayName?: string;
    preferredLanguageId?: string;
    type?: GroupReportTemplateType;
    consistencyCheckCountMax?: number | undefined;
    consistencyCheckCountMin?: number | undefined;
    extremeResponseCheckCountMax?: number | undefined;
    extremeResponseCheckCountMin?: number | undefined;
    reportGenerationMethod?: ReportGenerationMethod;
    outlierCalculateMethod?: OutlierCalculateMethod;
    showUnmatchToken?: boolean;

    constructor(data?: ICreateGroupReportTemplateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.preferredLanguageId = _data["preferredLanguageId"];
            this.type = _data["type"];
            this.consistencyCheckCountMax = _data["consistencyCheckCountMax"];
            this.consistencyCheckCountMin = _data["consistencyCheckCountMin"];
            this.extremeResponseCheckCountMax = _data["extremeResponseCheckCountMax"];
            this.extremeResponseCheckCountMin = _data["extremeResponseCheckCountMin"];
            this.reportGenerationMethod = _data["reportGenerationMethod"];
            this.outlierCalculateMethod = _data["outlierCalculateMethod"];
            this.showUnmatchToken = _data["showUnmatchToken"];
        }
    }

    static fromJS(data: any): CreateGroupReportTemplateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGroupReportTemplateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["preferredLanguageId"] = this.preferredLanguageId;
        data["type"] = this.type;
        data["consistencyCheckCountMax"] = this.consistencyCheckCountMax;
        data["consistencyCheckCountMin"] = this.consistencyCheckCountMin;
        data["extremeResponseCheckCountMax"] = this.extremeResponseCheckCountMax;
        data["extremeResponseCheckCountMin"] = this.extremeResponseCheckCountMin;
        data["reportGenerationMethod"] = this.reportGenerationMethod;
        data["outlierCalculateMethod"] = this.outlierCalculateMethod;
        data["showUnmatchToken"] = this.showUnmatchToken;
        return data;
    }
}

export interface ICreateGroupReportTemplateCommand {
    name?: string;
    displayName?: string;
    preferredLanguageId?: string;
    type?: GroupReportTemplateType;
    consistencyCheckCountMax?: number | undefined;
    consistencyCheckCountMin?: number | undefined;
    extremeResponseCheckCountMax?: number | undefined;
    extremeResponseCheckCountMin?: number | undefined;
    reportGenerationMethod?: ReportGenerationMethod;
    outlierCalculateMethod?: OutlierCalculateMethod;
    showUnmatchToken?: boolean;
}

export class UpdateGroupReportTemplateCommand implements IUpdateGroupReportTemplateCommand {
    id?: number;
    name?: string;
    displayName?: string;
    preferredLanguageId?: string;
    type?: GroupReportTemplateType;
    consistencyCheckCountMax?: number | undefined;
    consistencyCheckCountMin?: number | undefined;
    extremeResponseCheckCountMax?: number | undefined;
    extremeResponseCheckCountMin?: number | undefined;
    reportGenerationMethod?: ReportGenerationMethod;
    outlierCalculateMethod?: OutlierCalculateMethod;
    showUnmatchToken?: boolean;

    constructor(data?: IUpdateGroupReportTemplateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.preferredLanguageId = _data["preferredLanguageId"];
            this.type = _data["type"];
            this.consistencyCheckCountMax = _data["consistencyCheckCountMax"];
            this.consistencyCheckCountMin = _data["consistencyCheckCountMin"];
            this.extremeResponseCheckCountMax = _data["extremeResponseCheckCountMax"];
            this.extremeResponseCheckCountMin = _data["extremeResponseCheckCountMin"];
            this.reportGenerationMethod = _data["reportGenerationMethod"];
            this.outlierCalculateMethod = _data["outlierCalculateMethod"];
            this.showUnmatchToken = _data["showUnmatchToken"];
        }
    }

    static fromJS(data: any): UpdateGroupReportTemplateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGroupReportTemplateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["preferredLanguageId"] = this.preferredLanguageId;
        data["type"] = this.type;
        data["consistencyCheckCountMax"] = this.consistencyCheckCountMax;
        data["consistencyCheckCountMin"] = this.consistencyCheckCountMin;
        data["extremeResponseCheckCountMax"] = this.extremeResponseCheckCountMax;
        data["extremeResponseCheckCountMin"] = this.extremeResponseCheckCountMin;
        data["reportGenerationMethod"] = this.reportGenerationMethod;
        data["outlierCalculateMethod"] = this.outlierCalculateMethod;
        data["showUnmatchToken"] = this.showUnmatchToken;
        return data;
    }
}

export interface IUpdateGroupReportTemplateCommand {
    id?: number;
    name?: string;
    displayName?: string;
    preferredLanguageId?: string;
    type?: GroupReportTemplateType;
    consistencyCheckCountMax?: number | undefined;
    consistencyCheckCountMin?: number | undefined;
    extremeResponseCheckCountMax?: number | undefined;
    extremeResponseCheckCountMin?: number | undefined;
    reportGenerationMethod?: ReportGenerationMethod;
    outlierCalculateMethod?: OutlierCalculateMethod;
    showUnmatchToken?: boolean;
}

export class ConnectivityResponseDto implements IConnectivityResponseDto {
    status?: string;
    clientId?: number;
    clientGroupId?: number;
    credentialId?: number;
    serverTime?: Date;

    constructor(data?: IConnectivityResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.clientId = _data["clientId"];
            this.clientGroupId = _data["clientGroupId"];
            this.credentialId = _data["credentialId"];
            this.serverTime = _data["serverTime"] ? new Date(_data["serverTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ConnectivityResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectivityResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["clientId"] = this.clientId;
        data["clientGroupId"] = this.clientGroupId;
        data["credentialId"] = this.credentialId;
        data["serverTime"] = this.serverTime ? this.serverTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IConnectivityResponseDto {
    status?: string;
    clientId?: number;
    clientGroupId?: number;
    credentialId?: number;
    serverTime?: Date;
}

export class CreateClientUserCommand2 implements ICreateClientUserCommand2 {
    userName?: string | undefined;
    password?: string | undefined;
    fullName?: string | undefined;
    preferredLanguageId?: string | undefined;
    email?: string | undefined;
    hasEmailNotification?: boolean | undefined;
    remark?: string | undefined;
    externalUserKey?: string | undefined;
    displayName?: string | undefined;

    constructor(data?: ICreateClientUserCommand2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.fullName = _data["fullName"];
            this.preferredLanguageId = _data["preferredLanguageId"];
            this.email = _data["email"];
            this.hasEmailNotification = _data["hasEmailNotification"];
            this.remark = _data["remark"];
            this.externalUserKey = _data["externalUserKey"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): CreateClientUserCommand2 {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClientUserCommand2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["fullName"] = this.fullName;
        data["preferredLanguageId"] = this.preferredLanguageId;
        data["email"] = this.email;
        data["hasEmailNotification"] = this.hasEmailNotification;
        data["remark"] = this.remark;
        data["externalUserKey"] = this.externalUserKey;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ICreateClientUserCommand2 {
    userName?: string | undefined;
    password?: string | undefined;
    fullName?: string | undefined;
    preferredLanguageId?: string | undefined;
    email?: string | undefined;
    hasEmailNotification?: boolean | undefined;
    remark?: string | undefined;
    externalUserKey?: string | undefined;
    displayName?: string | undefined;
}

export class AssessmentReportMetadataDto implements IAssessmentReportMetadataDto {
    id?: number;
    assessmentId?: number;
    clientUserId?: string;
    clientId?: number;
    clientGroupId?: number;
    status?: string;
    completedOn?: Date | undefined;
    fileName?: string | undefined;
    contentType?: string | undefined;
    fileSize?: number | undefined;
    resourceUrl?: string;

    constructor(data?: IAssessmentReportMetadataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assessmentId = _data["assessmentId"];
            this.clientUserId = _data["clientUserId"];
            this.clientId = _data["clientId"];
            this.clientGroupId = _data["clientGroupId"];
            this.status = _data["status"];
            this.completedOn = _data["completedOn"] ? new Date(_data["completedOn"].toString()) : <any>undefined;
            this.fileName = _data["fileName"];
            this.contentType = _data["contentType"];
            this.fileSize = _data["fileSize"];
            this.resourceUrl = _data["resourceUrl"];
        }
    }

    static fromJS(data: any): AssessmentReportMetadataDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentReportMetadataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assessmentId"] = this.assessmentId;
        data["clientUserId"] = this.clientUserId;
        data["clientId"] = this.clientId;
        data["clientGroupId"] = this.clientGroupId;
        data["status"] = this.status;
        data["completedOn"] = this.completedOn ? this.completedOn.toISOString() : <any>undefined;
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        data["fileSize"] = this.fileSize;
        data["resourceUrl"] = this.resourceUrl;
        return data;
    }
}

export interface IAssessmentReportMetadataDto {
    id?: number;
    assessmentId?: number;
    clientUserId?: string;
    clientId?: number;
    clientGroupId?: number;
    status?: string;
    completedOn?: Date | undefined;
    fileName?: string | undefined;
    contentType?: string | undefined;
    fileSize?: number | undefined;
    resourceUrl?: string;
}

export class IntegrationReportJsonDto implements IIntegrationReportJsonDto {
    reportId?: number;
    assessmentId?: number;
    clientUserId?: string;
    clientGroupId?: number;
    generatedAt?: Date;
    schema?: string;
    score?: IntegrationReportScorePayloadDto;

    constructor(data?: IIntegrationReportJsonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.assessmentId = _data["assessmentId"];
            this.clientUserId = _data["clientUserId"];
            this.clientGroupId = _data["clientGroupId"];
            this.generatedAt = _data["generatedAt"] ? new Date(_data["generatedAt"].toString()) : <any>undefined;
            this.schema = _data["schema"];
            this.score = _data["score"] ? IntegrationReportScorePayloadDto.fromJS(_data["score"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IntegrationReportJsonDto {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationReportJsonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["assessmentId"] = this.assessmentId;
        data["clientUserId"] = this.clientUserId;
        data["clientGroupId"] = this.clientGroupId;
        data["generatedAt"] = this.generatedAt ? this.generatedAt.toISOString() : <any>undefined;
        data["schema"] = this.schema;
        data["score"] = this.score ? this.score.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIntegrationReportJsonDto {
    reportId?: number;
    assessmentId?: number;
    clientUserId?: string;
    clientGroupId?: number;
    generatedAt?: Date;
    schema?: string;
    score?: IntegrationReportScorePayloadDto;
}

export class IntegrationReportScorePayloadDto implements IIntegrationReportScorePayloadDto {
    source?: string;
    payload?: any;

    constructor(data?: IIntegrationReportScorePayloadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.source = _data["source"];
            this.payload = _data["payload"];
        }
    }

    static fromJS(data: any): IntegrationReportScorePayloadDto {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationReportScorePayloadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source;
        data["payload"] = this.payload;
        return data;
    }
}

export interface IIntegrationReportScorePayloadDto {
    source?: string;
    payload?: any;
}

export class AssessmentMetadataDto implements IAssessmentMetadataDto {
    id?: number;
    clientUserId?: string;
    clientId?: number;
    clientGroupId?: number;
    clientGroupAssessmentTemplateId?: number;
    completedOn?: Date | undefined;
    reportIds?: number[];

    constructor(data?: IAssessmentMetadataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientUserId = _data["clientUserId"];
            this.clientId = _data["clientId"];
            this.clientGroupId = _data["clientGroupId"];
            this.clientGroupAssessmentTemplateId = _data["clientGroupAssessmentTemplateId"];
            this.completedOn = _data["completedOn"] ? new Date(_data["completedOn"].toString()) : <any>undefined;
            if (Array.isArray(_data["reportIds"])) {
                this.reportIds = [] as any;
                for (let item of _data["reportIds"])
                    this.reportIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AssessmentMetadataDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentMetadataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientUserId"] = this.clientUserId;
        data["clientId"] = this.clientId;
        data["clientGroupId"] = this.clientGroupId;
        data["clientGroupAssessmentTemplateId"] = this.clientGroupAssessmentTemplateId;
        data["completedOn"] = this.completedOn ? this.completedOn.toISOString() : <any>undefined;
        if (Array.isArray(this.reportIds)) {
            data["reportIds"] = [];
            for (let item of this.reportIds)
                data["reportIds"].push(item);
        }
        return data;
    }
}

export interface IAssessmentMetadataDto {
    id?: number;
    clientUserId?: string;
    clientId?: number;
    clientGroupId?: number;
    clientGroupAssessmentTemplateId?: number;
    completedOn?: Date | undefined;
    reportIds?: number[];
}

export class PaginatedListOfIntegrationReportListItemDto implements IPaginatedListOfIntegrationReportListItemDto {
    items?: IntegrationReportListItemDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfIntegrationReportListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(IntegrationReportListItemDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfIntegrationReportListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfIntegrationReportListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfIntegrationReportListItemDto {
    items?: IntegrationReportListItemDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class IntegrationReportListItemDto implements IIntegrationReportListItemDto {
    reportId?: number;
    assessmentId?: number;
    clientUserId?: string;
    clientGroupId?: number;
    externalUserKey?: string;
    status?: string;
    reportTemplateId?: number;
    reportTemplateName?: string | undefined;
    preferredLanguageId?: string | undefined;
    completedAt?: Date | undefined;
    readyAt?: Date | undefined;
    fileUrl?: string | undefined;
    jsonUrl?: string | undefined;

    constructor(data?: IIntegrationReportListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.assessmentId = _data["assessmentId"];
            this.clientUserId = _data["clientUserId"];
            this.clientGroupId = _data["clientGroupId"];
            this.externalUserKey = _data["externalUserKey"];
            this.status = _data["status"];
            this.reportTemplateId = _data["reportTemplateId"];
            this.reportTemplateName = _data["reportTemplateName"];
            this.preferredLanguageId = _data["preferredLanguageId"];
            this.completedAt = _data["completedAt"] ? new Date(_data["completedAt"].toString()) : <any>undefined;
            this.readyAt = _data["readyAt"] ? new Date(_data["readyAt"].toString()) : <any>undefined;
            this.fileUrl = _data["fileUrl"];
            this.jsonUrl = _data["jsonUrl"];
        }
    }

    static fromJS(data: any): IntegrationReportListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationReportListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["assessmentId"] = this.assessmentId;
        data["clientUserId"] = this.clientUserId;
        data["clientGroupId"] = this.clientGroupId;
        data["externalUserKey"] = this.externalUserKey;
        data["status"] = this.status;
        data["reportTemplateId"] = this.reportTemplateId;
        data["reportTemplateName"] = this.reportTemplateName;
        data["preferredLanguageId"] = this.preferredLanguageId;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : <any>undefined;
        data["readyAt"] = this.readyAt ? this.readyAt.toISOString() : <any>undefined;
        data["fileUrl"] = this.fileUrl;
        data["jsonUrl"] = this.jsonUrl;
        return data;
    }
}

export interface IIntegrationReportListItemDto {
    reportId?: number;
    assessmentId?: number;
    clientUserId?: string;
    clientGroupId?: number;
    externalUserKey?: string;
    status?: string;
    reportTemplateId?: number;
    reportTemplateName?: string | undefined;
    preferredLanguageId?: string | undefined;
    completedAt?: Date | undefined;
    readyAt?: Date | undefined;
    fileUrl?: string | undefined;
    jsonUrl?: string | undefined;
}

export class CursorPaginatedListOfIntegrationEventDto implements ICursorPaginatedListOfIntegrationEventDto {
    items?: IntegrationEventDto[];
    nextCursor?: string | undefined;

    constructor(data?: ICursorPaginatedListOfIntegrationEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(IntegrationEventDto.fromJS(item));
            }
            this.nextCursor = _data["nextCursor"];
        }
    }

    static fromJS(data: any): CursorPaginatedListOfIntegrationEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new CursorPaginatedListOfIntegrationEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["nextCursor"] = this.nextCursor;
        return data;
    }
}

export interface ICursorPaginatedListOfIntegrationEventDto {
    items?: IntegrationEventDto[];
    nextCursor?: string | undefined;
}

export class IntegrationEventDto implements IIntegrationEventDto {
    eventId?: string;
    eventType?: string;
    clientGroupId?: number;
    occurredAt?: Date;
    subjectType?: string;
    subjectId?: string;
    resourceUrl?: string | undefined;

    constructor(data?: IIntegrationEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventId = _data["eventId"];
            this.eventType = _data["eventType"];
            this.clientGroupId = _data["clientGroupId"];
            this.occurredAt = _data["occurredAt"] ? new Date(_data["occurredAt"].toString()) : <any>undefined;
            this.subjectType = _data["subjectType"];
            this.subjectId = _data["subjectId"];
            this.resourceUrl = _data["resourceUrl"];
        }
    }

    static fromJS(data: any): IntegrationEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventId"] = this.eventId;
        data["eventType"] = this.eventType;
        data["clientGroupId"] = this.clientGroupId;
        data["occurredAt"] = this.occurredAt ? this.occurredAt.toISOString() : <any>undefined;
        data["subjectType"] = this.subjectType;
        data["subjectId"] = this.subjectId;
        data["resourceUrl"] = this.resourceUrl;
        return data;
    }
}

export interface IIntegrationEventDto {
    eventId?: string;
    eventType?: string;
    clientGroupId?: number;
    occurredAt?: Date;
    subjectType?: string;
    subjectId?: string;
    resourceUrl?: string | undefined;
}

export class IntegrationGroupReportMetadataDto implements IIntegrationGroupReportMetadataDto {
    groupReportId?: number;
    clientId?: number;
    clientGroupId?: number;
    clientGroupName?: string;
    status?: string;
    readyAt?: Date | undefined;
    completedAt?: Date | undefined;
    userCount?: number;
    assessmentTemplateId?: number;
    assessmentTemplateName?: string;
    groupReportTemplateId?: number;
    groupReportTemplateName?: string;
    scoringKeySetId?: number;
    scoringKeySetName?: string;
    normTableId?: number;
    normTableName?: string;
    reportGenerationMethod?: string;
    generationSetting?: IntegrationGroupReportGenerationSettingDto | undefined;
    jsonUrl?: string;
    fileUrl?: string;

    constructor(data?: IIntegrationGroupReportMetadataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupReportId = _data["groupReportId"];
            this.clientId = _data["clientId"];
            this.clientGroupId = _data["clientGroupId"];
            this.clientGroupName = _data["clientGroupName"];
            this.status = _data["status"];
            this.readyAt = _data["readyAt"] ? new Date(_data["readyAt"].toString()) : <any>undefined;
            this.completedAt = _data["completedAt"] ? new Date(_data["completedAt"].toString()) : <any>undefined;
            this.userCount = _data["userCount"];
            this.assessmentTemplateId = _data["assessmentTemplateId"];
            this.assessmentTemplateName = _data["assessmentTemplateName"];
            this.groupReportTemplateId = _data["groupReportTemplateId"];
            this.groupReportTemplateName = _data["groupReportTemplateName"];
            this.scoringKeySetId = _data["scoringKeySetId"];
            this.scoringKeySetName = _data["scoringKeySetName"];
            this.normTableId = _data["normTableId"];
            this.normTableName = _data["normTableName"];
            this.reportGenerationMethod = _data["reportGenerationMethod"];
            this.generationSetting = _data["generationSetting"] ? IntegrationGroupReportGenerationSettingDto.fromJS(_data["generationSetting"]) : <any>undefined;
            this.jsonUrl = _data["jsonUrl"];
            this.fileUrl = _data["fileUrl"];
        }
    }

    static fromJS(data: any): IntegrationGroupReportMetadataDto {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationGroupReportMetadataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupReportId"] = this.groupReportId;
        data["clientId"] = this.clientId;
        data["clientGroupId"] = this.clientGroupId;
        data["clientGroupName"] = this.clientGroupName;
        data["status"] = this.status;
        data["readyAt"] = this.readyAt ? this.readyAt.toISOString() : <any>undefined;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : <any>undefined;
        data["userCount"] = this.userCount;
        data["assessmentTemplateId"] = this.assessmentTemplateId;
        data["assessmentTemplateName"] = this.assessmentTemplateName;
        data["groupReportTemplateId"] = this.groupReportTemplateId;
        data["groupReportTemplateName"] = this.groupReportTemplateName;
        data["scoringKeySetId"] = this.scoringKeySetId;
        data["scoringKeySetName"] = this.scoringKeySetName;
        data["normTableId"] = this.normTableId;
        data["normTableName"] = this.normTableName;
        data["reportGenerationMethod"] = this.reportGenerationMethod;
        data["generationSetting"] = this.generationSetting ? this.generationSetting.toJSON() : <any>undefined;
        data["jsonUrl"] = this.jsonUrl;
        data["fileUrl"] = this.fileUrl;
        return data;
    }
}

export interface IIntegrationGroupReportMetadataDto {
    groupReportId?: number;
    clientId?: number;
    clientGroupId?: number;
    clientGroupName?: string;
    status?: string;
    readyAt?: Date | undefined;
    completedAt?: Date | undefined;
    userCount?: number;
    assessmentTemplateId?: number;
    assessmentTemplateName?: string;
    groupReportTemplateId?: number;
    groupReportTemplateName?: string;
    scoringKeySetId?: number;
    scoringKeySetName?: string;
    normTableId?: number;
    normTableName?: string;
    reportGenerationMethod?: string;
    generationSetting?: IntegrationGroupReportGenerationSettingDto | undefined;
    jsonUrl?: string;
    fileUrl?: string;
}

export class IntegrationGroupReportGenerationSettingDto implements IIntegrationGroupReportGenerationSettingDto {
    settingId?: number;
    kind?: string;
    name?: string;
    createdAt?: Date;

    constructor(data?: IIntegrationGroupReportGenerationSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.settingId = _data["settingId"];
            this.kind = _data["kind"];
            this.name = _data["name"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): IntegrationGroupReportGenerationSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationGroupReportGenerationSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["settingId"] = this.settingId;
        data["kind"] = this.kind;
        data["name"] = this.name;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IIntegrationGroupReportGenerationSettingDto {
    settingId?: number;
    kind?: string;
    name?: string;
    createdAt?: Date;
}

export class IntegrationGroupReportJsonDto implements IIntegrationGroupReportJsonDto {
    groupReportId?: number | undefined;
    clientGroupId?: number;
    generatedAt?: Date;
    schema?: string;
    score?: IntegrationGroupReportScorePayloadDto;

    constructor(data?: IIntegrationGroupReportJsonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupReportId = _data["groupReportId"];
            this.clientGroupId = _data["clientGroupId"];
            this.generatedAt = _data["generatedAt"] ? new Date(_data["generatedAt"].toString()) : <any>undefined;
            this.schema = _data["schema"];
            this.score = _data["score"] ? IntegrationGroupReportScorePayloadDto.fromJS(_data["score"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IntegrationGroupReportJsonDto {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationGroupReportJsonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupReportId"] = this.groupReportId;
        data["clientGroupId"] = this.clientGroupId;
        data["generatedAt"] = this.generatedAt ? this.generatedAt.toISOString() : <any>undefined;
        data["schema"] = this.schema;
        data["score"] = this.score ? this.score.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIntegrationGroupReportJsonDto {
    groupReportId?: number | undefined;
    clientGroupId?: number;
    generatedAt?: Date;
    schema?: string;
    score?: IntegrationGroupReportScorePayloadDto;
}

export class IntegrationGroupReportScorePayloadDto implements IIntegrationGroupReportScorePayloadDto {
    source?: string;
    payload?: any;

    constructor(data?: IIntegrationGroupReportScorePayloadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.source = _data["source"];
            this.payload = _data["payload"];
        }
    }

    static fromJS(data: any): IntegrationGroupReportScorePayloadDto {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationGroupReportScorePayloadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source;
        data["payload"] = this.payload;
        return data;
    }
}

export interface IIntegrationGroupReportScorePayloadDto {
    source?: string;
    payload?: any;
}

export class IntegrationGroupReportGenerationOptionDto implements IIntegrationGroupReportGenerationOptionDto {
    settingId?: number;
    clientGroupAssessmentTemplateId?: number;
    scoringKeySetId?: number;
    scoringKeySetName?: string | undefined;
    normTableId?: number;
    normTableName?: string | undefined;
    groupReportTemplateId?: number;
    groupReportTemplateName?: string;
    groupReportTemplateDisplayName?: string | undefined;
    groupReportLanguage?: string | undefined;

    constructor(data?: IIntegrationGroupReportGenerationOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.settingId = _data["settingId"];
            this.clientGroupAssessmentTemplateId = _data["clientGroupAssessmentTemplateId"];
            this.scoringKeySetId = _data["scoringKeySetId"];
            this.scoringKeySetName = _data["scoringKeySetName"];
            this.normTableId = _data["normTableId"];
            this.normTableName = _data["normTableName"];
            this.groupReportTemplateId = _data["groupReportTemplateId"];
            this.groupReportTemplateName = _data["groupReportTemplateName"];
            this.groupReportTemplateDisplayName = _data["groupReportTemplateDisplayName"];
            this.groupReportLanguage = _data["groupReportLanguage"];
        }
    }

    static fromJS(data: any): IntegrationGroupReportGenerationOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationGroupReportGenerationOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["settingId"] = this.settingId;
        data["clientGroupAssessmentTemplateId"] = this.clientGroupAssessmentTemplateId;
        data["scoringKeySetId"] = this.scoringKeySetId;
        data["scoringKeySetName"] = this.scoringKeySetName;
        data["normTableId"] = this.normTableId;
        data["normTableName"] = this.normTableName;
        data["groupReportTemplateId"] = this.groupReportTemplateId;
        data["groupReportTemplateName"] = this.groupReportTemplateName;
        data["groupReportTemplateDisplayName"] = this.groupReportTemplateDisplayName;
        data["groupReportLanguage"] = this.groupReportLanguage;
        return data;
    }
}

export interface IIntegrationGroupReportGenerationOptionDto {
    settingId?: number;
    clientGroupAssessmentTemplateId?: number;
    scoringKeySetId?: number;
    scoringKeySetName?: string | undefined;
    normTableId?: number;
    normTableName?: string | undefined;
    groupReportTemplateId?: number;
    groupReportTemplateName?: string;
    groupReportTemplateDisplayName?: string | undefined;
    groupReportLanguage?: string | undefined;
}

export class CreateGroupReportCommand implements ICreateGroupReportCommand {
    clientGroupGroupReportGenerationSettingId?: number;
    clientGroupsIdList?: number[];
    reportTitle?: string | undefined;

    constructor(data?: ICreateGroupReportCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientGroupGroupReportGenerationSettingId = _data["clientGroupGroupReportGenerationSettingId"];
            if (Array.isArray(_data["clientGroupsIdList"])) {
                this.clientGroupsIdList = [] as any;
                for (let item of _data["clientGroupsIdList"])
                    this.clientGroupsIdList!.push(item);
            }
            this.reportTitle = _data["reportTitle"];
        }
    }

    static fromJS(data: any): CreateGroupReportCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGroupReportCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientGroupGroupReportGenerationSettingId"] = this.clientGroupGroupReportGenerationSettingId;
        if (Array.isArray(this.clientGroupsIdList)) {
            data["clientGroupsIdList"] = [];
            for (let item of this.clientGroupsIdList)
                data["clientGroupsIdList"].push(item);
        }
        data["reportTitle"] = this.reportTitle;
        return data;
    }
}

export interface ICreateGroupReportCommand {
    clientGroupGroupReportGenerationSettingId?: number;
    clientGroupsIdList?: number[];
    reportTitle?: string | undefined;
}

export class PaginatedListOfInternationalizationDto implements IPaginatedListOfInternationalizationDto {
    items?: InternationalizationDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfInternationalizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(InternationalizationDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfInternationalizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfInternationalizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfInternationalizationDto {
    items?: InternationalizationDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class InternationalizationDto implements IInternationalizationDto {
    key?: InternationalizationKey;
    content?: { [key: string]: string; } | undefined;

    constructor(data?: IInternationalizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            if (_data["content"]) {
                this.content = {} as any;
                for (let key in _data["content"]) {
                    if (_data["content"].hasOwnProperty(key))
                        (<any>this.content)![key] = _data["content"][key];
                }
            }
        }
    }

    static fromJS(data: any): InternationalizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new InternationalizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        if (this.content) {
            data["content"] = {};
            for (let key in this.content) {
                if (this.content.hasOwnProperty(key))
                    (<any>data["content"])[key] = (<any>this.content)[key];
            }
        }
        return data;
    }
}

export interface IInternationalizationDto {
    key?: InternationalizationKey;
    content?: { [key: string]: string; } | undefined;
}

export class UpdateInternationalizationCommand implements IUpdateInternationalizationCommand {
    key?: InternationalizationKey;
    content?: string;
    languageId?: string;

    constructor(data?: IUpdateInternationalizationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.content = _data["content"];
            this.languageId = _data["languageId"];
        }
    }

    static fromJS(data: any): UpdateInternationalizationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInternationalizationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["content"] = this.content;
        data["languageId"] = this.languageId;
        return data;
    }
}

export interface IUpdateInternationalizationCommand {
    key?: InternationalizationKey;
    content?: string;
    languageId?: string;
}

export class LanguageDto implements ILanguageDto {
    id?: string | undefined;
    displayName?: string | undefined;
    enable?: boolean;

    constructor(data?: ILanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.enable = _data["enable"];
        }
    }

    static fromJS(data: any): LanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["enable"] = this.enable;
        return data;
    }
}

export interface ILanguageDto {
    id?: string | undefined;
    displayName?: string | undefined;
    enable?: boolean;
}

export class PaginatedListOfMediaLibraryBriefDto implements IPaginatedListOfMediaLibraryBriefDto {
    items?: MediaLibraryBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfMediaLibraryBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MediaLibraryBriefDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfMediaLibraryBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfMediaLibraryBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfMediaLibraryBriefDto {
    items?: MediaLibraryBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class MediaLibraryBriefDto implements IMediaLibraryBriefDto {
    id?: number;
    mediaType?: MediaType;
    imageId?: number | undefined;
    name?: string;
    extension?: string | undefined;
    dimensions?: string | undefined;
    contentType?: string;
    lastModified?: Date | undefined;
    aliVodVideo?: AliVodVideoDto | undefined;
    videoId?: string | undefined;

    constructor(data?: IMediaLibraryBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mediaType = _data["mediaType"];
            this.imageId = _data["imageId"];
            this.name = _data["name"];
            this.extension = _data["extension"];
            this.dimensions = _data["dimensions"];
            this.contentType = _data["contentType"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.aliVodVideo = _data["aliVodVideo"] ? AliVodVideoDto.fromJS(_data["aliVodVideo"]) : <any>undefined;
            this.videoId = _data["videoId"];
        }
    }

    static fromJS(data: any): MediaLibraryBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new MediaLibraryBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mediaType"] = this.mediaType;
        data["imageId"] = this.imageId;
        data["name"] = this.name;
        data["extension"] = this.extension;
        data["dimensions"] = this.dimensions;
        data["contentType"] = this.contentType;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["aliVodVideo"] = this.aliVodVideo ? this.aliVodVideo.toJSON() : <any>undefined;
        data["videoId"] = this.videoId;
        return data;
    }
}

export interface IMediaLibraryBriefDto {
    id?: number;
    mediaType?: MediaType;
    imageId?: number | undefined;
    name?: string;
    extension?: string | undefined;
    dimensions?: string | undefined;
    contentType?: string;
    lastModified?: Date | undefined;
    aliVodVideo?: AliVodVideoDto | undefined;
    videoId?: string | undefined;
}

export enum MediaType {
    Image = 0,
    Video = 1,
}

export class CreateMediaLibraryCommand implements ICreateMediaLibraryCommand {
    mediaType?: MediaType;
    name?: string;
    extension?: string | undefined;
    dimensions?: string | undefined;
    fileId?: number;
    contentType?: string;
    videoId?: string;

    constructor(data?: ICreateMediaLibraryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mediaType = _data["mediaType"];
            this.name = _data["name"];
            this.extension = _data["extension"];
            this.dimensions = _data["dimensions"];
            this.fileId = _data["fileId"];
            this.contentType = _data["contentType"];
            this.videoId = _data["videoId"];
        }
    }

    static fromJS(data: any): CreateMediaLibraryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMediaLibraryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mediaType"] = this.mediaType;
        data["name"] = this.name;
        data["extension"] = this.extension;
        data["dimensions"] = this.dimensions;
        data["fileId"] = this.fileId;
        data["contentType"] = this.contentType;
        data["videoId"] = this.videoId;
        return data;
    }
}

export interface ICreateMediaLibraryCommand {
    mediaType?: MediaType;
    name?: string;
    extension?: string | undefined;
    dimensions?: string | undefined;
    fileId?: number;
    contentType?: string;
    videoId?: string;
}

export class DeleteBatchMediaLibraryCommand implements IDeleteBatchMediaLibraryCommand {
    mediaLibraryIds?: number[];

    constructor(data?: IDeleteBatchMediaLibraryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mediaLibraryIds"])) {
                this.mediaLibraryIds = [] as any;
                for (let item of _data["mediaLibraryIds"])
                    this.mediaLibraryIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DeleteBatchMediaLibraryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteBatchMediaLibraryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mediaLibraryIds)) {
            data["mediaLibraryIds"] = [];
            for (let item of this.mediaLibraryIds)
                data["mediaLibraryIds"].push(item);
        }
        return data;
    }
}

export interface IDeleteBatchMediaLibraryCommand {
    mediaLibraryIds?: number[];
}

export class UpdateMediaLibraryCommand implements IUpdateMediaLibraryCommand {
    id?: number;
    mediaType?: MediaType;
    name?: string;
    extension?: string | undefined;
    dimensions?: string | undefined;
    fileId?: number;
    contentType?: string;
    videoId?: string;

    constructor(data?: IUpdateMediaLibraryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mediaType = _data["mediaType"];
            this.name = _data["name"];
            this.extension = _data["extension"];
            this.dimensions = _data["dimensions"];
            this.fileId = _data["fileId"];
            this.contentType = _data["contentType"];
            this.videoId = _data["videoId"];
        }
    }

    static fromJS(data: any): UpdateMediaLibraryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMediaLibraryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mediaType"] = this.mediaType;
        data["name"] = this.name;
        data["extension"] = this.extension;
        data["dimensions"] = this.dimensions;
        data["fileId"] = this.fileId;
        data["contentType"] = this.contentType;
        data["videoId"] = this.videoId;
        return data;
    }
}

export interface IUpdateMediaLibraryCommand {
    id?: number;
    mediaType?: MediaType;
    name?: string;
    extension?: string | undefined;
    dimensions?: string | undefined;
    fileId?: number;
    contentType?: string;
    videoId?: string;
}

export class PaginatedListOfNormTableBriefDto implements IPaginatedListOfNormTableBriefDto {
    items?: NormTableBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfNormTableBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(NormTableBriefDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfNormTableBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfNormTableBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfNormTableBriefDto {
    items?: NormTableBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class PaginatedListOfQuestionCategoryDto implements IPaginatedListOfQuestionCategoryDto {
    items?: QuestionCategoryDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfQuestionCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(QuestionCategoryDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfQuestionCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfQuestionCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfQuestionCategoryDto {
    items?: QuestionCategoryDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class CreateQuestionCategoryCommand implements ICreateQuestionCategoryCommand {
    alias?: string | undefined;

    constructor(data?: ICreateQuestionCategoryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alias = _data["alias"];
        }
    }

    static fromJS(data: any): CreateQuestionCategoryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateQuestionCategoryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alias"] = this.alias;
        return data;
    }
}

export interface ICreateQuestionCategoryCommand {
    alias?: string | undefined;
}

export class PaginatedListOfQuestionChoiceListBriefDto implements IPaginatedListOfQuestionChoiceListBriefDto {
    items?: QuestionChoiceListBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfQuestionChoiceListBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(QuestionChoiceListBriefDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfQuestionChoiceListBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfQuestionChoiceListBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfQuestionChoiceListBriefDto {
    items?: QuestionChoiceListBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class QuestionChoiceListBriefDto implements IQuestionChoiceListBriefDto {
    id?: number;
    name?: string | undefined;
    remarks?: string | undefined;

    constructor(data?: IQuestionChoiceListBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.remarks = _data["remarks"];
        }
    }

    static fromJS(data: any): QuestionChoiceListBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionChoiceListBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["remarks"] = this.remarks;
        return data;
    }
}

export interface IQuestionChoiceListBriefDto {
    id?: number;
    name?: string | undefined;
    remarks?: string | undefined;
}

export class CreateQuestionChoiceListCommand implements ICreateQuestionChoiceListCommand {
    name?: string | undefined;
    remarks?: string | undefined;

    constructor(data?: ICreateQuestionChoiceListCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.remarks = _data["remarks"];
        }
    }

    static fromJS(data: any): CreateQuestionChoiceListCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateQuestionChoiceListCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["remarks"] = this.remarks;
        return data;
    }
}

export interface ICreateQuestionChoiceListCommand {
    name?: string | undefined;
    remarks?: string | undefined;
}

export class UpdateQuestionChoiceListCommand implements IUpdateQuestionChoiceListCommand {
    id?: number;
    name?: string | undefined;
    remarks?: string | undefined;

    constructor(data?: IUpdateQuestionChoiceListCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.remarks = _data["remarks"];
        }
    }

    static fromJS(data: any): UpdateQuestionChoiceListCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateQuestionChoiceListCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["remarks"] = this.remarks;
        return data;
    }
}

export interface IUpdateQuestionChoiceListCommand {
    id?: number;
    name?: string | undefined;
    remarks?: string | undefined;
}

export class PaginatedListOfQuestionChoiceDto implements IPaginatedListOfQuestionChoiceDto {
    items?: QuestionChoiceDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfQuestionChoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(QuestionChoiceDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfQuestionChoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfQuestionChoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfQuestionChoiceDto {
    items?: QuestionChoiceDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class QuestionChoiceDto implements IQuestionChoiceDto {
    id?: number;
    questionChoiceListId?: number;
    questionChoiceListName?: string | undefined;
    isPlaceHolder?: boolean;
    itemNumber?: number;
    content?: { [key: string]: string; } | undefined;

    constructor(data?: IQuestionChoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.questionChoiceListId = _data["questionChoiceListId"];
            this.questionChoiceListName = _data["questionChoiceListName"];
            this.isPlaceHolder = _data["isPlaceHolder"];
            this.itemNumber = _data["itemNumber"];
            if (_data["content"]) {
                this.content = {} as any;
                for (let key in _data["content"]) {
                    if (_data["content"].hasOwnProperty(key))
                        (<any>this.content)![key] = _data["content"][key];
                }
            }
        }
    }

    static fromJS(data: any): QuestionChoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionChoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["questionChoiceListId"] = this.questionChoiceListId;
        data["questionChoiceListName"] = this.questionChoiceListName;
        data["isPlaceHolder"] = this.isPlaceHolder;
        data["itemNumber"] = this.itemNumber;
        if (this.content) {
            data["content"] = {};
            for (let key in this.content) {
                if (this.content.hasOwnProperty(key))
                    (<any>data["content"])[key] = (<any>this.content)[key];
            }
        }
        return data;
    }
}

export interface IQuestionChoiceDto {
    id?: number;
    questionChoiceListId?: number;
    questionChoiceListName?: string | undefined;
    isPlaceHolder?: boolean;
    itemNumber?: number;
    content?: { [key: string]: string; } | undefined;
}

export class CreateQuestionChoiceCommand implements ICreateQuestionChoiceCommand {
    questionChoiceListId?: number;
    isPlaceHolder?: boolean;
    itemNumber?: number;
    content?: { [key: string]: string; };

    constructor(data?: ICreateQuestionChoiceCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionChoiceListId = _data["questionChoiceListId"];
            this.isPlaceHolder = _data["isPlaceHolder"];
            this.itemNumber = _data["itemNumber"];
            if (_data["content"]) {
                this.content = {} as any;
                for (let key in _data["content"]) {
                    if (_data["content"].hasOwnProperty(key))
                        (<any>this.content)![key] = _data["content"][key];
                }
            }
        }
    }

    static fromJS(data: any): CreateQuestionChoiceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateQuestionChoiceCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionChoiceListId"] = this.questionChoiceListId;
        data["isPlaceHolder"] = this.isPlaceHolder;
        data["itemNumber"] = this.itemNumber;
        if (this.content) {
            data["content"] = {};
            for (let key in this.content) {
                if (this.content.hasOwnProperty(key))
                    (<any>data["content"])[key] = (<any>this.content)[key];
            }
        }
        return data;
    }
}

export interface ICreateQuestionChoiceCommand {
    questionChoiceListId?: number;
    isPlaceHolder?: boolean;
    itemNumber?: number;
    content?: { [key: string]: string; };
}

export class UpdateQuestionChoiceCommand implements IUpdateQuestionChoiceCommand {
    id?: number;
    isPlaceHolder?: boolean;
    itemNumber?: number;
    content?: { [key: string]: string; };

    constructor(data?: IUpdateQuestionChoiceCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isPlaceHolder = _data["isPlaceHolder"];
            this.itemNumber = _data["itemNumber"];
            if (_data["content"]) {
                this.content = {} as any;
                for (let key in _data["content"]) {
                    if (_data["content"].hasOwnProperty(key))
                        (<any>this.content)![key] = _data["content"][key];
                }
            }
        }
    }

    static fromJS(data: any): UpdateQuestionChoiceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateQuestionChoiceCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isPlaceHolder"] = this.isPlaceHolder;
        data["itemNumber"] = this.itemNumber;
        if (this.content) {
            data["content"] = {};
            for (let key in this.content) {
                if (this.content.hasOwnProperty(key))
                    (<any>data["content"])[key] = (<any>this.content)[key];
            }
        }
        return data;
    }
}

export interface IUpdateQuestionChoiceCommand {
    id?: number;
    isPlaceHolder?: boolean;
    itemNumber?: number;
    content?: { [key: string]: string; };
}

export class PaginatedListOfQuestionDto implements IPaginatedListOfQuestionDto {
    items?: QuestionDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(QuestionDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfQuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfQuestionDto {
    items?: QuestionDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class QuestionDto implements IQuestionDto {
    id?: number;
    itemNumber?: number;
    content?: { [key: string]: string; } | undefined;
    contentId?: number;
    categoryAlias?: string | undefined;
    categoryId?: number;
    type?: QuestionType;
    questionChoiceListName?: string | undefined;
    created?: Date;
    socialDesirablilityType?: SocialDesirablilityType | undefined;

    constructor(data?: IQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.itemNumber = _data["itemNumber"];
            if (_data["content"]) {
                this.content = {} as any;
                for (let key in _data["content"]) {
                    if (_data["content"].hasOwnProperty(key))
                        (<any>this.content)![key] = _data["content"][key];
                }
            }
            this.contentId = _data["contentId"];
            this.categoryAlias = _data["categoryAlias"];
            this.categoryId = _data["categoryId"];
            this.type = _data["type"];
            this.questionChoiceListName = _data["questionChoiceListName"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.socialDesirablilityType = _data["socialDesirablilityType"];
        }
    }

    static fromJS(data: any): QuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["itemNumber"] = this.itemNumber;
        if (this.content) {
            data["content"] = {};
            for (let key in this.content) {
                if (this.content.hasOwnProperty(key))
                    (<any>data["content"])[key] = (<any>this.content)[key];
            }
        }
        data["contentId"] = this.contentId;
        data["categoryAlias"] = this.categoryAlias;
        data["categoryId"] = this.categoryId;
        data["type"] = this.type;
        data["questionChoiceListName"] = this.questionChoiceListName;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["socialDesirablilityType"] = this.socialDesirablilityType;
        return data;
    }
}

export interface IQuestionDto {
    id?: number;
    itemNumber?: number;
    content?: { [key: string]: string; } | undefined;
    contentId?: number;
    categoryAlias?: string | undefined;
    categoryId?: number;
    type?: QuestionType;
    questionChoiceListName?: string | undefined;
    created?: Date;
    socialDesirablilityType?: SocialDesirablilityType | undefined;
}

export enum SocialDesirablilityType {
    Lowest = 0,
    Highest = 1,
}

export class PaginatedListOfRatingScaleBriefDto implements IPaginatedListOfRatingScaleBriefDto {
    items?: RatingScaleBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfRatingScaleBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RatingScaleBriefDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfRatingScaleBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfRatingScaleBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfRatingScaleBriefDto {
    items?: RatingScaleBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class RatingScaleBriefDto implements IRatingScaleBriefDto {
    id?: number;
    title?: string | undefined;
    pointOfScale?: number;

    constructor(data?: IRatingScaleBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.pointOfScale = _data["pointOfScale"];
        }
    }

    static fromJS(data: any): RatingScaleBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new RatingScaleBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["pointOfScale"] = this.pointOfScale;
        return data;
    }
}

export interface IRatingScaleBriefDto {
    id?: number;
    title?: string | undefined;
    pointOfScale?: number;
}

export class RatingScaleDto implements IRatingScaleDto {
    title?: string | undefined;
    pointOfScale?: number;
    ratingScalePoints?: RatingScalePointDto[] | undefined;

    constructor(data?: IRatingScaleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.pointOfScale = _data["pointOfScale"];
            if (Array.isArray(_data["ratingScalePoints"])) {
                this.ratingScalePoints = [] as any;
                for (let item of _data["ratingScalePoints"])
                    this.ratingScalePoints!.push(RatingScalePointDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RatingScaleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RatingScaleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["pointOfScale"] = this.pointOfScale;
        if (Array.isArray(this.ratingScalePoints)) {
            data["ratingScalePoints"] = [];
            for (let item of this.ratingScalePoints)
                data["ratingScalePoints"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRatingScaleDto {
    title?: string | undefined;
    pointOfScale?: number;
    ratingScalePoints?: RatingScalePointDto[] | undefined;
}

export class RatingScalePointDto implements IRatingScalePointDto {
    id?: number;
    value?: number;
    label?: { [key: string]: string; } | undefined;

    constructor(data?: IRatingScalePointDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            if (_data["label"]) {
                this.label = {} as any;
                for (let key in _data["label"]) {
                    if (_data["label"].hasOwnProperty(key))
                        (<any>this.label)![key] = _data["label"][key];
                }
            }
        }
    }

    static fromJS(data: any): RatingScalePointDto {
        data = typeof data === 'object' ? data : {};
        let result = new RatingScalePointDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        if (this.label) {
            data["label"] = {};
            for (let key in this.label) {
                if (this.label.hasOwnProperty(key))
                    (<any>data["label"])[key] = (<any>this.label)[key];
            }
        }
        return data;
    }
}

export interface IRatingScalePointDto {
    id?: number;
    value?: number;
    label?: { [key: string]: string; } | undefined;
}

export class CreateRatingScaleCommand implements ICreateRatingScaleCommand {
    title?: string | undefined;
    pointOfScale?: number;

    constructor(data?: ICreateRatingScaleCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.pointOfScale = _data["pointOfScale"];
        }
    }

    static fromJS(data: any): CreateRatingScaleCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRatingScaleCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["pointOfScale"] = this.pointOfScale;
        return data;
    }
}

export interface ICreateRatingScaleCommand {
    title?: string | undefined;
    pointOfScale?: number;
}

export class UpdateRatingScalePointCommand implements IUpdateRatingScalePointCommand {
    id?: number;
    label?: { [key: string]: string; };

    constructor(data?: IUpdateRatingScalePointCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (_data["label"]) {
                this.label = {} as any;
                for (let key in _data["label"]) {
                    if (_data["label"].hasOwnProperty(key))
                        (<any>this.label)![key] = _data["label"][key];
                }
            }
        }
    }

    static fromJS(data: any): UpdateRatingScalePointCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRatingScalePointCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.label) {
            data["label"] = {};
            for (let key in this.label) {
                if (this.label.hasOwnProperty(key))
                    (<any>data["label"])[key] = (<any>this.label)[key];
            }
        }
        return data;
    }
}

export interface IUpdateRatingScalePointCommand {
    id?: number;
    label?: { [key: string]: string; };
}

export class PaginatedListOfRegistrationDto implements IPaginatedListOfRegistrationDto {
    items?: RegistrationDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfRegistrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RegistrationDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfRegistrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfRegistrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfRegistrationDto {
    items?: RegistrationDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class RegistrationDto extends AuditableEntity implements IRegistrationDto {
    id?: number;
    registrationPeriodId?: number;
    clientUser?: ClientUserLoginDto;
    loginToken?: string | undefined;

    constructor(data?: IRegistrationDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.registrationPeriodId = _data["registrationPeriodId"];
            this.clientUser = _data["clientUser"] ? ClientUserLoginDto.fromJS(_data["clientUser"]) : <any>undefined;
            this.loginToken = _data["loginToken"];
        }
    }

    static fromJS(data: any): RegistrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["registrationPeriodId"] = this.registrationPeriodId;
        data["clientUser"] = this.clientUser ? this.clientUser.toJSON() : <any>undefined;
        data["loginToken"] = this.loginToken;
        super.toJSON(data);
        return data;
    }
}

export interface IRegistrationDto extends IAuditableEntity {
    id?: number;
    registrationPeriodId?: number;
    clientUser?: ClientUserLoginDto;
    loginToken?: string | undefined;
}

export class ClientUserLoginDto implements IClientUserLoginDto {
    userName?: string;
    defaultPassword?: string | undefined;
    preferredLanguageId?: string | undefined;

    constructor(data?: IClientUserLoginDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.defaultPassword = _data["defaultPassword"];
            this.preferredLanguageId = _data["preferredLanguageId"];
        }
    }

    static fromJS(data: any): ClientUserLoginDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientUserLoginDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["defaultPassword"] = this.defaultPassword;
        data["preferredLanguageId"] = this.preferredLanguageId;
        return data;
    }
}

export interface IClientUserLoginDto {
    userName?: string;
    defaultPassword?: string | undefined;
    preferredLanguageId?: string | undefined;
}

export class CreateRegistrationCommand implements ICreateRegistrationCommand {
    passphrase?: string;
    email?: string | undefined;
    confirmCode?: string | undefined;

    constructor(data?: ICreateRegistrationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.passphrase = _data["passphrase"];
            this.email = _data["email"];
            this.confirmCode = _data["confirmCode"];
        }
    }

    static fromJS(data: any): CreateRegistrationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRegistrationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["passphrase"] = this.passphrase;
        data["email"] = this.email;
        data["confirmCode"] = this.confirmCode;
        return data;
    }
}

export interface ICreateRegistrationCommand {
    passphrase?: string;
    email?: string | undefined;
    confirmCode?: string | undefined;
}

export class RegistrationPeriodDto implements IRegistrationPeriodDto {
    id?: number;
    clientGroup?: ClientGroupBriefDto;
    startOn?: Date;
    endOn?: Date;
    passphrase?: string;
    isEnabled?: boolean;
    quota?: number | undefined;
    registrationsCount?: number;
    hasEmailNotification?: boolean;
    hasLoginToken?: boolean;
    hasConfirmCode?: boolean;

    constructor(data?: IRegistrationPeriodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientGroup = _data["clientGroup"] ? ClientGroupBriefDto.fromJS(_data["clientGroup"]) : <any>undefined;
            this.startOn = _data["startOn"] ? new Date(_data["startOn"].toString()) : <any>undefined;
            this.endOn = _data["endOn"] ? new Date(_data["endOn"].toString()) : <any>undefined;
            this.passphrase = _data["passphrase"];
            this.isEnabled = _data["isEnabled"];
            this.quota = _data["quota"];
            this.registrationsCount = _data["registrationsCount"];
            this.hasEmailNotification = _data["hasEmailNotification"];
            this.hasLoginToken = _data["hasLoginToken"];
            this.hasConfirmCode = _data["hasConfirmCode"];
        }
    }

    static fromJS(data: any): RegistrationPeriodDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationPeriodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientGroup"] = this.clientGroup ? this.clientGroup.toJSON() : <any>undefined;
        data["startOn"] = this.startOn ? this.startOn.toISOString() : <any>undefined;
        data["endOn"] = this.endOn ? this.endOn.toISOString() : <any>undefined;
        data["passphrase"] = this.passphrase;
        data["isEnabled"] = this.isEnabled;
        data["quota"] = this.quota;
        data["registrationsCount"] = this.registrationsCount;
        data["hasEmailNotification"] = this.hasEmailNotification;
        data["hasLoginToken"] = this.hasLoginToken;
        data["hasConfirmCode"] = this.hasConfirmCode;
        return data;
    }
}

export interface IRegistrationPeriodDto {
    id?: number;
    clientGroup?: ClientGroupBriefDto;
    startOn?: Date;
    endOn?: Date;
    passphrase?: string;
    isEnabled?: boolean;
    quota?: number | undefined;
    registrationsCount?: number;
    hasEmailNotification?: boolean;
    hasLoginToken?: boolean;
    hasConfirmCode?: boolean;
}

export class PaginatedListOfRegistrationPeriodDto implements IPaginatedListOfRegistrationPeriodDto {
    items?: RegistrationPeriodDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfRegistrationPeriodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RegistrationPeriodDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfRegistrationPeriodDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfRegistrationPeriodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfRegistrationPeriodDto {
    items?: RegistrationPeriodDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class UpdateRegistrationPeriodCommand implements IUpdateRegistrationPeriodCommand {
    id?: number;
    startOn?: Date;
    endOn?: Date;
    quota?: number | undefined;

    constructor(data?: IUpdateRegistrationPeriodCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startOn = _data["startOn"] ? new Date(_data["startOn"].toString()) : <any>undefined;
            this.endOn = _data["endOn"] ? new Date(_data["endOn"].toString()) : <any>undefined;
            this.quota = _data["quota"];
        }
    }

    static fromJS(data: any): UpdateRegistrationPeriodCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRegistrationPeriodCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startOn"] = this.startOn ? this.startOn.toISOString() : <any>undefined;
        data["endOn"] = this.endOn ? this.endOn.toISOString() : <any>undefined;
        data["quota"] = this.quota;
        return data;
    }
}

export interface IUpdateRegistrationPeriodCommand {
    id?: number;
    startOn?: Date;
    endOn?: Date;
    quota?: number | undefined;
}

export class CreateRegistrationPeriodCommand implements ICreateRegistrationPeriodCommand {
    clientGroupId?: number;
    startOn?: Date;
    endOn?: Date;
    quota?: number | undefined;
    hasEmailNotification?: boolean;
    hasLoginToken?: boolean;
    hasConfirmCode?: boolean;

    constructor(data?: ICreateRegistrationPeriodCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientGroupId = _data["clientGroupId"];
            this.startOn = _data["startOn"] ? new Date(_data["startOn"].toString()) : <any>undefined;
            this.endOn = _data["endOn"] ? new Date(_data["endOn"].toString()) : <any>undefined;
            this.quota = _data["quota"];
            this.hasEmailNotification = _data["hasEmailNotification"];
            this.hasLoginToken = _data["hasLoginToken"];
            this.hasConfirmCode = _data["hasConfirmCode"];
        }
    }

    static fromJS(data: any): CreateRegistrationPeriodCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRegistrationPeriodCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientGroupId"] = this.clientGroupId;
        data["startOn"] = this.startOn ? this.startOn.toISOString() : <any>undefined;
        data["endOn"] = this.endOn ? this.endOn.toISOString() : <any>undefined;
        data["quota"] = this.quota;
        data["hasEmailNotification"] = this.hasEmailNotification;
        data["hasLoginToken"] = this.hasLoginToken;
        data["hasConfirmCode"] = this.hasConfirmCode;
        return data;
    }
}

export interface ICreateRegistrationPeriodCommand {
    clientGroupId?: number;
    startOn?: Date;
    endOn?: Date;
    quota?: number | undefined;
    hasEmailNotification?: boolean;
    hasLoginToken?: boolean;
    hasConfirmCode?: boolean;
}

export class GroupReportGenerationSettingsDto implements IGroupReportGenerationSettingsDto {
    assessmentTemplate?: AssessmentTemplateBriefDto;
    form?: FormBriefDto;
    scoringKeySet?: ScoringKeySetDto;
    normTable?: NormTableBriefDto;
    groupReportTemplate?: GroupReportTemplateBriefDto;

    constructor(data?: IGroupReportGenerationSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assessmentTemplate = _data["assessmentTemplate"] ? AssessmentTemplateBriefDto.fromJS(_data["assessmentTemplate"]) : <any>undefined;
            this.form = _data["form"] ? FormBriefDto.fromJS(_data["form"]) : <any>undefined;
            this.scoringKeySet = _data["scoringKeySet"] ? ScoringKeySetDto.fromJS(_data["scoringKeySet"]) : <any>undefined;
            this.normTable = _data["normTable"] ? NormTableBriefDto.fromJS(_data["normTable"]) : <any>undefined;
            this.groupReportTemplate = _data["groupReportTemplate"] ? GroupReportTemplateBriefDto.fromJS(_data["groupReportTemplate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GroupReportGenerationSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupReportGenerationSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assessmentTemplate"] = this.assessmentTemplate ? this.assessmentTemplate.toJSON() : <any>undefined;
        data["form"] = this.form ? this.form.toJSON() : <any>undefined;
        data["scoringKeySet"] = this.scoringKeySet ? this.scoringKeySet.toJSON() : <any>undefined;
        data["normTable"] = this.normTable ? this.normTable.toJSON() : <any>undefined;
        data["groupReportTemplate"] = this.groupReportTemplate ? this.groupReportTemplate.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGroupReportGenerationSettingsDto {
    assessmentTemplate?: AssessmentTemplateBriefDto;
    form?: FormBriefDto;
    scoringKeySet?: ScoringKeySetDto;
    normTable?: NormTableBriefDto;
    groupReportTemplate?: GroupReportTemplateBriefDto;
}

export class PaginatedListOfGroupReportGenerationSettingsBriefDto implements IPaginatedListOfGroupReportGenerationSettingsBriefDto {
    items?: GroupReportGenerationSettingsBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfGroupReportGenerationSettingsBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GroupReportGenerationSettingsBriefDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfGroupReportGenerationSettingsBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfGroupReportGenerationSettingsBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfGroupReportGenerationSettingsBriefDto {
    items?: GroupReportGenerationSettingsBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class GroupReportGenerationSettingsBriefDto implements IGroupReportGenerationSettingsBriefDto {
    assessmentTemplateAlias?: string | undefined;
    formName?: string | undefined;
    scoringKeySetName?: string | undefined;
    normTableName?: string | undefined;
    groupReportTemplateName?: string | undefined;

    constructor(data?: IGroupReportGenerationSettingsBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assessmentTemplateAlias = _data["assessmentTemplateAlias"];
            this.formName = _data["formName"];
            this.scoringKeySetName = _data["scoringKeySetName"];
            this.normTableName = _data["normTableName"];
            this.groupReportTemplateName = _data["groupReportTemplateName"];
        }
    }

    static fromJS(data: any): GroupReportGenerationSettingsBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupReportGenerationSettingsBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assessmentTemplateAlias"] = this.assessmentTemplateAlias;
        data["formName"] = this.formName;
        data["scoringKeySetName"] = this.scoringKeySetName;
        data["normTableName"] = this.normTableName;
        data["groupReportTemplateName"] = this.groupReportTemplateName;
        return data;
    }
}

export interface IGroupReportGenerationSettingsBriefDto {
    assessmentTemplateAlias?: string | undefined;
    formName?: string | undefined;
    scoringKeySetName?: string | undefined;
    normTableName?: string | undefined;
    groupReportTemplateName?: string | undefined;
}

export class PaginatedListOfReportTemplateNormTableBriefDto implements IPaginatedListOfReportTemplateNormTableBriefDto {
    items?: ReportTemplateNormTableBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfReportTemplateNormTableBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ReportTemplateNormTableBriefDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfReportTemplateNormTableBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfReportTemplateNormTableBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfReportTemplateNormTableBriefDto {
    items?: ReportTemplateNormTableBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class ReportTemplateNormTableBriefDto implements IReportTemplateNormTableBriefDto {
    id?: number;
    normTable?: NormTableBriefDto;
    reportTemplate?: ReportTemplateBriefDto;

    constructor(data?: IReportTemplateNormTableBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.normTable = _data["normTable"] ? NormTableBriefDto.fromJS(_data["normTable"]) : <any>undefined;
            this.reportTemplate = _data["reportTemplate"] ? ReportTemplateBriefDto.fromJS(_data["reportTemplate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ReportTemplateNormTableBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportTemplateNormTableBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["normTable"] = this.normTable ? this.normTable.toJSON() : <any>undefined;
        data["reportTemplate"] = this.reportTemplate ? this.reportTemplate.toJSON() : <any>undefined;
        return data;
    }
}

export interface IReportTemplateNormTableBriefDto {
    id?: number;
    normTable?: NormTableBriefDto;
    reportTemplate?: ReportTemplateBriefDto;
}

export class CreateReportTemplateNormTableCommand implements ICreateReportTemplateNormTableCommand {
    reportTemplateId?: number;
    normTableId?: number;

    constructor(data?: ICreateReportTemplateNormTableCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportTemplateId = _data["reportTemplateId"];
            this.normTableId = _data["normTableId"];
        }
    }

    static fromJS(data: any): CreateReportTemplateNormTableCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateReportTemplateNormTableCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportTemplateId"] = this.reportTemplateId;
        data["normTableId"] = this.normTableId;
        return data;
    }
}

export interface ICreateReportTemplateNormTableCommand {
    reportTemplateId?: number;
    normTableId?: number;
}

export class PaginatedListOfReportTemplateBriefDto implements IPaginatedListOfReportTemplateBriefDto {
    items?: ReportTemplateBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfReportTemplateBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ReportTemplateBriefDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfReportTemplateBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfReportTemplateBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfReportTemplateBriefDto {
    items?: ReportTemplateBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class CreateReportTemplateCommand implements ICreateReportTemplateCommand {
    name?: string;
    displayName?: string;
    preferredLanguageId?: string;
    reportGenerationMethod?: ReportGenerationMethod;
    showUnmatchToken?: boolean;

    constructor(data?: ICreateReportTemplateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.preferredLanguageId = _data["preferredLanguageId"];
            this.reportGenerationMethod = _data["reportGenerationMethod"];
            this.showUnmatchToken = _data["showUnmatchToken"];
        }
    }

    static fromJS(data: any): CreateReportTemplateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateReportTemplateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["preferredLanguageId"] = this.preferredLanguageId;
        data["reportGenerationMethod"] = this.reportGenerationMethod;
        data["showUnmatchToken"] = this.showUnmatchToken;
        return data;
    }
}

export interface ICreateReportTemplateCommand {
    name?: string;
    displayName?: string;
    preferredLanguageId?: string;
    reportGenerationMethod?: ReportGenerationMethod;
    showUnmatchToken?: boolean;
}

export class UpdateReportTemplateCommand implements IUpdateReportTemplateCommand {
    id?: number;
    name?: string;
    displayName?: string;
    preferredLanguageId?: string;
    reportGenerationMethod?: ReportGenerationMethod;
    showUnmatchToken?: boolean;

    constructor(data?: IUpdateReportTemplateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.preferredLanguageId = _data["preferredLanguageId"];
            this.reportGenerationMethod = _data["reportGenerationMethod"];
            this.showUnmatchToken = _data["showUnmatchToken"];
        }
    }

    static fromJS(data: any): UpdateReportTemplateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateReportTemplateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["preferredLanguageId"] = this.preferredLanguageId;
        data["reportGenerationMethod"] = this.reportGenerationMethod;
        data["showUnmatchToken"] = this.showUnmatchToken;
        return data;
    }
}

export interface IUpdateReportTemplateCommand {
    id?: number;
    name?: string;
    displayName?: string;
    preferredLanguageId?: string;
    reportGenerationMethod?: ReportGenerationMethod;
    showUnmatchToken?: boolean;
}

export class PaginatedListOfScoringKeySetDto implements IPaginatedListOfScoringKeySetDto {
    items?: ScoringKeySetDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfScoringKeySetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ScoringKeySetDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfScoringKeySetDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfScoringKeySetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfScoringKeySetDto {
    items?: ScoringKeySetDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class PaginatedListOfLanguageDto implements IPaginatedListOfLanguageDto {
    items?: LanguageDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LanguageDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfLanguageDto {
    items?: LanguageDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class CreateSupportedLanguageCommand implements ICreateSupportedLanguageCommand {
    id?: string;

    constructor(data?: ICreateSupportedLanguageCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateSupportedLanguageCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSupportedLanguageCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateSupportedLanguageCommand {
    id?: string;
}

export class UpdateSupportedLanguageCommand implements IUpdateSupportedLanguageCommand {
    id?: string;
    enable?: boolean;

    constructor(data?: IUpdateSupportedLanguageCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.enable = _data["enable"];
        }
    }

    static fromJS(data: any): UpdateSupportedLanguageCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSupportedLanguageCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["enable"] = this.enable;
        return data;
    }
}

export interface IUpdateSupportedLanguageCommand {
    id?: string;
    enable?: boolean;
}

export class TechnicalBriefDto implements ITechnicalBriefDto {
    userName?: string | undefined;
    email?: string | undefined;
    id?: string | undefined;

    constructor(data?: ITechnicalBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TechnicalBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new TechnicalBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["id"] = this.id;
        return data;
    }
}

export interface ITechnicalBriefDto {
    userName?: string | undefined;
    email?: string | undefined;
    id?: string | undefined;
}

export class GetTechnicalsQuery implements IGetTechnicalsQuery {

    constructor(data?: IGetTechnicalsQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetTechnicalsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetTechnicalsQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetTechnicalsQuery {
}

export class CreateTechnicalCommand implements ICreateTechnicalCommand {
    userName?: string;
    email?: string;
    password?: string;

    constructor(data?: ICreateTechnicalCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): CreateTechnicalCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTechnicalCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["password"] = this.password;
        return data;
    }
}

export interface ICreateTechnicalCommand {
    userName?: string;
    email?: string;
    password?: string;
}

export class PaginatedListOfTodoItemBriefDto implements IPaginatedListOfTodoItemBriefDto {
    items?: TodoItemBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfTodoItemBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TodoItemBriefDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfTodoItemBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfTodoItemBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfTodoItemBriefDto {
    items?: TodoItemBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class TodoItemBriefDto implements ITodoItemBriefDto {
    id?: number;
    listId?: number;
    title?: string | undefined;
    done?: boolean;

    constructor(data?: ITodoItemBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.listId = _data["listId"];
            this.title = _data["title"];
            this.done = _data["done"];
        }
    }

    static fromJS(data: any): TodoItemBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new TodoItemBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["listId"] = this.listId;
        data["title"] = this.title;
        data["done"] = this.done;
        return data;
    }
}

export interface ITodoItemBriefDto {
    id?: number;
    listId?: number;
    title?: string | undefined;
    done?: boolean;
}

export class CreateTodoItemCommand implements ICreateTodoItemCommand {
    listId?: number;
    title?: string | undefined;

    constructor(data?: ICreateTodoItemCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.listId = _data["listId"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): CreateTodoItemCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTodoItemCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listId"] = this.listId;
        data["title"] = this.title;
        return data;
    }
}

export interface ICreateTodoItemCommand {
    listId?: number;
    title?: string | undefined;
}

export class UpdateTodoItemCommand implements IUpdateTodoItemCommand {
    id?: number;
    title?: string | undefined;
    done?: boolean;

    constructor(data?: IUpdateTodoItemCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.done = _data["done"];
        }
    }

    static fromJS(data: any): UpdateTodoItemCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTodoItemCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["done"] = this.done;
        return data;
    }
}

export interface IUpdateTodoItemCommand {
    id?: number;
    title?: string | undefined;
    done?: boolean;
}

export class UpdateTodoItemDetailCommand implements IUpdateTodoItemDetailCommand {
    id?: number;
    listId?: number;
    priority?: PriorityLevel;
    note?: string | undefined;

    constructor(data?: IUpdateTodoItemDetailCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.listId = _data["listId"];
            this.priority = _data["priority"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UpdateTodoItemDetailCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTodoItemDetailCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["listId"] = this.listId;
        data["priority"] = this.priority;
        data["note"] = this.note;
        return data;
    }
}

export interface IUpdateTodoItemDetailCommand {
    id?: number;
    listId?: number;
    priority?: PriorityLevel;
    note?: string | undefined;
}

export enum PriorityLevel {
    None = 0,
    Low = 1,
    Medium = 2,
    High = 3,
}

export class TodosVm implements ITodosVm {
    priorityLevels?: PriorityLevelDto[];
    lists?: TodoListDto[];

    constructor(data?: ITodosVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["priorityLevels"])) {
                this.priorityLevels = [] as any;
                for (let item of _data["priorityLevels"])
                    this.priorityLevels!.push(PriorityLevelDto.fromJS(item));
            }
            if (Array.isArray(_data["lists"])) {
                this.lists = [] as any;
                for (let item of _data["lists"])
                    this.lists!.push(TodoListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TodosVm {
        data = typeof data === 'object' ? data : {};
        let result = new TodosVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.priorityLevels)) {
            data["priorityLevels"] = [];
            for (let item of this.priorityLevels)
                data["priorityLevels"].push(item.toJSON());
        }
        if (Array.isArray(this.lists)) {
            data["lists"] = [];
            for (let item of this.lists)
                data["lists"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITodosVm {
    priorityLevels?: PriorityLevelDto[];
    lists?: TodoListDto[];
}

export class PriorityLevelDto implements IPriorityLevelDto {
    value?: number;
    name?: string | undefined;

    constructor(data?: IPriorityLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PriorityLevelDto {
        data = typeof data === 'object' ? data : {};
        let result = new PriorityLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["name"] = this.name;
        return data;
    }
}

export interface IPriorityLevelDto {
    value?: number;
    name?: string | undefined;
}

export class TodoListDto implements ITodoListDto {
    id?: number;
    title?: string | undefined;
    colour?: string | undefined;
    items?: TodoItemDto[];

    constructor(data?: ITodoListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.colour = _data["colour"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TodoItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TodoListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TodoListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["colour"] = this.colour;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITodoListDto {
    id?: number;
    title?: string | undefined;
    colour?: string | undefined;
    items?: TodoItemDto[];
}

export class TodoItemDto implements ITodoItemDto {
    id?: number;
    listId?: number;
    title?: string | undefined;
    done?: boolean;
    priority?: number;
    note?: string | undefined;

    constructor(data?: ITodoItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.listId = _data["listId"];
            this.title = _data["title"];
            this.done = _data["done"];
            this.priority = _data["priority"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): TodoItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new TodoItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["listId"] = this.listId;
        data["title"] = this.title;
        data["done"] = this.done;
        data["priority"] = this.priority;
        data["note"] = this.note;
        return data;
    }
}

export interface ITodoItemDto {
    id?: number;
    listId?: number;
    title?: string | undefined;
    done?: boolean;
    priority?: number;
    note?: string | undefined;
}

export class CreateTodoListCommand implements ICreateTodoListCommand {
    title?: string | undefined;

    constructor(data?: ICreateTodoListCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): CreateTodoListCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTodoListCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        return data;
    }
}

export interface ICreateTodoListCommand {
    title?: string | undefined;
}

export class UpdateTodoListCommand implements IUpdateTodoListCommand {
    id?: number;
    title?: string | undefined;

    constructor(data?: IUpdateTodoListCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): UpdateTodoListCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTodoListCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        return data;
    }
}

export interface IUpdateTodoListCommand {
    id?: number;
    title?: string | undefined;
}

export class WeatherForecast implements IWeatherForecast {
    date?: Date;
    temperatureC?: number;
    temperatureF?: number;
    summary?: string | undefined;

    constructor(data?: IWeatherForecast) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.temperatureC = _data["temperatureC"];
            this.temperatureF = _data["temperatureF"];
            this.summary = _data["summary"];
        }
    }

    static fromJS(data: any): WeatherForecast {
        data = typeof data === 'object' ? data : {};
        let result = new WeatherForecast();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["temperatureC"] = this.temperatureC;
        data["temperatureF"] = this.temperatureF;
        data["summary"] = this.summary;
        return data;
    }
}

export interface IWeatherForecast {
    date?: Date;
    temperatureC?: number;
    temperatureF?: number;
    summary?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}